import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { personalizeAction } from "../../../store/pesonalize-store";
import validateInfo from "../validateInfo";
import useHttp from "../../../hooks/use-http";
import { endPoints } from "../../../config/end-points";
import {fonts} from "../../../config/webFontLists"
import { FaSortDown,FaSortUp,FaPlay,FaRegClock,FaPause,FaTimesCircle,FaPager, FaPoll, FaCalendarAlt , FaPercent } from "react-icons/fa";
import { BiImageAdd   } from "react-icons/bi";
import { RiPagesFill} from "react-icons/ri";
import { MdRateReview, MdTimer , MdRestaurantMenu , MdUpcoming, MdContentCopy, MdContentPaste } from "react-icons/md";
import { IoShareSocial, IoArrowBackOutline  } from "react-icons/io5";
import { TiArrowRepeat } from "react-icons/ti";
import { HiVolumeOff, HiVolumeUp, HiCursorClick   } from "react-icons/hi";
import { FaStar, FaFileDownload , FaGift, FaQrcode ,FaRegCalendarAlt , FaTag, FaCode, FaLink     } from "react-icons/fa";
import { useRef } from "react";
import { cuteToast } from "../../UI/cute";
import Switch from "react-switch";
// import useVideoPlayer from "./useVideoPlayer";
import Slider from 'rc-slider';
// import "rc-slider/assets/index.css";
import {
  BsCodeSlash,
  BsFillEmojiHeartEyesFill,
  BsQuestionCircle,
} from "react-icons/bs";
import { BiEditAlt } from "react-icons/bi";
import { useParams } from "react-router-dom";
import { MdOutlineInsertEmoticon, MdRequestPage } from "react-icons/md"
// import { WidthProvider, Responsive } from "react-grid-layout";
import { Resizable } from "re-resizable";
import Draggable from 'react-draggable'; // The default
import Select from "react-select";
import Input from "../../UI/Input";
import ColorPicker from "../../UI/ColorPicker";
import OverlayTemplatesModal from "../../shared/modals/OverlayTemplatesModal";
import LowerThirdTemplatesModal from "../../shared/modals/LowerThirdTemplatesModal";
import SocialMediaTemplatesModal from "../../shared/modals/SocialMediaTemplatesModal";
import QrCodeModal from "../../shared/modals/QrCodeModal";
import ReviewLayerModal from "../../shared/modals/ReviewLayerModal";
import { smiley } from "../../../config/icons";
import { settingAction } from "../../../store/setting-store";
// const ResponsiveReactGridLayout = WidthProvider(Responsive);
import ReactPlayer from 'react-player'
import UploadService from "../../../Services/FileUploadServices";
import WebFont from 'webfontloader';
import "../personalize.css";
import "../personalize2.css";
import "../custAnimate.scss";
import "../animate.styles.css";
import ReactTooltip from "react-tooltip";

const VideoActions = ({useVideoPlayer,videoUrl,videoDuration,playerStatus}) => {
  const { sendRequest: fetchDataRequest } = useHttp();

  const [showMeetingLink, setShowMeetingLink] = useState(false);
  const [showCTA, setShowCTA] = useState(false);
  const [showAnnotation, setShowAnnotation] = useState(false);
  const [showCopyPaste, setShowCopyPaste] = useState(false);
  const [showLeadGenForm, setShowLeadGenForm] = useState(false);
  const [showLeadGen2Form, setShowLeadGen2Form] = useState(false);
  const [showCustomPoll, setShowCustomPoll] = useState(false);
  const [showCustom2Poll, setShowCustom2Poll] = useState(false);
  const [showCustom3Poll, setShowCustom3Poll] = useState(false);

  const [showopentable1, setShowopentable1] = useState(false);
  const [showReview1, setShowReview1] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  const [isVisible3, setIsVisible3] = useState(false);

  const [isCTA_Visible, setIsCTA_Visible] = useState(false);
  const [isPoll_Visible, setIsPoll_Visible] = useState(false);
  const [isLeadForm_Visible, setIsLeadForm_Visible] = useState(false);
  const [isOverlay_Visible, setIsOverlay_Visible] = useState(false);
  const [isReview_Visible, setIsReview_Visible] = useState(false);
  const [isRsevation_Visible, setIsRsevation_Visible] = useState(false);
  const [isQrCode_Visible, setIsQrCode_Visible] = useState(false);
  const [isTimer_Visible, setIsTimer_Visible] = useState(false);  
  const [isMenu_Visible, setIsMenu_Visible] = useState(false);  

  const [ scriptCodeForm_Visible, setScriptCodeForm_Visible] = useState(false);


  const [showOverlay, setShowOverlay] = useState(false);
  const [showEffectControls,setShowEffectControls] = useState(false);
  const [showLowerThird, setShowLowerThird] = useState(false);
  const [showBuybutton, setShowBuybutton] = useState(false);
  const [showLinkbutton2, setShowLinkbutton2] = useState(false);
  const [showLinkbutton3, setShowLinkbutton3] = useState(false); 
  const [showLinkbutton4, setShowLinkbutton4] = useState(false); 
  const [showLinkbutton5, setShowLinkbutton5] = useState(false); 
  const [showLinkbutton6, setShowLinkbutton6] = useState(false); 
  const [showLinkbutton7, setShowLinkbutton7] = useState(false); 
  const [showLinkbutton8, setShowLinkbutton8] = useState(false); 
  const [showLinkbutton9, setShowLinkbutton9] = useState(false); 

  const [timeLeft1, setTimeLeft1] = useState({
    days: 0,
    mins: 0,
    hours: 0,
    sec: 0,
  });

  const [showImgbtn1, setShowImgbtn1] = useState(false);
  const [showImgbtn2, setShowImgbtn2] = useState(false);
  const [showImgbtn3, setShowImgbtn3] = useState(false);
  const [showImgbtn4, setShowImgbtn4] = useState(false);
  const [showImgbtn5, setShowImgbtn5] = useState(false);
  const [showImgbtn6, setShowImgbtn6] = useState(false);
  const [showImgbtn7, setShowImgbtn7] = useState(false);
  const [showImgbtn8, setShowImgbtn8] = useState(false);
  
  const [showTimingControl,setShowTimingControl] = useState(false);
  const [showActiveTrigger,setShowActiveTrigger] = useState("");
  const [isPlayInBetween,setIsPlayInBetween] = useState(false);

  const [showOverlayModal,setShowOverlayModal] = useState(false);
  const [showLowerThirdModal,setShowLowerThirdModal] = useState(false);
  const [showSocialMediaModal,  setShowSocialMediaModal ] = useState(false);
  const [showQrCodeModal,setShowQrCodeModal ] = useState(false);
  const [showReviewLayerModal,setShowReviewLayerModal ] = useState(false);
  const [showIcons,setShowIcons] = useState(false);
  const [activeElement,setActiveElelment] = useState("");

  const [isFontLoaded,setIsFontLoaded] = useState(false);

  const [errors, setErrors] = useState({});
  const { sendRequest: updatePersonalizeData } = useHttp();
  const { sendRequest: deletePersonalizeData } = useHttp();
  const { sendRequest: getConnetedResponderData } = useHttp();
  const { sendRequest: fetchResponderLists } = useHttp();

  const videoFrameRef = useRef(null);


  const timeRef = useRef(null);
  const annoStartTimeRef = useRef(null);
  const annoEndtimeRef = useRef(null);

  const buybtnStartTimeRef = useRef(null);
  const buybtnEndtimeRef = useRef(null);
  const linkbtn2StartTimeRef = useRef(null);
  const linkbtn2EndtimeRef = useRef(null);
  const linkbtn3StartTimeRef = useRef(null);
  const linkbtn3EndtimeRef = useRef(null);
  const linkbtn4StartTimeRef = useRef(null);
  const linkbtn4EndtimeRef = useRef(null);
  const linkbtn5StartTimeRef = useRef(null);
  const linkbtn5EndtimeRef = useRef(null);
  const linkbtn6StartTimeRef = useRef(null);
  const linkbtn6EndtimeRef = useRef(null);
  const linkbtn7StartTimeRef = useRef(null);
  const linkbtn7EndtimeRef = useRef(null);
  const linkbtn8StartTimeRef = useRef(null);
  const linkbtn8EndtimeRef = useRef(null);
  const linkbtn9StartTimeRef = useRef(null);
  const linkbtn9EndtimeRef = useRef(null);

  const Imgbtn1StartTimeRef = useRef(null);
  const Imgbtn1EndtimeRef = useRef(null);
  const Imgbtn2StartTimeRef = useRef(null);
  const Imgbtn2EndtimeRef = useRef(null);
  const Imgbtn3StartTimeRef = useRef(null);
  const Imgbtn3EndtimeRef = useRef(null);
  const Imgbtn4StartTimeRef = useRef(null);
  const Imgbtn4EndtimeRef = useRef(null);
  const Imgbtn5StartTimeRef = useRef(null);
  const Imgbtn5EndtimeRef = useRef(null);
  const Imgbtn6StartTimeRef = useRef(null);
  const Imgbtn6EndtimeRef = useRef(null);
  const Imgbtn7StartTimeRef = useRef(null);
  const Imgbtn7EndtimeRef = useRef(null);
  const Imgbtn8StartTimeRef = useRef(null);
  const Imgbtn8EndtimeRef = useRef(null);

  const CRMstartTimeRef = useRef(null);
  const CRMendtimeRef = useRef(null);
  const leadgenTimeRef = useRef(null); 
  const leadgen2TimeRef = useRef(null); 
  const pollTimeRef = useRef(null);
  const poll2TimeRef = useRef(null);
  const poll3TimeRef = useRef(null);

  const opentable1Ref = useRef(null);
  const review1StartTimeRef = useRef(null);
  const review1EndtimeRef = useRef(null);

  const startTimeRef = useRef(null)
  const endTimeRef = useRef(null)
  const setStartTimeRef = useRef(null)
  const setEndTimeRef = useRef(null)

  const dispatch = useDispatch();

  const videoLength = useSelector((state) => state.campaign.total_duration);
  const token = useSelector((state) => state.auth.token);

  const is_autoresponder_loaded = useSelector(
    (state) => state.settings.is_autoresponder_loaded
  );

  // const myAccess = useSelector((state) => state.auth.access);

  const autoresponder = useSelector((state) => state.settings.autoresponder)
  const [activeCampaignLists,setActiveCampaignLists] = useState({})
  // console.log(autoresponder)

  useEffect(() => {
    ReactTooltip.rebuild();
  });

  useEffect(() => {
    // console.log(is_autoresponder_loaded);
    if (!is_autoresponder_loaded) {
      getConnetedResponderData(
        {
          url: endPoints.fetchAllKeys,
          method: "GET",
        },
        (response) => {
          dispatch(
            settingAction.setAutoresponder({ autoresponder: response.body })
          );

          dispatch(settingAction.setAutoresponderStatus({ status: true }));
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [is_autoresponder_loaded]);

  const personalize_triggerTime = useSelector(
    (state) => state.personalize.personalize_triggerTime
  );

  // const personalize_page_load = useSelector(
  //     (state) => state.personalize.personalize_page_load
  // );

  const [triggerTime, setTriggerTime] = useState(personalize_triggerTime);

  const videoElement = useRef();

  const {
    // playerState,
    // togglePlay,
    // handleOnTimeUpdate,
    // handleVideoProgress,
    // handleVideoSpeed,
    // toggleMute,
    // handleAudioLevel,
    handleVideoLength
  } = useVideoPlayer(videoElement);

  const { camp_id } = useParams();

  const campaign_data = useSelector((state) => state.campaign.campaign_data);
  const overlayData = useSelector((state) => state.personalize.personalize_overlayTemplateData);

  const [ scriptCodeData, setScriptCodeData] = useState({
    script: "",
    scriptCodeStartTime: "00:01",
  });

  const [videoMeetingData, setVideoMeetingData] = useState({
    fullname: "John Smith",
    designation: "Senior Manager",
    buttontext: "Join Me",
    meetingLink: "https://calendly.me",
    buttonColor: "#00b2eb",
  });

  const [videoCTAData, setVideoCTAData] = useState({
    formtype: "text",
    text: "",
    image: "",
    link: "",
    actiontime: "00:00",
    ctaSkipCheck: true,
  });

  const [annotationData, setAnnotationData] = useState({
    annotationText: "Click on this link",
    annotationLink: "",
    annotationStartTime: "00:00",
    annotationEndTime: "00:00",
  });

  const [buybuttonData, setBuybuttonData] = useState({
    buybuttonText: "Free Software",
    buybuttonText2: "Our Website is under construction",
    buybuttonText3: "Download",
    buybuttonLink: "",
    buybuttonStartTime: "00:00",
    buybuttonEndTime: "00:00",
    xPosition: 0,
    yPosition: 0
  });

  const [ linkbtn2Data, setLinkbtn2Data] = useState({
    linkbtnText: "COMING SOON",
    linkbtnText2: "Our Website is under construction",
    linkbtnText3: "Get Updates",
    linkbtnLink: "",
    linkbtn2StartTime: "00:00",
    linkbtn2EndTime: "00:00",
    xPosition: 0,
    yPosition: 0
  });

  const [ linkbtn3Data, setLinkbtn3Data] = useState({
    linkbtnText: "GET FREE",
    linkbtnText2: "EBook Unlocked With Button",
    linkbtnText3: "Download",
    linkbtnLink: "",
    linkbtn3StartTime: "00:00",
    linkbtn3EndTime: "00:00",
    xPosition: 0,
    yPosition: 0
  });

  const [ linkbtn4Data, setLinkbtn4Data] = useState({
    linkbtnText: "FREE GIFT AVAILABLE",
    text1FontFamily: "Poppins",
    text1FontColor: "#ffffff",
    text1bold: false,
    text1Italic: false,
    linkbtnLink: "",
    linkbtn4StartTime: "00:00",
    linkbtn4EndTime: "00:00",
    xPosition: 0,
    yPosition: 0
  });  
  
  const [ linkbtn5Data, setLinkbtn5Data] = useState({
    linkbtnText: "ENGAGE WITH QUIZZES",
    linkbtnText2: "Looking for something new?",
    linkbtnText3: "GET STARTED",
    linkbtnLink: "",
    linkbtn5StartTime: "00:00",
    linkbtn5EndTime: "00:00",
    xPosition: 0,
    yPosition: 0
  });

  const [ linkbtn6Data, setLinkbtn6Data] = useState({
    linkbtnText: "COMING SOON",
    text1FontFamily: "Poppins",
    text1FontColor: "#ffffff",
    text1bold: true,
    text1Italic: false,
    linkbtnText2: "Reference site about Lorem Ipsum, giving information on its origins,",
    text2FontFamily: "Poppins",
    text2FontColor: "#ffffff",
    text2bold: false,
    text2Italic: false,
    TimerTime: "2024-06-25T00:00:00",
    text3FontFamily: "Poppins",
    text3FontColor: "#ffffff",
    text3bold: false,
    text3Italic: false,
    bgcolor:"#5918ff",
    linkbtn6StartTime: "00:00",
    linkbtn6EndTime: "00:00",
    xPosition: 0,
    yPosition: 0
  });

  const [ linkbtn7Data, setLinkbtn7Data] = useState({
    linkbtnText: "Read our 12,350 Google reviews",
    googleRating: 5,
    linkbtnLink: "",
    linkbtn6StartTime: "00:00",
    linkbtn6EndTime: "00:00",
    xPosition: 0,
    yPosition: 0
  });

  const [ linkbtn8Data, setLinkbtn8Data] = useState({
    linkbtnLink1: "https://facebook.com/",
    linkbtnLink2: "https://twitter.com/",
    linkbtnLink3: "https://instagram.com/",
    linkbtnLink4: "https://linkedin.com/",
    design: "design1",
    linkbtn8StartTime: "00:00",
    linkbtn8EndTime: "00:05",
    xPosition: 0,
    yPosition: 0
  });

  const [ linkbtn9Data, setLinkbtn9Data] = useState({
    linkbtnText: "SPECIAL OFFER",
    linkbtnText2: "VOUCHER SHOPPING",
    linkbtnText3: "75%",
    linkbtnText4: "1298383-E4839-34848",
    linkbtn9StartTime: "00:00",
    linkbtn9EndTime: "00:00",
    xPosition: 0,
    yPosition: 0,
    
    text1FontFamily: "Poppins",
    text1FontColor: "#222f7d",
    text1bold: true,
    text1Italic: false,
    text2FontFamily: "Poppins",
    text2FontColor: "#2994ff",
    text2bold: true,
    text2Italic: false,
    text3FontFamily: "Poppins",
    text3FontColor: "#ffffff",
    text3bold: false,
    text3Italic: false,
  });

  const [ Imgbtn1Data, setImgbtn1Data] = useState({
    ImgbtnText: "Scaling Your Site",
    ImgbtnText2: "Price: $56.00",
    ImgbtnText3: "Buy Now",
    ImgbtnText4: "Learn about hosting built for scale and reliability.",
    ImgbtnLink: "",
    ImgbtnURL: "https://d37q3r06begyqi.cloudfront.net/VidAmaze/users/1/images/site.jpg",
    Imgbtn1StartTime: "00:00",
    Imgbtn1EndTime: "00:00",
    xPosition: 0,
    yPosition: 0,
    
    text1FontFamily: "Poppins",
    text1FontColor: "#222f7d",
    text1bold: true,
    text1Italic: false,
    text2FontFamily: "Poppins",
    text2FontColor: "#2994ff",
    text2bold: true,
    text2Italic: false,
    text3FontFamily: "Poppins",
    text3FontColor: "#ffffff",
    text3bold: false,
    text3Italic: false,
    text4FontFamily: "Poppins",
    text4FontColor: "#222F7D",
    text4bold: false,
    text4Italic: false,
    
    buybuttonbgcolor:"#fa452d",
    bgcolor:"#ffffff",

  });

  const [ Imgbtn2Data, setImgbtn2Data] = useState({
    ImgbtnText: "SCAN QR CODE",
    ImgbtnText2: "Scan it to login to your dashboard ",
    ImgbtnURL: "https://d37q3r06begyqi.cloudfront.net/VidAmaze/users/1/uploads/hui9f3t1fkf.png",
    Imgbtn2StartTime: "00:00",
    Imgbtn2EndTime: "00:00",
    xPosition: 0,
    yPosition: 0,

    bgcolor: "#6d34ff",
    text1FontFamily: "Poppins",
    text1FontColor: "#ffffff",
    text1bold: true,
    text1Italic: false,
    text2FontFamily: "Poppins",
    text2FontColor: "#ffffff",
    text2bold: false,
    text2Italic: false,

  });

  const [ Imgbtn3Data, setImgbtn3Data] = useState({
    ImgbtnText: "Molecular Repair Hair Oil",
    ImgbtnText2: "Price: $8.69",
    ImgbtnLink: "",
    ImgbtnURL: "https://d37q3r06begyqi.cloudfront.net/VidAmaze/users/1/images/Molecular-Repair-Hair-Oil.png",
    Imgbtn3StartTime: "00:00",
    Imgbtn3EndTime: "00:00",
    xPosition: 0,
    yPosition: 0,

    text1FontFamily: "Poppins",
    text1FontColor: "#ffffff",
    text1bold: false,
    text1Italic: false,
    text2FontFamily: "Poppins",
    text2FontColor: "#ffffff",
    text2bold: true,
    text2Italic: true,
  });

  const [ Imgbtn4Data, setImgbtn4Data] = useState({
    ImgbtnText: "SCAN THE QR TO CONTINUE",
    ImgbtnURL: "https://d37q3r06begyqi.cloudfront.net/VidAmaze/users/1/uploads/hui9f3t1fkf.png",
    ImgbtnURL2: "https://d37q3r06begyqi.cloudfront.net/VidAmaze/users/1/images/Molecular-Repair-Hair-Oil.png",
    Imgbtn4StartTime: "00:00",
    Imgbtn4EndTime: "00:00",
    xPosition: 0,
    yPosition: 0,

    bgcolor: "#282a39",
    bgcolor2: "#0E1437",
    text1FontFamily: "Poppins",
    text1FontColor: "#99EEFF",
    text1bold: false,
    text1Italic: false,
  });

  const [ Imgbtn5Data, setImgbtn5Data] = useState({
    TimerTime: "2024-06-25T00:00:00",
    ImgbtnText: "Scaling Your Site",
    ImgbtnText2: "Price: $56.00",
    ImgbtnText3: "Buy Now",
    ImgbtnText4: "Learn about hosting built for scale and reliability.",
    ImgbtnLink: "",
    ImgbtnURL: "https://d37q3r06begyqi.cloudfront.net/VidAmaze/users/1/images/shoes.png",
    Imgbtn5StartTime: "00:00",
    Imgbtn5EndTime: "00:00",
    xPosition: 0,
    yPosition: 0,

    text1FontFamily: "Poppins",
    text1FontColor: "#222f7d",
    text1bold: true,
    text1Italic: false,
    text2FontFamily: "Poppins",
    text2FontColor: "#2994ff",
    text2bold: true,
    text2Italic: false,
    text3FontFamily: "Poppins",
    text3FontColor: "#ffffff",
    text3bold: false,
    text3Italic: false,
    text4FontFamily: "Poppins",
    text4FontColor: "#222F7D",
    text4bold: false,
    text4Italic: false,
    text5FontFamily: "Poppins",
    text5FontColor: "#222f7d",
    text5bold: false,
    text5Italic: false,
    timerbgcolor:"#FFE695",
    buybuttonbgcolor:"#fa452d",
    bgcolor:"#ffffff",
  });

  const [ Imgbtn6Data, setImgbtn6Data] = useState({
    ImgbtnText: "spicy fried fish",
    text1FontFamily: "Poppins",
    text1FontColor: "#0e1438",
    text1bold: true,
    text1Italic: false,
    ImgbtnText2: "salad, spicy, thai food single and for multiple",
    text2FontFamily: "Poppins",
    text2FontColor: "#7e85ab",
    text2bold: false,
    text2Italic: false,
    ImgbtnText3: "$8.6",
    text3FontFamily: "Poppins",
    text3FontColor: "#ffffff",
    text3bold: false,
    text3Italic: false,
    ImgbtnURL: "https://cdn.builder.io/api/v1/image/assets/TEMP/5fab9de7558ccae431ede5598ff3e99439da1f3c309d1a11bb5206c27807d8f5?apiKey=a520b1951fdc460185feff71c8ac30ff&width=100 100w",
    buttonColor: "#ff302f",
    bgColor: "#ffffff",
    ImgbtnLink: "",
    Imgbtn6StartTime: "00:00",
    Imgbtn6EndTime: "00:00",
    xPosition: 0,
    yPosition: 0
  });

  const [ Imgbtn7Data, setImgbtn7Data] = useState({
    ImgbtnText: "italian pizza",
    text1FontFamily: "Poppins",
    text1FontColor: "#ffffff",
    text1bold: true,
    text1Italic: false,
    ImgbtnText2: "$25.75",
    text2FontFamily: "Poppins",
    text2FontColor: "#ffffff",
    text2bold: false,
    text2Italic: false,
    ImgbtnLink: "",
    ImgbtnURL: "https://cdn.builder.io/api/v1/image/assets/TEMP/9423c4d2b3dcf46a90fbbbfcfd88c7f1d73fff19617ead31a2132ce9d60ac212?apiKey=a520b1951fdc460185feff71c8ac30ff&width=100 100w",
    Imgbtn7StartTime: "00:00",
    Imgbtn7EndTime: "00:00",
    xPosition: 0,
    yPosition: 0
  });

  const [ Imgbtn8Data, setImgbtn8Data] = useState({
    
    ImgbtnText: "Book training sessions",
    text1FontFamily: "Poppins",
    text1FontColor: "#222f7d",
    text1bold: true,
    text1Italic: false,
    ImgbtnText2: "BOOK NOW",
    text2FontFamily: "Poppins",
    text2FontColor: "#222f7d",
    text2bold: true,
    text2Italic: false,
    bgcolor1: "#6b71ff",
    bgcolor2: "#ffffff",
    bgcolor3: "#ffffff",
    ImgbtnLink: "",
    ImgbtnURL: "https://cdn.builder.io/api/v1/image/assets/TEMP/767d161f6eaf3cf52e7dfd279f225b9bd8ea202b7feeb771e1894b962d96544e?apiKey=a520b1951fdc460185feff71c8ac30ff&",
    Imgbtn8StartTime: "00:00",
    Imgbtn8EndTime: "00:00",
    xPosition: 0,
    yPosition: 0
  });

  const [copyPasteData, setCopyPasteData] = useState({
    CRMHtmlText: "",
    CRMskipCheck: true,
    bgCRMTheme: true,
    CRMstartTime: "00:00",
    // CRMendTime: "00:00"
  });

  const [leadgenFormData, setLeadgenFormData] = useState({
    askphonechk: false,
    askcompanychk: false,
    headline: "Enter the following details to continue playing",
    buttonname: "Play",
    buttonColor: "#ff3987",
    note: "Note",
    leadgenTime: "00:00",
    leadgenSkipCheck: true,
    responderType:"",
    param1:"",
    param2:"",
    param3:"",
  });

  const [leadgen2FormData, setLeadgen2FormData] = useState({
    headline: "ENGAGE WITH QUIZZES",
    buttonname: "GET STARTED",
    note: "Looking for something new?",
    termsText: "Agree To Our Terms & Conditions",
    termsURL: "",
    hideterms: false,
    leadgenTime: "00:00",
    leadgenSkipCheck: true,
    responderType:"",
    param1:"",
    param2:"",
    param3:"",

    text1FontFamily: "Poppins",
    text1FontColor: "#ffffff",
    text1bold: true,
    text1Italic: false,
    text2FontFamily: "Poppins",
    text2FontColor: "#ffffff",
    text2bold: false,
    text2Italic: false,
    text3FontFamily: "Poppins",
    text3FontColor: "#88BDD8",
    text3bold: false,
    text3Italic: false,
    text4FontFamily: "Poppins",
    text4FontColor: "#0E1437",
    text4bold: false,
    text4Italic: false,
    bgcolor1:"#23013E",
    bgcolor2:"#99EEFF",

  });

  const [custPollData, setCustPollData] = useState({
    question: "Your Question ?",
    option1: "Yes",
    option2: "No",
    option3: "",
    pollTime: "00:00",
    pollSkipChk: true,
  });

  const [cust2PollData, setCust2PollData] = useState({
    question: "Your Question ?",
    option1: "Option 1",
    option2: "Option 2",
    option3: "Option 3",
    option4: "Option 4",
    pollTime: "00:00",
    pollSkipChk: true,
    xPosition: 0,
    yPosition: 0
  });

  const [cust3PollData, setCust3PollData] = useState({
    question: "Your Questionc 3 ?",
    polldesc: "Head over to dashboard to get started",
    option1: "Option 1",
    option2: "Option 2",
    option3: "Option 3",
    option4: "Option 4",
    pollTime: "00:00",
    pollSkipChk: true,
    xPosition: 0,
    yPosition: 0
  });

  const [opentable1Data, setOpentable1Data] = useState({
    opentableText: "FIND YOUR DREAM HOME",
    opentableText2: "Head Over To Dashboard To Get Started",
    opentableText3: "LET'S GO",
    booktime: "00:00",
    pollSkipChk: true,
    xPosition: 0,
    yPosition: 0,

    text1FontFamily: "Poppins",
    text1FontColor: "#99EEFF",
    text1bold: true,
    text1Italic: false,
    text2FontFamily: "Poppins",
    text2FontColor: "#ffffff",
    text2bold: false,
    text2Italic: false,
    text3FontFamily: "Poppins",
    text3FontColor: "#0E1437",
    text3bold: false,
    text3Italic: false,
    bgcolor:"#0E1437",
    submitbgcolor:"#99EEFF",
  });

  const [review1Data, setReview1Data] = useState({
    auth_profile_url: '',
    author_name: '',
    time_description: '',
    rating: '',
    reviewText: '',
    auth_profile_url2: '',
    author_name2: '',
    time_description2: '',
    rating2: '',
    reviewText2: '',
    summery1: '',
    summery2: '',
    summery3: '',
    source: '',
    source_logo: '',
    review1StartTime: "00:00",
    review1EndTime: "00:05",
    xPosition: 0,
    yPosition: 0
  });

  const [width, setWidth] = useState(200);
  const [height, setHeight] = useState(100);

  const [showAnimation,setShowAnimation] = useState({
    name:null,
    text1:null,
    text2:null,
    startTime:"00:00",
    endTime:"00:00",
    xPosition:0,
    yPosition:0,
    text1FontSize:"",
    text2FontSize:"",
    text1FontFamily:"",
    text2FontFamily:"",
    text1FontColor:"",
    text2FontColor:"",
    text1BgColor:"",
    text2BgColor:"",
    width,
    height,
    bgTheme:"",
    nameAnim:null,
    textAnim1:null,
    textAnim2:null,
    simpleRevealShow:null,
    speechBubble:null,
    speechThought:null,
    speechBubble2:null,
    speechBubble3:null,
    borderAnim:null,
    borderAnim2:null,
    ltAnimation1:null,
    ltAnimation2:null,
    ltAnimation3:null,
    ltAnimation4:null,
    ltAnimation5:null,
    smiley:null,
    smileyContent:[],
    animationType:"",
    frameHeight: "",
    frameWidth: "",
  })

  const handleChange = (layer_name, index, color) => setShowAnimation({...showAnimation,bgTheme:color});

  var options = fonts

  const [actionPoint, setActionPoint] = useState([]);

  const [pageLoad, setPageLoad] = useState(false);

  const [ytPlayer,setYtPlayer] = useState({
    url: "",
    playing: false,
    volume: 0.8,
    muted: false,
    played: 0,
    loaded: 0,
    duration: 0,
    playedSeconds:0,
    start:"00:00",
    end: 5
  })

  // const createSliderWithTooltip = Slider.createSliderWithTooltip;
  // const RangeSlider = createSliderWithTooltip(Slider.Range);
  // const Range = createSliderWithTooltip(Slider);

  const ytPlayerRef = useRef(null);
  const [showPreviewElem,setShowPreviewElem] = useState(false)

  const style = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "dashed 2px #ddd",
    textAlign: "center"
    // background: "#f0f0f0"
  };

  // console.log(pageLoad);

  useEffect(() => {
    showMeetingLink &&
      dispatch(
        personalizeAction.setMeetingData({
          personalize_meetingData: videoMeetingData,
        })
      );
    showCTA &&
      dispatch(
        personalizeAction.setCTAData({ personalize_CTAData: videoCTAData })
      );
    showAnnotation &&
      dispatch(
        personalizeAction.setAnnotationData({
          personalize_AnnotationData: annotationData,
        })
      );
    showBuybutton &&
      dispatch(
        personalizeAction.setBuybuttonData({
          personalize_BuybuttonData: buybuttonData,
        })
      );
    showLinkbutton2 &&
      dispatch(
        personalizeAction.setLinkbtn2Data({
          personalize_linkbtn2Data: linkbtn2Data,
        })
      );
    showLinkbutton3 &&
      dispatch(
        personalizeAction.setLinkbtn3Data({
          personalize_linkbtn3Data: linkbtn3Data,
        })
      );
    showLinkbutton4 &&
      dispatch(
        personalizeAction.setLinkbtn4Data({
          personalize_linkbtn4Data: linkbtn4Data,
        })
      );
    showLinkbutton5 &&
      dispatch(
        personalizeAction.setLinkbtn5Data({
          personalize_linkbtn5Data: linkbtn5Data,
        })
      );
    showLinkbutton6 &&
        dispatch(
          personalizeAction.setLinkbtn6Data({
            personalize_linkbtn6Data: linkbtn6Data,
          })
        );
    showLinkbutton7 &&
        dispatch(
            personalizeAction.setLinkbtn7Data({
            personalize_linkbtn7Data: linkbtn7Data,
          })
        );
    showLinkbutton7 &&
        dispatch(
            personalizeAction.setLinkbtn7Data({
            personalize_linkbtn7Data: linkbtn7Data,
          })
        );
    showLinkbutton8 &&
        dispatch(
            personalizeAction.setLinkbtn8Data({
            personalize_linkbtn8Data: linkbtn8Data,
          })
        );
    showLinkbutton9 &&
        dispatch(
          personalizeAction.setLinkbtn9Data({
            personalize_linkbtn9Data: linkbtn9Data,
          })
        );
    showImgbtn1 &&
      dispatch(
        personalizeAction.setImgbtn1Data({
          personalize_Imgbtn1Data: Imgbtn1Data,
        })
      );
    showImgbtn2 &&
      dispatch(
        personalizeAction.setImgbtn2Data({
          personalize_Imgbtn2Data: Imgbtn2Data,
        })
      );
    showImgbtn3 &&
        dispatch(
          personalizeAction.setImgbtn3Data({
            personalize_Imgbtn3Data: Imgbtn3Data,
          })
        );
    showImgbtn4 &&
        dispatch(
          personalizeAction.setImgbtn4Data({
            personalize_Imgbtn4Data: Imgbtn4Data,
          })
        );
    showImgbtn5 &&
          dispatch(
            personalizeAction.setImgbtn5Data({
              personalize_Imgbtn5Data: Imgbtn5Data,
            })
        );
    showImgbtn6 &&
        dispatch(
          personalizeAction.setImgbtn6Data({
            personalize_Imgbtn6Data: Imgbtn6Data,
          })
      );
    showImgbtn7 &&
      dispatch(
        personalizeAction.setImgbtn7Data({
          personalize_Imgbtn7Data: Imgbtn7Data,
        })
    );
    showImgbtn8 &&
      dispatch(
        personalizeAction.setImgbtn8Data({
          personalize_Imgbtn8Data: Imgbtn8Data,
        })
    );
    showCopyPaste &&
      dispatch(
        personalizeAction.setCopyPasteData({
          personalize_copyPasteData: copyPasteData,
        })
      );
    scriptCodeForm_Visible &&
      dispatch(
        personalizeAction.setScript_Code({
          personalize_scriptCodeData: scriptCodeData,
        })
      );
    showLeadGenForm &&
      dispatch(
        personalizeAction.setLeadgenFormData({
          personalize_leadgenFormData: leadgenFormData,
        })
      );
    showLeadGen2Form &&
        dispatch(
          personalizeAction.setLeadgen2FormData({
            personalize_leadgen2FormData: leadgen2FormData,
          })
      );
    showCustomPoll &&
      dispatch(
        personalizeAction.setPollData({ personalize_pollData: custPollData })
      );
    showCustom2Poll &&
      dispatch(
        personalizeAction.setPoll2Data({ personalize_poll2Data: cust2PollData })
      );
    showCustom3Poll &&
      dispatch(
        personalizeAction.setPoll3Data({ personalize_poll3Data: cust3PollData })
      );
    
    showopentable1 &&
      dispatch(
        personalizeAction.setOpentable1Data({ personalize_opentable1Data: opentable1Data })
      );
    
    showReview1 &&
      dispatch(
        personalizeAction.setReview1Data({ personalize_review1Data: review1Data })
      );


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    videoMeetingData,
    videoCTAData,
    annotationData,
    buybuttonData,
    linkbtn2Data,
    linkbtn3Data,
    linkbtn4Data,
    linkbtn5Data,
    linkbtn6Data,
    linkbtn7Data,
    linkbtn8Data,
    linkbtn9Data,
    Imgbtn1Data,
    Imgbtn2Data,
    Imgbtn3Data,
    Imgbtn4Data,
    Imgbtn5Data,
    Imgbtn6Data,
    Imgbtn7Data,
    Imgbtn8Data,
    copyPasteData,
    scriptCodeData,
    leadgenFormData,
    leadgen2FormData,
    custPollData,
    cust2PollData,
    cust3PollData,
    opentable1Data,
    review1Data
  ]);

  useEffect(() => {
    console.log(videoDuration,videoLength,campaign_data.video_path)
    if(videoLength > 0){
      handleVideoLength({
        length:videoLength,
        start:videoDuration.start,
        end:videoDuration.end,
        status:playerStatus
      })

      setYtPlayer({
        ...ytPlayer,
        url:videoUrl
      })
      setPageLoad(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoLength,videoDuration,playerStatus]);

  useEffect(() => {
    // console.log(videoLength,pageLoad);
    if (!pageLoad && videoLength > 0) {
      // console.log(camp_id)
      fetchDataRequest(
        {
          url: endPoints.getPersonalize + "/" + camp_id,
          method: "GET",
        },
        responsePersonalizeHandle
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDataRequest, camp_id, videoLength]);

  useEffect(()=>{

    actionPoint.map((trigger)=>{
      // console.log(trigger.action_time)
      let duration = trigger.action_time.split(":")
      let sec = (parseInt(duration[0] * 60) + parseInt(duration[1]))
      // console.log(sec,(ytPlayer.duration * ytPlayer.played))
      if(Math.round(ytPlayer.duration * ytPlayer.played) === sec){
        let showTrigger = trigger.action_event;
        if(!showPreviewElem){
          showPreview(showTrigger)
          setShowActiveTrigger(showTrigger)
        }
      }else{
        setShowPreviewElem(false)
        // setShowActiveTrigger("")
        // hidePreview()
      }
      // console.log(sec)
      return true;
    })

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[ytPlayer.playedSeconds])




  useEffect(() => {

    const calculateTimeLeft = () => {
      let targetDate = "2024-01-05T00:00:00";//2023-12-25T00:00:00
      if(showLinkbutton6){
        targetDate = linkbtn6Data.TimerTime ;
      }else if(showImgbtn5){
        targetDate = Imgbtn5Data.TimerTime ;
      }

      console.log(targetDate)

      const difference = +new Date(targetDate) - +new Date();
      let timeLeftx = {};

      if (difference > 0) {
        timeLeftx = {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          mins: Math.floor((difference / 1000 / 60) % 60),
          sec: Math.floor((difference / 1000) % 60),
        };
      }else{
        timeLeftx = {
          days: 0,
          mins: 0,
          hours: 0,
          sec: 0,
        };
      }

      return timeLeftx;
    };
    
    if (showLinkbutton6 || showImgbtn5) {
      const timer = setInterval(() => {
        setTimeLeft1(calculateTimeLeft());
      }, 1000);
  
      return () => clearInterval(timer);
    }


  }, [showLinkbutton6,linkbtn6Data.TimerTime,showImgbtn5,Imgbtn5Data.TimerTime]);


    

  const inputFileRef = useRef(null);
  const inputFileRef2 = useRef(null);
  const inputFileRef3 = useRef(null);
  const inputFileRef4 = useRef(null);
  const inputFileRef5 = useRef(null);
  const inputFileRef6 = useRef(null);
  const inputFileRef7 = useRef(null);

  const addImage = ( ref ) => {
    ref.current.click();
  };

  const onFileChange = (e, num) => {
    let currentFiles = e.target.files;

    // console.log(currentFiles)
    // console.log(num)

    if (checkMimeType(e) && checkFileSize(e)) {
      
      UploadService.upload(currentFiles[0], token, (event) => {
        console.log(Math.round((100 * event.loaded) / event.total));
      }).then((response) => {
          // console.log(response.status);

          const imgLink = response.data.url;
          if (response.status === 200) {
            
            if (num === 1) {
              setImgbtn1Data({
                ...Imgbtn1Data,
                ImgbtnURL: imgLink,
              })
            }else if (num === 2) {
              setImgbtn3Data({
                ...Imgbtn3Data,
                ImgbtnURL: imgLink,
              })
            }else if (num === 3) {
              setImgbtn5Data({
                ...Imgbtn5Data,
                ImgbtnURL: imgLink,
              })
            }else if (num === 4) {
              setImgbtn6Data({
                ...Imgbtn6Data,
                ImgbtnURL: imgLink,
              })
            }else if (num === 5) {
              setImgbtn7Data({
                ...Imgbtn7Data,
                ImgbtnURL: imgLink,
              })
            }else if (num === 6) {
              setImgbtn4Data({
                ...Imgbtn4Data,
                ImgbtnURL2: imgLink,
              })
            }else if (num === 7) {
              setImgbtn8Data({
                ...Imgbtn8Data,
                ImgbtnURL: imgLink,
              })
            }
            
          }

          // e.target.value = "";
        })
        .catch((err) => {
           console.log(err);
        });
      
      // console.log(currentFileData);
    }
  };

  const showPreview = (trigger) => {
    // console.log(trigger)
      setShowMeetingLink(false);
      setShowCTA(false);
      setShowAnnotation(false);
      setShowBuybutton(false);
      setShowLinkbutton2(false);
      setShowLinkbutton3(false);
      setShowLinkbutton4(false);
      setShowLinkbutton5(false);
      setShowLinkbutton6(false);
      setShowLinkbutton7(false);
      setShowLinkbutton8(false);
      setShowLinkbutton9(false);
      setShowImgbtn1(false);
      setShowImgbtn2(false);
      setShowImgbtn3(false);
      setShowImgbtn4(false);
      setShowImgbtn5(false);
      setShowImgbtn6(false);
      setShowImgbtn7(false);
      setShowImgbtn8(false);
      setShowCopyPaste(false);
      setScriptCodeForm_Visible(false) 
      setShowLeadGenForm(false);
      setShowLeadGen2Form(false);
      setShowCustomPoll(false);
      setShowCustom2Poll(false);
      setShowCustom3Poll(false);
      setShowopentable1(false);
      setShowReview1(false);
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(false)
      setShowTimingControl(false)
      setShowActiveTrigger(trigger)
  
      if(trigger === "video_meeting"){
        setShowMeetingLink(true);
      }

      if(trigger === "video_cta"){
        setShowCTA(true) 
      }

      if(trigger === "video_annotation"){
        setShowAnnotation(true)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(annotationData.annotationStartTime),
          end:getSeconds(annotationData.annotationEndTime)
        })
      }

      if(trigger === "video_copypaste"){
        setShowCopyPaste(true) 
      }

      if(trigger === "scriptCode"){
        setScriptCodeForm_Visible(true) 
      }

      if(trigger === "video_leadgen"){
        setShowLeadGenForm(true)
      }

      if(trigger === "video_leadgen2"){
        setShowLeadGen2Form(true)
      }

      if(trigger === "video_custPoll"){
        setShowCustomPoll(true)
      }

      if(trigger === "video_cust2Poll"){
        setShowCustom2Poll(true)
      }

      if(trigger === "video_cust3Poll"){
        setShowCustom3Poll(true)
      }

      if(trigger === "video_opentable1"){
        setShowopentable1(true)
      }

      if(trigger === "video_review1"){
        setShowReview1(true)
        setShowTimingControl(false)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(review1Data.review1StartTime),
          end:getSeconds(review1Data.review1EndTime)
        })
      }

      if(trigger === "buy_button"){
        setShowBuybutton(true)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(buybuttonData.buybuttonStartTime),
          end:getSeconds(buybuttonData.buybuttonEndTime)
        })
      }

      if(trigger === "link_button2"){
        setShowLinkbutton2(true)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(linkbtn2Data.linkbtn2StartTime),
          end:getSeconds(linkbtn2Data.linkbtn2EndTime)
        })
      }

      if(trigger === "link_button3"){
        setShowLinkbutton3(true)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(linkbtn3Data.linkbtn3StartTime),
          end:getSeconds(linkbtn3Data.linkbtn3EndTime)
        })
      }

      if(trigger === "link_button4"){
        setShowLinkbutton4(true)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(linkbtn4Data.linkbtn4StartTime),
          end:getSeconds(linkbtn4Data.linkbtn4EndTime)
        })
      }

      if(trigger === "link_button5"){
        setShowLinkbutton5(true)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(linkbtn5Data.linkbtn5StartTime),
          end:getSeconds(linkbtn5Data.linkbtn5EndTime)
        })
      }

      if(trigger === "link_button6"){
        setShowLinkbutton6(true)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(linkbtn6Data.linkbtn6StartTime),
          end:getSeconds(linkbtn6Data.linkbtn6EndTime)
        })
      }

      if(trigger === "link_button7"){
        setShowLinkbutton7(true)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(linkbtn7Data.linkbtn7StartTime),
          end:getSeconds(linkbtn7Data.linkbtn7EndTime)
        })
      }
      
      if(trigger === "link_button8"){
        setShowLinkbutton8(true)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(linkbtn8Data.linkbtn8StartTime),
          end:getSeconds(linkbtn8Data.linkbtn8EndTime)
        })
      }
      if(trigger === "link_button9"){
        setShowLinkbutton9(true)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(linkbtn9Data.linkbtn9StartTime),
          end:getSeconds(linkbtn9Data.linkbtn9EndTime)
        })
      }

      if(trigger === "Img_btn1"){
        setShowImgbtn1(true)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(Imgbtn1Data.Imgbtn1StartTime),
          end:getSeconds(Imgbtn1Data.Imgbtn1EndTime)
        })
      }

      if(trigger === "Img_btn2"){
        setShowImgbtn2(true)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(Imgbtn2Data.Imgbtn2StartTime),
          end:getSeconds(Imgbtn2Data.Imgbtn2EndTime)
        })
      }

      if(trigger === "Img_btn3"){
        setShowImgbtn3(true)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(Imgbtn3Data.Imgbtn3StartTime),
          end:getSeconds(Imgbtn3Data.Imgbtn3EndTime)
        })
      }

      if(trigger === "Img_btn4"){
        setShowImgbtn4(true)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(Imgbtn4Data.Imgbtn4StartTime),
          end:getSeconds(Imgbtn4Data.Imgbtn4EndTime)
        })
      }

      if(trigger === "Img_btn5"){
        setShowImgbtn5(true)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(Imgbtn5Data.Imgbtn5StartTime),
          end:getSeconds(Imgbtn5Data.Imgbtn5EndTime)
        })
      }

      if(trigger === "Img_btn6"){
        setShowImgbtn6(true)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(Imgbtn6Data.Imgbtn6StartTime),
          end:getSeconds(Imgbtn6Data.Imgbtn6EndTime)
        })
      }

      if(trigger === "Img_btn7"){
        setShowImgbtn7(true)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(Imgbtn7Data.Imgbtn7StartTime),
          end:getSeconds(Imgbtn7Data.Imgbtn7EndTime)
        })
      }
      if(trigger === "Img_btn8"){
        setShowImgbtn8(true)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(Imgbtn8Data.Imgbtn8StartTime),
          end:getSeconds(Imgbtn8Data.Imgbtn8EndTime)
        })
      }

      if(trigger === "simple_reveal"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        let revealData = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Simple Reveal Text",
          text1:revealData[0].text1,
          text2:revealData[0].text2,
          simpleRevealShow:revealData[0].simpleRevealShow,
          startTime: revealData[0].startTime,
          endTime : revealData[0].endTime,
          xPosition : revealData[0].xPosition,
          yPosition : revealData[0].yPosition,
          text1FontFamily:revealData[0].text1FontFamily,
          text1FontSize:revealData[0].text1FontSize,
          text1FontColor:revealData[0].text1FontColor,
          text1BgColor:revealData[0].text1BgColor,
          text2FontFamily:revealData[0].text2FontFamily,
          text2FontSize:revealData[0].text2FontSize,
          text2FontColor:revealData[0].text2FontColor,
          text2BgColor:revealData[0].text2BgColor,
          width:revealData[0].width,
          height:revealData[0].height,
          bgTheme:revealData[0].bgTheme,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          speechBubble:false,
          speechBubble2:false,
          speechBubble3:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation1:false,
          ltAnimation3:false,
          ltAnimation2:false,
          ltAnimation4:false,
          ltAnimation5:false,
          smiley:false
        })

        setWidth(revealData[0].width)
        setHeight(revealData[0].height)
        setShowTimingControl(true) 
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(revealData[0].startTime),
          end:getSeconds(revealData[0].endTime)
        })
      }

      if(trigger === "speech_bubble"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        // console.log(overlayData)
        let data = overlayData.filter((item)=>item.type === trigger)
        // console.log(data)
        setShowAnimation({
          ...showAnimation,
          name:"Speech Bubble",
          text1:data[0].text1,
          speechBubble:data[0].speechBubble,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          text1BgColor:data[0].text1BgColor,
          width:data[0].width,
          height:data[0].height,
          bgTheme:data[0].bgTheme,
          simpleRevealShow:false,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          speechBubble2:false,
          speechBubble3:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation1:false,
          ltAnimation3:false,
          ltAnimation2:false,
          ltAnimation4:false,
          ltAnimation5:false,
          smiley:false
        })

        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(data[0].startTime),
          end:getSeconds(data[0].endTime)
        })

        setWidth(data[0].width)
        setHeight(data[0].height)
        setShowTimingControl(true)
        
      }

      if(trigger === "speech_bubble_2"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        let data = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Speech Bubble",
          text1:data[0].text1,
          text2:data[0].text2,
          speechBubble2:data[0].speechBubble2,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          text2FontFamily:data[0].text2FontFamily,
          text2FontSize:data[0].text2FontSize,
          text2FontColor:data[0].text2FontColor,
          text1BgColor:data[0].text1BgColor,
          width:data[0].width,
          height:data[0].height,
          bgTheme:data[0].bgTheme,
          simpleRevealShow:false,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          speechBubble:false,
          speechBubble3:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation1:false,
          ltAnimation3:false,
          ltAnimation2:false,
          ltAnimation4:false,
          ltAnimation5:false,
          smiley:false
        })

        setWidth(data[0].width)
        setHeight(data[0].height)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(data[0].startTime),
          end:getSeconds(data[0].endTime)
        })
      }

      if(trigger === "speech_bubble_3"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        let data = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Speech Bubble",
          text1:data[0].text1,
          speechBubble3:data[0].speechBubble3,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          text1BgColor:data[0].text1BgColor,
          width:data[0].width,
          height:data[0].height,
          bgTheme:data[0].bgTheme,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation1:false,
          ltAnimation3:false,
          ltAnimation2:false,
          ltAnimation4:false,
          ltAnimation5:false,
          smiley:false
        })

        setWidth(data[0].width)
        setHeight(data[0].height)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(data[0].startTime),
          end:getSeconds(data[0].endTime)
        })
      }
      // console.log(overlayData)

      if(trigger === "speech_thought"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        console.log(overlayData)
        let data = overlayData.filter((item)=>item.type === trigger)
        console.log(data)
        setShowAnimation({
          ...showAnimation,
          name:"Speech Thought",
          text1:data[0].text1,
          speechThought:data[0].speechThought,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          text1BgColor:data[0].text1BgColor,
          width:data[0].width,
          height:data[0].height,
          bgTheme:data[0].bgTheme,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation1:false,
          ltAnimation3:false,
          ltAnimation2:false,
          ltAnimation4:false,
          ltAnimation5:false,
          smiley:false
        })

        setWidth(data[0].width)
        setHeight(data[0].height)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(data[0].startTime),
          end:getSeconds(data[0].endTime)
        })
      }

      if(trigger === "border_animation"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        let data = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Border Animation",
          text1:data[0].text1,
          borderAnim:data[0].borderAnim,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          text1BgColor:data[0].text1BgColor,
          text2BgColor:data[0].text2BgColor,
          width:data[0].width,
          height:data[0].height,
          bgTheme:data[0].bgTheme,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim2:false,
          ltAnimation1:false,
          ltAnimation3:false,
          ltAnimation2:false,
          ltAnimation4:false,
          ltAnimation5:false,
          smiley:false
        })

        setWidth(data[0].width)
        setHeight(data[0].height)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(data[0].startTime),
          end:getSeconds(data[0].endTime)
        })
      }

      if(trigger === "border_animation_2"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        let data = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Border Animation",
          text1:data[0].text1,
          borderAnim2:data[0].borderAnim2,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          text1BgColor:data[0].text1BgColor,
          width:data[0].width,
          height:data[0].height,
          bgTheme:data[0].bgTheme,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          ltAnimation1:false,
          ltAnimation3:false,
          ltAnimation2:false,
          ltAnimation4:false,
          ltAnimation5:false,
          smiley:false
        })
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(data[0].startTime),
          end:getSeconds(data[0].endTime)
        })
      }

      if(trigger === "lt_animation_1"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        let data = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Lower Third Animation",
          text1:data[0].text1,
          text2:data[0].text2,
          ltAnimation1:data[0].ltAnimation1,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          text2FontFamily:data[0].text2FontFamily,
          text2FontSize:data[0].text2FontSize,
          text2FontColor:data[0].text2FontColor,
          bgTheme:data[0].bgTheme,
          text2BgColor:data[0].text2BgColor,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation3:false,
          ltAnimation2:false,
          ltAnimation4:false,
          ltAnimation5:false,
          smiley:false
        })
        
      }

      if(trigger === "lt_animation_2"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        let data = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Lower Third Animation",
          text1:data[0].text1,
          text2:data[0].text2,
          ltAnimation2:data[0].ltAnimation2,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          text2FontFamily:data[0].text2FontFamily,
          text2FontSize:data[0].text2FontSize,
          text2FontColor:data[0].text2FontColor,
          bgTheme:data[0].bgTheme,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation3:false,
          ltAnimation1:false,
          ltAnimation4:false,
          ltAnimation5:false,
          smiley:false
        })
        
      }

      if(trigger === "lt_animation_3"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        let data = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Lower Third Animation",
          text1:data[0].text1,
          text2:data[0].text2,
          ltAnimation3:data[0].ltAnimation3,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          text2FontFamily:data[0].text2FontFamily,
          text2FontSize:data[0].text2FontSize,
          text2FontColor:data[0].text2FontColor,
          bgTheme:data[0].bgTheme,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation2:false,
          ltAnimation1:false,
          ltAnimation4:false,
          ltAnimation5:false,
          smiley:false
        })
        
      }

      if(trigger === "lt_animation_4"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        let data = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Lower Third Animation",
          text1:data[0].text1,
          ltAnimation4:data[0].ltAnimation4,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          bgTheme:data[0].bgTheme,
          text2BgColor:data[0].text2BgColor,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation2:false,
          ltAnimation1:false,
          ltAnimation3:false,
          ltAnimation5:false,
          smiley:false
        })
        
      }

      if(trigger === "lt_animation_5"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        // setShowIcons(false);
        setShowEffectControls(true)
        let data = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Lower Third Animation",
          text1:data[0].text1,
          text2:data[0].text2,
          ltAnimation5:data[0].ltAnimation5,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          text2FontFamily:data[0].text2FontFamily,
          text2FontSize:data[0].text2FontSize,
          text2FontColor:data[0].text2FontColor,
          text2BgColor:data[0].text2BgColor,
          bgTheme:data[0].bgTheme,
          nameAnim:false,
          textAnim1:false,
          textAnim2:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation2:false,
          ltAnimation1:false,
          ltAnimation4:false,
          ltAnimation3:false,
          smiley:false
        })
        
      }

      if(trigger === "name_animation"){ 
        // setShowOverlay(false)
        // setShowLowerThird(false)
        setShowEffectControls(true)
        // setShowIcons(false);
        // console.log(overlayData)
        let data = overlayData.filter((item)=>item.type === trigger)
        console.log(data)
        setShowAnimation({
          ...showAnimation,
          name:"Text Overlay",
          text1:data[0].text1,
          nameAnim:data[0].nameAnim,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          width:data[0].width,
          height:data[0].height,
          textAnim1:false,
          textAnim2:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation2:false,
          ltAnimation1:false,
          ltAnimation4:false,
          ltAnimation3:false,
          ltAnimation5:false,
          smiley:false
        })

        setWidth(data[0].width)
        setHeight(data[0].height)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(data[0].startTime),
          end:getSeconds(data[0].endTime)
        })
      }

      if(trigger === "text_animation_1"){ 
        // setShowOverlay(false)
        // setShowLowerThird(false)
        setShowEffectControls(true)
        // setShowIcons(false);
        // console.log(overlayData)
        let data = overlayData.filter((item)=>item.type === trigger)
        console.log(data)
        setShowAnimation({
          ...showAnimation,
          name:"Simple Text Animation",
          text1:data[0].text1,
          textAnim1:data[0].textAnim1,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          width:data[0].width,
          height:data[0].height,
          nameAnim : false,
          textAnim2 : false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation2:false,
          ltAnimation1:false,
          ltAnimation4:false,
          ltAnimation3:false,
          ltAnimation5:false,
          smiley:false
        })

        setWidth(data[0].width)
        setHeight(data[0].height)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(data[0].startTime),
          end:getSeconds(data[0].endTime)
        })
      }

      if(trigger === "text_animation_2"){ 
        // setShowOverlay(false)
        // setShowLowerThird(false)
        setShowEffectControls(true)
        // setShowIcons(false);
        // console.log(overlayData)
        let data = overlayData.filter((item)=>item.type === trigger)
        // console.log(data)
        setShowAnimation({
          ...showAnimation,
          name:"Simple Text Animation",
          text1:data[0].text1,
          textAnim2:data[0].textAnim2,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          text1FontFamily:data[0].text1FontFamily,
          text1FontSize:data[0].text1FontSize,
          text1FontColor:data[0].text1FontColor,
          width:data[0].width,
          height:data[0].height,
          nameAnim : false,
          textAnim1 : false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation2:false,
          ltAnimation1:false,
          ltAnimation4:false,
          ltAnimation3:false,
          ltAnimation5:false,
          smiley:false
        })

        setWidth(data[0].width)
        setHeight(data[0].height)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(data[0].startTime),
          end:getSeconds(data[0].endTime)
        })
      }

      if(trigger === "emoji_content"){
        // setShowOverlay(false)
        // setShowLowerThird(false)
        setShowEffectControls(true)
        setShowIcons(true);
        let data = overlayData.filter((item)=>item.type === trigger)
        setShowAnimation({
          ...showAnimation,
          name:"Smiley",
          text1:data[0].text1,
          smiley:data[0].smiley,
          startTime: data[0].startTime,
          endTime : data[0].endTime,
          xPosition : data[0].xPosition,
          yPosition : data[0].yPosition,
          width:data[0].width,
          height:data[0].height,
          smileyContent:data[0].smileyContent,
          nameAnim:false,
          simpleRevealShow:false,
          speechBubble2:false,
          speechBubble3:false,
          speechBubble:false,
          speechThought:false,
          borderAnim:false,
          borderAnim2:false,
          ltAnimation2:false,
          ltAnimation1:false,
          ltAnimation4:false,
          ltAnimation3:false,
          ltAnimation5:false,
        })

        setWidth(data[0].width)
        setHeight(data[0].height)
        setShowTimingControl(true)
        setYtPlayer({
          ...ytPlayer,
          start:getSeconds(data[0].startTime),
          end:getSeconds(data[0].endTime)
        })
        
      }
      setYtPlayer({...ytPlayer,playing:false})
    
  }

  const responsePersonalizeHandle = (response) => {
    // console.log('here',response)
    // console.log(videoLength,'here')
    if (response.body) {
      // console.log(response.body,'outputData')
      dispatch(personalizeAction.resetState());
      const data = response.body;
      const meetingData = data.filter(
        (item) => item.meta_type === "video_meeting"
      );
      const ctaData = data.filter((item) => item.meta_type === "video_cta");
      const annotationData = data.filter(
        (item) => item.meta_type === "video_annotation"
      );
      const buybuttonData = data.filter(
        (item) => item.meta_type === "buy_button"
      );
      const linkbtn2Data = data.filter(
        (item) => item.meta_type === "link_button2"
      );
      const linkbtn3Data = data.filter(
        (item) => item.meta_type === "link_button3"
      );
      const linkbtn4Data = data.filter(
        (item) => item.meta_type === "link_button4"
      );
      const linkbtn5Data = data.filter(
        (item) => item.meta_type === "link_button5"
      );
      const linkbtn6Data = data.filter(
        (item) => item.meta_type === "link_button6"
      );
      const linkbtn7Data = data.filter(
        (item) => item.meta_type === "link_button7"
      );
      const linkbtn8Data = data.filter(
        (item) => item.meta_type === "link_button8"
      );
      const linkbtn9Data = data.filter(
        (item) => item.meta_type === "link_button9"
      );
      const review1Data = data.filter(
        (item) => item.meta_type === "video_review1"
      )
      const Imgbtn1Data = data.filter(
        (item) => item.meta_type === "Img_btn1"
      );
      const Imgbtn2Data = data.filter(
        (item) => item.meta_type === "Img_btn2"
      );
      const Imgbtn3Data = data.filter(
        (item) => item.meta_type === "Img_btn3"
      );
      const Imgbtn4Data = data.filter(
        (item) => item.meta_type === "Img_btn4"
      );
      const Imgbtn5Data = data.filter(
        (item) => item.meta_type === "Img_btn5"
      );
      const Imgbtn6Data = data.filter(
        (item) => item.meta_type === "Img_btn6"
      );
      const Imgbtn7Data = data.filter(
        (item) => item.meta_type === "Img_btn7"
      );
      const Imgbtn8Data = data.filter(
        (item) => item.meta_type === "Img_btn8"
      );
      const copypasteData = data.filter(
        (item) => item.meta_type === "video_copypaste"
      );
      const scriptCodeData = data.filter(
        (item) => item.meta_type === "scriptCode"
      );
      const leadgenData = data.filter(
        (item) => item.meta_type === "video_leadgen"
      );
      const leadgen2Data = data.filter(
        (item) => item.meta_type === "video_leadgen2"
      );
      const custPollData = data.filter(
        (item) => item.meta_type === "video_custPoll"
      );
      const cust2PollData = data.filter(
        (item) => item.meta_type === "video_cust2Poll"
      );
      const cust3PollData = data.filter(
        (item) => item.meta_type === "video_cust3Poll"
      );
      const opentable1Data = data.filter(
        (item) => item.meta_type === "video_opentable1"
      );
      const brandingData = data.filter(
        (item) => item.meta_type === "video_branding"
      );
      const privacyData = data.filter(
        (item) => item.meta_type === "video_privacy"
      );

      const simpleRevealData = data.filter((item)=>item.meta_type === 'simple_reveal')
      const speechBubbleData = data.filter((item)=>item.meta_type === 'speech_bubble')
      const speechThoughtData = data.filter((item)=>item.meta_type === 'speech_thought')
      const speechBubble2Data = data.filter((item)=>item.meta_type === 'speech_bubble_2')
      const speechBubble3Data = data.filter((item)=>item.meta_type === 'speech_bubble_3')
      const speechBubble4Data = data.filter((item)=>item.meta_type === 'speech_bubble_4')
      const borderAnimationData = data.filter((item)=>item.meta_type === 'border_animation')
      const borderAnimation2Data = data.filter((item)=>item.meta_type === 'border_animation_2')
      const ltAnimation1Data = data.filter((item)=>item.meta_type === 'lt_animation_1')
      const ltAnimation2Data = data.filter((item)=>item.meta_type === 'lt_animation_2')
      const ltAnimation3Data = data.filter((item)=>item.meta_type === 'lt_animation_3')
      const ltAnimation4Data = data.filter((item)=>item.meta_type === 'lt_animation_4')
      const ltAnimation5Data = data.filter((item)=>item.meta_type === 'lt_animation_5')
      const nameAnimData = data.filter((item)=>item.meta_type === 'name_animation')
      const textAnim1Data = data.filter((item)=>item.meta_type === 'text_animation_1')
      const textAnim2Data = data.filter((item)=>item.meta_type === 'text_animation_2')
      const emojiContentData = data.filter((item)=>item.meta_type === 'emoji_content')

      // console.log(emojiContentData)

      let actionPointArr = [];
      var overlayArr = [];

      if (meetingData.length > 0) {
        let mins = Math.floor(videoLength / 60);
        let meetingDuration =
          (mins < 10 ? `0${mins}` : mins) +
          ":" +
          ("0" + Math.floor(videoLength % 60)).slice(-2);
        dispatch(
          personalizeAction.setMeetingData({
            personalize_meetingData: JSON.parse(meetingData[0].meta_data),
          })
        );
        setVideoMeetingData(JSON.parse(meetingData[0].meta_data));
        actionPointArr.push({
          action_event: "video_meeting",
          action_time: meetingDuration,
          id:meetingData[0].id
        });
        setTriggerTime([...triggerTime, meetingDuration]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: meetingDuration,
          })
        );
      }

      if (ctaData && ctaData.length > 0) {
        let actionTime = JSON.parse(ctaData[0].meta_data).actiontime;
        dispatch(
          personalizeAction.setCTAData({
            personalize_CTAData: JSON.parse(ctaData[0].meta_data),
          })
        );
        setTriggerTime([...triggerTime, actionTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: actionTime,
          })
        );
        setVideoCTAData(JSON.parse(ctaData[0].meta_data));
        actionPointArr.push({
          action_event: "video_cta",
          action_time: actionTime,
          id:ctaData[0].id
        });
      }

      if (annotationData.length > 0) {
        let getAnnotationData = JSON.parse(annotationData[0].meta_data);
        dispatch(
          personalizeAction.setAnnotationData({
            personalize_AnnotationData: getAnnotationData,
          })
        );
        setAnnotationData(getAnnotationData);
        actionPointArr.push({
          action_event: "video_annotation",
          action_time: getAnnotationData.annotationStartTime,
          action_end_time:getAnnotationData.annotationEndTime,
          id:annotationData[0].id
        });
        setTriggerTime([...triggerTime, getAnnotationData.annotationStartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getAnnotationData.annotationStartTime,
          })
        );
      }

      if (buybuttonData.length > 0) {
        let getbuybuttonData = JSON.parse(buybuttonData[0].meta_data);
        dispatch(
          personalizeAction.setBuybuttonData({
            personalize_BuybuttonData: getbuybuttonData,
          })
        );
        setBuybuttonData(getbuybuttonData);
        actionPointArr.push({
          action_event: "buy_button",
          action_time: getbuybuttonData.buybuttonStartTime,
          action_end_time:getbuybuttonData.buybuttonEndTime,
          id:buybuttonData[0].id
        });
        setTriggerTime([...triggerTime, getbuybuttonData.buybuttonStartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getbuybuttonData.buybuttonStartTime,
          })
        );
      }

      if (linkbtn2Data.length > 0) {
        let getlinkbtn2Data = JSON.parse(linkbtn2Data[0].meta_data);
        dispatch(
          personalizeAction.setLinkbtn2Data({
            personalize_linkbtn2Data: getlinkbtn2Data,
          })
        );
        setLinkbtn2Data(getlinkbtn2Data);
        actionPointArr.push({
          action_event: "link_button2",
          action_time: getlinkbtn2Data.linkbtn2StartTime,
          action_end_time:getlinkbtn2Data.linkbtn2EndTime,
          id:linkbtn2Data[0].id
        });
        setTriggerTime([...triggerTime, getlinkbtn2Data.linkbtn2StartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getlinkbtn2Data.linkbtn2StartTime,
          })
        );
      }

      if (linkbtn3Data.length > 0) {
        let getlinkbtn3Data = JSON.parse(linkbtn3Data[0].meta_data);
        dispatch(
          personalizeAction.setLinkbtn3Data({
            personalize_linkbtn3Data: getlinkbtn3Data,
          })
        );
        setLinkbtn3Data(getlinkbtn3Data);
        actionPointArr.push({
          action_event: "link_button3",
          action_time: getlinkbtn3Data.linkbtn3StartTime,
          action_end_time:getlinkbtn3Data.linkbtn3EndTime,
          id:linkbtn3Data[0].id
        });
        setTriggerTime([...triggerTime, getlinkbtn3Data.linkbtn3StartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getlinkbtn3Data.linkbtn3StartTime,
          })
        );
      }

      if (linkbtn4Data.length > 0) {
        let getlinkbtn4Data = JSON.parse(linkbtn4Data[0].meta_data);
        dispatch(
          personalizeAction.setLinkbtn4Data({
            personalize_linkbtn4Data: getlinkbtn4Data,
          })
        );
        setLinkbtn4Data(getlinkbtn4Data);
        actionPointArr.push({
          action_event: "link_button4",
          action_time: getlinkbtn4Data.linkbtn4StartTime,
          action_end_time:getlinkbtn4Data.linkbtn4EndTime,
          id:linkbtn4Data[0].id
        });
        setTriggerTime([...triggerTime, getlinkbtn4Data.linkbtn4StartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getlinkbtn4Data.linkbtn4StartTime,
          })
        );
      }

      if (linkbtn5Data.length > 0) {
        let getlinkbtn5Data = JSON.parse(linkbtn5Data[0].meta_data);
        dispatch(
          personalizeAction.setLinkbtn5Data({
            personalize_linkbtn5Data: getlinkbtn5Data,
          })
        );
        setLinkbtn5Data(getlinkbtn5Data);
        actionPointArr.push({
          action_event: "link_button5",
          action_time: getlinkbtn5Data.linkbtn5StartTime,
          action_end_time:getlinkbtn5Data.linkbtn5EndTime,
          id:linkbtn5Data[0].id
        });
        setTriggerTime([...triggerTime, getlinkbtn5Data.linkbtn5StartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getlinkbtn5Data.linkbtn5StartTime,
          })
        );
      }

      if (linkbtn6Data.length > 0) {
        let getlinkbtn6Data = JSON.parse(linkbtn6Data[0].meta_data);
        dispatch(
          personalizeAction.setLinkbtn6Data({
            personalize_linkbtn6Data: getlinkbtn6Data,
          })
        );
        setLinkbtn6Data(getlinkbtn6Data);
        actionPointArr.push({
          action_event: "link_button6",
          action_time: getlinkbtn6Data.linkbtn6StartTime,
          action_end_time:getlinkbtn6Data.linkbtn6EndTime,
          id:linkbtn6Data[0].id
        });
        setTriggerTime([...triggerTime, getlinkbtn6Data.linkbtn6StartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getlinkbtn6Data.linkbtn6StartTime,
          })
        );
      }

      if (linkbtn7Data.length > 0) {
        let getlinkbtnData = JSON.parse(linkbtn7Data[0].meta_data);
        dispatch(
          personalizeAction.setLinkbtn7Data({
            personalize_linkbtn7Data: getlinkbtnData,
          })
        );
        setLinkbtn7Data(getlinkbtnData);
        actionPointArr.push({
          action_event: "link_button7",
          action_time: getlinkbtnData.linkbtn7StartTime,
          action_end_time:getlinkbtnData.linkbtn7EndTime,
          id:linkbtn7Data[0].id
        });
        setTriggerTime([...triggerTime, getlinkbtnData.linkbtn7StartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getlinkbtnData.linkbtn7StartTime,
          })
        );
      }

      if (linkbtn8Data.length > 0) {
        let getlinkbtnData = JSON.parse(linkbtn8Data[0].meta_data);
        dispatch(
          personalizeAction.setLinkbtn8Data({
            personalize_linkbtn8Data: getlinkbtnData,
          })
        );
        setLinkbtn8Data(getlinkbtnData);
        actionPointArr.push({
          action_event: "link_button8",
          action_time: getlinkbtnData.linkbtn8StartTime,
          action_end_time:getlinkbtnData.linkbtn8EndTime,
          id:linkbtn8Data[0].id
        });
        setTriggerTime([...triggerTime, getlinkbtnData.linkbtn8StartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getlinkbtnData.linkbtn8StartTime,
          })
        );
      }
      if (linkbtn9Data.length > 0) {
        let getlinkbtnData = JSON.parse(linkbtn9Data[0].meta_data);
        dispatch(
          personalizeAction.setLinkbtn9Data({
            personalize_linkbtn9Data: getlinkbtnData,
          })
        );
        setLinkbtn9Data(getlinkbtnData);
        actionPointArr.push({
          action_event: "link_button9",
          action_time: getlinkbtnData.linkbtn9StartTime,
          action_end_time:getlinkbtnData.linkbtn9EndTime,
          id:linkbtn9Data[0].id
        });
        setTriggerTime([...triggerTime, getlinkbtnData.linkbtn9StartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getlinkbtnData.linkbtn9StartTime,
          })
        );
      }

      if (Imgbtn1Data.length > 0) {
        let getImgbtn1Data = JSON.parse(Imgbtn1Data[0].meta_data);
        dispatch(
          personalizeAction.setImgbtn1Data({
            personalize_Imgbtn1Data: getImgbtn1Data,
          })
        );
        setImgbtn1Data(getImgbtn1Data);
        actionPointArr.push({
          action_event: "Img_btn1",
          action_time: getImgbtn1Data.Imgbtn1StartTime,
          action_end_time:getImgbtn1Data.Imgbtn1EndTime,
          id:Imgbtn1Data[0].id
        });
        setTriggerTime([...triggerTime, getImgbtn1Data.Imgbtn1StartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getImgbtn1Data.Imgbtn1StartTime,
          })
        );
      }

      if (Imgbtn2Data.length > 0) {
        let getImgbtn2Data = JSON.parse(Imgbtn2Data[0].meta_data);
        dispatch(
          personalizeAction.setImgbtn2Data({
            personalize_Imgbtn2Data: getImgbtn2Data,
          })
        );
        setImgbtn2Data(getImgbtn2Data);
        actionPointArr.push({
          action_event: "Img_btn2",
          action_time: getImgbtn2Data.Imgbtn2StartTime,
          action_end_time:getImgbtn2Data.Imgbtn2EndTime,
          id:Imgbtn2Data[0].id
        });
        setTriggerTime([...triggerTime, getImgbtn2Data.Imgbtn2StartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getImgbtn2Data.Imgbtn2StartTime,
          })
        );
      }

      if (Imgbtn3Data.length > 0) {
        let getImgbtn3Data = JSON.parse(Imgbtn3Data[0].meta_data);
        dispatch(
          personalizeAction.setImgbtn3Data({
            personalize_Imgbtn3Data: getImgbtn3Data,
          })
        );
        setImgbtn3Data(getImgbtn3Data);
        actionPointArr.push({
          action_event: "Img_btn3",
          action_time: getImgbtn3Data.Imgbtn3StartTime,
          action_end_time:getImgbtn3Data.Imgbtn3EndTime,
          id:Imgbtn3Data[0].id
        });
        setTriggerTime([...triggerTime, getImgbtn3Data.Imgbtn3StartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getImgbtn3Data.Imgbtn3StartTime,
          })
        );
      }

      if (Imgbtn4Data.length > 0) {
        let getImgbtn4Data = JSON.parse(Imgbtn4Data[0].meta_data);
        dispatch(
          personalizeAction.setImgbtn4Data({
            personalize_Imgbtn4Data: getImgbtn4Data,
          })
        );
        setImgbtn4Data(getImgbtn4Data);
        actionPointArr.push({
          action_event: "Img_btn4",
          action_time: getImgbtn4Data.Imgbtn4StartTime,
          action_end_time:getImgbtn4Data.Imgbtn4EndTime,
          id:Imgbtn4Data[0].id
        });
        setTriggerTime([...triggerTime, getImgbtn4Data.Imgbtn4StartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getImgbtn4Data.Imgbtn4StartTime,
          })
        );
      }

      if (Imgbtn5Data.length > 0) {
        let getImgbtn5Data = JSON.parse(Imgbtn5Data[0].meta_data);
        dispatch(
          personalizeAction.setImgbtn5Data({
            personalize_Imgbtn5Data: getImgbtn5Data,
          })
        );
        setImgbtn5Data(getImgbtn5Data);
        actionPointArr.push({
          action_event: "Img_btn5",
          action_time: getImgbtn5Data.Imgbtn5StartTime,
          action_end_time:getImgbtn5Data.Imgbtn5EndTime,
          id:Imgbtn5Data[0].id
        });
        setTriggerTime([...triggerTime, getImgbtn5Data.Imgbtn5StartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getImgbtn5Data.Imgbtn5StartTime,
          })
        );
      }

      if (Imgbtn6Data.length > 0) {
        let getImgbtn6Data = JSON.parse(Imgbtn6Data[0].meta_data);
        dispatch(
          personalizeAction.setImgbtn6Data({
            personalize_Imgbtn6Data: getImgbtn6Data,
          })
        );
        setImgbtn6Data(getImgbtn6Data);
        actionPointArr.push({
          action_event: "Img_btn6",
          action_time: getImgbtn6Data.Imgbtn6StartTime,
          action_end_time:getImgbtn6Data.Imgbtn6EndTime,
          id:Imgbtn6Data[0].id
        });
        setTriggerTime([...triggerTime, getImgbtn6Data.Imgbtn6StartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getImgbtn6Data.Imgbtn6StartTime,
          })
        );
      }

      if (Imgbtn7Data.length > 0) {
        let getImgbtn7Data = JSON.parse(Imgbtn7Data[0].meta_data);
        dispatch(
          personalizeAction.setImgbtn7Data({
            personalize_Imgbtn7Data: getImgbtn7Data,
          })
        );
        setImgbtn7Data(getImgbtn7Data);
        actionPointArr.push({
          action_event: "Img_btn7",
          action_time: getImgbtn7Data.Imgbtn7StartTime,
          action_end_time:getImgbtn7Data.Imgbtn7EndTime,
          id:Imgbtn7Data[0].id
        });
        setTriggerTime([...triggerTime, getImgbtn7Data.Imgbtn7StartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getImgbtn7Data.Imgbtn7StartTime,
          })
        );
      }

      if (Imgbtn8Data.length > 0) {
        let getImgbtn8Data = JSON.parse(Imgbtn8Data[0].meta_data);
        dispatch(
          personalizeAction.setImgbtn8Data({
            personalize_Imgbtn8Data: getImgbtn8Data,
          })
        );
        setImgbtn8Data(getImgbtn8Data);
        actionPointArr.push({
          action_event: "Img_btn8",
          action_time: getImgbtn8Data.Imgbtn8StartTime,
          action_end_time:getImgbtn8Data.Imgbtn8EndTime,
          id:Imgbtn8Data[0].id
        });
        setTriggerTime([...triggerTime, getImgbtn8Data.Imgbtn8StartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getImgbtn8Data.Imgbtn8StartTime,
          })
        );
      }

      if (copypasteData.length > 0) {
        let getCopypasteData = JSON.parse(copypasteData[0].meta_data);
        dispatch(
          personalizeAction.setCopyPasteData({
            personalize_copyPasteData: getCopypasteData,
          })
        );
        setCopyPasteData(getCopypasteData);
        actionPointArr.push({
          action_event: "video_copypaste",
          action_time: getCopypasteData.CRMstartTime,
          id:copypasteData[0].id
        });
        setTriggerTime([...triggerTime, getCopypasteData.CRMstartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getCopypasteData.CRMstartTime,
          })
        );
      }

      if (scriptCodeData.length > 0) {
        let getScript_codeData = JSON.parse(scriptCodeData[0].meta_data);
        dispatch(
          personalizeAction.setScript_Code({
            personalize_scriptCodeData: getScript_codeData,
          })
        );
        setScriptCodeData(getScript_codeData);
        actionPointArr.push({
          action_event: "scriptCode",
          action_time: getScript_codeData.scriptCodeStartTime,
          id:scriptCodeData[0].id
        });
        setTriggerTime([...triggerTime, getScript_codeData.scriptCodeStartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getScript_codeData.scriptCodeStartTime,
          })
        );
      }

      if (leadgenData.length > 0) {
        let getLeadGenData = JSON.parse(leadgenData[0].meta_data);
        dispatch(
          personalizeAction.setLeadgenFormData({
            personalize_leadgenFormData: getLeadGenData,
          })
        );
        setLeadgenFormData(getLeadGenData);
        actionPointArr.push({
          action_event: "video_leadgen",
          action_time: getLeadGenData.leadgenTime,
          id:leadgenData[0].id
        });
        setTriggerTime([...triggerTime, getLeadGenData.leadgenTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getLeadGenData.leadgenTime,
          })
        );
      }

      if (leadgen2Data.length > 0) {
        let getLeadGenData = JSON.parse(leadgen2Data[0].meta_data);
        dispatch(
          personalizeAction.setLeadgen2FormData({
            personalize_leadgen2FormData: getLeadGenData,
          })
        );
        setLeadgen2FormData(getLeadGenData);
        actionPointArr.push({
          action_event: "video_leadgen2",
          action_time: getLeadGenData.leadgenTime,
          id:leadgen2Data[0].id
        });
        setTriggerTime([...triggerTime, getLeadGenData.leadgenTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getLeadGenData.leadgenTime,
          })
        );
      }

      if (custPollData.length > 0) {
        let getcustpollData = JSON.parse(custPollData[0].meta_data);
        dispatch(
          personalizeAction.setPollData({
            personalize_pollData: getcustpollData,
          })
        );
        setCustPollData(getcustpollData);
        actionPointArr.push({
          action_event: "video_custPoll",
          action_time: getcustpollData.pollTime,
          id:custPollData[0].id
        });
        setTriggerTime([...triggerTime, getcustpollData.pollTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getcustpollData.pollTime,
          })
        );
      }

      if (brandingData.length > 0) {
        let getbrandingData = JSON.parse(brandingData[0].meta_data);
        dispatch(
          personalizeAction.setBrandingData({
            personalize_brandingData: getbrandingData,
          })
        );
      }

      if (cust2PollData.length > 0) {
        let getcust2pollData = JSON.parse(cust2PollData[0].meta_data);
        dispatch(
          personalizeAction.setPoll2Data({
            personalize_poll2Data: getcust2pollData,
          })
        );
        setCust2PollData(getcust2pollData);
        actionPointArr.push({
          action_event: "video_cust2Poll",
          action_time: getcust2pollData.pollTime,
          id:cust2PollData[0].id
        });
        setTriggerTime([...triggerTime, getcust2pollData.pollTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getcust2pollData.pollTime,
          })
        );
      }

      if (cust3PollData.length > 0) {
        let getcust3pollData = JSON.parse(cust3PollData[0].meta_data);
        dispatch(
          personalizeAction.setPoll3Data({
            personalize_poll3Data: getcust3pollData,
          })
        );
        setCust3PollData(getcust3pollData);
        actionPointArr.push({
          action_event: "video_cust3Poll",
          action_time: getcust3pollData.pollTime,
          id:cust3PollData[0].id
        });
        setTriggerTime([...triggerTime, getcust3pollData.pollTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getcust3pollData.pollTime,
          })
        );
      }

      if (opentable1Data.length > 0) {
        let getopentable1Data = JSON.parse(opentable1Data[0].meta_data);
        dispatch(
          personalizeAction.setOpentable1Data({
            personalize_opentable1Data: getopentable1Data,
          })
        );
        setOpentable1Data(getopentable1Data);
        actionPointArr.push({
          action_event: "video_opentable1",
          action_time: getopentable1Data.booktime,
          id:opentable1Data[0].id
        });
        setTriggerTime([...triggerTime, getopentable1Data.booktime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getopentable1Data.booktime,
          })
        );
      }

      if (review1Data.length > 0) {
        let getreview1Data = JSON.parse(review1Data[0].meta_data);
        dispatch(
          personalizeAction.setReview1Data({
            personalize_review1Data: getreview1Data,
          })
        );
        setReview1Data(getreview1Data);
        actionPointArr.push({
          action_event: "video_review1",
          action_time: getreview1Data.review1StartTime,
          action_end_time:getreview1Data.review1EndTime,
          id:review1Data[0].id
        });
        setTriggerTime([...triggerTime, getreview1Data.review1StartTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getreview1Data.review1StartTime,
          })
        );
      }
      

      if(privacyData.length > 0){
        let getprivacyData = JSON.parse(privacyData[0].meta_data)
        dispatch(personalizeAction.setPrivacyData({ personalize_privacyData: getprivacyData }));
      }

      if (simpleRevealData && simpleRevealData.length > 0) {
        let getsimpleRevealData = JSON.parse(simpleRevealData[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getsimpleRevealData)
        setTriggerTime([...triggerTime, getsimpleRevealData.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getsimpleRevealData.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "simple_reveal",
          action_time: getsimpleRevealData.startTime,
          action_end_time:getsimpleRevealData.endTime,
          id:simpleRevealData[0].id
        });
      }

      if (speechBubbleData && speechBubbleData.length > 0) {
        let getspeechBubbleData = JSON.parse(speechBubbleData[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getspeechBubbleData)
        setTriggerTime([...triggerTime, getspeechBubbleData.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getspeechBubbleData.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "speech_bubble",
          action_time: getspeechBubbleData.startTime,
          action_end_time:getspeechBubbleData.endTime,
          id:speechBubbleData[0].id
        });
      }

      if (speechThoughtData && speechThoughtData.length > 0) {
        let getspeechThoughtData = JSON.parse(speechThoughtData[0].meta_data);
        console.log(getspeechThoughtData)
        overlayArr = [].concat(overlayArr, getspeechThoughtData)
        setTriggerTime([...triggerTime, getspeechThoughtData.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getspeechThoughtData.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "speech_thought",
          action_time: getspeechThoughtData.startTime,
          action_end_time:getspeechThoughtData.endTime,
          id:speechThoughtData[0].id
        });
      }

      if (speechBubble2Data && speechBubble2Data.length > 0) {
        let getspeechBubble2Data = JSON.parse(speechBubble2Data[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getspeechBubble2Data)
        setTriggerTime([...triggerTime, getspeechBubble2Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getspeechBubble2Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "speech_bubble_2",
          action_time: getspeechBubble2Data.startTime,
          action_end_time:getspeechBubble2Data.endTime,
          id:speechBubble2Data[0].id
        });
      }

      if (speechBubble3Data && speechBubble3Data.length > 0) {
        let getspeechBubble3Data = JSON.parse(speechBubble3Data[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getspeechBubble3Data)
        setTriggerTime([...triggerTime, getspeechBubble3Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getspeechBubble3Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "speech_bubble_3",
          action_time: getspeechBubble3Data.startTime,
          action_end_time:getspeechBubble3Data.endTime,
          id:speechBubble3Data[0].id
        });
      }

      if (speechBubble4Data && speechBubble4Data.length > 0) {
        let getspeechBubble4Data = JSON.parse(speechBubble4Data[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getspeechBubble4Data)
        setTriggerTime([...triggerTime, getspeechBubble4Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getspeechBubble4Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "speech_bubble_4",
          action_time: getspeechBubble4Data.startTime,
          action_end_time:getspeechBubble4Data.endTime,
          id:speechBubble4Data[0].id
        });
      }

      if (borderAnimationData && borderAnimationData.length > 0) {
        let getborderAnimationData = JSON.parse(borderAnimationData[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getborderAnimationData)
        setTriggerTime([...triggerTime, getborderAnimationData.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getborderAnimationData.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "border_animation",
          action_time: getborderAnimationData.startTime,
          action_end_time:getborderAnimationData.endTime,
          id:borderAnimationData[0].id
        });
      }

      if (borderAnimation2Data && borderAnimation2Data.length > 0) {
        let getborderAnimation2Data = JSON.parse(borderAnimation2Data[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getborderAnimation2Data)
        setTriggerTime([...triggerTime, getborderAnimation2Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getborderAnimation2Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "border_animation_2",
          action_time: getborderAnimation2Data.startTime,
          action_end_time:getborderAnimation2Data.endTime,
          id:borderAnimation2Data[0].id
        });
      }

      if (ltAnimation1Data && ltAnimation1Data.length > 0) {
        let getltAnimation1Data = JSON.parse(ltAnimation1Data[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getltAnimation1Data)
        setTriggerTime([...triggerTime, getltAnimation1Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getltAnimation1Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "lt_animation_1",
          action_time: getltAnimation1Data.startTime,
          action_end_time:getltAnimation1Data.endTime,
          id:ltAnimation1Data[0].id
        });
      }

      if (ltAnimation2Data && ltAnimation2Data.length > 0) {
        let getltAnimation2Data = JSON.parse(ltAnimation2Data[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getltAnimation2Data)
        setTriggerTime([...triggerTime, getltAnimation2Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getltAnimation2Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "lt_animation_2",
          action_time: getltAnimation2Data.startTime,
          action_end_time:getltAnimation2Data.endTime,
          id:ltAnimation2Data[0].id
        });
      }

      if (ltAnimation3Data && ltAnimation3Data.length > 0) {
        let getltAnimation3Data = JSON.parse(ltAnimation3Data[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getltAnimation3Data)
        setTriggerTime([...triggerTime, getltAnimation3Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getltAnimation3Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "lt_animation_3",
          action_time: getltAnimation3Data.startTime,
          action_end_time:getltAnimation3Data.endTime,
          id:ltAnimation3Data[0].id
        });
      }

      if (ltAnimation4Data && ltAnimation4Data.length > 0) {
        let getltAnimation4Data = JSON.parse(ltAnimation4Data[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getltAnimation4Data)
        setTriggerTime([...triggerTime, getltAnimation4Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getltAnimation4Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "lt_animation_4",
          action_time: getltAnimation4Data.startTime,
          action_end_time:getltAnimation4Data.endTime,
          id:ltAnimation4Data[0].id
        });
      }

      if (ltAnimation5Data && ltAnimation5Data.length > 0) {
        let getltAnimation5Data = JSON.parse(ltAnimation5Data[0].meta_data);
        // console.log(getsimpleRevealData)
        overlayArr = [].concat(overlayArr, getltAnimation5Data)
        setTriggerTime([...triggerTime, getltAnimation5Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getltAnimation5Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "lt_animation_5",
          action_time: getltAnimation5Data.startTime,
          action_end_time:getltAnimation5Data.endTime,
          id:ltAnimation5Data[0].id
        });
      }

      if(nameAnimData && nameAnimData.length > 0){
        let getnameAnimData = JSON.parse(nameAnimData[0].meta_data);
          overlayArr = [].concat(overlayArr, getnameAnimData)
        // console.log(newState)
        setTriggerTime([...triggerTime, getnameAnimData.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: getnameAnimData.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "name_animation",
          action_time: getnameAnimData.startTime,
          action_end_time:getnameAnimData.endTime,
          id:nameAnimData[0].id
        });
      }

      if(textAnim1Data && textAnim1Data.length > 0){
        let gettextAnim1Data = JSON.parse(textAnim1Data[0].meta_data);
          overlayArr = [].concat(overlayArr, gettextAnim1Data)
        // console.log(newState)
        setTriggerTime([...triggerTime, gettextAnim1Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: gettextAnim1Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "text_animation_1",
          action_time: gettextAnim1Data.startTime,
          action_end_time:gettextAnim1Data.endTime,
          id:textAnim1Data[0].id
        });
      }

      if(textAnim2Data && textAnim2Data.length > 0){
        let gettextAnim2Data = JSON.parse(textAnim2Data[0].meta_data);
          overlayArr = [].concat(overlayArr, gettextAnim2Data)
        // console.log(newState)
        setTriggerTime([...triggerTime, gettextAnim2Data.startTime]);
        dispatch(
          personalizeAction.setTriggerTime({
            personalize_triggerTime: gettextAnim2Data.startTime,
          })
        );
        // setVideoCTAData(getsimpleRevealData);
        actionPointArr.push({
          action_event: "text_animation_2",
          action_time: gettextAnim2Data.startTime,
          action_end_time:gettextAnim2Data.endTime,
          id:textAnim2Data[0].id
        });
      }

      if(emojiContentData && emojiContentData.length > 0){
        emojiContentData.map((emojiContent)=>{
          let getemojiContentData = JSON.parse(emojiContent.meta_data);

            overlayArr = [].concat(overlayArr, {...getemojiContentData,id:emojiContent.id})
            console.log(getemojiContentData)
          setTriggerTime([...triggerTime, getemojiContentData.startTime]);
          dispatch(
            personalizeAction.setTriggerTime({
              personalize_triggerTime: getemojiContentData.startTime,
            })
          );
          // setVideoCTAData(getsimpleRevealData);
          actionPointArr.push({
            action_event: "emoji_content",
            action_time: getemojiContentData.startTime,
            action_end_time:getemojiContentData.endTime,
            id:emojiContent.id
          });

          return true;
        })
        
      }

      // console.log(emojiContentData)
      dispatch(
        personalizeAction.setOverlayData({
          overlayData:overlayArr
        })
      );
      setActionPoint(actionPointArr);
      setPageLoad(true);
    }
  };

  function getStarIcons(num , type = "google") {
    let stars = [];
    if (num > 5)
    {
      cuteToast({
        type: "error",
        message: "Rating should be less than 5",
        timer: 2000,
        title: "",
      });
      num = 5; 
    }else if(num < 1){
      cuteToast({
        type: "error",
        message:  "Atleast 1 star is required",
        timer: 2000,
        title: "",
      }); 
      num = 1;
    }
    
    
    for (let i = 0; i < num; i++) {
      if(type === "yelp"){
        stars.push(<img alt="imgi" src="https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/Images/yelp-star.png" className="rating-start" key={i} />);
      }else{
        stars.push(<FaStar className="rating-start" key={i} />); 
      }
    }
    return stars;
  }

  const timeKeyUphandle = (keycode, value) => {
    // console.log(time)
    let step = "01";
    let minutes = Math.floor(videoLength / 60);
    const videoTotalDuration =
      (minutes < 10 ? `0${minutes}` : minutes) +
      ":" +
      ("0" + Math.floor(videoLength % 60)).slice(-2);
    // console.log(value,videoTotalDuration)

    if (keycode === 38 || keycode === "up") {
      // console.log(value,videoLength)

      // console.log(value,videoTotalDuration)
      if (value < videoTotalDuration) {
        const duration = value.split(":");

        if (duration[1] === "59") {
          duration[1] = `0`;

          duration[0] = Number(duration[0]) + Number(step);

          if (duration[0] < 10) {
            duration[0] = `0${duration[0]}`;
          }
        } else {
          duration[1] = Number(duration[1]) + Number(step);
        }
        if (duration[1] < 10) {
          duration[1] = `0${duration[1]}`;
        }

        return `${duration[0]}:${duration[1]}`;
      } else {
        return value;
      }
    } else if (keycode === 40 || keycode === "down") {
      const duration = value.split(":");

      if (duration[1] === "00" && duration[0] === "00") {
        duration[1] = `00`;
        return false;
      }

      if (duration[1] === "00") {
        duration[1] = `59`;

        duration[0] = Number(duration[0]) - Number(step);

        if (duration[0] < 10) {
          duration[0] = `0${duration[0]}`;
        }
      } else {
        duration[1] = Number(duration[1]) - Number(step);
      }

      if (duration[1] < 10) {
        duration[1] = `0${duration[1]}`;
      }

      return `${duration[0]}:${duration[1]}`;
    } else {
      return value;
    }
  };

  const handleTimeKeyUp = (event, type) => {
    event.preventDefault();
    // console.log(event.keyCode)
    
    const { value } = event.target;
    // console.log(value,type,event.keyCode)
    let changeDur;
    changeDur = timeKeyUphandle(event.keyCode, value);
    // console.log(changeDur)
    if (!changeDur) changeDur = "00:00";

    if (type === "ctaTime")
      setVideoCTAData({ ...videoCTAData, actiontime: changeDur });

    if (type === "annotationStartTime")
      setAnnotationData({ ...annotationData, annotationStartTime: changeDur });

    if (type === "annotationEndTime")
      setAnnotationData({ ...annotationData, annotationEndTime: changeDur });

    if (type === "buybuttonStartTime")
      setBuybuttonData({ ...buybuttonData, buybuttonStartTime: changeDur });

    if (type === "buybuttonEndTime")
      setBuybuttonData({ ...buybuttonData, buybuttonEndTime: changeDur });

    if (type === "linkbtn2StartTime")
      setLinkbtn2Data({ ...linkbtn2Data, linkbtn2StartTime: changeDur });
    if (type === "linkbtn2EndTime")
      setLinkbtn2Data({ ...linkbtn2Data, linkbtn2EndTime: changeDur });

    if (type === "linkbtn3StartTime")
      setLinkbtn3Data({ ...linkbtn3Data, linkbtn3StartTime: changeDur });
    if (type === "linkbtn3EndTime")
      setLinkbtn3Data({ ...linkbtn3Data, linkbtn3EndTime: changeDur });

    if (type === "linkbtn4StartTime")
      setLinkbtn4Data({ ...linkbtn4Data, linkbtn4StartTime: changeDur });
    if (type === "linkbtn4EndTime")
      setLinkbtn4Data({ ...linkbtn4Data, linkbtn4EndTime: changeDur });
  
    if (type === "linkbtn5StartTime")
      setLinkbtn5Data({ ...linkbtn5Data, linkbtn5StartTime: changeDur });
    if (type === "linkbtn5EndTime")
      setLinkbtn5Data({ ...linkbtn5Data, linkbtn5EndTime: changeDur });
  
    if (type === "linkbtn6StartTime")
      setLinkbtn6Data({ ...linkbtn6Data, linkbtn6StartTime: changeDur });
    if (type === "linkbtn6EndTime")
      setLinkbtn6Data({ ...linkbtn6Data, linkbtn6EndTime: changeDur });
  
    if (type === "linkbtn7StartTime")
      setLinkbtn7Data({ ...linkbtn7Data, linkbtn7StartTime: changeDur });
    if (type === "linkbtn7EndTime")
      setLinkbtn7Data({ ...linkbtn7Data, linkbtn7EndTime: changeDur });
  
    if (type === "linkbtn8StartTime")
      setLinkbtn8Data({ ...linkbtn8Data, linkbtn8StartTime: changeDur });
    if (type === "linkbtn8EndTime")
      setLinkbtn8Data({ ...linkbtn8Data, linkbtn8EndTime: changeDur });
    
    if (type === "linkbtn9StartTime")
      setLinkbtn9Data({ ...linkbtn9Data, linkbtn9StartTime: changeDur });
    if (type === "linkbtn9EndTime")
      setLinkbtn9Data({ ...linkbtn9Data, linkbtn9EndTime: changeDur });

    if (type === "Imgbtn1StartTime")
      setImgbtn1Data({ ...Imgbtn1Data, Imgbtn1StartTime: changeDur });

    if (type === "Imgbtn1EndTime")
      setImgbtn1Data({ ...Imgbtn1Data, Imgbtn1EndTime: changeDur });

    if (type === "Imgbtn2StartTime")
      setImgbtn2Data({ ...Imgbtn2Data, Imgbtn2StartTime: changeDur });
  
    if (type === "Imgbtn2EndTime")
      setImgbtn2Data({ ...Imgbtn2Data, Imgbtn2EndTime: changeDur });

    if (type === "Imgbtn3StartTime")
      setImgbtn3Data({ ...Imgbtn3Data, Imgbtn3StartTime: changeDur });
    
    if (type === "Imgbtn3EndTime")
      setImgbtn3Data({ ...Imgbtn3Data, Imgbtn3EndTime: changeDur });

    if (type === "Imgbtn4StartTime")
      setImgbtn4Data({ ...Imgbtn4Data, Imgbtn4StartTime: changeDur });
    
    if (type === "Imgbtn4EndTime")
      setImgbtn4Data({ ...Imgbtn4Data, Imgbtn4EndTime: changeDur });

    if (type === "Imgbtn5StartTime")
      setImgbtn5Data({ ...Imgbtn5Data, Imgbtn5StartTime: changeDur });
    if (type === "Imgbtn5EndTime")
      setImgbtn5Data({ ...Imgbtn5Data, Imgbtn5EndTime: changeDur });

    if (type === "Imgbtn6StartTime")
      setImgbtn6Data({ ...Imgbtn6Data, Imgbtn6StartTime: changeDur });
    if (type === "Imgbtn6EndTime")
      setImgbtn6Data({ ...Imgbtn6Data, Imgbtn6EndTime: changeDur });

    if (type === "Imgbtn7StartTime")
      setImgbtn7Data({ ...Imgbtn7Data, Imgbtn7StartTime: changeDur });
    if (type === "Imgbtn7EndTime")
      setImgbtn7Data({ ...Imgbtn7Data, Imgbtn7EndTime: changeDur });
    
    if (type === "Imgbtn8StartTime")
      setImgbtn8Data({ ...Imgbtn8Data, Imgbtn8StartTime: changeDur });
    if (type === "Imgbtn8EndTime")
      setImgbtn8Data({ ...Imgbtn8Data, Imgbtn8EndTime: changeDur });
      
    if (type === "CRMstartTime")
      setCopyPasteData({ ...copyPasteData, CRMstartTime: changeDur });

    if (type === "CRMendTime")
      setCopyPasteData({ ...copyPasteData, CRMendTime: changeDur });

    if (type === "leadgenTime")
      setLeadgenFormData({ ...leadgenFormData, leadgenTime: changeDur });
    if (type === "leadgen2Time")
      setLeadgen2FormData({ ...leadgen2FormData, leadgenTime: changeDur });

    if (type === "pollTime")
      setCustPollData({ ...custPollData, pollTime: changeDur });

    if (type === "poll2Time")
      setCust2PollData({ ...cust2PollData, pollTime: changeDur });

    if (type === "poll3Time")
      setCust2PollData({ ...cust2PollData, pollTime: changeDur });

    if (type === "booktime1")
      setOpentable1Data({ ...opentable1Data, booktime: changeDur });

    if (type === "review1StartTime")
      setReview1Data({ ...review1Data, review1StartTime: changeDur });

    if (type === "review1EndTime")
      setReview1Data({ ...review1Data, review1EndTime: changeDur });

    if (type === "startTime")
      setShowAnimation({...showAnimation,startTime:changeDur})

    if (type === "endTime")
      setShowAnimation({...showAnimation,endTime:changeDur})

    if(type === "setStartTime" || type.includes("Start")){
      setYtPlayer({...ytPlayer,start:changeDur})
      let s_time = getSeconds(changeDur);
      let e_time = getSeconds(ytPlayer.end);
      handleTriggerTime([s_time,e_time], "sync");
    }

    if(type === "setEndTime" || type.includes("End")){
      setYtPlayer({...ytPlayer,end:changeDur})
      let s_time = getSeconds(ytPlayer.start);
      let e_time = getSeconds(changeDur);
      handleTriggerTime([s_time,e_time], "sync");
    }


  };

  const handleTimeBlur = (event, type) => {
    event.preventDefault();
    const { value } = event.target;
    let changeDur;

    let re = /^\d{1,2}:\d{2}([ap]m)?$/;

    if (value !== "" && !value.match(re)) {
      changeDur = "00:00";
    } else {
      changeDur = value;
    }
    // console.log(value, changeDur )
    if( getSeconds(value) > ytPlayer.duration ){
       
      console.log("greater")
      changeDur = getTime(Math.floor(ytPlayer.duration))

      console.log(value, changeDur, type)

    }

    if (type === "ctaTime")
      setVideoCTAData({ ...videoCTAData, actiontime: changeDur });

    if (type === "annotationStartTime")
      setAnnotationData({ ...annotationData, annotationStartTime: changeDur });

    if (type === "annotationEndTime")
      setAnnotationData({ ...annotationData, annotationEndTime: changeDur });

    if (type === "buybuttonStartTime")
      setBuybuttonData({ ...buybuttonData, buybuttonStartTime: changeDur });

    if (type === "buybuttonEndTime")
      setBuybuttonData({ ...buybuttonData, buybuttonEndTime: changeDur });

    if (type === "linkbtn2StartTime")
      setLinkbtn2Data({ ...linkbtn2Data, linkbtn2StartTime: changeDur });

    if (type === "linkbtn2EndTime")
      setLinkbtn2Data({ ...linkbtn2Data, linkbtn2EndTime: changeDur });

    if (type === "linkbtn3StartTime")
      setLinkbtn3Data({ ...linkbtn3Data, linkbtn3StartTime: changeDur });

    if (type === "linkbtn3EndTime") 
      setLinkbtn3Data({ ...linkbtn3Data, linkbtn3EndTime: changeDur });

      if (type === "linkbtn4StartTime")
        setLinkbtn4Data({ ...linkbtn4Data, linkbtn4StartTime: changeDur });
  
      if (type === "linkbtn4EndTime")
        setLinkbtn4Data({ ...linkbtn4Data, linkbtn4EndTime: changeDur });
  
      if (type === "linkbtn5StartTime")
        setLinkbtn5Data({ ...linkbtn5Data, linkbtn5StartTime: changeDur });
  
      if (type === "linkbtn5EndTime") 
        setLinkbtn5Data({ ...linkbtn5Data, linkbtn5EndTime: changeDur });
  
      if (type === "linkbtn6StartTime")
        setLinkbtn6Data({ ...linkbtn6Data, linkbtn6StartTime: changeDur });
      if (type === "linkbtn6EndTime") 
        setLinkbtn6Data({ ...linkbtn6Data, linkbtn6EndTime: changeDur });
  
  
      if (type === "linkbtn7StartTime")
        setLinkbtn7Data({ ...linkbtn7Data, linkbtn7StartTime: changeDur });
      if (type === "linkbtn7EndTime") 
        setLinkbtn7Data({ ...linkbtn7Data, linkbtn7EndTime: changeDur });
      
      if (type === "linkbtn8StartTime")
        setLinkbtn8Data({ ...linkbtn8Data, linkbtn8StartTime: changeDur });
      if (type === "linkbtn8EndTime") 
        setLinkbtn8Data({ ...linkbtn8Data, linkbtn8EndTime: changeDur });
      
      if (type === "linkbtn9StartTime")
        setLinkbtn9Data({ ...linkbtn9Data, linkbtn9StartTime: changeDur });
      if (type === "linkbtn9EndTime") 
        setLinkbtn9Data({ ...linkbtn9Data, linkbtn9EndTime: changeDur });

      if (type === "Imgbtn1StartTime")
      setImgbtn1Data({ ...Imgbtn1Data, Imgbtn1StartTime: changeDur });

    if (type === "Imgbtn1EndTime") 
      setImgbtn1Data({ ...Imgbtn1Data, Imgbtn1EndTime: changeDur });

      if (type === "Imgbtn2StartTime")
      setImgbtn2Data({ ...Imgbtn2Data, Imgbtn2StartTime: changeDur });

    if (type === "Imgbtn2EndTime") 
      setImgbtn2Data({ ...Imgbtn2Data, Imgbtn2EndTime: changeDur });

    if (type === "Imgbtn3StartTime")
      setImgbtn3Data({ ...Imgbtn3Data, Imgbtn3StartTime: changeDur });

    if (type === "Imgbtn3EndTime") 
      setImgbtn3Data({ ...Imgbtn3Data, Imgbtn3EndTime: changeDur });

    if (type === "Imgbtn4StartTime")
      setImgbtn4Data({ ...Imgbtn4Data, Imgbtn4StartTime: changeDur });
    if (type === "linkbtn4EndTime") 
      setImgbtn4Data({ ...Imgbtn4Data, Imgbtn4EndTime: changeDur });
    if (type === "Imgbtn5StartTime")
      setImgbtn5Data({ ...Imgbtn5Data, Imgbtn5StartTime: changeDur });
    if (type === "linkbtn5EndTime") 
      setImgbtn5Data({ ...Imgbtn5Data, Imgbtn5EndTime: changeDur });
    
    if (type === "Imgbtn6StartTime")
      setImgbtn6Data({ ...Imgbtn6Data, Imgbtn6StartTime: changeDur });
    if (type === "linkbtn6EndTime") 
      setImgbtn6Data({ ...Imgbtn6Data, Imgbtn6EndTime: changeDur });
    if (type === "Imgbtn7StartTime")
      setImgbtn7Data({ ...Imgbtn7Data, Imgbtn7StartTime: changeDur });
    if (type === "linkbtn7EndTime") 
      setImgbtn7Data({ ...Imgbtn7Data, Imgbtn7EndTime: changeDur });
    if (type === "Imgbtn8StartTime")
      setImgbtn8Data({ ...Imgbtn8Data, Imgbtn8StartTime: changeDur });
    if (type === "linkbtn8EndTime") 
      setImgbtn8Data({ ...Imgbtn8Data, Imgbtn8EndTime: changeDur });

    if (type === "CRMstartTime")
      setCopyPasteData({ ...copyPasteData, CRMstartTime: changeDur });

    if (type === "CRMendTime")
      setCopyPasteData({ ...copyPasteData, CRMendTime: changeDur });

    if (type === "leadgenTime")
      setLeadgenFormData({ ...leadgenFormData, leadgenTime: changeDur });
    if (type === "leadgen2Time")
      setLeadgen2FormData({ ...leadgen2FormData, leadgenTime: changeDur });

    if (type === "pollTime")
      setCustPollData({ ...custPollData, pollTime: changeDur });
    if (type === "poll2Time")
      setCust2PollData({ ...cust2PollData, pollTime: changeDur });
    if (type === "poll3Time")
      setCust3PollData({ ...cust3PollData, pollTime: changeDur });

    if (type === "booktime1")
      setOpentable1Data({ ...opentable1Data, booktime: changeDur });

    if (type === "review1StartTime")  
      setReview1Data({ ...review1Data, review1StartTime: changeDur });

    if (type === "review1EndTime")
      setReview1Data({ ...review1Data, review1EndTime: changeDur });


    if (type === "startTime")
      setShowAnimation({...showAnimation,startTime:changeDur})  

    if (type === "endTime")
      setShowAnimation({...showAnimation,endTime:changeDur})

    if(type === "setStartTime")
      setYtPlayer({...ytPlayer,start:changeDur})

    if(type === "setEndTime")
      setYtPlayer({...ytPlayer,end:changeDur})
  };

  const handleTimeUpDown = (event, type, action) => {
    // console.log(Event)
    // console.log(ytPlayer, type,action)
    
    event.preventDefault();
    let changeDur, value;
    if (action === "ctaTime") value = timeRef.current.value;

    if (action === "annotationStartTime") value = annoStartTimeRef.current.value;
    if (action === "annotationEndTime") value = annoEndtimeRef.current.value;

    if (action === "buybuttonStartTime") value = buybtnStartTimeRef.current.value;
    if (action === "buybuttonEndTime") value = buybtnEndtimeRef.current.value;

    if (action === "linkbtn2StartTime") value = linkbtn2StartTimeRef.current.value;
    if (action === "linkbtn2EndTime") value = linkbtn2EndtimeRef.current.value;

    if (action === "linkbtn3StartTime") value = linkbtn3StartTimeRef.current.value;
    if (action === "linkbtn3EndTime") value = linkbtn3EndtimeRef.current.value;

    if (action === "linkbtn4StartTime") value = linkbtn4StartTimeRef.current.value;
    if (action === "linkbtn4EndTime") value = linkbtn4EndtimeRef.current.value;

    if (action === "linkbtn5StartTime") value = linkbtn5StartTimeRef.current.value;
    if (action === "linkbtn5EndTime") value = linkbtn5EndtimeRef.current.value;

    if (action === "linkbtn6StartTime") value = linkbtn6StartTimeRef.current.value;
    if (action === "linkbtn6EndTime") value = linkbtn6EndtimeRef.current.value;

    if (action === "linkbtn7StartTime") value = linkbtn7StartTimeRef.current.value;
    if (action === "linkbtn7EndTime") value = linkbtn7EndtimeRef.current.value;

    if (action === "linkbtn8StartTime") value = linkbtn8StartTimeRef.current.value;
    if (action === "linkbtn8EndTime") value = linkbtn8EndtimeRef.current.value;
    if (action === "linkbtn9StartTime") value = linkbtn9StartTimeRef.current.value;
    if (action === "linkbtn9EndTime") value = linkbtn9EndtimeRef.current.value;

    if (action === "Imgbtn1StartTime") value = Imgbtn1StartTimeRef.current.value;
    if (action === "Imgbtn1EndTime") value = Imgbtn1EndtimeRef.current.value;

    if (action === "Imgbtn2StartTime") value = Imgbtn2StartTimeRef.current.value;
    if (action === "Imgbtn2EndTime") value = Imgbtn2EndtimeRef.current.value;

    if (action === "Imgbtn3StartTime") value = Imgbtn3StartTimeRef.current.value;
    if (action === "Imgbtn3EndTime") value = Imgbtn3EndtimeRef.current.value;

    if (action === "Imgbtn4StartTime") value = Imgbtn4StartTimeRef.current.value;
    if (action === "Imgbtn4EndTime") value = Imgbtn4EndtimeRef.current.value;

    if (action === "Imgbtn5StartTime") value = Imgbtn5StartTimeRef.current.value;
    if (action === "Imgbtn5EndTime") value = Imgbtn5EndtimeRef.current.value;

    if (action === "Imgbtn6StartTime") value = Imgbtn6StartTimeRef.current.value;
    if (action === "Imgbtn6EndTime") value = Imgbtn6EndtimeRef.current.value;

    if (action === "Imgbtn7StartTime") value = Imgbtn7StartTimeRef.current.value;
    if (action === "Imgbtn7EndTime") value = Imgbtn7EndtimeRef.current.value;

    if (action === "Imgbtn8StartTime") value = Imgbtn8StartTimeRef.current.value;
    if (action === "Imgbtn8EndTime") value = Imgbtn8EndtimeRef.current.value;

    if (action === "CRMstartTime") value = CRMstartTimeRef.current.value;
    if (action === "CRMendTime") value = CRMendtimeRef.current.value;

    if (action === "leadgenTime") value = leadgenTimeRef.current.value;
    if (action === "leadgen2Time") value = leadgen2TimeRef.current.value;

    if (action === "pollTime") value = pollTimeRef.current.value;
    if (action === "poll2Time") value = poll2TimeRef.current.value;
    if (action === "poll3Time") value = poll3TimeRef.current.value;

    if (action === "booktime1") value = opentable1Ref.current.value;

    if (action === "review1StartTime") value = review1StartTimeRef.current.value;
    if (action === "review1EndTime") value = review1EndtimeRef.current.value;

    if (action === "startTime") value = startTimeRef.current.value;
    if (action === "endTime") value = endTimeRef.current.value;

    if(action === "setStartTime") value = setStartTimeRef.current.value;
    if(action === "setEndTime") value = setEndTimeRef.current.value;

    // console.log(value,type)
    changeDur = timeKeyUphandle(type, value);
    console.log(changeDur);

    if( getSeconds(changeDur) > ytPlayer.duration ){
       
      console.log("greater")
      changeDur = value;
    }

    if (!changeDur) changeDur = "00:00";
    
    if (action === "ctaTime")
      setVideoCTAData({ ...videoCTAData, actiontime: changeDur });

    if (action === "annotationStartTime")
      setAnnotationData({ ...annotationData, annotationStartTime: changeDur });

    if (action === "annotationEndTime")
      setAnnotationData({ ...annotationData, annotationEndTime: changeDur });

      
    if (action === "buybuttonStartTime") setBuybuttonData({ ...buybuttonData, buybuttonStartTime: changeDur });
    if (action === "buybuttonEndTime") setBuybuttonData({ ...buybuttonData, buybuttonEndTime: changeDur });
    if (action === "linkbtn2StartTime") setLinkbtn2Data({ ...linkbtn2Data, linkbtn2StartTime: changeDur });
    if (action === "linkbtn2EndTime") setLinkbtn2Data({ ...linkbtn2Data, linkbtn2EndTime: changeDur });
    if (action === "linkbtn3StartTime") setLinkbtn3Data({ ...linkbtn3Data, linkbtn3StartTime: changeDur });
    if (action === "linkbtn3EndTime") setLinkbtn3Data({ ...linkbtn3Data, linkbtn3EndTime: changeDur });
    if (action === "linkbtn4StartTime") setLinkbtn4Data({ ...linkbtn4Data, linkbtn4StartTime: changeDur });
    if (action === "linkbtn4EndTime") setLinkbtn4Data({ ...linkbtn4Data, linkbtn4EndTime: changeDur });
    if (action === "linkbtn5StartTime") setLinkbtn5Data({ ...linkbtn5Data, linkbtn5StartTime: changeDur });
    if (action === "linkbtn5EndTime") setLinkbtn5Data({ ...linkbtn5Data, linkbtn5EndTime: changeDur });
    if (action === "linkbtn6StartTime") setLinkbtn6Data({ ...linkbtn6Data, linkbtn6StartTime: changeDur });
    if (action === "linkbtn6EndTime") setLinkbtn6Data({ ...linkbtn6Data, linkbtn6EndTime: changeDur });
    if (action === "linkbtn7StartTime") setLinkbtn7Data({ ...linkbtn7Data, linkbtn7StartTime: changeDur });
    if (action === "linkbtn7EndTime") setLinkbtn7Data({ ...linkbtn7Data, linkbtn7EndTime: changeDur });
    if (action === "linkbtn8StartTime") setLinkbtn7Data({ ...linkbtn8Data, linkbtn8StartTime: changeDur });
    if (action === "linkbtn8EndTime") setLinkbtn7Data({ ...linkbtn8Data, linkbtn8EndTime: changeDur });
    if (action === "linkbtn9StartTime") setLinkbtn7Data({ ...linkbtn9Data, linkbtn9StartTime: changeDur });
    if (action === "linkbtn9EndTime") setLinkbtn7Data({ ...linkbtn9Data, linkbtn9EndTime: changeDur });

    if (action === "Imgbtn1StartTime") setImgbtn1Data({ ...Imgbtn1Data, Imgbtn1StartTime: changeDur });
    if (action === "Imgbtn1EndTime") setImgbtn1Data({ ...Imgbtn1Data, Imgbtn1EndTime: changeDur });
    if (action === "Imgbtn2StartTime") setImgbtn2Data({ ...Imgbtn2Data, Imgbtn2StartTime: changeDur });
    if (action === "Imgbtn2EndTime") setImgbtn2Data({ ...Imgbtn2Data, Imgbtn2EndTime: changeDur });
    if (action === "Imgbtn3StartTime") setImgbtn3Data({ ...Imgbtn3Data, Imgbtn3StartTime: changeDur });
    if (action === "Imgbtn3EndTime") setImgbtn3Data({ ...Imgbtn3Data, Imgbtn3EndTime: changeDur });
    if (action === "Imgbtn4StartTime") setImgbtn4Data({ ...Imgbtn4Data, Imgbtn4StartTime: changeDur });
    if (action === "Imgbtn4EndTime") setImgbtn4Data({ ...Imgbtn4Data, Imgbtn4EndTime: changeDur });
    if (action === "Imgbtn5StartTime") setImgbtn5Data({ ...Imgbtn5Data, Imgbtn5StartTime: changeDur });
    if (action === "Imgbtn5EndTime") setImgbtn5Data({ ...Imgbtn5Data, Imgbtn5EndTime: changeDur });
    if (action === "Imgbtn6StartTime") setImgbtn6Data({ ...Imgbtn6Data, Imgbtn6StartTime: changeDur });
    if (action === "Imgbtn6EndTime") setImgbtn6Data({ ...Imgbtn6Data, Imgbtn6EndTime: changeDur });
    if (action === "Imgbtn7StartTime") setImgbtn7Data({ ...Imgbtn7Data, Imgbtn7StartTime: changeDur });
    if (action === "Imgbtn7EndTime") setImgbtn7Data({ ...Imgbtn7Data, Imgbtn7EndTime: changeDur });
    if (action === "Imgbtn8StartTime") setImgbtn8Data({ ...Imgbtn8Data, Imgbtn8StartTime: changeDur });
    if (action === "Imgbtn8EndTime") setImgbtn8Data({ ...Imgbtn8Data, Imgbtn8EndTime: changeDur });

    if (action === "review1StartTime") setReview1Data({ ...review1Data, review1StartTime: changeDur });
    if (action === "review1EndTime") setReview1Data({ ...review1Data, review1EndTime: changeDur });



    if (action === "CRMstartTime")
      setCopyPasteData({ ...copyPasteData, CRMstartTime: changeDur });

    if (action === "CRMendTime")
      setCopyPasteData({ ...copyPasteData, CRMendTime: changeDur });

    if (action === "leadgenTime")
      setLeadgenFormData({ ...leadgenFormData, leadgenTime: changeDur });
    if (action === "leadgen2Time")
      setLeadgenFormData({ ...leadgen2FormData, leadgenTime: changeDur });

    if (action === "pollTime")
      setCustPollData({ ...custPollData, pollTime: changeDur });
      
    if (action === "poll2Time")
      setCust2PollData({ ...cust2PollData, pollTime: changeDur });
      
    if (action === "poll3Time")
      setCust3PollData({ ...cust3PollData, pollTime: changeDur });

    if (action === "booktime1")
      setOpentable1Data({ ...opentable1Data, booktime: changeDur });

    if (action === "startTime")
      setShowAnimation({...showAnimation,startTime:changeDur})

    if (action === "endTime")
      setShowAnimation({...showAnimation,endTime:changeDur})

    if(action === "setStartTime" || action.includes("Start") ){
      setYtPlayer({...ytPlayer,start:changeDur})
      let s_time = getSeconds(changeDur);
      let e_time = getSeconds(ytPlayer.end);
      handleTriggerTime([s_time,e_time], "sync");
    }

    if(action === "setEndTime" || action.includes("End")){
      setYtPlayer({...ytPlayer,end:changeDur})
      let s_time = getSeconds(ytPlayer.start);
      let e_time = getSeconds(changeDur);
      handleTriggerTime([s_time,e_time], "sync");
    }
  };

  const handleImageChange = async (event) => {
    // console.log('joo');
    try {
      if (checkFileSize(event) && checkMimeType(event)) {
        // EditorContextData.loadingHandler(true);
        // document.getElementById("imageglrybx").classList.remove('show');
        // console.log(event.target.files[0]);
        // let imageDataUrl = await readFile(event.target.files[0]);

        UploadService.upload(event.target.files[0], token, (event) => {
          console.log(Math.round((100 * event.loaded) / event.total));
        })
        .then((response) => {
          // console.log(response.status);
          const imgLink = response.data.url;
          if (response.status === 200) {
            setVideoCTAData({ ...videoCTAData, image: imgLink });
          }
        })

        // EditorContextData.loadingHandler(false);

        event.target.value = "";
      }
    } catch (err) {
      console.log(err);
    }
  };

  const checkMimeType = (event) => {
    //getting file object
    let files = event.target.files;
    //define message container
    let err = "";
    // list allow mime type
    const types = ["image/png", "image/jpeg", "image/gif"];
    // loop access array

    //    console.log(files.length);
    if (types.every((type) => files[0].type !== type)) {
      // create error message and assign to container
      err +=
        files[0].type +
        " is not a supported format\n please upload JPG/PNG Images";
    }

    if (err !== "") {
      // if message not same old that mean has error
      event.target.value = null; // discard selected file
      // console.log(err)
      cuteToast({
        type: "error",
        message: err,
        timer: 5000,
        title: "",
      });
      return false;
    }
    return true;
  };

  const checkFileSize = (event) => {
    let files = event.target.files;
    let size = 2000000;
    let err = "";
    for (var x = 0; x < files.length; x++) {
      // console.log(files[x].size);
      if (files[x].size > size) {
        err +=
          files[x].type +
          " is too large, please pick a smaller file\n which is less than 4MB";
      }
    }
    if (err !== "") {
      event.target.value = null;
      // console.log(err)
      cuteToast({
        type: "error",
        message: err,
        timer: 5000,
        title: "",
      });
      return false;
    }

    return true;
  };

  const handleMeetingData = (event) => {
    event.preventDefault();
    const validateData = validateInfo(videoMeetingData, "meeting");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...videoMeetingData,
            camp_id,
            type: "video_meeting",
          },
        },
        (response) => {
          if (response.status === 200) {
            let mints = Math.floor(videoLength / 60);
            let meetingDuration =
              (mints < 10 ? `0${mints}` : mints) +
              ":" +
              ("0" + Math.floor(videoLength % 60)).slice(-2);
            setShowMeetingLink(false);

            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "video_meeting"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "video_meeting"
                  ? { ...obj, action_time: meetingDuration }
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                { action_event: "video_meeting", action_time: meetingDuration,id:response.id},
              ]);
            }

            setTriggerTime([...triggerTime, meetingDuration]);
            dispatch(
              personalizeAction.setTriggerTime({
                personalize_triggerTime: videoLength,
              })
            );
            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Meeting Timeline",
            });
          }
        }
      );
    }
  };

  const handleCTAData = (event) => {
    event.preventDefault();
    const validateData = validateInfo(videoCTAData, "cta");
    // const objIndex = actionPoint.findIndex(
    //   (obj) => (obj.action_event === "video_cta" && obj.action_time === videoCTAData.actiontime)
    // )
    // console.log(objIndex)
    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      setTriggerTime([...triggerTime, videoCTAData.actiontime]);
      dispatch(
        personalizeAction.setTriggerTime({
          personalize_triggerTime: videoCTAData.actiontime,
        })
      );
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...videoCTAData,
            camp_id,
            type: "video_cta",
          },
        },
        (response) => {
          // console.log(response);
          if (response.status === 200) {
            setShowCTA(false);
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "video_cta"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "video_cta"
                  ? { ...obj, action_time: videoCTAData.actiontime }
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "video_cta",
                  action_time: videoCTAData.actiontime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Call To Action Timeline",
            });
          }
        }
      );
    }
  };

  const handleAnnotationData = (event) => {
    event.preventDefault();
    const validateData = validateInfo(annotationData, "annotation");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...annotationData,
            camp_id,
            type: "video_annotation",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowAnnotation(false);
            // setTriggerTime(arrayRemove(triggerTime,annotationData.annotationStartTime,'triggerTime'))
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "video_annotation"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "video_annotation"
                  ? { ...obj, action_time: annotationData.annotationStartTime,action_end_time:annotationData.annotationEndTime}
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "video_annotation",
                  action_time: annotationData.annotationStartTime,
                  action_end_time:annotationData.annotationEndTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "CTA Timeline",
            });

            setShowTimingControl(false)
          }
        }
      );
    }
  };

  const handleBuybuttonData = (event) => {
    event.preventDefault();
    const validateData = validateInfo(buybuttonData, "buybutton");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...buybuttonData,
            camp_id,
            type: "buy_button",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowBuybutton(false);
            // setTriggerTime(arrayRemove(triggerTime,annotationData.annotationStartTime,'triggerTime'))
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "buy_button"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "buy_button"
                  ? { ...obj, action_time: buybuttonData.buybuttonStartTime,action_end_time:buybuttonData.buybuttonEndTime}
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "buy_button",
                  action_time: buybuttonData.buybuttonStartTime,
                  action_end_time:buybuttonData.buybuttonEndTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Annotation Timeline",
            });

            setShowTimingControl(false)
          }
        }
      );
    }
  };

  const handleLinkbtn2Data = (event) => {
    // eslint-disable-next-line
    event.preventDefault();
    const validateData = validateInfo(linkbtn2Data, "linkbutton2");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...linkbtn2Data,
            camp_id,
            type: "link_button2",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowLinkbutton2(false); 
            // setTriggerTime(arrayRemove(triggerTime,annotationData.annotationStartTime,'triggerTime'))
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "link_button2"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "link_button2"
                  ? { ...obj, action_time: linkbtn2Data.linkbtn2StartTime,action_end_time:linkbtn2Data.linkbtn2EndTime}
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "link_button2",
                  action_time: linkbtn2Data.linkbtn2StartTime,
                  action_end_time:linkbtn2Data.linkbtn2EndTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Button Link Timeline",
            });

            setShowTimingControl(false)
          }
        }
      );
    }
  };

  const handleLinkbtn3Data = (event) => {
    // eslint-disable-next-line
    event.preventDefault();
    const validateData = validateInfo(linkbtn3Data, "linkbutton3");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...linkbtn3Data,
            camp_id,
            type: "link_button3",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowLinkbutton3(false); 
            // setTriggerTime(arrayRemove(triggerTime,annotationData.annotationStartTime,'triggerTime'))
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "link_button3"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "link_button3"
                  ? { ...obj, action_time: linkbtn3Data.linkbtn3StartTime,action_end_time:linkbtn3Data.linkbtn3EndTime}
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "link_button3",
                  action_time: linkbtn3Data.linkbtn3StartTime,
                  action_end_time:linkbtn3Data.linkbtn3EndTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Button Link Timeline",
            });

            setShowTimingControl(false)
          }
        }
      );
    }
  };

  const handleLinkbtn4Data = (event) => {
    // eslint-disable-next-line
    event.preventDefault();
    const validateData = validateInfo(linkbtn4Data, "linkbutton4");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...linkbtn4Data,
            camp_id,
            type: "link_button4",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowLinkbutton4(false); 
            // setTriggerTime(arrayRemove(triggerTime,annotationData.annotationStartTime,'triggerTime'))
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "link_button4"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "link_button4"
                  ? { ...obj, action_time: linkbtn4Data.linkbtn4StartTime,action_end_time:linkbtn4Data.linkbtn4EndTime}
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "link_button4",
                  action_time: linkbtn4Data.linkbtn4StartTime,
                  action_end_time:linkbtn4Data.linkbtn4EndTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Button Link Timeline",
            });

            setShowTimingControl(false)
          }
        }
      );
    }
  };

  const handleLinkbtn5Data = (event) => {
    // eslint-disable-next-line
    event.preventDefault();
    const validateData = validateInfo(linkbtn5Data, "linkbutton5");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...linkbtn5Data,
            camp_id,
            type: "link_button5",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowLinkbutton5(false); 
            // setTriggerTime(arrayRemove(triggerTime,annotationData.annotationStartTime,'triggerTime'))
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "link_button5"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "link_button5"
                  ? { ...obj, action_time: linkbtn5Data.linkbtn5StartTime,action_end_time:linkbtn5Data.linkbtn5EndTime}
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "link_button5",
                  action_time: linkbtn5Data.linkbtn5StartTime,
                  action_end_time:linkbtn5Data.linkbtn5EndTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Button Link Timeline",
            });

            setShowTimingControl(false)
          }
        }
      );
    }
  };

  const handleLinkbtn6Data = (event) => {
    // eslint-disable-next-line
    event.preventDefault();
    const validateData = validateInfo(linkbtn6Data, "linkbutton6");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...linkbtn6Data,
            camp_id,
            type: "link_button6",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowLinkbutton6(false); 
            // setTriggerTime(arrayRemove(triggerTime,annotationData.annotationStartTime,'triggerTime'))
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "link_button6"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "link_button6"
                  ? { ...obj, action_time: linkbtn6Data.linkbtn6StartTime,action_end_time:linkbtn6Data.linkbtn6EndTime}
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "link_button6",
                  action_time: linkbtn6Data.linkbtn6StartTime,
                  action_end_time:linkbtn6Data.linkbtn6EndTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Button Timeline",
            });

            setShowTimingControl(false)
          }
        }
      );
    }
  };

  const handleLinkbtn7Data = (event) => {
    // eslint-disable-next-line
    event.preventDefault();
    const validateData = validateInfo(linkbtn7Data, "linkbutton7");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...linkbtn7Data,
            camp_id,
            type: "link_button7",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowLinkbutton7(false); 
            // setTriggerTime(arrayRemove(triggerTime,annotationData.annotationStartTime,'triggerTime'))
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "link_button7"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "link_button7"
                  ? { ...obj, action_time: linkbtn7Data.linkbtn7StartTime,action_end_time:linkbtn7Data.linkbtn7EndTime}
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "link_button7",
                  action_time: linkbtn7Data.linkbtn7StartTime,
                  action_end_time:linkbtn7Data.linkbtn7EndTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Button Timeline",
            });

            setShowTimingControl(false)
          }
        }
      );
    }
  };

  const handleLinkbtn8Data = (event) => {
    // eslint-disable-next-line
    event.preventDefault();
    const validateData = validateInfo(linkbtn8Data, "linkbutton8");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...linkbtn8Data,
            camp_id,
            type: "link_button8",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowLinkbutton8(false); 
            // setTriggerTime(arrayRemove(triggerTime,annotationData.annotationStartTime,'triggerTime'))
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "link_button8"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "link_button8"
                  ? { ...obj, action_time: linkbtn8Data.linkbtn8StartTime,action_end_time:linkbtn8Data.linkbtn8EndTime}
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "link_button8",
                  action_time: linkbtn8Data.linkbtn8StartTime,
                  action_end_time:linkbtn8Data.linkbtn8EndTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Social Media Timeline",
            });

            setShowTimingControl(false)
          }
        }
      );
    }
  };

  const handleLinkbtn9Data = (event) => {
    // eslint-disable-next-line
    event.preventDefault();
    const validateData = validateInfo(linkbtn9Data, "linkbutton9");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...linkbtn9Data,
            camp_id,
            type: "link_button9",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowLinkbutton9(false); 
            // setTriggerTime(arrayRemove(triggerTime,annotationData.annotationStartTime,'triggerTime'))
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "link_button9"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "link_button9"
                  ? { ...obj, action_time: linkbtn9Data.linkbtn9StartTime,action_end_time:linkbtn9Data.linkbtn9EndTime}
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "link_button9",
                  action_time: linkbtn9Data.linkbtn9StartTime,
                  action_end_time:linkbtn9Data.linkbtn9EndTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Social Media Timeline",
            });

            setShowTimingControl(false)
          }
        }
      );
    }
  };

  const handleImgbtn1Data = (event) => {
    // eslint-disable-next-line
    event.preventDefault();
    const validateData = validateInfo(Imgbtn1Data, "Imgbutton1");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...Imgbtn1Data,
            camp_id,
            type: "Img_btn1",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowImgbtn1(false); 
            // setTriggerTime(arrayRemove(triggerTime,annotationData.annotationStartTime,'triggerTime'))
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "Img_btn1"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "Img_btn1"
                  ? { ...obj, action_time: Imgbtn1Data.Imgbtn1StartTime,action_end_time:Imgbtn1Data.Imgbtn1EndTime}
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "Img_btn1",
                  action_time: Imgbtn1Data.Imgbtn1StartTime,
                  action_end_time:Imgbtn1Data.Imgbtn1EndTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Button Link Timeline",
            });

            setShowTimingControl(false)
          }
        }
      );
    }
  };

  const handleImgbtn2Data = (event) => {
    // eslint-disable-next-line
    event.preventDefault();
    const validateData = validateInfo(Imgbtn2Data, "Imgbutton2");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...Imgbtn2Data,
            camp_id,
            type: "Img_btn2",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowImgbtn2(false); 
            // setTriggerTime(arrayRemove(triggerTime,annotationData.annotationStartTime,'triggerTime'))
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "Img_btn2"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "Img_btn2"
                  ? { ...obj, action_time: Imgbtn2Data.Imgbtn2StartTime,action_end_time:Imgbtn2Data.Imgbtn2EndTime}
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "Img_btn2",
                  action_time: Imgbtn2Data.Imgbtn2StartTime,
                  action_end_time:Imgbtn2Data.Imgbtn2EndTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Button Link Timeline",
            });

            setShowTimingControl(false)
          }
        }
      );
    }
  };

  const handleImgbtn3Data = (event) => {
    // eslint-disable-next-line
    event.preventDefault();
    const validateData = validateInfo(Imgbtn3Data, "Imgbutton3");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...Imgbtn3Data,
            camp_id,
            type: "Img_btn3",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowImgbtn3(false); 
            // setTriggerTime(arrayRemove(triggerTime,annotationData.annotationStartTime,'triggerTime'))
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "Img_btn3"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "Img_btn3"
                  ? { ...obj, action_time: Imgbtn3Data.Imgbtn3StartTime,action_end_time:Imgbtn3Data.Imgbtn3EndTime}
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "Img_btn3",
                  action_time: Imgbtn3Data.Imgbtn3StartTime,
                  action_end_time:Imgbtn3Data.Imgbtn3EndTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Button Link Timeline",
            });

            setShowTimingControl(false)
          }
        }
      );
    }
  };

  const handleImgbtn4Data = (event) => {
    // eslint-disable-next-line
    event.preventDefault();
    const validateData = validateInfo(Imgbtn4Data, "Imgbutton4");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...Imgbtn4Data,
            camp_id,
            type: "Img_btn4",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowImgbtn4(false); 
            // setTriggerTime(arrayRemove(triggerTime,annotationData.annotationStartTime,'triggerTime'))
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "Img_btn4"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "Img_btn4"
                  ? { ...obj, action_time: Imgbtn4Data.Imgbtn4StartTime,action_end_time:Imgbtn4Data.Imgbtn4EndTime}
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "Img_btn4",
                  action_time: Imgbtn4Data.Imgbtn4StartTime,
                  action_end_time:Imgbtn4Data.Imgbtn4EndTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Button Link Timeline",
            });

            setShowTimingControl(false)
          }
        }
      );
    }
  };

  const handleImgbtn5Data = (event) => {
    // eslint-disable-next-line
    event.preventDefault();
    const validateData = validateInfo(Imgbtn5Data, "Imgbutton5");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...Imgbtn5Data,
            camp_id,
            type: "Img_btn5",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowImgbtn5(false); 
            // setTriggerTime(arrayRemove(triggerTime,annotationData.annotationStartTime,'triggerTime'))
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "Img_btn5"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "Img_btn5"
                  ? { ...obj, action_time: Imgbtn5Data.Imgbtn5StartTime,action_end_time:Imgbtn5Data.Imgbtn5EndTime}
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "Img_btn5",
                  action_time: Imgbtn5Data.Imgbtn5StartTime,
                  action_end_time:Imgbtn5Data.Imgbtn5EndTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Button Timer Timeline",
            });

            setShowTimingControl(false)
          }
        }
      );
    }
  };

  const handleImgbtn6Data = (event) => {
    // eslint-disable-next-line
    event.preventDefault();
    const validateData = validateInfo(Imgbtn6Data, "Imgbutton6");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...Imgbtn6Data,
            camp_id,
            type: "Img_btn6",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowImgbtn6(false); 
            // setTriggerTime(arrayRemove(triggerTime,annotationData.annotationStartTime,'triggerTime'))
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "Img_btn6"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "Img_btn6"
                  ? { ...obj, action_time: Imgbtn6Data.Imgbtn6StartTime,action_end_time:Imgbtn6Data.Imgbtn6EndTime}
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "Img_btn6",
                  action_time: Imgbtn6Data.Imgbtn6StartTime,
                  action_end_time:Imgbtn6Data.Imgbtn6EndTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Button Timer Timeline",
            });

            setShowTimingControl(false)
          }
        }
      );
    }
  };

  const handleImgbtn7Data = (event) => {
    // eslint-disable-next-line
    event.preventDefault();
    const validateData = validateInfo(Imgbtn7Data, "Imgbutton7");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...Imgbtn7Data,
            camp_id,
            type: "Img_btn7",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowImgbtn7(false); 
            // setTriggerTime(arrayRemove(triggerTime,annotationData.annotationStartTime,'triggerTime'))
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "Img_btn7"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "Img_btn7"
                  ? { ...obj, action_time: Imgbtn7Data.Imgbtn7StartTime,action_end_time:Imgbtn7Data.Imgbtn7EndTime}
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "Img_btn7",
                  action_time: Imgbtn7Data.Imgbtn7StartTime,
                  action_end_time:Imgbtn7Data.Imgbtn7EndTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Button Timer Timeline",
            });

            setShowTimingControl(false)
          }
        }
      );
    }
  };

  const handleImgbtn8Data = (event) => {
    // eslint-disable-next-line
    event.preventDefault();
    const validateData = validateInfo(Imgbtn8Data, "Imgbutton8");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...Imgbtn8Data,
            camp_id,
            type: "Img_btn8",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowImgbtn8(false); 
            // setTriggerTime(arrayRemove(triggerTime,annotationData.annotationStartTime,'triggerTime'))
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "Img_btn8"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "Img_btn8"
                  ? { ...obj, action_time: Imgbtn8Data.Imgbtn8StartTime,action_end_time:Imgbtn8Data.Imgbtn8EndTime}
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "Img_btn8",
                  action_time: Imgbtn8Data.Imgbtn8StartTime,
                  action_end_time:Imgbtn8Data.Imgbtn8EndTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Text & Image CTA Card Timeline",
            });

            setShowTimingControl(false)
          }
        }
      );
    }
  };

  const handleCopyPasteData = (event) => {
    event.preventDefault();
    const validateData = validateInfo(copyPasteData, "copyPaste");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...copyPasteData,
            camp_id,
            type: "video_copypaste",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowCopyPaste(false);

            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "video_copypaste"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "video_copypaste"
                  ? { ...obj, action_time: copyPasteData.CRMstartTime }
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "video_copypaste",
                  action_time: copyPasteData.CRMstartTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Copy Paste Form Timeline",
            });
          }
        }
      );
    }
  };

  const handleScriptCodeData = (event) => {
    event.preventDefault();
    const validateData = validateInfo(scriptCodeData, "scriptCode");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...scriptCodeData,
            camp_id,
            type: "scriptCode",
          },
        },
        (response) => {
          if (response.status === 200) {
            
            setScriptCodeForm_Visible(false);

            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "scriptCode"
            );
            console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "scriptCode"
                  ? { ...obj, action_time: scriptCodeData.scriptCodeStartTime }
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "scriptCode",
                  action_time: scriptCodeData.scriptCodeStartTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Script Code",
            });
          }
        }
      );
    }
  };
  
  const handleLeadGenData = (event) => {
    event.preventDefault();
    const validateData = validateInfo(leadgenFormData, "leadgenForm");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {

      dispatch(
        personalizeAction.setTriggerTime({
          personalize_triggerTime: leadgenFormData.leadgenTime,
        })
      );
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...leadgenFormData,
            camp_id,
            type: "video_leadgen",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowLeadGenForm(false);
            const objactIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "video_leadgen"
            );
            // console.log(objIndex)
            if (objactIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "video_leadgen"
                  ? { ...obj, action_time: leadgenFormData.leadgenTime }
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "video_leadgen",
                  action_time: leadgenFormData.leadgenTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Trigger Reel Form Timeline",
            });
          }
        }
      );
    }
  };

  const handleLeadGen2Data = (event) => {
    event.preventDefault();
    const validateData = validateInfo(leadgen2FormData, "leadgenForm");
    // const objIndex = actionPoint.findIndex(
    //   (obj) => (obj.action_event === "video_leadgen" && obj.action_time === leadgenFormData.leadgenTime)
    // )

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      // setTriggerTime([...triggerTime, leadgenFormData.leadgenTime]);
      dispatch(
        personalizeAction.setTriggerTime({
          personalize_triggerTime: leadgen2FormData.leadgenTime,
        })
      );
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...leadgen2FormData,
            camp_id,
            type: "video_leadgen2",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowLeadGen2Form(false);
            const objactIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "video_leadgen2"
            );
            // console.log(objIndex)
            if (objactIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "video_leadgen2"
                  ? { ...obj, action_time: leadgen2FormData.leadgenTime }
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "video_leadgen2",
                  action_time: leadgen2FormData.leadgenTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Trigger Reel Form Timeline",
            });
          }
        }
      );
    }
  };

  const handlePollData = (event) => {
    event.preventDefault();
    const validateData = validateInfo(custPollData, "customPoll");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...custPollData,
            camp_id,
            type: "video_custPoll",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowCustomPoll(false);

            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "video_custPoll"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "video_custPoll"
                  ? { ...obj, action_time: custPollData.pollTime }
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "video_custPoll",
                  action_time: custPollData.pollTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Full Screen Custom Poll Timeline",
            });
          }
        }
      );
    }
  };

  const handlePoll2Data = (event) => {
    event.preventDefault();
    const validateData = validateInfo(cust2PollData, "customPoll2");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...cust2PollData,
            camp_id,
            type: "video_cust2Poll",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowCustom2Poll(false);

            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "video_cust2Poll"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "video_cust2Poll"
                  ? { ...obj, action_time: cust2PollData.pollTime }
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "video_cust2Poll",
                  action_time: cust2PollData.pollTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Custom Poll Timeline",
            });
          }
        }
      );
    }
  };

  const handlePoll3Data = (event) => {
    event.preventDefault();
    const validateData = validateInfo(cust3PollData, "customPoll3");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...cust3PollData,
            camp_id,
            type: "video_cust3Poll",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowCustom3Poll(false);

            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "video_cust3Poll"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "video_cust3Poll"
                  ? { ...obj, action_time: cust3PollData.pollTime }
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "video_cust3Poll",
                  action_time: cust3PollData.pollTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Custom Poll Timeline",
            });
          }
        }
      );
    }
  };

  const handleOpentable1Data = (event) => {
    event.preventDefault();
    const validateData = validateInfo(opentable1Data, "opentable1");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...opentable1Data,
            camp_id,
            type: "video_opentable1",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowopentable1(false);

            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "video_opentable1"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "video_opentable1"
                  ? { ...obj, action_time: opentable1Data.booktime }
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "video_opentable1",
                  action_time: opentable1Data.booktime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Custom  Timeline",
            });
          }
        }
      );
    }
  };


  const handleReview1Data = (event) => {
    // eslint-disable-next-line
    event.preventDefault();
    const validateData = validateInfo(review1Data, "video_review1");

    if (Object.keys(validateData).length > 0) {
      setErrors(validateData);
      return false;
    } else if (Object.keys(validateData).length === 0) {
      updatePersonalizeData(
        {
          url: endPoints.addPersonalize,
          method: "POST",
          body: {
            ...review1Data,
            camp_id,
            type: "video_review1",
          },
        },
        (response) => {
          if (response.status === 200) {
            setShowReview1(false);
            // setTriggerTime(arrayRemove(triggerTime,annotationData.annotationStartTime,'triggerTime'))
            const objIndex = actionPoint.findIndex(
              (obj) => obj.action_event === "video_review1"
            );
            // console.log(objIndex)
            if (objIndex >= 0) {
              const newState = actionPoint.map((obj) =>
                obj.action_event === "video_review1"
                  ? { ...obj, action_time: review1Data.review1StartTime,action_end_time:review1Data.review1EndTime}
                  : obj
              );
              setActionPoint(newState);
            } else {
              setActionPoint([
                ...actionPoint,
                {
                  action_event: "video_review1",
                  action_time: review1Data.review1StartTime,
                  action_end_time:review1Data.review1EndTime,
                  id:response.id
                },
              ]);
            }

            cuteToast({
              type: "success",
              message: "Applied Successfully.",
              timer: 5000,
              title: "Review Timeline",
            });

            setShowTimingControl(false)
          }
        }
      );
    }
  };
  

  const getSeconds = (time) =>{
    // console.log(time)
    if(time === 0 || time === '0' || Number(time)){
      return time;
    }
    let duration = time.split(":");
    let sec = (parseInt(duration[0] * 60) + parseInt(duration[1]));
    return sec;
  }

  const getTime = (time) =>{
    // console.log(time)
    let minutes = Math.floor(time / 60);
    let video_duration = (minutes < 10 ? `0${minutes}` : minutes) + ":" + 
    ("0" + Math.floor(time % 60)).slice(-2);
    return video_duration;
  }

  const handleEditTrigger = (e, trigger,id) => {
    e.preventDefault();
    // console.log(trigger)
    setShowMeetingLink(false);
    setShowCTA(false);
    setShowAnnotation(false);
    setShowBuybutton(false);
    setShowLinkbutton2(false);
    setShowLinkbutton3(false);
    setShowLinkbutton4(false);
    setShowLinkbutton5(false);
    setShowLinkbutton6(false);
    setShowLinkbutton7(false);
    setShowLinkbutton8(false);
    setShowLinkbutton9(false);
    setShowImgbtn1(false);
    setShowImgbtn2(false);
    setShowImgbtn3(false);
    setShowImgbtn4(false);
    setShowImgbtn5(false);
    setShowImgbtn6(false);
    setShowImgbtn7(false);
    setShowImgbtn8(false);
    setShowCopyPaste(false);
    setScriptCodeForm_Visible(false);
    setShowLeadGenForm(false);
    setShowLeadGen2Form(false);
    setShowCustomPoll(false);
    setShowCustom2Poll(false);
    setShowCustom3Poll(false);
    setShowopentable1(false);
    setShowReview1(false);
    setErrors({})
    setShowIcons(false);
    setShowOverlay(false)
    setShowLowerThird(false)
    setShowIcons(false);
    setShowEffectControls(false)
    setShowTimingControl(false)
    setShowActiveTrigger(trigger)

    setShowAnimation({
      ...showAnimation,
      animationType:"",
      simpleRevealShow:false,
      nameAnim:false,
      textAnim1:false,
      textAnim2:false,
      speechBubble:false,
      speechBubble2:false,
      speechBubble3:false,
      speechThought:false,
      borderAnim:false,
      borderAnim2:false,
      ltAnimation1:false,
      ltAnimation3:false,
      ltAnimation2:false,
      ltAnimation4:false,
      ltAnimation5:false,
      smiley:false
    })

    trigger === "video_meeting" && setShowMeetingLink(true);
    if(trigger === "video_cta"){
      setShowCTA(true);
      setYtPlayer({
        ...ytPlayer,
        played:(getSeconds(videoCTAData.actiontime)/ytPlayer.duration),
        playedSeconds:getSeconds(videoCTAData.actiontime)
      })
    }
    
    if(trigger === "video_copypaste"){
      setShowCopyPaste(true);
      setYtPlayer({
        ...ytPlayer,
        played:(getSeconds(copyPasteData.CRMstartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(copyPasteData.CRMstartTime)
      })
    }

    if(trigger === "scriptCode"){
      setScriptCodeForm_Visible(true);
    }

    trigger === "video_leadgen" && setShowLeadGenForm(true);
    trigger === "video_leadgen2" && setShowLeadGen2Form(true);

    if(trigger === "video_custPoll"){
      setShowCustomPoll(true);
      setShowTimingControl(false);
      setYtPlayer({
        ...ytPlayer,
        played:(getSeconds(custPollData.pollTime)/ytPlayer.duration),
        playedSeconds:getSeconds(custPollData.pollTime)
      })
    }

    if(trigger === "video_cust2Poll"){
      setShowCustom2Poll(true);
      setShowTimingControl(false);
      setYtPlayer({
        ...ytPlayer,
        played:(getSeconds(cust2PollData.pollTime)/ytPlayer.duration),
        playedSeconds:getSeconds(cust2PollData.pollTime)
      })
    }

    if(trigger === "video_cust3Poll"){
      setShowCustom3Poll(true);
      setShowTimingControl(false);
      setYtPlayer({
        ...ytPlayer,
        played:(getSeconds(cust3PollData.pollTime)/ytPlayer.duration),
        playedSeconds:getSeconds(cust3PollData.pollTime)
      })
    }

    if(trigger === "video_opentable1"){
      setShowopentable1(true);
      setShowTimingControl(false);
      setYtPlayer({
        ...ytPlayer,
        played:(getSeconds(opentable1Data.booktime)/ytPlayer.duration),
        playedSeconds:getSeconds(opentable1Data.booktime)
      })
    }

    if(trigger === "video_review1"){
      setShowReview1(true);
      setShowTimingControl(false);
      setYtPlayer({
        ...ytPlayer,
        played:(getSeconds(review1Data.review1StartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(review1Data.review1StartTime)
      })
    }

    if(trigger === "video_annotation"){
      setShowAnnotation(true);
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(annotationData.annotationStartTime),
        end:getSeconds(annotationData.annotationEndTime),
        played:(getSeconds(annotationData.annotationStartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(annotationData.annotationStartTime)
      })
      setShowTimingControl(true)
    }

    if(trigger === "buy_button"){
      setShowBuybutton(true);
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(buybuttonData.buybuttonStartTime),
        end:getSeconds(buybuttonData.buybuttonEndTime),
        played:(getSeconds(buybuttonData.buybuttonStartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(buybuttonData.buybuttonStartTime)
      })
      setShowTimingControl(true)
    }

    if(trigger === "link_button2"){
      setShowLinkbutton2(true);
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(linkbtn2Data.linkbtn2StartTime),
        end:getSeconds(linkbtn2Data.linkbtn2EndTime),
        played:(getSeconds(linkbtn2Data.linkbtn2StartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(linkbtn2Data.linkbtn2StartTime)
      })
      setShowTimingControl(true)
    }

    if(trigger === "link_button3"){
      setShowLinkbutton3(true);
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(linkbtn3Data.linkbtn3StartTime),
        end:getSeconds(linkbtn3Data.linkbtn3EndTime),
        played:(getSeconds(linkbtn3Data.linkbtn3StartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(linkbtn3Data.linkbtn3StartTime)
      })
      setShowTimingControl(true)
    }
    
    if(trigger === "link_button4"){
      setShowLinkbutton4(true);
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(linkbtn4Data.linkbtn4StartTime),
        end:getSeconds(linkbtn4Data.linkbtn4EndTime),
        played:(getSeconds(linkbtn4Data.linkbtn4StartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(linkbtn4Data.linkbtn4StartTime)
      })
      setShowTimingControl(true)
    }
    
    if(trigger === "link_button5"){
      setShowLinkbutton5(true);
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(linkbtn5Data.linkbtn5StartTime),
        end:getSeconds(linkbtn5Data.linkbtn5EndTime),
        played:(getSeconds(linkbtn5Data.linkbtn5StartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(linkbtn5Data.linkbtn5StartTime)
      })
      setShowTimingControl(true)
    }

    
    if(trigger === "link_button6"){
      setShowLinkbutton6(true);
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(linkbtn6Data.linkbtn6StartTime),
        end:getSeconds(linkbtn6Data.linkbtn6EndTime),
        played:(getSeconds(linkbtn6Data.linkbtn6StartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(linkbtn6Data.linkbtn6StartTime)
      })
      setShowTimingControl(true)
    }
    
    if(trigger === "link_button7"){
      setShowLinkbutton7(true);
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(linkbtn7Data.linkbtn7StartTime),
        end:getSeconds(linkbtn7Data.linkbtn7EndTime),
        played:(getSeconds(linkbtn7Data.linkbtn7StartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(linkbtn7Data.linkbtn7StartTime)
      })
      setShowTimingControl(true)
    }
    
    if(trigger === "link_button8"){
      setShowLinkbutton8(true);
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(linkbtn8Data.linkbtn8StartTime),
        end:getSeconds(linkbtn8Data.linkbtn8EndTime),
        played:(getSeconds(linkbtn8Data.linkbtn8StartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(linkbtn8Data.linkbtn8StartTime)
      })
      setShowTimingControl(true)
    }
    if(trigger === "link_button9"){
      setShowLinkbutton9(true);
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(linkbtn9Data.linkbtn9StartTime),
        end:getSeconds(linkbtn9Data.linkbtn9EndTime),
        played:(getSeconds(linkbtn9Data.linkbtn9StartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(linkbtn9Data.linkbtn9StartTime)
      })
      setShowTimingControl(true)
    }

    if(trigger === "Img_btn1"){
      setShowImgbtn1(true);
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(Imgbtn1Data.Imgbtn1StartTime),
        end:getSeconds(Imgbtn1Data.Imgbtn1EndTime),
        played:(getSeconds(Imgbtn1Data.Imgbtn1StartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(Imgbtn1Data.Imgbtn1StartTime)
      })
      setShowTimingControl(true)
    }

    if(trigger === "Img_btn2"){
      setShowImgbtn2(true);
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(Imgbtn2Data.Imgbtn2StartTime),
        end:getSeconds(Imgbtn2Data.Imgbtn2EndTime),
        played:(getSeconds(Imgbtn2Data.Imgbtn2StartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(Imgbtn2Data.Imgbtn2StartTime)
      })
      setShowTimingControl(true)
    }

    if(trigger === "Img_btn3"){
      setShowImgbtn3(true);
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(Imgbtn3Data.Imgbtn3StartTime),
        end:getSeconds(Imgbtn3Data.Imgbtn3EndTime),
        played:(getSeconds(Imgbtn3Data.Imgbtn3StartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(Imgbtn3Data.Imgbtn3StartTime)
      })
      setShowTimingControl(true)
    }

    if(trigger === "Img_btn4"){
      setShowImgbtn4(true);
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(Imgbtn4Data.Imgbtn4StartTime),
        end:getSeconds(Imgbtn4Data.Imgbtn4EndTime),
        played:(getSeconds(Imgbtn4Data.Imgbtn4StartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(Imgbtn4Data.Imgbtn4StartTime)
      })
      setShowTimingControl(true)
    }

    if(trigger === "Img_btn5"){
      setShowImgbtn5(true);
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(Imgbtn5Data.Imgbtn5StartTime),
        end:getSeconds(Imgbtn5Data.Imgbtn5EndTime),
        played:(getSeconds(Imgbtn5Data.Imgbtn5StartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(Imgbtn5Data.Imgbtn5StartTime)
      })
      setShowTimingControl(true)
    }

    if(trigger === "Img_btn6"){
      setShowImgbtn6(true);
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(Imgbtn6Data.Imgbtn6StartTime),
        end:getSeconds(Imgbtn6Data.Imgbtn6EndTime),
        played:(getSeconds(Imgbtn6Data.Imgbtn6StartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(Imgbtn6Data.Imgbtn6StartTime)
      })
      setShowTimingControl(true)
    }

    if(trigger === "Img_btn7"){
      setShowImgbtn7(true);
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(Imgbtn7Data.Imgbtn7StartTime),
        end:getSeconds(Imgbtn7Data.Imgbtn7EndTime),
        played:(getSeconds(Imgbtn7Data.Imgbtn7StartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(Imgbtn7Data.Imgbtn7StartTime)
      })
      setShowTimingControl(true)
    }

    if(trigger === "Img_btn8"){
      setShowImgbtn8(true);
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(Imgbtn8Data.Imgbtn8StartTime),
        end:getSeconds(Imgbtn8Data.Imgbtn8EndTime),
        played:(getSeconds(Imgbtn8Data.Imgbtn8StartTime)/ytPlayer.duration),
        playedSeconds:getSeconds(Imgbtn8Data.Imgbtn8StartTime)
      })
      setShowTimingControl(true)
    }

    if(trigger === "simple_reveal"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      let revealData = overlayData.filter((item)=>item.type === trigger)
      setShowAnimation({
        ...showAnimation,
        name:"Simple Reveal Text",
        text1:revealData[0].text1,
        text2:revealData[0].text2,
        simpleRevealShow:revealData[0].simpleRevealShow,
        startTime: revealData[0].startTime,
        endTime : revealData[0].endTime,
        xPosition : revealData[0].xPosition,
        yPosition : revealData[0].yPosition,
        text1FontFamily:revealData[0].text1FontFamily,
        text1FontSize:revealData[0].text1FontSize,
        text1FontColor:revealData[0].text1FontColor,
        text1BgColor:revealData[0].text1BgColor,
        text2FontFamily:revealData[0].text2FontFamily,
        text2FontSize:revealData[0].text2FontSize,
        text2FontColor:revealData[0].text2FontColor,
        text2BgColor:revealData[0].text2BgColor,
        width:revealData[0].width,
        height:revealData[0].height,
        bgTheme:revealData[0].bgTheme,
        nameAnim:false,
        speechBubble:false,
        speechBubble2:false,
        speechBubble3:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation1:false,
        ltAnimation3:false,
        ltAnimation2:false,
        ltAnimation4:false,
        ltAnimation5:false,
        smiley:false
      })

      setWidth(revealData[0].width)
      setHeight(revealData[0].height)
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(revealData[0].startTime),
        end:getSeconds(revealData[0].endTime),
        played:(getSeconds(revealData[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(revealData[0].startTime)
      })
      setShowTimingControl(true) 

    }

    if(trigger === "speech_bubble"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      // console.log(overlayData)
      let data = overlayData.filter((item)=>item.type === trigger)
      // console.log(data)
      setShowAnimation({
        ...showAnimation,
        name:"Speech Bubble",
        text1:data[0].text1,
        speechBubble:data[0].speechBubble,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        text1BgColor:data[0].text1BgColor,
        width:data[0].width,
        height:data[0].height,
        bgTheme:data[0].bgTheme,
        simpleRevealShow:false,
        nameAnim:false,
        speechBubble2:false,
        speechBubble3:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation1:false,
        ltAnimation3:false,
        ltAnimation2:false,
        ltAnimation4:false,
        ltAnimation5:false,
        smiley:false,
        frameHeight:data[0].frameHeight,
        frameWidth:data[0].frameWidth,
      })

      setWidth(data[0].width)
      setHeight(data[0].height)

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "speech_bubble_2"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      let data = overlayData.filter((item)=>item.type === trigger)
      setShowAnimation({
        ...showAnimation,
        name:"Speech Bubble",
        text1:data[0].text1,
        text2:data[0].text2,
        speechBubble2:data[0].speechBubble2,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        text2FontFamily:data[0].text2FontFamily,
        text2FontSize:data[0].text2FontSize,
        text2FontColor:data[0].text2FontColor,
        text1BgColor:data[0].text1BgColor,
        width:data[0].width,
        height:data[0].height,
        bgTheme:data[0].bgTheme,
        simpleRevealShow:false,
        nameAnim:false,
        speechBubble:false,
        speechBubble3:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation1:false,
        ltAnimation3:false,
        ltAnimation2:false,
        ltAnimation4:false,
        ltAnimation5:false,
        smiley:false,
        frameHeight:data[0].frameHeight,
        frameWidth:data[0].frameWidth,
      })

      setWidth(data[0].width)
      setHeight(data[0].height)
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "speech_bubble_3"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      let data = overlayData.filter((item)=>item.type === trigger)
      setShowAnimation({
        ...showAnimation,
        name:"Speech Bubble",
        text1:data[0].text1,
        speechBubble3:data[0].speechBubble3,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        text1BgColor:data[0].text1BgColor,
        width:data[0].width,
        height:data[0].height,
        bgTheme:data[0].bgTheme,
        nameAnim:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation1:false,
        ltAnimation3:false,
        ltAnimation2:false,
        ltAnimation4:false,
        ltAnimation5:false,
        smiley:false,
        frameHeight:data[0].frameHeight,
        frameWidth:data[0].frameWidth,
      })

      setWidth(data[0].width)
      setHeight(data[0].height)
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "speech_thought"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      console.log(overlayData)
      let data = overlayData.filter((item)=>item.type === trigger)
      console.log(data)
      setShowAnimation({
        ...showAnimation,
        name:"Speech Thought",
        text1:data[0].text1,
        speechThought:data[0].speechThought,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        text1BgColor:data[0].text1BgColor,
        width:data[0].width,
        height:data[0].height,
        bgTheme:data[0].bgTheme,
        nameAnim:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation1:false,
        ltAnimation3:false,
        ltAnimation2:false,
        ltAnimation4:false,
        ltAnimation5:false,
        smiley:false,
        frameHeight:data[0].frameHeight,
        frameWidth:data[0].frameWidth,
      })

      setWidth(data[0].width)
      setHeight(data[0].height)
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "border_animation"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      let data = overlayData.filter((item)=>item.type === trigger)
      setShowAnimation({
        ...showAnimation,
        name:"Border Animation",
        text1:data[0].text1,
        borderAnim:data[0].borderAnim,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        text1BgColor:data[0].text1BgColor,
        text2BgColor:data[0].text2BgColor,
        width:data[0].width,
        height:data[0].height,
        bgTheme:data[0].bgTheme,
        nameAnim:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim2:false,
        ltAnimation1:false,
        ltAnimation3:false,
        ltAnimation2:false,
        ltAnimation4:false,
        ltAnimation5:false,
        smiley:false,
        frameHeight:data[0].frameHeight,
        frameWidth:data[0].frameWidth,
      })

      setWidth(data[0].width)
      setHeight(data[0].height)
      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "border_animation_2"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      let data = overlayData.filter((item)=>item.type === trigger)
      setShowAnimation({
        ...showAnimation,
        name:"Border Animation",
        text1:data[0].text1,
        borderAnim2:data[0].borderAnim2,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        text1BgColor:data[0].text1BgColor,
        width:data[0].width,
        height:data[0].height,
        bgTheme:data[0].bgTheme,
        nameAnim:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        ltAnimation1:false,
        ltAnimation3:false,
        ltAnimation2:false,
        ltAnimation4:false,
        ltAnimation5:false,
        smiley:false,
        frameHeight:data[0].frameHeight,
        frameWidth:data[0].frameWidth,
      })

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "lt_animation_1"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      // console.log(overlayData)
      let data = overlayData.filter((item)=>item.type === trigger)
      setShowAnimation({
        ...showAnimation,
        name:"Lower Third Animation",
        text1:data[0].text1,
        text2:data[0].text2,
        ltAnimation1:data[0].ltAnimation1,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        text2FontFamily:data[0].text2FontFamily,
        text2FontSize:data[0].text2FontSize,
        text2FontColor:data[0].text2FontColor,
        bgTheme:data[0].bgTheme,
        text2BgColor:data[0].text2BgColor,
        nameAnim:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation3:false,
        ltAnimation2:false,
        ltAnimation4:false,
        ltAnimation5:false,
        smiley:false
      })

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "lt_animation_2"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      let data = overlayData.filter((item)=>item.type === trigger)
      setShowAnimation({
        ...showAnimation,
        name:"Lower Third Animation",
        text1:data[0].text1,
        text2:data[0].text2,
        ltAnimation2:data[0].ltAnimation2,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        text2FontFamily:data[0].text2FontFamily,
        text2FontSize:data[0].text2FontSize,
        text2FontColor:data[0].text2FontColor,
        bgTheme:data[0].bgTheme,
        nameAnim:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation3:false,
        ltAnimation1:false,
        ltAnimation4:false,
        ltAnimation5:false,
        smiley:false
      })

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "lt_animation_3"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      let data = overlayData.filter((item)=>item.type === trigger)
      setShowAnimation({
        ...showAnimation,
        name:"Lower Third Animation",
        text1:data[0].text1,
        text2:data[0].text2,
        ltAnimation3:data[0].ltAnimation3,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        text2FontFamily:data[0].text2FontFamily,
        text2FontSize:data[0].text2FontSize,
        text2FontColor:data[0].text2FontColor,
        bgTheme:data[0].bgTheme,
        nameAnim:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation2:false,
        ltAnimation1:false,
        ltAnimation4:false,
        ltAnimation5:false,
        smiley:false
      })

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "lt_animation_4"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      let data = overlayData.filter((item)=>item.type === trigger)
      setShowAnimation({
        ...showAnimation,
        name:"Lower Third Animation",
        text1:data[0].text1,
        ltAnimation4:data[0].ltAnimation4,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        bgTheme:data[0].bgTheme,
        text2BgColor:data[0].text2BgColor,
        nameAnim:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation2:false,
        ltAnimation1:false,
        ltAnimation3:false,
        ltAnimation5:false,
        smiley:false
      })

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "lt_animation_5"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowIcons(false);
      setShowEffectControls(true)
      let data = overlayData.filter((item)=>item.type === trigger)
      setShowAnimation({
        ...showAnimation,
        name:"Lower Third Animation",
        text1:data[0].text1,
        text2:data[0].text2,
        ltAnimation5:data[0].ltAnimation5,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        text2FontFamily:data[0].text2FontFamily,
        text2FontSize:data[0].text2FontSize,
        text2FontColor:data[0].text2FontColor,
        text2BgColor:data[0].text2BgColor,
        bgTheme:data[0].bgTheme,
        nameAnim:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation2:false,
        ltAnimation1:false,
        ltAnimation4:false,
        ltAnimation3:false,
        smiley:false
      })

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "name_animation"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowEffectControls(true)
      setShowIcons(false);
      // console.log(overlayData)
      let data = overlayData.filter((item)=>item.type === trigger)
      // console.log(overlayData)
      setShowAnimation({
        ...showAnimation,
        name:"Name Overlay",
        text1:data[0].text1,
        nameAnim:data[0].nameAnim,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        width:data[0].width,
        height:data[0].height,
        animationType:data[0].animationType,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation2:false,
        ltAnimation1:false,
        ltAnimation4:false,
        ltAnimation3:false,
        ltAnimation5:false,
        smiley:false,
        frameHeight:data[0].frameHeight,
        frameWidth:data[0].frameWidth,
      })

      setWidth(data[0].width)
      setHeight(data[0].height)

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "text_animation_1"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowEffectControls(true)
      setShowIcons(false);
      // console.log(overlayData)
      let data = overlayData.filter((item)=>item.type === trigger)
      // console.log(overlayData)
      setShowAnimation({
        ...showAnimation,
        name:"Text Overlay",
        text1:data[0].text1,
        textAnim1:data[0].textAnim1,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        width:data[0].width,
        height:data[0].height,
        animationType:data[0].animationType,
        nameAnim:false,
        textAnim2:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation2:false,
        ltAnimation1:false,
        ltAnimation4:false,
        ltAnimation3:false,
        ltAnimation5:false,
        smiley:false
      })

      setWidth(data[0].width)
      setHeight(data[0].height)

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "text_animation_2"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowEffectControls(true)
      setShowIcons(false);
      // console.log(overlayData)
      let data = overlayData.filter((item)=>item.type === trigger)
      // console.log(overlayData)
      setShowAnimation({
        ...showAnimation,
        name:"Text Overlay",
        text1:data[0].text1,
        textAnim2:data[0].textAnim2,
        startTime: data[0].startTime,
        endTime : data[0].endTime,
        xPosition : data[0].xPosition,
        yPosition : data[0].yPosition,
        text1FontFamily:data[0].text1FontFamily,
        text1FontSize:data[0].text1FontSize,
        text1FontColor:data[0].text1FontColor,
        width:data[0].width,
        height:data[0].height,
        animationType:data[0].animationType,
        nameAnim:false,
        textAnim1:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation2:false,
        ltAnimation1:false,
        ltAnimation4:false,
        ltAnimation3:false,
        ltAnimation5:false,
        smiley:false
      })

      setWidth(data[0].width)
      setHeight(data[0].height)

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    if(trigger === "emoji_content"){
      setShowOverlay(false)
      setShowLowerThird(false)
      setShowEffectControls(true)
      setShowIcons(true);
      let data = overlayData.filter((item)=>item.type === trigger)
      // console.log(data)
      // console.log(data.findIndex((obj)=>obj.id === id))
      setShowAnimation({
        ...showAnimation,
        name:"Smiley",
        text1:data[data.findIndex((obj)=>obj.id === id)].text1,
        smiley:data[data.findIndex((obj)=>obj.id === id)].smiley,
        startTime: data[data.findIndex((obj)=>obj.id === id)].startTime,
        endTime : data[data.findIndex((obj)=>obj.id === id)].endTime,
        xPosition : data[data.findIndex((obj)=>obj.id === id)].xPosition,
        yPosition : data[data.findIndex((obj)=>obj.id === id)].yPosition,
        width:data[data.findIndex((obj)=>obj.id === id)].width,
        height:data[data.findIndex((obj)=>obj.id === id)].height,
        smileyContent:data[data.findIndex((obj)=>obj.id === id)].smileyContent,
        nameAnim:false,
        simpleRevealShow:false,
        speechBubble2:false,
        speechBubble3:false,
        speechBubble:false,
        speechThought:false,
        borderAnim:false,
        borderAnim2:false,
        ltAnimation2:false,
        ltAnimation1:false,
        ltAnimation4:false,
        ltAnimation3:false,
        ltAnimation5:false,
        frameWidth:data[data.findIndex((obj)=>obj.id === id)].frameWidth,
        frameHeight:data[data.findIndex((obj)=>obj.id === id)].frameHeight,
      })
      setActiveElelment(id)
      setWidth(data[0].width)
      setHeight(data[0].height)

      setYtPlayer({
        ...ytPlayer,
        start:getSeconds(data[0].startTime),
        end:getSeconds(data[0].endTime),
        played:(getSeconds(data[0].startTime)/ytPlayer.duration),
        playedSeconds:getSeconds(data[0].startTime)
      })
      setShowTimingControl(true) 
    }

    setShowActiveTrigger(trigger)
    setShowTimingControl(true)
  };



  const handleDeleteTrigger = (e, trigger,actionTime,id) => {
    e.preventDefault();

    deletePersonalizeData(
      {
        url: endPoints.deletePersonalize,
        method: "POST",
        body: { camp_id, id },
      },
      (response) => {
        if (response.status === 200 && response.message === "deleted") {
          if (trigger === "video_meeting") {
            dispatch(
              personalizeAction.setMeetingData({ personalize_meetingData: {} })
            );
            // var result = arrayRemove(actionPoint,trigger);
            let mints = Math.floor(videoLength / 60);
            let meetingDuration =
              (mints < 10 ? `0${mints}` : mints) +
              ":" +
              ("0" + Math.floor(videoLength % 60)).slice(-2);
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setTriggerTime(
              arrayRemove(triggerTime, meetingDuration, "triggerTime")
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: meetingDuration,
              })
            );
            setVideoMeetingData({
              fullname: "",
              designation: "",
              buttontext: "",
              meetingLink: "",
              buttonColor: "#00b2eb",
            });
          }

          if (trigger === "video_cta") {
            dispatch(personalizeAction.setCTAData({ personalize_CTAData: {} }));
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: videoCTAData.actiontime,
              })
            );
            setTriggerTime(
              arrayRemove(triggerTime, videoCTAData.actiontime, "triggerTime")
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setVideoCTAData({
              formtype: "text",
              text: "",
              image: "",
              link: "",
              actiontime: "00:00",
            });
          }

          if (trigger === "video_annotation") {
            dispatch(
              personalizeAction.setAnnotationData({
                personalize_AnnotationData: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: annotationData.annotationStartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                annotationData.annotationStartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setAnnotationData({
              annotationText: "Click on this link",
              annotationLink: "",
              annotationStartTime: "00:00",
              annotationEndTime: "00:00",
            });
          }

          if (trigger === "buy_button") {
            dispatch(
              personalizeAction.setBuybuttonData({
                personalize_BuybuttonData: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: buybuttonData.buybuttonStartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                buybuttonData.buybuttonStartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setBuybuttonData({
              buybuttonText: "Free Software",
              buybuttonText2: "Our Website is under construction",
              buybuttonText3: "Download",
              buybuttonLink: "",
              buybuttonStartTime: "00:00",
              buybuttonEndTime: "00:00",
              xPosition: 0,
              yPosition: 0
            });
          }

          if (trigger === "link_button2") {
            dispatch(
              personalizeAction.setLinkbtn2Data({
                personalize_linkbtn2Data: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: linkbtn2Data.linkbtn2StartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                linkbtn2Data.linkbtn2StartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setLinkbtn2Data({
              linkbtnText: "COMING SOON",
              linkbtnText2: "Our Website is under construction",
              linkbtnText3: "Get Updates",
              linkbtnLink: "",
              linkbtn2StartTime: "00:00",
              linkbtn2EndTime: "00:00",
              xPosition: 0,
              yPosition: 0
            });
          }

          if (trigger === "link_button3") {
            dispatch(
              personalizeAction.setLinkbtn3Data({
                personalize_linkbtn3Data: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: linkbtn3Data.linkbtn3StartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                linkbtn3Data.linkbtn3StartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setLinkbtn3Data({
              linkbtnText: "GET FREE",
              linkbtnText2: "EBook Unlocked With Button",
              linkbtnText3: "Download",
              linkbtnLink: "",
              linkbtn3StartTime: "00:00",
              linkbtn3EndTime: "00:00",
              xPosition: 0,
              yPosition: 0
            });
          }

          if (trigger === "link_button4") {
            dispatch(
              personalizeAction.setLinkbtn4Data({
                personalize_linkbtn4Data: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: linkbtn4Data.linkbtn4StartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                linkbtn4Data.linkbtn4StartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setLinkbtn4Data({
              linkbtnText: "FREE GIFT AVAILABLE",
              text1FontFamily: "Poppins",
              text1FontColor: "#ffffff",
              text1bold: false,
              text1Italic: false,
              linkbtnLink: "",
              linkbtn4StartTime: "00:00",
              linkbtn4EndTime: "00:00",
              xPosition: 0,
              yPosition: 0
            });
          }

          if (trigger === "link_button5") {
            dispatch(
              personalizeAction.setLinkbtn5Data({
                personalize_linkbtn5Data: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: linkbtn5Data.linkbtn5StartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                linkbtn5Data.linkbtn5StartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setLinkbtn5Data({
              linkbtnText: "GET FREE",
              linkbtnText2: "EBook Unlocked With Button",
              linkbtnText3: "Download",
              linkbtnLink: "",
              linkbtn5StartTime: "00:00",
              linkbtn5EndTime: "00:00",
              xPosition: 0,
              yPosition: 0
            });
          }

          if (trigger === "link_button6") {
            dispatch(
              personalizeAction.setLinkbtn6Data({
                personalize_linkbtn6Data: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: linkbtn6Data.linkbtn6StartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                linkbtn6Data.linkbtn6StartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setLinkbtn6Data({
              linkbtnText: "COMING SOON",
              text1FontFamily: "Poppins",
              text1FontColor: "#ffffff",
              text1bold: true,
              text1Italic: false,
              linkbtnText2: "Reference site about Lorem Ipsum, giving information on its origins,",
              text2FontFamily: "Poppins",
              text2FontColor: "#ffffff",
              text2bold: false,
              text2Italic: false,
              TimerTime: "2024-06-25T00:00:00",
              text3FontFamily: "Poppins",
              text3FontColor: "#ffffff",
              text3bold: false,
              text3Italic: false,
              bgcolor:"#5918ff",
              linkbtn6StartTime: "00:00",
              linkbtn6EndTime: "00:00",
              xPosition: 0,
              yPosition: 0
            });
          }
          
          if (trigger === "link_button7") {
            dispatch(
              personalizeAction.setLinkbtn7Data({
                personalize_linkbtn7Data: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: linkbtn7Data.linkbtn7StartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                linkbtn7Data.linkbtn7StartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setLinkbtn7Data({
              linkbtnText: "Read our 12,350 Google reviews",
              linkbtnLink: "",
              googleRating: "5",
              linkbtn7StartTime: "00:00",
              linkbtn7EndTime: "00:00",
              xPosition: 0,
              yPosition: 0
            });
          }

          if (trigger === "link_button8") {
            dispatch(
              personalizeAction.setLinkbtn8Data({
                personalize_linkbtn8Data: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: linkbtn8Data.linkbtn8StartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                linkbtn8Data.linkbtn8StartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setLinkbtn8Data({
              linkbtnLink1: "https://facebook.com/",
              linkbtnLink2: "https://twitter.com/",
              linkbtnLink3: "https://instagram.com/",
              linkbtnLink4: "https://linkedin.com/",
              design: "design1",
              linkbtn8StartTime: "00:00",
              linkbtn8EndTime: "00:05",
              xPosition: 0,
              yPosition: 0
            });
          }
          
          if (trigger === "link_button9") {
            dispatch(
              personalizeAction.setLinkbtn9Data({
                personalize_linkbtn9Data: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: linkbtn9Data.linkbtn9StartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                linkbtn9Data.linkbtn9StartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setLinkbtn9Data({
              linkbtnText: "SPECIAL OFFER",
              linkbtnText2: "VOUCHER SHOPPING",
              linkbtnText3: "75%",
              linkbtnText4: "1298383-E4839-34848",
              linkbtn9StartTime: "00:00",
              linkbtn9EndTime: "00:00",
              xPosition: 0,
              yPosition: 0,
              
              text1FontFamily: "Poppins",
              text1FontColor: "#222f7d",
              text1bold: true,
              text1Italic: false,
              text2FontFamily: "Poppins",
              text2FontColor: "#2994ff",
              text2bold: true,
              text2Italic: false,
              text3FontFamily: "Poppins",
              text3FontColor: "#ffffff",
              text3bold: false,
              text3Italic: false,
            });
          }

          if (trigger === "Img_btn1") {
            dispatch(
              personalizeAction.setImgbtn1Data({
                personalize_Imgbtn1Data: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: Imgbtn1Data.Imgbtn1StartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                Imgbtn1Data.Imgbtn1StartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setImgbtn1Data({
              ImgbtnText: "Scaling Your Site",
              ImgbtnText2: "Price: $56.00",
              ImgbtnText3: "Buy Now",
              ImgbtnText4: "Learn about hosting built for scale and reliability.",
              ImgbtnLink: "",
              ImgbtnURL: "https://d37q3r06begyqi.cloudfront.net/VidAmaze/users/1/images/site.jpg",
              Imgbtn1StartTime: "00:00",
              Imgbtn1EndTime: "00:00",
              xPosition: 0,
              yPosition: 0,

              text1FontFamily: "Poppins",
              text1FontColor: "#222f7d",
              text1bold: true,
              text1Italic: false,
              text2FontFamily: "Poppins",
              text2FontColor: "#2994ff",
              text2bold: false,
              text2Italic: false,
              text3FontFamily: "Poppins",
              text3FontColor: "#ffffff",
              text3bold: false,
              text3Italic: false,
              text4FontFamily: "Poppins",
              text4FontColor: "#222F7D",
              text4bold: false,
              text4Italic: false,
              
              buybuttonbgcolor:"#fa452d",
              bgcolor:"#ffffff",

              
            });
          }

          if (trigger === "Img_btn2") {
            dispatch(
              personalizeAction.setImgbtn2Data({
                personalize_Imgbtn2Data: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: Imgbtn2Data.Imgbtn2StartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                Imgbtn2Data.Imgbtn2StartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setImgbtn2Data({
              ImgbtnText: "SCAN QR CODE",
              ImgbtnText2: "Scan it to login to your dashboard ",
              ImgbtnURL: "https://d37q3r06begyqi.cloudfront.net/VidAmaze/users/1/uploads/hui9f3t1fkf.png",
              Imgbtn2StartTime: "00:00",
              Imgbtn2EndTime: "00:00",
              xPosition: 0,
              yPosition: 0,

              bgcolor: "#6d34ff",
              text1FontFamily: "Poppins",
              text1FontColor: "#ffffff",
              text1bold: true,
              text1Italic: false,
              text2FontFamily: "Poppins",
              text2FontColor: "#ffffff",
              text2bold: false,
              text2Italic: false,
            });
          }

          if (trigger === "Img_btn3") {
            dispatch(
              personalizeAction.setImgbtn3Data({
                personalize_Imgbtn3Data: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: Imgbtn3Data.Imgbtn3StartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                Imgbtn3Data.Imgbtn3StartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setImgbtn3Data({
              ImgbtnText: "Molecular Repair Hair Oil",
              ImgbtnText2: "Price: $8.69",
              ImgbtnLink: "",
              ImgbtnURL: "https://d37q3r06begyqi.cloudfront.net/VidAmaze/users/1/images/Molecular-Repair-Hair-Oil.png",
              Imgbtn3StartTime: "00:00",
              Imgbtn3EndTime: "00:00",
              xPosition: 0,
              yPosition: 0,

              text1FontFamily: "Poppins",
              text1FontColor: "#ffffff",
              text1bold: false,
              text1Italic: false,
              text2FontFamily: "Poppins",
              text2FontColor: "#ffffff",
              text2bold: true,
              text2Italic: true,
            });
          }

          if (trigger === "Img_btn4") {
            dispatch(
              personalizeAction.setImgbtn4Data({
                personalize_Imgbtn4Data: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: Imgbtn4Data.Imgbtn4StartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                Imgbtn4Data.Imgbtn4StartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setImgbtn4Data({
              ImgbtnText: "SCAN THE QR TO CONTINUE",
              ImgbtnURL: "https://d37q3r06begyqi.cloudfront.net/VidAmaze/users/1/uploads/hui9f3t1fkf.png",
              ImgbtnURL2: "https://d37q3r06begyqi.cloudfront.net/VidAmaze/users/1/images/Molecular-Repair-Hair-Oil.png",
              Imgbtn4StartTime: "00:00",
              Imgbtn4EndTime: "00:00",
              xPosition: 0,
              yPosition: 0,
              
              bgcolor: "#282a39",
              bgcolor2: "#0E1437",
              text1FontFamily: "Poppins",
              text1FontColor: "#99EEFF",
              text1bold: false,
              text1Italic: false,
            });
          }

          if (trigger === "Img_btn5") {
            dispatch(
              personalizeAction.setImgbtn5Data({
                personalize_Imgbtn5Data: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: Imgbtn5Data.Imgbtn5StartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                Imgbtn5Data.Imgbtn5StartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setImgbtn5Data({
              TimerTime: "2024-06-25T00:00:00",
              ImgbtnText: "Scaling Your Site",
              ImgbtnText2: "Price: $56.00",
              ImgbtnText3: "Buy Now",
              ImgbtnText4: "Learn about hosting built for scale and reliability.",
              ImgbtnLink: "",
              ImgbtnURL: "https://d37q3r06begyqi.cloudfront.net/VidAmaze/users/1/images/shoes.png",
              Imgbtn5StartTime: "00:00",
              Imgbtn5EndTime: "00:00",
              xPosition: 0,
              yPosition: 0,

              text1FontFamily: "Poppins",
              text1FontColor: "#ffffff",
              text1bold: true,
              text1Italic: false,
              text2FontFamily: "Poppins",
              text2FontColor: "#ffffff",
              text2bold: false,
              text2Italic: false,
              text3FontFamily: "Poppins",
              text3FontColor: "#ffffff",
              text3bold: false,
              text3Italic: false,
              text4FontFamily: "Poppins",
              text4FontColor: "#222F7D",
              text4bold: false,
              text4Italic: false,
              text5FontFamily: "Poppins",
              text5FontColor: "#222f7d",
              text5bold: false,
              text5Italic: false,
              timerbgcolor:"#FFE695",
              buybuttonbgcolor:"#fa452d",
              bgcolor:"#ffffff",
            });
          }

          if (trigger === "Img_btn6") {
            dispatch(
              personalizeAction.setImgbtn6Data({
                personalize_Imgbtn6Data: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: Imgbtn6Data.Imgbtn6StartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                Imgbtn6Data.Imgbtn6StartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setImgbtn6Data({
              ImgbtnText: "spicy fried fish",
              text1FontFamily: "Poppins",
              text1FontColor: "#0e1438",
              text1bold: true,
              text1Italic: false,
              ImgbtnText2: "salad, spicy, thai food single and for multiple",
              text2FontFamily: "Poppins",
              text2FontColor: "#7e85ab",
              text2bold: false,
              text2Italic: false,
              ImgbtnText3: "$8.6",
              text3FontFamily: "Poppins",
              text3FontColor: "#ffffff",
              text3bold: false,
              text3Italic: false,
              ImgbtnURL: "https://cdn.builder.io/api/v1/image/assets/TEMP/5fab9de7558ccae431ede5598ff3e99439da1f3c309d1a11bb5206c27807d8f5?apiKey=a520b1951fdc460185feff71c8ac30ff&width=100 100w",
              buttonColor: "#ff302f",
              bgColor: "#ffffff",
              ImgbtnLink: "",
              Imgbtn6StartTime: "00:00",
              Imgbtn6EndTime: "00:00",
              xPosition: 0,
              yPosition: 0
            });
          }

          if (trigger === "Img_btn7") {
            dispatch(
              personalizeAction.setImgbtn7Data({
                personalize_Imgbtn7Data: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: Imgbtn7Data.Imgbtn7StartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                Imgbtn7Data.Imgbtn7StartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setImgbtn7Data({
              ImgbtnText: "italian pizza",
              text1FontFamily: "Poppins",
              text1FontColor: "#ffffff",
              text1bold: true,
              text1Italic: false,
              ImgbtnText2: "$25.75",
              text2FontFamily: "Poppins",
              text2FontColor: "#ffffff",
              text2bold: false,
              text2Italic: false,
              ImgbtnLink: "",
              ImgbtnURL: "https://cdn.builder.io/api/v1/image/assets/TEMP/9423c4d2b3dcf46a90fbbbfcfd88c7f1d73fff19617ead31a2132ce9d60ac212?apiKey=a520b1951fdc460185feff71c8ac30ff&width=100 100w",
              Imgbtn7StartTime: "00:00",
              Imgbtn7EndTime: "00:00",
              xPosition: 0,
              yPosition: 0
            });
          }

          if (trigger === "Img_btn8") {
            dispatch(
              personalizeAction.setImgbtn8Data({
                personalize_Imgbtn8Data: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: Imgbtn8Data.Imgbtn8StartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                Imgbtn8Data.Imgbtn8StartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setImgbtn8Data({
              ImgbtnText: "Book training sessions",
              text1FontFamily: "Poppins",
              text1FontColor: "#222f7d",
              text1bold: true,
              text1Italic: false,
              ImgbtnText2: "BOOK NOW",
              text2FontFamily: "Poppins",
              text2FontColor: "#222f7d",
              text2bold: true,
              text2Italic: false,
              bgcolor1: "#6b71ff",
              bgcolor2: "#ffffff",
              bgcolor3: "#ffffff",
              ImgbtnLink: "",
              ImgbtnURL: "https://cdn.builder.io/api/v1/image/assets/TEMP/767d161f6eaf3cf52e7dfd279f225b9bd8ea202b7feeb771e1894b962d96544e?apiKey=a520b1951fdc460185feff71c8ac30ff&",
              Imgbtn8StartTime: "00:00",
              Imgbtn8EndTime: "00:00",
              xPosition: 0,
              yPosition: 0
            });
          }

          if (trigger === "video_copypaste") {
            dispatch(
              personalizeAction.setCopyPasteData({
                personalize_copyPasteData: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: copyPasteData.CRMstartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                copyPasteData.CRMstartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setCopyPasteData({
              CRMHtmlText: "",
              CRMskipCheck: true,
              bgCRMTheme: true,
              CRMstartTime: "00:00",
              CRMendTime: "00:00",
            });
          }

          if (trigger === "scriptCode") {
            dispatch(
              personalizeAction.setScript_Code({
                personalize_scriptCodeData: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: scriptCodeData.scriptCodeStartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                scriptCodeData.scriptCodeStartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setScriptCodeData({
              script: "",
              scriptCodeStartTime: "00:01",
            });
          }

          if (trigger === "video_leadgen") {
            dispatch(
              personalizeAction.setLeadgenFormData({
                personalize_leadgenFormData: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: leadgenFormData.leadgenTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                leadgenFormData.leadgenTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setLeadgenFormData({
              askphonechk: false,
              askcompanychk: false,
              headline: "Enter the following details to continue playing",
              buttonname: "Play",
              buttonColor: "#ff3987",
              note: "Note",
              leadgenTime: "00:00",
              leadgenSkipCheck: true,
            });
          }

          if (trigger === "video_leadgen2") {
            dispatch(
              personalizeAction.setLeadgen2FormData({
                personalize_leadgen2FormData: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: leadgen2FormData.leadgenTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                leadgen2FormData.leadgenTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setLeadgen2FormData({
              headline: "ENGAGE WITH QUIZZES",
              buttonname: "GET STARTED",
              note: "Looking for something new?",
              termsText: "Agree To Our Terms & Conditions",
              termsURL: "",
              hideterms: false,
              leadgenTime: "00:00",
              leadgenSkipCheck: true,
              responderType:"",
              param1:"",
              param2:"",
              param3:"",
            });
          }

          if (trigger === "video_custPoll") {
            dispatch(
              personalizeAction.setPollData({ personalize_pollData: {} })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: custPollData.pollTime,
              })
            );
            setTriggerTime(
              arrayRemove(triggerTime, custPollData.pollTime, "triggerTime")
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setCustPollData({
              question: "Your Question ?",
              option1: "Yes",
              option2: "No",
              option3: "",
              pollTime: "00:00",
              pollSkipChk: true,
            });
          }

          if (trigger === "video_cust2Poll") {
            dispatch(
              personalizeAction.setPoll2Data({ personalize_poll2Data: {} })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: cust2PollData.pollTime,
              })
            );
            setTriggerTime(
              arrayRemove(triggerTime, cust2PollData.pollTime, "triggerTime")
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setCust2PollData({
              question: "Your Question ?",
              option1: "Option 1",
              option2: "Option 2",
              option3: "Option 3",
              option4: "Option 4",
              pollTime: "00:00",
              pollSkipChk: true,
              xPosition: 0,
              yPosition: 0
            });
          }

          if (trigger === "video_cust3Poll") {
            dispatch(
              personalizeAction.setPoll3Data({ personalize_poll3Data: {} })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: cust3PollData.pollTime,
              })
            );
            setTriggerTime(
              arrayRemove(triggerTime, cust3PollData.pollTime, "triggerTime")
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setCust3PollData({
              question: "Your Question ?",
              polldesc: "Head over to dashboard to get started",
              option1: "Option 1",
              option2: "Option 2",
              option3: "Option 3",
              option4: "Option 4",
              pollTime: "00:00",
              pollSkipChk: true,
              xPosition: 0,
              yPosition: 0
            });
          }

          if (trigger === "video_opentable1") {
            dispatch(
              personalizeAction.setOpentable1Data({
                personalize_opentable1Data: {},
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: opentable1Data.booktime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                opentable1Data.booktime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setOpentable1Data({
              opentableText: "FIND YOUR DREAM HOME",
              opentableText2: "Head Over To Dashboard To Get Started",
              opentableText3: "LET'S GO",
              booktime: "00:00",
              pollSkipChk: true,
              xPosition: 0,
              yPosition: 0,

              text1FontFamily: "Poppins",
              text1FontColor: "#99EEFF",
              text1bold: true,
              text1Italic: false,
              text2FontFamily: "Poppins",
              text2FontColor: "#ffffff",
              text2bold: false,
              text2Italic: false,
              text3FontFamily: "Poppins",
              text3FontColor: "#0E1437",
              text3bold: false,
              text3Italic: false,
              bgcolor:"#0E1437",
              submitbgcolor:"#99EEFF",
            });
          }

          if (trigger === "video_review1"){
            dispatch(
              personalizeAction.setReview1Data({
                personalize_review1Data: {}
              })
            );
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: review1Data.review1StartTime,
              })
            );
            setTriggerTime(
              arrayRemove(
                triggerTime,
                review1Data.review1StartTime,
                "triggerTime"
              )
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));
            setReview1Data({
              auth_profile_url: '',
              author_name: '',
              time_description: '',
              rating: '',
              reviewText: '',
              auth_profile_url2: '',
              author_name2: '',
              time_description2: '',
              summery1: '',
              summery2: '',
              summery3: '',
              rating2: '',
              reviewText2: '',
              source: '',
              source_logo: '',
              review1StartTime: "00:00",
              review1EndTime: "00:05",
              xPosition: 0,
              yPosition: 0
            });
          }
          

          if (trigger === "name_animation") {
            
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: actionTime,
              })
            );
            setTriggerTime(
              arrayRemove(triggerTime, actionTime, "triggerTime")
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));

            dispatch(
              personalizeAction.setDeleteOverlayData({
                personalize_trigger: trigger,
              })
            );
            
          }

          if (trigger === "simple_reveal" || trigger === "speech_bubble" || trigger === "speech_bubble_2" || trigger === "speech_thought" ||
              trigger === "speech_bubble_3" || trigger === "border_animation" || trigger === "border_animation_2" || trigger === "lt_animation_1" || 
              trigger === "lt_animation_2" || trigger === "lt_animation_3" || trigger === "lt_animation_4" || trigger === "lt_animation_5") 
          {
            
            dispatch(
              personalizeAction.setDeleteTriggerTime({
                personalize_triggerTime: actionTime,
              })
            );
            setTriggerTime(
              arrayRemove(triggerTime, actionTime, "triggerTime")
            );
            setActionPoint(arrayRemove(actionPoint, trigger, "action_event"));

            dispatch(
              personalizeAction.setDeleteOverlayData({
                personalize_trigger: trigger,
              })
            );
          }

          if (trigger === "emoji_content" && id !== '') {
            
            const objIndex = actionPoint.findIndex(
              (obj) => obj.id === id
            );

            if(objIndex >= 0){
              dispatch(
                personalizeAction.setDeleteTriggerTime({
                  personalize_triggerTime: actionTime,
                })
              );
              setTriggerTime(
                arrayRemove(triggerTime, actionTime, "triggerTime")
              );
              setActionPoint(arrayRemove(actionPoint, id, "action_emoji"));
                
              dispatch(
                personalizeAction.setDeleteOverlayData({
                  personalize_trigger: id,
                })
              );
            }
            
          }

          cuteToast({
            type: "success",
            message: "Deleted Successfully.",
            timer: 5000,
            title: `${trigger.replace(/_/g, " ")} Timeline`,
          });

        }
      }
    );
  };

  function arrayRemove(arr, value, type) {
    if (type === "action_event") {
      return arr.filter(function (ele) {
        return ele.action_event !== value;
      });
    } else if (type === "triggerTime") {
      return arr.filter(function (ele) {
        return ele !== value;
      });
    }else if (type === 'action_emoji'){
      return arr.filter(function (ele) {
        return ele.id !== value;
      });
    }
  }

  const getActioTime = (time) => {
    // console.log(time,videoLength)
    let duration = time.split(":");
    let sec = (parseInt(duration[0] * 60) + parseInt(duration[1]));
    // console.log(sec,videoLength)
    return (sec / videoLength) * 100 + "%";
  };

  const handleEffectSetting = (e,type) =>{
    e.preventDefault();
    setShowOverlay(false)
    setShowLowerThird(false)
    setShowEffectControls(true)
    // console.log(format(ytPlayer.loaded * ytPlayer.played))
    if(type === 'simple_reveal'){
      setShowAnimation({
        ...showAnimation,
        name:"Simple Reveal Text",
        text1:"Simple Reveal Effect",
        text2:"Using HTML And CSS",
        text1FontFamily:"Montserrat",
        text1FontSize:"28",
        text1FontColor:"#ffffff",
        text1BgColor:"#f9ff57",
        text2FontFamily:"Montserrat",
        text2FontSize:"28",
        text2FontColor:"#ffffff",
        text2BgColor:"#9933ab",
        bgTheme:"0,0,0,.75",
        startTime:(Number(ytPlayer.start) || ytPlayer.start === 0)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        xPosition:0,
        yPosition:0,
        simpleRevealShow:true
      })
      setWidth(390)
      setHeight(180)
    }else if(type === 'speech_bubble'){
      setShowAnimation({
        ...showAnimation,
        name:"Speech Bubble",
        text1:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Autem quos",
        text1FontFamily:"Montserrat",
        text1FontSize:"18",
        text1FontColor:"#8b8888",
        text1BgColor:"#904ece",
        bgTheme:"0,0,0,.75",
        startTime:(Number(ytPlayer.start) || ytPlayer.start === 0)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        xPosition:0,
        yPosition:0,
        speechBubble:true
      })
      setWidth(200)
      setHeight(120)
    }else if(type === 'speech_thought'){
      setShowAnimation({
        ...showAnimation,
        name:"Speech Bubble Thought",
        text1:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Autem quos",
        text1FontFamily:"Montserrat",
        text1FontSize:"18",
        text1FontColor:"#8b8888",
        text1BgColor:"#904ece",
        bgTheme:"0,0,0,.75",
        startTime:(Number(ytPlayer.start) || ytPlayer.start === 0)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        xPosition:0,
        yPosition:0,
        speechThought:true
      })
      setWidth(400)
      setHeight(120)
    }else if(type === 'speech_bubble_2'){
      setShowAnimation({
        ...showAnimation,
        name:"Preset Horizontal Wobble",
        text1:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Autem quos",
        text2:"Autem quos",
        text1FontFamily:"Montserrat",
        text1FontSize:"15",
        text1FontColor:"#ffffff",
        text1BgColor:"#1abc9c",
        text2FontFamily:"Montserrat",
        text2FontSize:"14",
        text2FontColor:"#ffffff",
        bgTheme:"0,0,0,.75",
        startTime:(Number(ytPlayer.start) || ytPlayer.start === 0)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        xPosition:0,
        yPosition:0,
        speechBubble2:true
      })
      setWidth(400)
      setHeight(210)
    }else if(type === 'speech_bubble_3'){
      setShowAnimation({
        ...showAnimation,
        name:"Speech Bubble",
        text1:"Lorem ipsum dolor sit amet !",
        text1FontFamily:"Montserrat",
        text1FontSize:"18",
        text1FontColor:"#8b8888",
        text1BgColor:"#629bdd",
        bgTheme:"0,0,0,.75",
        startTime:(Number(ytPlayer.start) || ytPlayer.start === 0)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        xPosition:0,
        yPosition:0,
        speechBubble3:true
      })
      setWidth(320)
      setHeight(120)
    }else if(type === 'speech_bubble_4'){
      setShowAnimation({
        ...showAnimation,
        name:"Speech Bubble",
        text1:"Lorem ipsum dolor sit amet !",
        startTime:(Number(ytPlayer.start) || ytPlayer.start === 0)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        xPosition:0,
        yPosition:0,
        speechBubble4:true
      })
    }else if(type === 'border_animation'){
      setShowAnimation({
        ...showAnimation,
        name:"Border Animation",
        text1:"Lorem ipsum dolor sit amet !",
        text1FontFamily:"Montserrat",
        text1FontSize:"28",
        text1FontColor:"#ffffff",
        text2BgColor:"#ffffff",
        text1BgColor:"#000000",
        bgTheme:"0,0,0,.75",
        startTime:(Number(ytPlayer.start) || ytPlayer.start === 0)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        xPosition:0,
        yPosition:0,
        borderAnim:true
      })
      setWidth(350)
      setHeight(130)
    }else if(type === 'border_animation_2'){
      setShowAnimation({
        ...showAnimation,
        name:"Border Animation",
        text1:"Lorem ipsum dolor sit amet !",
        text1FontFamily:"Montserrat",
        text1FontSize:"28",
        text1FontColor:"#ffffff",
        text1BgColor:"#787878",
        text2BgColor:"#eaab00",
        bgTheme:"0,0,0,.75",
        startTime:(Number(ytPlayer.start) || ytPlayer.start === 0)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        xPosition:0,
        yPosition:0,
        borderAnim2:true
      })
      setWidth(300)
      setHeight(250)
    }else if(type === 'lt_animation_1'){
      setShowAnimation({
        ...showAnimation,
        name:"Lower Third Animation",
        text1:"John Doe",
        text2:"Motion Designer",
        text1FontFamily:"Montserrat",
        text1FontSize:"28",
        text1FontColor:"#ffffff",
        text2FontFamily:"Montserrat",
        text2FontSize:"28",
        text2FontColor:"#ffffff",
        bgTheme:"0,0,0,.75",
        text2BgColor:"#cf4c4e",
        startTime:(Number(ytPlayer.start) || ytPlayer.start === 0)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        ltAnimation1:true
      })
    }else if(type === 'lt_animation_2'){
      setShowAnimation({
        ...showAnimation,
        name:"Lower Third Animation",
        text1:"John Doe",
        text2:"Motion Designer",
        text1FontFamily:"Montserrat",
        text1FontSize:"20",
        text1FontColor:"#cf4c4e",
        text2FontFamily:"Montserrat",
        text2FontSize:"20",
        text2FontColor:"#ffffff",
        bgTheme:"0,0,0,.75",
        startTime:(Number(ytPlayer.start) || ytPlayer.start === 0)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        ltAnimation2:true
      })
    }else if(type === 'lt_animation_3'){
      setShowAnimation({
        ...showAnimation,
        name:"Lower Third Animation",
        text1:"John",
        text2:"Doe",
        text1FontFamily:"Montserrat",
        text1FontSize:"38",
        text1FontColor:"#ffffff",
        text2FontFamily:"Montserrat",
        text2FontSize:"40",
        text2FontColor:"#cf4c4e",
        bgTheme:"0,0,0,.75",
        startTime:(Number(ytPlayer.start) || ytPlayer.start === 0)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        ltAnimation3:true
      })
    }else if(type === 'lt_animation_4'){
      setShowAnimation({
        ...showAnimation,
        name:"Lower Third Animation",
        text1:"John Doe",
        text1FontFamily:"Montserrat",
        text1FontSize:"42",
        text1FontColor:"#ffffff",
        bgTheme:"0,0,0,.75",
        text2BgColor:"#cf4c4e",
        startTime:(Number(ytPlayer.start) || ytPlayer.start === 0)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        ltAnimation4:true
      })
    }else if(type === 'lt_animation_5'){
      setShowAnimation({
        ...showAnimation,
        name:"Lower Third Animation",
        text1:"John Doe",
        text2:"Motion Designer",
        text1FontFamily:"Montserrat",
        text1FontSize:"32",
        text1FontColor:"#ffffff",
        text2FontFamily:"Montserrat",
        text2FontSize:"13",
        text2FontColor:"#ffffff",
        bgTheme:"0,0,0,.75",
        text2BgColor:"#cf4c4e",
        startTime:(Number(ytPlayer.start) || ytPlayer.start === 0)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        ltAnimation5:true
      })
    }else if(type === 'name_animation'){
      setShowAnimation({
        ...showAnimation,
        name:"Text Overlay",
        text1:"John Doe",
        text1FontFamily:"Montserrat",
        text1FontSize:"28",
        text1FontColor:"#ffffff",
        startTime:(Number(ytPlayer.start) || ytPlayer.start === 0)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        animationType:"",
        nameAnim:true
      })
      setHeight(100)
    }else if(type === 'text_animation_1'){
      setShowAnimation({
        ...showAnimation,
        name:"Simple Text Animation",
        text1:"John Doe",
        text1FontFamily:"Montserrat",
        text1FontSize:"28",
        text1FontColor:"#ffffff",
        startTime:(Number(ytPlayer.start) || ytPlayer.start === 0)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        animationType:"",
        textAnim1:true
      })
      setHeight(100)
    }else if(type === 'text_animation_2'){
      setShowAnimation({
        ...showAnimation,
        name:"Simple Text Animation",
        text1:"John Doe",
        text1FontFamily:"Montserrat",
        text1FontSize:"28",
        text1FontColor:"#ffffff",
        startTime:(Number(ytPlayer.start) || ytPlayer.start === 0)? format(ytPlayer.start):"00:00",
        endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
        animationType:"",
        textAnim2:true
      })
      setHeight(100)
    }else if(type.includes(".svg")){
      // console.log(type)
      var contentArr = [...showAnimation.smileyContent];
      // console.log(contentArr)
          contentArr.push(type)

      if(activeElement){
        setShowAnimation({
          ...showAnimation,
          name:"Smileys",
          text1:type,
          smiley:true,
          smileyContent:contentArr
        })
        
      }else{
        setShowAnimation({
          ...showAnimation,
          name:"Smileys",
          text1:type,
          startTime:(Number(ytPlayer.start) || ytPlayer.start === 0)? format(ytPlayer.start):"00:00",
          endTime:Number(ytPlayer.end)? format(ytPlayer.end):"00:05",
          smiley:true,
          smileyContent:contentArr
        })
      }
      setWidth(150)
      setHeight(100)
    }
    setShowActiveTrigger(type)
    setShowTimingControl(true)

  }

  const handleCloseShowIcon = () =>{
    setShowIcons(false);
    setShowAnimation({
      ...showAnimation,
      smileyContent:[]
    })
    setActiveElelment("")
  }

  const handleClose = (e,type) =>{
    setShowTimingControl(false)
    if(type === 'simple_reveal'){
      setShowAnimation({
        ...showAnimation,
        simpleRevealShow:false
      })
    }

    if(type === 'speech_bubble'){
      setShowAnimation({
        ...showAnimation,
        speechBubble:false
      })
    }

    if(type === 'speech_bubble_2'){
      setShowAnimation({
        ...showAnimation,
        speechBubble2:false
      })
    }

    if(type === 'speech_bubble_3'){
      setShowAnimation({
        ...showAnimation,
        speechBubble3:false
      })
    }

    // if(type === 'speech_bubble_4'){
    //   setShowAnimation({
    //     ...showAnimation,
    //     speechBubble3:false
    //   })
    // }

    if(type === 'speech_thought'){
      setShowAnimation({
        ...showAnimation,
        speechThought:false
      })
    }

    if(type === 'border_animation'){
      setShowAnimation({
        ...showAnimation,
        borderAnim:false
      })
    }

    if(type === 'border_animation_2'){
      setShowAnimation({
        ...showAnimation,
        borderAnim2:false
      })
    }

    if(type === 'lt_animation_1'){
      setShowAnimation({
        ...showAnimation,
        ltAnimation1:false
      })
    }

    if(type === 'lt_animation_2'){
      setShowAnimation({
        ...showAnimation,
        ltAnimation2:false
      })
    }

    if(type === 'lt_animation_3'){
      setShowAnimation({
        ...showAnimation,
        ltAnimation3:false
      })
    }

    if(type === 'lt_animation_4'){
      setShowAnimation({
        ...showAnimation,
        ltAnimation4:false
      })
    }

    if(type === 'lt_animation_5'){
      setShowAnimation({
        ...showAnimation,
        ltAnimation5:false
      })
    }

    if(type === 'name_animation'){
      setShowAnimation({
        ...showAnimation,
        nameAnim:false
      })
    }

    if(type === 'text_animation_1'){
      setShowAnimation({
        ...showAnimation,
        textAnim1:false
      })
    }

    if(type === 'text_animation_2'){
      setShowAnimation({
        ...showAnimation,
        textAnim2:false
      })
    }

    if(type === 'emoji_content'){
      setShowAnimation({
        ...showAnimation,
        smiley:false
      })
      setActiveElelment("")
    }

    setShowEffectControls(false);
  }

  const handleDeleteIcon = (e,icon) =>{
    e.preventDefault();
    let contentArr = showAnimation.smileyContent;
    const removeIconElem = contentArr.filter((svg) => svg !== icon);
    setShowAnimation({
      ...showAnimation,
      smileyContent:removeIconElem
    })
  }

  const handleEffectData = (e,type) =>{
    e.preventDefault();
    // console.log(type)
    if(type === 'simple_reveal' || type === 'speech_bubble' || type === 'speech_bubble_2' || type === 'speech_bubble_3' ||
    type === 'speech_thought' || type === 'speech_bubble_4' || type === 'border_animation' || type === 'border_animation_2' || 
    type === 'lt_animation_1' || type === 'lt_animation_2' || type === 'lt_animation_3' || type === 'lt_animation_4' || 
    type === 'lt_animation_5' || type === 'name_animation' || type === 'text_animation_1' || type === 'text_animation_2'){
      const validateData = validateInfo(showAnimation, type);

      if (Object.keys(validateData).length > 0) {
        setErrors(validateData);
        return false;
      } else if (Object.keys(validateData).length === 0) {
        updatePersonalizeData(
          {
            url: endPoints.addPersonalize,
            method: "POST",
            body: {
              ...showAnimation,
              camp_id,
              type,
            },
          },
          (response) => {
            if (response.status === 200) {
              setShowEffectControls(false);
              setShowTimingControl(false)

              const objIndex = actionPoint.findIndex(
                (obj) => obj.action_event === type
              );
              // console.log(objIndex)
              if (objIndex >= 0) {
                const newState = actionPoint.map((obj) =>
                  obj.action_event === type
                    ? { ...obj, action_time: showAnimation.startTime,action_end_time:showAnimation.endTime }
                    : obj
                );
                setActionPoint(newState);
              } else {
                setActionPoint([
                  ...actionPoint,
                  {
                    action_event: type,
                    action_time: showAnimation.startTime,
                    action_end_time:showAnimation.endTime,
                    id:response.id
                  },
                ]);
              }

              if(type === 'lt_animation_1' || type === 'lt_animation_2' || type === 'lt_animation_3' || 
              type === 'lt_animation_4' || type === 'lt_animation_5'){
                cuteToast({
                  type: "success",
                  message: "Applied Successfully.",
                  timer: 5000,
                  title: "Lower Third Effect Timeline",
                });

              }else if(type === 'name_animation'){
                cuteToast({
                  type: "success",
                  message: "Applied Successfully.",
                  timer: 5000,
                  title: "Name Personalize Timeline",
                });
              }else if(type === 'text_animation_1'){
                cuteToast({
                  type: "success",
                  message: "Applied Successfully.",
                  timer: 5000,
                  title: "Text Personalize Timeline",
                });
              }else if(type === 'text_animation_2'){
                cuteToast({
                  type: "success",
                  message: "Applied Successfully.",
                  timer: 5000,
                  title: "Text Personalize Timeline",
                });
              }else{
                cuteToast({
                  type: "success",
                  message: "Applied Successfully.",
                  timer: 5000,
                  title: "Overlay Effect Timeline",
                });
              }

              setShowAnimation({
                ...showAnimation,
                animationType:"",
                simpleRevealShow:false,
                nameAnim:false,
                textAnim1:false,
                textAnim2:false,
                speechBubble:false,
                speechBubble2:false,
                speechBubble3:false,
                speechThought:false,
                borderAnim:false,
                borderAnim2:false,
                ltAnimation1:false,
                ltAnimation3:false,
                ltAnimation2:false,
                ltAnimation4:false,
                ltAnimation5:false,
                speechBubble4:false
              })

            }
          }
        );
      }
    }

    if(type === "emoji_content"){
      const validateData = validateInfo(showAnimation, type);

      if (Object.keys(validateData).length > 0) {
        setErrors(validateData);
        return false;
      } else if (Object.keys(validateData).length === 0) {
        updatePersonalizeData(
          {
            url: endPoints.addPersonalize,
            method: "POST",
            body: {
              ...showAnimation,
              camp_id,
              type,
              id:activeElement
            },
          },
          (response) => {
            if (response.status === 200) {
              setShowEffectControls(false);
              setShowTimingControl(false)


              const objIndex = actionPoint.findIndex(
                (obj) => obj.id === activeElement
              );
              // console.log(objIndex)
              if (objIndex >= 0) {
                const newState = actionPoint.map((obj) =>
                  obj.id === activeElement
                    ? { ...obj, action_time: showAnimation.startTime }
                    : obj
                );
                setActionPoint(newState);
              } else {
                setActionPoint([
                  ...actionPoint,
                  {
                    action_event: type,
                    action_time: showAnimation.startTime,
                    id:response.id
                  },
                ]);
              }

              cuteToast({
                type: "success",
                message: "Applied Successfully.",
                timer: 5000,
                title: "Icons Timeline",
              });

              setShowAnimation({
                ...showAnimation,
                smiley:false
              })
              setActiveElelment("");
              setShowIcons(false);

              const objOverlayIndex = overlayData.findIndex(
                (obj) => obj.id === activeElement
              );
          
              if (objOverlayIndex >= 0) {
                const newState = overlayData.map((obj) =>
                  obj.id === activeElement
                    ? { ...obj, ...showAnimation }
                    : obj
                );
          
                dispatch(
                  personalizeAction.setOverlayData({
                    overlayData:newState
                  })
                );
          
              }else{
                dispatch(
                  personalizeAction.setOverlayData({
                    overlayData: [{...showAnimation,type,id:activeElement}],
                  })
                );
              }
            }
          }
        );
      }
    }else{
     
      const objOverlayIndex = overlayData.findIndex(
        (obj) => obj.type === type
      );
      const existData = overlayData.filter((obj)=>obj.type !== type);
        
      if (objOverlayIndex >= 0) {
        const newState = overlayData.map((obj) =>
          obj.type === type
            ? { ...obj, ...showAnimation }
            : obj
        );
        
        dispatch(
          personalizeAction.setOverlayData({
            overlayData:newState
          })
        );
  
      }else{
        
        dispatch(
          personalizeAction.setOverlayData({
            overlayData: [].concat(existData, {...showAnimation,type}),
          })
        );
      }
    }

  }

  const DraggableEventHandler = (e,data) =>{
    // e.stopPropagation();
    console.log(data)

    let frameWidth = videoFrameRef.current.offsetWidth;
    let frameHeight = videoFrameRef.current.offsetHeight;
    

    // console.log(data.node.getAttribute("class").includes("simple-reveal-container"))

    if(data.node.getAttribute("class").includes("simple-reveal-container-resize")){
      setShowAnimation({
        ...showAnimation,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("speech-bubble-container-resize")){
      setShowAnimation({
        ...showAnimation,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("speech-thought-container-resize")){
      setShowAnimation({
        ...showAnimation,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("speech-bubble-2-container-resize")){
      setShowAnimation({
        ...showAnimation,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("speech-bubble-3-container-resize")){
      setShowAnimation({
        ...showAnimation,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("border-animation-container-resize")){
      setShowAnimation({
        ...showAnimation,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("border-animation-2-container-resize")){
      setShowAnimation({
        ...showAnimation,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("name-animation-container-resize")){
      setShowAnimation({
        ...showAnimation,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("text-animation-1-container-resize")){
      setShowAnimation({
        ...showAnimation,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("icon-smiley-container-resize")){
      setShowAnimation({
        ...showAnimation,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("freesoftware")){
      setBuybuttonData({
        ...buybuttonData,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("getfree")){
      setLinkbtn3Data({
        ...linkbtn3Data,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("sacn_qr_code")){
      setImgbtn2Data({
        ...Imgbtn2Data,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("ebook_unlocked")){
      setCust2PollData({
        ...cust2PollData,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("quizze_2")){
      setCust3PollData({
        ...cust3PollData,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("scan_qr_el")){
      setImgbtn4Data({
        ...Imgbtn4Data,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("product_s_bx")){
      setImgbtn3Data({
        ...Imgbtn3Data,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("gift_available")){
      setLinkbtn4Data({
        ...linkbtn4Data,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("quizze_4")){
      setLinkbtn5Data({
        ...linkbtn5Data,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("coming_soon2")){
      setLinkbtn6Data({
        ...linkbtn6Data,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("badge1")){
      setLinkbtn7Data({
        ...linkbtn7Data,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("socialIcons")){
      setLinkbtn8Data({
        ...linkbtn8Data,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("voucher1")){
      setLinkbtn8Data({
        ...linkbtn8Data,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("coming_soon")){
      setLinkbtn2Data({
        ...linkbtn2Data,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("scaling_your_site2")){
      setImgbtn5Data({
        ...Imgbtn5Data,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("menu_1")){
      setImgbtn6Data({
        ...Imgbtn6Data,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("menu_2")){
      setImgbtn7Data({
        ...Imgbtn7Data,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("scaling_your_site")){
      setImgbtn1Data({
        ...Imgbtn1Data,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("find_dream_home3")){
      setOpentable1Data({
        ...opentable1Data,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("review_1")){
      setReview1Data({
        ...review1Data,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("social_media")){
      setLinkbtn8Data({
        ...linkbtn8Data,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }else if(data.node.getAttribute("class").includes("social_element_1")){
      setImgbtn8Data({
        ...Imgbtn8Data,
        xPosition:data.x,
        yPosition:data.y,
        frameWidth:frameWidth,
        frameHeight:frameHeight,
      })
    }

    
    
    
    
  }

  const selectStyles = {
    control: base => ({
      ...base,
      border: 0,
      // This line disable the blue border
      boxShadow: 'none'
    })
  };

  const formatOptionLabel = ({ value, label }) => (
    <span style={{fontFamily:value+",sans-serif"}}>{label}</span>
  );

  const handlePersonalizeClick = (e,type,line) =>{
    if(type === 'name_animation' || type === 'simple_reveal' || 
    type === 'speech_bubble' || type === 'speech_bubble_2' || 
    type === 'speech_bubble_3' || type === 'speech_thought' || 
    type === 'border_animation' || type === 'border_animation_2' || 
    type === 'text_animation_1' || type === 'text_animation_2'){
      // console.log(e.target.innerText)
      if(line === 'text1'){
        const value = showAnimation.text1 + `{{${e.target.innerText}}}`;
        setShowAnimation({
          ...showAnimation,
          text1:value
        })
      }else{
        const value = showAnimation.text2 + `{{${e.target.innerText}}}`;
        setShowAnimation({
          ...showAnimation,
          text2:value
        })
      }
      
    }
  }

  const handleResponderChange = (e) =>{

    const {value} = e.target;
    setLeadgenFormData({
      ...leadgenFormData,
      responderType: value,
    })

    if(value === 'active campaign'){
      const activeCampaign = autoresponder.filter(
        ({ meta_key }) => meta_key === value
      );

      // console.log(activeCampaign)
      if (activeCampaign.length > 0) {
        const meta_data = JSON.parse(activeCampaign[0].meta_data);

        fetchResponderLists(
          {
            url: endPoints.activeCampaignLists,
            method: "POST",
            body: {
              ac_url: meta_data.ac_url,
              ac_key: meta_data.ac_key
            },
          },
          (response) => {
            // console.log(response)
            if(response.statusCode === 200){
              // console.log(response.data)
              setActiveCampaignLists(response.data)
            }
          })
      }
    }

    if(value === 'aweber'){
      const aweber = autoresponder.filter(
        ({ meta_key }) => meta_key === value
      );

      // console.log(activeCampaign)
      if (aweber.length > 0) {
        const meta_data = JSON.parse(aweber[0].meta_data);

        fetchResponderLists(
          {
            url: endPoints.aweberLists,
            method: "POST",
            body: {
              refresh_token: meta_data.refresh_token,
              access_token: meta_data.access_token
            },
          },
          (response) => {
            // console.log(response)
            if(response.statusCode === 200){
              // console.log(response.data)
              setActiveCampaignLists(response.data)
            }
          })
      }
    }

    if(value === "mailchimp"){
      const mailchimp = autoresponder.filter(
        ({ meta_key }) => meta_key === value
      );

      // console.log(activeCampaign)
      if (mailchimp.length > 0) {
        const meta_data = JSON.parse(mailchimp[0].meta_data);

        fetchResponderLists(
          {
            url: endPoints.mailchimpLists,
            method: "POST",
            body: {
              mc_key: meta_data.mc_key
            },
          },
          (response) => {
            // console.log(response)
            if(response.statusCode === 200){
              // console.log(response.data)
              setActiveCampaignLists(response.data)
            }
          })
      }
    }

    if (value === "getresponse") {
      const getresponse = autoresponder.filter(
        ({ meta_key }) => meta_key === value
      );

      // console.log(activeCampaign)
      if (getresponse.length > 0) {
        const meta_data = JSON.parse(getresponse[0].meta_data);

        fetchResponderLists(
          {
            url: endPoints.getResponseLists,
            method: "POST",
            body: {
              gr_key: meta_data.gr_key,
            },
          },
          (response) => {
            // console.log(response)
            if (response.statusCode === 200) {
              // console.log(response.data)
              setActiveCampaignLists(response.data);
            }
          }
        );
      }
    }

  }

  const animationLists = [
    {label:"None",value:""},
    {label:"BackIn Left",value:"animate__backInLeft"},
    {label:"BackIn Down",value:"animate__backInDown"},
    {label:"Bounce In",value:"animate__bounceIn"},
    {label:"rotateIn",value:"animate__rotateIn"},
    {label:"rotateInUpLeft",value:"animate__rotateInUpLeft"},
    {label:"zoomIn",value:"animate__zoomIn"},
    {label:"zoomInUp",value:"animate__zoomInUp"},
    {label:"zoomInDown",value:"animate__zoomInDown"},
    {label:"zoomOut",value:"animate__zoomOut"},
    {label:"zoomOutDown",value:"animate__zoomOutDown"},
    {label:"zoomOutUp",value:"animate__zoomOutUp"},
    {label:"slideInRight",value:"animate__slideInRight"},
    {label:"slideInLeft",value:"animate__slideInLeft"},
    {label:"flipInX",value:"animate__flipInX"},
    {label:"flipInY",value:"animate__flipInY"},
  ]

  const handleDuration = (duration) =>{
    // console.log('onDuration', duration)
    setYtPlayer({
      ...ytPlayer,
      duration:duration
    })
  }

  const handleProgress = (state) =>{
    // console.log('onProgress', state)
    // We only want to update time slider if we are not currently seeking
    if (!ytPlayer.seeking) {
      setYtPlayer({
        ...ytPlayer,
        loaded:state.loaded,
        played:state.played,
        playedSeconds:state.playedSeconds,
        // start:(ytPlayer.duration * state.played),
        // end:((ytPlayer.duration * state.played) + 5)
      })
      // console.log('inn')
    }

    if(isPlayInBetween && !ytPlayer.playing){
      setYtPlayer({
        ...ytPlayer,
        url:ytPlayer.url.split("&start=")[0]
      })
    }

    
    // console.log(format(ytPlayer.duration * ytPlayer.played),format(ytPlayer.playedSeconds))
  }

  const handleSeekMouseDown = e => {
    // console.log(e,"handleSeekMouseDown")
    setYtPlayer({
      ...ytPlayer,
      seeking:true
    })
  }

  const handleSeekChange = e => {
    // console.log(e,"handleSeekChange",parseFloat(e.target.value))
    setYtPlayer({
      ...ytPlayer,
      played:parseFloat(e.target.value),
      start:(ytPlayer.duration * parseFloat(e.target.value)),
      end:((ytPlayer.duration * parseFloat(e.target.value)) + 5.0),
      playedSeconds:(ytPlayer.duration * parseFloat(e.target.value))
    })

    if(showCTA){
      setVideoCTAData({
        ...videoCTAData,
        actiontime:format(ytPlayer.duration * parseFloat(e.target.value))
      })
    }

    if(showCopyPaste){
      setCopyPasteData({
        ...copyPasteData,
        CRMstartTime:format(ytPlayer.duration * parseFloat(e.target.value))
      })
    }

    if(showCustomPoll){
      setCustPollData({
        ...custPollData,
        pollTime:format(ytPlayer.duration * parseFloat(e.target.value))
      })
    }

    if(showCustom2Poll){
      setCust2PollData({
        ...cust2PollData,
        pollTime:format(ytPlayer.duration * parseFloat(e.target.value))
      })
    }

    if(showCustom3Poll){
      setCust3PollData({
        ...cust3PollData,
        pollTime:format(ytPlayer.duration * parseFloat(e.target.value))
      })
    }

    // console.log(format(ytPlayer.duration * ytPlayer.played))
  }

  const handleSeekMouseUp = e => {
    // console.log(e,"handleSeekMouseUp")
    setYtPlayer({
      ...ytPlayer,
      seeking:false
    })
    ytPlayerRef.current.seekTo(parseFloat(e.target.value))
    
  }

  function format (seconds) {
    // console.log(seconds)
    const date = new Date(seconds * 1000)
    const hh = date.getUTCHours()
    const mm = date.getUTCMinutes()
    const ss = pad(date.getUTCSeconds())
    if (hh) {
      return `${hh}:${pad(mm)}:${ss}`
    }
    return `${pad(mm)}:${pad(ss)}`
  }
  
  function pad (string) {
    return ('0' + string).slice(-2)
  }

  const toggleYtMute = () =>{
    setYtPlayer({
      ...ytPlayer,
      muted:!ytPlayer.muted
    })
  }

  const handleYtAudioLevel = (value) =>{
    if(value > 0){
      setYtPlayer({
        ...ytPlayer,
        volume:value,
        muted:false
      })
    }else{
      setYtPlayer({
        ...ytPlayer,
        volume:value,
        muted:true
      })
    }
  }
  
  if(!isFontLoaded){
    WebFont.load({
      google: {
        families: ['Uncial Antiqua','Metal Mania','Atomic Age','Emblema One','Miltonian','Poppins','Staatliches','Caveat','Satisfy','Electrolize','Luckiest Guy','Audiowide','Pangolin','Merienda One','Capriola','Fredericka the Great','Aladin','Alegreya SC','Ceviche One','Lemon','Abril+Fatface', 'Anton', 'Dancing+Script', 'Droid+Sans', 'Droid+Serif', 'Gloria+Hallelujah', 'Indie+Flower', 'Lato', 'Lobster', 'Lora', 'Montserrat', 'Open+Sans', 'Oswald', 'PT+Sans', 'PT+Serif', 'Pacifico', 'Playfair+Display', 'Raleway', 'Roboto', 'Roboto+Condensed', 'Roboto+Slab', 'Rubik', 'Slabo+27px', 'Source+Sans+Pro', 'Ubuntu', 'Monoton', 'Bungee+Inline', 'Black+Ops+One', 'Finger+Paint', 'Bungee+Shade', 'Ribeye+Marrow', 'Suez+One', 'Teko', 'Josefin+Sans', 'Acme', 'Varela Round', 'Archivo Black', 'Berkshire Swash', 'Righteous', 'Concert One', 'Fredoka One', 'Limelight', 'Cabin Sketch', 'Electrolize', 'Niconne', 'Aclonica', 'Reem Kufi', 'Love Ya Like A Sister', 'Vast Shadow', 'Ravi Prakash', 'Germania One', 'Nosifer', 'Pirata One', 'Rubik Mono One', 'Butcherman', 'Great Vibes', 'Teko', 'Quicksand', 'Bree+Serif', 'Francois+One', 'Kaushan+Script', 'Patua+One', 'Permanent+Marker', 'Alfa+Slab+One', 'Cookie', 'Lalezar', 'Patrick+Hand', 'Passion+One', 'Boogaloo', 'Paytone+One', 'Playball', 'Fugaz+One', 'Oleo+Script', 'Knewave', 'Bevan', 'Faster+One', 'Leckerli+One', 'Bungee', 'Pattaya', 'Rye', 'Federo', 'Nova+Square', 'Ranchers', 'New+Rocker']

      }            
    });
    setIsFontLoaded(true)
    console.log('font loaded')
  }

  const handleTriggerTime = (value, type = "normal") =>{
    console.log('A'+Math.random(1,100)) 
    console.log(value)
    let startDuration = 0;
    let endDuration = 5;
    if(type === 'normal'){
      let start = value[0];
      let end = value[1];
      startDuration = ((start / 100) * ytPlayer.duration);
      endDuration = ((end / 100) * ytPlayer.duration);
    }else{
      startDuration = value[0];
      endDuration = value[1];
    }
    

    setYtPlayer({
      ...ytPlayer,
      start:startDuration,
      end:endDuration
    })
 
    console.log(startDuration, endDuration, ytPlayer)
    let startDuration_formated = (Number(startDuration) || startDuration === 0 )?format(startDuration):startDuration ;
    let endDuration_formated = (Number(endDuration) || endDuration === 0 )?format(endDuration):endDuration ;

    if( showImgbtn1 ){

      setImgbtn1Data({
        ...Imgbtn1Data,
        Imgbtn1StartTime: startDuration_formated,
        Imgbtn1EndTime: endDuration_formated
      })
    }else if( showImgbtn2 ){
      setImgbtn2Data({
        ...Imgbtn2Data,
        Imgbtn2StartTime: startDuration_formated,
        Imgbtn2EndTime: endDuration_formated
      })
    }else if( showImgbtn3 ){
      setImgbtn3Data({
        ...Imgbtn3Data,
        Imgbtn3StartTime: startDuration_formated,
        Imgbtn3EndTime: endDuration_formated
      })
    }else if(showImgbtn4){
      setImgbtn4Data({
        ...Imgbtn4Data,
        Imgbtn4StartTime: startDuration_formated,
        Imgbtn4EndTime: endDuration_formated
      })
    } else if(showImgbtn5){
      setImgbtn5Data({
        ...Imgbtn5Data,
        Imgbtn5StartTime: startDuration_formated,
        Imgbtn5EndTime: endDuration_formated
      })
    } else if(showImgbtn6){
      setImgbtn6Data({
        ...Imgbtn6Data,
        Imgbtn6StartTime: startDuration_formated,
        Imgbtn6EndTime: endDuration_formated
      })
    } else if(showImgbtn7){
      setImgbtn7Data({
        ...Imgbtn7Data,
        Imgbtn7StartTime: startDuration_formated,
        Imgbtn7EndTime: endDuration_formated
      })
    } else if(showImgbtn8){
      setImgbtn8Data({
        ...Imgbtn8Data,
        Imgbtn8StartTime: startDuration_formated,
        Imgbtn8EndTime: endDuration_formated
      })
    } else if( showBuybutton ){
      setBuybuttonData({
        ...buybuttonData,
        buybuttonStartTime: startDuration_formated,
        buybuttonEndTime: endDuration_formated
      })
    } else if(showLinkbutton2){
      setLinkbtn2Data({
        ...linkbtn2Data,
        linkbtn2StartTime: startDuration_formated,
        linkbtn2EndTime: endDuration_formated
      })
    } else if(showLinkbutton3){
      setLinkbtn3Data({
        ...linkbtn3Data,
        linkbtn3StartTime: startDuration_formated,
        linkbtn3EndTime: endDuration_formated
      })
    } else if(showLinkbutton4){
      setLinkbtn4Data({
        ...linkbtn4Data,
        linkbtn4StartTime: startDuration_formated,
        linkbtn4EndTime: endDuration_formated
      })
    } else if(showLinkbutton5){
      setLinkbtn5Data({
        ...linkbtn5Data,
        linkbtn5StartTime: startDuration_formated,
        linkbtn5EndTime: endDuration_formated
      })
    } else if(showLinkbutton6){
      setLinkbtn6Data({
        ...linkbtn6Data,
        linkbtn6StartTime: startDuration_formated,
        linkbtn6EndTime: endDuration_formated
      })
    } else if(showLinkbutton7){
      setLinkbtn7Data({
        ...linkbtn7Data,
        linkbtn7StartTime: startDuration_formated,
        linkbtn7EndTime: endDuration_formated
      })
    } else if(showLinkbutton8){
      setLinkbtn8Data({
        ...linkbtn8Data,
        linkbtn8StartTime: startDuration_formated,
        linkbtn8EndTime: endDuration_formated
      })
    } else if(showLinkbutton9){
      setLinkbtn9Data({
        ...linkbtn9Data,
        linkbtn9StartTime: startDuration_formated,
        linkbtn9EndTime: endDuration_formated
      })
    } else if(showAnnotation){
      setAnnotationData({
        ...annotationData,
        annotationStartTime: startDuration_formated,
        annotationEndTime: endDuration_formated
      })
    }else if(showReview1){
      setReview1Data({
        ...review1Data,
        review1StartTime: startDuration_formated,
        review1EndTime: endDuration_formated
      })
    }else if(showAnimation){
      setShowAnimation({
        ...showAnimation,
        startTime: startDuration_formated,
        endTime: endDuration_formated
      })
    }

    
    // handlePlayBetween();
  }

  const handlePlayAfter = (value) =>{
    // console.log('B'+Math.random(1,100))
    let start = value[0];
    let end = value[1];
    let startDuration = ((start / 100) * ytPlayer.duration);
    let endDuration = ((end / 100) * ytPlayer.duration);
    // console.log(ytPlayer,startDuration,endDuration);
    setYtPlayer({
      ...ytPlayer,
      start:startDuration,
      end:endDuration,
      playing:false
    })

    // handlePlayBetween(startDuration,endDuration);
  }

  const handleSetTime = (event) =>{
    event.preventDefault();
    if(showActiveTrigger && showActiveTrigger === 'video_annotation'){
      setAnnotationData({
        ...annotationData,
        annotationStartTime: (Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
        annotationEndTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }

    if(showActiveTrigger && showActiveTrigger === 'video_review1'){
      setReview1Data({
        ...review1Data,
        review1StartTime: (Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
        review1EndTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }

    if(showActiveTrigger && showActiveTrigger === 'buy_button'){
      setBuybuttonData({
        ...buybuttonData,
        buybuttonStartTime: (Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
        buybuttonEndTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }
    

    if(showActiveTrigger && showActiveTrigger === 'link_button2'){
      setLinkbtn2Data({
        ...linkbtn2Data,
        linkbtn2StartTime: (Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
        linkbtn2EndTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }

    if(showActiveTrigger && showActiveTrigger === 'link_button3'){
      setLinkbtn3Data({
        ...linkbtn3Data,
        linkbtn3StartTime: (Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
        linkbtn3EndTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }

    if(showActiveTrigger && showActiveTrigger === 'link_button4'){
      setLinkbtn4Data({
        ...linkbtn4Data,
        linkbtn4StartTime: (Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
        linkbtn4EndTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }

    if(showActiveTrigger && showActiveTrigger === 'link_button5'){
      setLinkbtn5Data({
        ...linkbtn5Data,
        linkbtn5StartTime: (Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
        linkbtn5EndTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }

    if(showActiveTrigger && showActiveTrigger === 'link_button6'){
      setLinkbtn6Data({
        ...linkbtn6Data,
        linkbtn6StartTime: (Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
        linkbtn6EndTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }
    
    if(showActiveTrigger && showActiveTrigger === 'link_button7'){
      setLinkbtn7Data({
        ...linkbtn7Data,
        linkbtn7StartTime: (Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
        linkbtn7EndTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }
    
    if(showActiveTrigger && showActiveTrigger === 'link_button8'){
      setLinkbtn8Data({
        ...linkbtn8Data,
        linkbtn8StartTime: (Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
        linkbtn8EndTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }
    if(showActiveTrigger && showActiveTrigger === 'link_button9'){
      setLinkbtn9Data({
        ...linkbtn9Data,
        linkbtn9StartTime: (Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
        linkbtn9EndTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }

    if(showActiveTrigger && showActiveTrigger === 'Img_btn1'){
      setImgbtn1Data({
        ...Imgbtn1Data,
        Imgbtn1StartTime: (Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
        Imgbtn1EndTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }

    if(showActiveTrigger && showActiveTrigger === 'Img_btn2'){
      setImgbtn2Data({
        ...Imgbtn2Data,
        Imgbtn2StartTime: (Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
        Imgbtn2EndTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }

    if(showActiveTrigger && showActiveTrigger === 'Img_btn3'){
      setImgbtn3Data({
        ...Imgbtn3Data,
        Imgbtn3StartTime: (Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
        Imgbtn3EndTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }

    if(showActiveTrigger && showActiveTrigger === 'Img_btn4'){
      setImgbtn4Data({
        ...Imgbtn4Data,
        Imgbtn4StartTime: (Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
        Imgbtn4EndTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }

    if(showActiveTrigger && showActiveTrigger === 'Img_btn5'){
      setImgbtn5Data({
        ...Imgbtn5Data,
        Imgbtn5StartTime: (Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
        Imgbtn5EndTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }
    if(showActiveTrigger && showActiveTrigger === 'Img_btn6'){
      setImgbtn6Data({
        ...Imgbtn6Data,
        Imgbtn6StartTime: (Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
        Imgbtn6EndTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }
    if(showActiveTrigger && showActiveTrigger === 'Img_btn7'){
      setImgbtn7Data({
        ...Imgbtn7Data,
        Imgbtn7StartTime: (Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
        Imgbtn7EndTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }
    if(showActiveTrigger && showActiveTrigger === 'Img_btn8'){
      setImgbtn8Data({
        ...Imgbtn8Data,
        Imgbtn8StartTime: (Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
        Imgbtn8EndTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }

    if(showActiveTrigger && (showActiveTrigger === "simple_reveal" || 
    showActiveTrigger === "speech_bubble" || 
    showActiveTrigger === "speech_bubble_2" || 
    showActiveTrigger === "speech_bubble_3" || 
    showActiveTrigger === "speech_bubble_4" || 
    showActiveTrigger === "speech_thought" || 
    showActiveTrigger === "border_animation" || 
    showActiveTrigger === "border_animation_2" || 
    showActiveTrigger === "lt_animation_1" || 
    showActiveTrigger === "lt_animation_2" || 
    showActiveTrigger === "lt_animation_3" || 
    showActiveTrigger === "lt_animation_4" || 
    showActiveTrigger === "lt_animation_5" || 
    showActiveTrigger === "name_animation" || 
    showActiveTrigger === "text_animation_1" || 
    showActiveTrigger === "text_animation_2" || 
    showActiveTrigger.includes(".svg"))){
      setShowAnimation({
        ...showAnimation,
        startTime: (Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
        endTime:Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end
      })
    }

    cuteToast({
      type: "success",
      message: "Time Updated.",
      timer: 5000,
      title: "Trigger Timeline",
    });
  }

  const handlePlayBetween = (startDuration,endDuration) =>{

    let ytPlayerUrl = ytPlayer.url;
    if(campaign_data && campaign_data.video_type === 'embed'){
      if(ytPlayer.url.includes("&start=")){
        ytPlayerUrl = ytPlayer.url.split("&start=")[0]
      }
      // console.log(ytPlayer,startDuration,endDuration)
      if(startDuration && endDuration){
        setYtPlayer({
          ...ytPlayer,
          url:`${ytPlayerUrl}&start=${startDuration}&end=${endDuration}`,
          start:startDuration,
          end:endDuration,
          playing:true,
        })
      }else{
        setYtPlayer({
          ...ytPlayer,
          url:`${ytPlayerUrl}&start=${(Number(ytPlayer.start) || ytPlayer.start === 0)?ytPlayer.start:getSeconds(ytPlayer.start)}&end=${Number(ytPlayer.end)?ytPlayer.end:getSeconds(ytPlayer.end)}`,
          playing:true,
        })
      }
    }else{
      if(ytPlayer.url.includes("#t=")){
        ytPlayerUrl = ytPlayer.url.split("#t=")[0]
      }
      // console.log(ytPlayer,startDuration,endDuration)
      if(startDuration && endDuration){
        setYtPlayer({
          ...ytPlayer,
          url:`${ytPlayerUrl}#t=${startDuration},${endDuration}`,
          start:startDuration,
          end:endDuration,
          playing:true,
        })
      }else{
        setYtPlayer({
          ...ytPlayer,
          url:`${ytPlayerUrl}#t=${ytPlayer.start},${ytPlayer.end}`,
          playing:true,
        })
      }
    }
    
    setIsPlayInBetween(true)
  }

  const hideAllElements = () =>{
    setIsCTA_Visible(false)
    setIsPoll_Visible(false)
    setIsLeadForm_Visible(false)
    setIsOverlay_Visible(false)
    setIsReview_Visible(false)
    setIsRsevation_Visible(false)
    setIsQrCode_Visible(false)
    setIsTimer_Visible(false)
    setIsMenu_Visible(false)
  }

  const hideAllTriggers = () =>{
    setShowMeetingLink(false);
    setShowCTA(false);
    setShowAnnotation(false);
    setShowBuybutton(false);
    setShowLinkbutton2(false);
    setShowLinkbutton3(false);
    setShowLinkbutton4(false);
    setShowLinkbutton5(false);
    setShowLinkbutton6(false);
    setShowLinkbutton7(false);
    setShowLinkbutton8(false);
    setShowLinkbutton9(false);
    setShowImgbtn1(false);
    setShowImgbtn2(false);
    setShowImgbtn3(false);
    setShowImgbtn4(false);
    setShowImgbtn5(false);
    setShowImgbtn6(false);
    setShowImgbtn7(false);
    setShowImgbtn8(false);
    setShowCopyPaste(false);
    setScriptCodeForm_Visible(false);
    setShowLeadGenForm(false);
    setShowLeadGen2Form(false);
    setShowCustomPoll(false);
    setShowCustom2Poll(false);
    setShowCustom3Poll(false);
    setShowopentable1(false);
    setShowReview1(false);
    setErrors({})
    setShowIcons(false);
    setShowOverlay(false)
    setShowLowerThird(false)
    setShowIcons(false);
    setShowEffectControls(false)
    setShowTimingControl(false)
    setShowActiveTrigger(false)
    setShowAnimation(false)
    
  }

  const textLimitExceed = (limit) =>{
    cuteToast({
      type: "error",
      message: "Maximum "+limit+" characters allowed",
      timer: 2000,
      title: "Character limit exceeded",
    });
  }
                            

  return (
    <>
      <div className="p-4 pb-2 pt-3">
       <ReactTooltip />
        <div className="video_action_main_wrap row">
          <div className="col-xl-5 col-lg-5 col-md-12">
            { !showMeetingLink &&
              !showCTA &&
              !showAnnotation &&
              !showCopyPaste &&
              !showLeadGenForm &&
              !showLeadGen2Form &&
              !showCustomPoll && 
              !showCustom2Poll && 
              !showCustom3Poll && 
              !showopentable1 &&
              !showReview1 &&
              !showOverlay && 
              !showEffectControls && 
              !showLowerThird && 
              !showIcons && 
              !showLinkbutton2 &&
              !showLinkbutton3 &&
              !showLinkbutton4 &&
              !showLinkbutton5 &&
              !showLinkbutton6 &&
              !showLinkbutton7 &&
              !showLinkbutton8 &&
              !showLinkbutton9 &&
              !showImgbtn1 &&
              !showImgbtn2 &&
              !showImgbtn3 &&
              !showImgbtn4 &&
              !showImgbtn5 &&
              !showImgbtn6 &&
              !showImgbtn7 &&
              !showImgbtn8 &&
              !scriptCodeForm_Visible &&
              !showBuybutton && (
                <div className="vac_aside bg-white p-3 shadow2">

                  
                  <div className="video_action_h text-center mb-4">
                    <h4>Timeline Action</h4>
                    <p className="m-0">
                      Customise your videos. Drive your viewers into your sales
                      pipeline using different tools.
                    </p>
                  </div>

                  <div className="video_action_tab">
                    
                    <ul className="list-unstyled m-0 p-0">
                    
                    <div className="animated-form ">
                      <div className="form_rw mb-2 pt-2 d-btn">
                        <button type="button" className={`expand-button ${isCTA_Visible ? 'rotate' : ''}`} onClick={() => 
                          {
                            hideAllElements();
                            setIsCTA_Visible(!isCTA_Visible)}}>
                          <span>CTA Link</span>
                          <i className="fas fa-chevron-down"></i>
                        </button>
                      </div>
                    </div> 

                    {isCTA_Visible && (
                      <>
                        <li>
                          <button
                            onClick={() => setShowMeetingLink(true)}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "video_meeting"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "video_meeting"
                            )}
                          >
                            <i>
                              <FaLink   
                                className="text-main-color" 
                                size={18}  />
                            </i>
                            CTA Link
                          </button>
                        </li>
                        <li>
                          <button
                            onClick={() => {
                              setShowCTA(true)
                              setShowTimingControl(false)
                              setVideoCTAData({
                                ...videoCTAData,
                                actiontime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) => element.action_event === "video_cta"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) => element.action_event === "video_cta"
                            )}
                          >
                            <i>
                              <HiCursorClick
                                className="text-main-color"
                                size={19}
                              />
                            </i>
                            Custom CTA Link
                          </button>
                        </li>
                        <li>
                          <button
                            onClick={() => {
                              setShowAnnotation(true)
                              setShowTimingControl(true)
                              setShowActiveTrigger('video_annotation')
                              setAnnotationData({
                                ...annotationData,
                                annotationStartTime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
                                annotationEndTime:format(ytPlayer.end),
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "video_annotation"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "video_annotation"
                            )}
                          >
                            <i>
                              <BiEditAlt
                                className="text-main-color"
                                size={19}
                              />
                            </i>
                            Link Card
                          </button>
                        </li>

                        <li>
                          <button
                          
                            onClick={() => {
                              setShowBuybutton(true)
                              setShowTimingControl(true)
                              setShowActiveTrigger('buy_button')
                              setBuybuttonData({
                                ...buybuttonData,
                                buybuttonStartTime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
                                buybuttonEndTime:format(ytPlayer.end),
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "buy_button"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "buy_button"
                            )}
                          >
                            <i>
                              <FaFileDownload 
                              className="text-main-color" 
                              size={18}  />
                            </i>
                            Free Software Download
                          </button>
                        </li>
                        <li>
                          <button
                          
                            onClick={() => {
                              setShowLinkbutton2(true)
                              setShowTimingControl(true)
                              setShowActiveTrigger('link_button2')
                              setLinkbtn2Data({
                                ...linkbtn2Data,
                                linkbtn2StartTime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
                                linkbtn2EndTime:format(ytPlayer.end),
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "link_button2"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "link_button2"
                            )}
                          >
                            <i>
                              <MdUpcoming  
                                className="text-main-color" 
                                size={18}  />
                            </i>
                            COMING SOON BUTTON
                          </button>
                        </li>
                        <li>
                          <button
                          
                            onClick={() => {
                              setShowLinkbutton3(true)
                              setShowTimingControl(true)
                              setShowActiveTrigger('link_button3')
                              setLinkbtn3Data({
                                ...linkbtn3Data,
                                linkbtn3StartTime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
                                linkbtn3EndTime:format(ytPlayer.end),
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "link_button3"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "link_button3"
                            )}
                          >
                            <i>
                              <FaFileDownload 
                                className="text-main-color" 
                                size={18}  />
                            </i>
                            EBook Download Button
                          </button>
                        </li>
                        <li>
                          <button
                          
                            onClick={() => {
                              setShowLinkbutton4(true)
                              setShowTimingControl(true)
                              setShowActiveTrigger('link_button4')
                              setLinkbtn4Data({
                                ...linkbtn4Data,
                                linkbtn4StartTime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
                                linkbtn4EndTime:format(ytPlayer.end),
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "link_button4"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "link_button4"
                            )}
                          >
                            <i>
                              <FaGift  
                                className="text-main-color" 
                                size={18}  />
                            </i>
                            FREE GIFT BUTTON
                          </button>
                        </li>
                        <li>
                          <button
                          
                            onClick={() => {
                              setShowLinkbutton5(true)
                              setShowTimingControl(true)
                              setShowActiveTrigger('link_button5')
                              setLinkbtn5Data({
                                ...linkbtn5Data,
                                linkbtn5StartTime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
                                linkbtn5EndTime:format(ytPlayer.end),
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "link_button5"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "link_button5"
                            )}
                          >
                            <i>
                              <HiCursorClick
                                className="text-main-color"
                                size={19}
                              />
                            </i> 
                            QUIZ BUTTON
                          </button>
                        </li>

                        <li>
                          <button
                          
                            onClick={() => {
                              setShowImgbtn1(true)
                              setShowTimingControl(true)
                              setShowActiveTrigger('Img_btn1')
                              setImgbtn1Data({
                                ...Imgbtn1Data,
                                Imgbtn1StartTime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
                                Imgbtn1EndTime:format(ytPlayer.end),
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "Img_btn1"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "Img_btn1"
                            )}
                          >
                            <i>
                              <FaTag  
                                className="text-main-color"
                                size={16}
                              />
                            </i>
                            Shopping Card
                          </button>
                        </li>
                        <li>
                          <button
                          
                            onClick={() => {
                              setShowImgbtn3(true)
                              setShowTimingControl(true)
                              setShowActiveTrigger('Img_btn3')
                              setImgbtn3Data({
                                ...Imgbtn3Data,
                                Imgbtn3StartTime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
                                Imgbtn3EndTime:format(ytPlayer.end),
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "Img_btn3"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "Img_btn3"
                            )}
                          >
                            <i>
                              <FaTag
                                className="text-main-color"
                                size={16}
                              />
                            </i>
                            Product Buy Button
                          </button>
                        </li>
                        <li>
                          <button
                          
                            onClick={() => {
                              setShowImgbtn8(true)
                              setShowTimingControl(true)
                              setShowActiveTrigger('Img_btn8')
                              setImgbtn8Data({
                                ...Imgbtn8Data,
                                Imgbtn8StartTime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
                                Imgbtn8EndTime:format(ytPlayer.end),
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "Img_btn8"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "Img_btn8"
                            )}
                          >
                            <i>
                              <FaCalendarAlt
                                className="text-main-color"
                                size={16}
                              />
                            </i>
                            Text & Image CTA Card 
                          </button>
                        </li>
                        <li className="d-none">
                          <button
                          
                            onClick={() => {
                              setShowLinkbutton9(true)
                              setShowTimingControl(true)
                              setShowActiveTrigger('link_button9')
                              setLinkbtn9Data({
                                ...linkbtn9Data,
                                linkbtn9StartTime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
                                linkbtn9EndTime:format(ytPlayer.end),
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "link_button9"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "link_button9"
                            )}
                          >
                             <i>
                              <FaPercent  
                                className="text-main-color"
                                size={16}
                              />
                            </i>
                            Voucher
                          </button>
                        </li>
                      </>
                    )}
                    
                    <div className="animated-form ">
                      <div className="form_rw mb-2 pt-2 d-btn">
                        <button type="button" className={`expand-button ${isPoll_Visible ? 'rotate' : ''}`} onClick={() => 
                          {
                            hideAllElements();
                            setIsPoll_Visible(!isPoll_Visible)}}>
                          <span>Polls & Quizzes</span>
                          <i className="fas fa-chevron-down"></i>
                        </button>
                      </div>
                    </div> 

                    {isPoll_Visible && (
                      <>
                        <li>
                          <button
                            onClick={() => {
                              setShowCustomPoll(true)
                              setShowTimingControl(false)
                              setCustPollData({
                                ...custPollData,
                                pollTime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "video_custPoll"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "video_custPoll"
                            )}
                          >
                            <i>
                              <FaPoll 
                                className="text-main-color"
                                size={19}
                              />
                            </i>
                            Full Screen Custom Poll
                          </button>
                        </li>
                        <li>
                          <button
                            onClick={() => {
                              setShowCustom2Poll(true)
                              setShowTimingControl(false)
                              setCust2PollData({
                                ...cust2PollData,
                                pollTime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "video_cust2Poll"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "video_cust2Poll"
                            )}
                          >
                            <i>
                              <FaPoll 
                                className="text-main-color"
                                size={19}
                              />
                            </i>
                            4 Option Poll - Small
                          </button>
                        </li>
                        <li>
                          <button
                            onClick={() => {
                              setShowCustom3Poll(true)
                              setShowTimingControl(false)
                              setCust3PollData({
                                ...cust3PollData,
                                pollTime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "video_cust3Poll"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "video_cust3Poll"
                            )}
                          >
                            <i>
                              <FaPoll 
                                className="text-main-color"
                                size={19}
                              />
                            </i>
                            4 Option Poll - Half Screen
                          </button>
                        </li>
                        
                      </>
                    )}
                    
                    <div className="animated-form ">
                      <div className="form_rw mb-2 pt-2 d-btn">
                        <button type="button" className={`expand-button ${isLeadForm_Visible ? 'rotate' : ''}`} onClick={() => 
                          {
                            hideAllElements();
                            setIsLeadForm_Visible(!isLeadForm_Visible)}}>
                          <span>Lead Forms</span>
                          <i className="fas fa-chevron-down"></i>
                        </button>
                      </div>
                    </div> 

                    {isLeadForm_Visible && (
                      <>
                        <li>
                          <button
                            onClick={() => {
                              setShowCopyPaste(true)
                              setShowTimingControl(false)
                              setCopyPasteData({
                                ...copyPasteData,
                                CRMstartTime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "video_copypaste"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "video_copypaste"
                            )}
                          >
                            <i>
                              <MdContentCopy
                                className="text-main-color" 
                                size={18} 
                              />
                            </i>
                            Content Locker Lead Form
                          </button>
                        </li>
                        <li>
                          <button
                            onClick={() => {
                              setShowLeadGenForm(true)
                              setShowTimingControl(false)
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "video_leadgen"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "video_leadgen"
                            )}
                          >
                            <i>
                              <MdContentPaste  className="text-main-color" size={18} />
                            </i>
                            Trigger Reel Form
                          </button>
                        </li>
                        <li>
                          <button
                            onClick={() => {
                              setShowLeadGen2Form(true)
                              setShowTimingControl(false)
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "video_leadgen2"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "video_leadgen2"
                            )}
                          >
                            <i>
                              <MdContentPaste  className="text-main-color" size={18} />
                            </i>
                            Lead Collection Form
                          </button>
                        </li>
                      </>
                    )}
                    
                    <div className="animated-form ">
                      <div className="form_rw mb-2 pt-2 d-btn">
                        <button type="button" className={`expand-button ${isOverlay_Visible ? 'rotate' : ''}`} onClick={() => 
                           
                           {
                            hideAllElements();
                            setIsOverlay_Visible(!isOverlay_Visible)}}>
                          <span>Overlay Templates</span>
                          <i className="fas fa-chevron-down"></i>
                        </button>
                      </div>
                    </div>

                    {isOverlay_Visible && (
                      <>
                        <li>
                          <button
                            onClick={() => setShowOverlayModal(true)}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "video_overlay"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "video_overlay"
                            )}
                          >
                            <i>
                              <FaPager className="text-main-color" size={18} />
                            </i>
                            Text Overlay Templates
                          </button>
                        </li>
                        <li>
                          <button
                            onClick={() => setShowLowerThirdModal(true)}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "video_lowerthird"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "video_lowerthird"
                            )}
                          >
                            <i>
                              
                              <RiPagesFill 
                                className="text-main-color" 
                                size={18} 
                                style={{transform: "rotateZ(180deg)"}}
                              />
                            </i>
                            Lower Third Templates
                          </button>
                        </li>
                        <li className="">
                          <button
                            onClick={() => setShowSocialMediaModal(true)}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "social_media"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "social_media"
                            )}
                          >
                            <i>
                              
                              <IoShareSocial 
                                className="text-main-color" 
                                size={18} 
                                style={{transform: "rotateZ(180deg)"}}
                              />
                            </i>
                            Social Media Icons
                          </button>
                        </li>
                        <li>
                          <button
                            onClick={() => setShowIcons(true)}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "video_icons"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "video_icons"
                            )}
                          >
                            <i>
                              <MdOutlineInsertEmoticon 
                                className="text-main-color" 
                                size={18} 
                              />
                            </i>
                            Icons
                          </button>
                        </li>
                      </>
                    )}
                    
                    <div className="animated-form ">
                      <div className="form_rw mb-2 pt-2 d-btn">
                        <button type="button" className={`expand-button ${isReview_Visible ? 'rotate' : ''}`} onClick={() => 
                          {
                            hideAllElements();
                            setIsReview_Visible(!isReview_Visible)}}>
                          <span>Reviews</span>
                          <i className="fas fa-chevron-down"></i>
                        </button>
                      </div>
                    </div>

                    {isReview_Visible && (
                      <>
                        <li>
                          <button
                            onClick={() => setShowReviewLayerModal(true)}
                            className={
                              actionPoint.some(
                                (element) => element.action_event === "review_layer"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) => element.action_event === "review_layer"
                            )}
                          >
                            <i>
                              <MdRateReview 
                              className="text-main-color" 
                              size={18}  />
                            </i>
                            Add Review 
                          </button>
                        </li>
                        <li>
                          <button
                          
                            onClick={() => {
                              setShowLinkbutton7(true)
                              setShowTimingControl(true)
                              setShowActiveTrigger('link_button7')
                              setLinkbtn7Data({
                                ...linkbtn7Data,
                                linkbtn7StartTime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
                                linkbtn7EndTime:format(ytPlayer.end),
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "link_button7"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "link_button7"
                            )}
                          >
                            <i>
                            <MdRateReview 
                              className="text-main-color" 
                              size={18}  />
                            </i>
                            Google Review Badge
                          </button>
                        </li>
                      </>  
                    )}

                    <div className="animated-form ">
                      <div className="form_rw mb-2 pt-2 d-btn">
                        <button type="button" className={`expand-button ${isRsevation_Visible ? 'rotate' : ''}`} onClick={() => 
                          {
                            hideAllElements();
                            setIsRsevation_Visible(!isRsevation_Visible)}}>
                          <span>Reservation & Appointment</span>
                          <i className="fas fa-chevron-down"></i>
                        </button>
                      </div>
                    </div>

                    {isRsevation_Visible && (
                      <>
                        <li>
                          <button
                            onClick={() => {
                              setShowopentable1(true)
                              setShowTimingControl(false)
                              setOpentable1Data({
                                ...opentable1Data,
                                booktime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "video_opentable1"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "video_opentable1"
                            )}
                          >
                            <i>
                              <FaRegCalendarAlt 
                                className="text-main-color"
                                size={18}
                              />
                            </i>
                            OpenTable
                          </button>
                        </li>
                        <li>
                          <button
                            onClick={() => {
                              setScriptCodeForm_Visible(true)
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "scriptCode"
                              ) ? "action-added" : ""
                            }
                            disabled={actionPoint.some( (element) => element.action_event === "scriptCode" )}
                          >
                            <i>
                            <FaCode
                            className="text-main-color" 
                            size={18}  />
                            </i>
                            Embed Script Code
                          </button>
                        </li>
                      </>  
                    )}

                    <div className="animated-form ">
                      <div className="form_rw mb-2 pt-2 d-btn">
                        <button type="button" className={`expand-button ${isQrCode_Visible ? 'rotate' : ''}`} onClick={() => 
                          {
                            hideAllElements();
                            setIsQrCode_Visible(!isQrCode_Visible)}}>
                          <span>QR Code</span>
                          <i className="fas fa-chevron-down"></i>
                        </button>
                      </div>
                    </div>

                    {isQrCode_Visible && (
                      <>
                        <li>
                          <button
                          
                            onClick={() => {
                              setShowImgbtn2(true)
                              setShowTimingControl(true)
                              setShowActiveTrigger('Img_btn2')
                              setImgbtn2Data({
                                ...Imgbtn2Data,
                                Imgbtn2StartTime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
                                Imgbtn2EndTime:format(ytPlayer.end),
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "Img_btn2"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "Img_btn2"
                            )}
                          >
                            <i>
                              <FaQrcode 
                               className="text-main-color" 
                               size={18} 
                              />
                            </i>
                            QR Code Button 1
                          </button>
                        </li>
                        <li>
                          <button
                          
                            onClick={() => {
                              setShowImgbtn4(true)
                              setShowTimingControl(true)
                              setShowActiveTrigger('Img_btn4')
                              setImgbtn4Data({
                                ...Imgbtn4Data,
                                Imgbtn4StartTime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
                                Imgbtn4EndTime:format(ytPlayer.end),
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "Img_btn4"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "Img_btn4"
                            )}
                          >
                            <i>
                              <FaQrcode 
                               className="text-main-color" 
                               size={18} 
                              />
                            </i>
                            QR Code Button 2
                          </button>
                        </li>
                      </>  
                    )}
                    
                    <div className="animated-form ">
                      <div className="form_rw mb-2 pt-2 d-btn">
                        <button type="button" className={`expand-button ${isTimer_Visible ? 'rotate' : ''}`} onClick={() => 
                          {
                            hideAllElements();
                            setIsTimer_Visible(!isTimer_Visible)}}>
                          <span>Timer</span>
                          <i className="fas fa-chevron-down"></i>
                        </button>
                      </div>
                    </div>

                    {isTimer_Visible && (
                      <>
                        <li>
                          <button
                          
                            onClick={() => {
                              setShowLinkbutton6(true)
                              setShowTimingControl(true)
                              setShowActiveTrigger('link_button6')
                              setLinkbtn6Data({
                                ...linkbtn6Data,
                                linkbtn6StartTime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
                                linkbtn6EndTime:format(ytPlayer.end),
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "link_button6"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "link_button6"
                            )}
                          >
                            <i>
                              <MdTimer 
                                className="text-main-color" 
                                size={18} 
                              />
                            </i>
                            Timer With Text
                          </button>
                        </li>
                        <li>
                          <button
                          
                            onClick={() => {
                              setShowImgbtn5(true)
                              setShowTimingControl(true)
                              setShowActiveTrigger('Img_btn5')
                              setImgbtn5Data({
                                ...Imgbtn5Data,
                                Imgbtn5StartTime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
                                Imgbtn5EndTime:format(ytPlayer.end),
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "Img_btn5"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "Img_btn5"
                            )}
                          >
                            <i>
                              <MdTimer 
                                className="text-main-color" 
                                size={18} 
                              />
                            </i>
                            Timer With Shopping Card
                          </button>
                        </li>
                      </>  
                    )}
                    
                    <div className="animated-form ">
                      <div className="form_rw mb-2 pt-2 d-btn">
                        <button type="button" className={`expand-button ${isMenu_Visible ? 'rotate' : ''}`} onClick={() => 
                          {
                            hideAllElements();
                            setIsMenu_Visible(!isMenu_Visible)}}>
                          <span>Restaurant Menu</span>
                          <i className="fas fa-chevron-down"></i>
                        </button>
                      </div>
                    </div>

                    {isMenu_Visible && (
                      <>
                        <li>
                          <button
                          
                            onClick={() => {
                              setShowImgbtn6(true)
                              setShowTimingControl(true)
                              setShowActiveTrigger('Img_btn6')
                              setImgbtn6Data({
                                ...Imgbtn6Data,
                                Imgbtn6StartTime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
                                Imgbtn6EndTime:format(ytPlayer.end),
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "Img_btn6"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "Img_btn6"
                            )}
                          >
                            <i>
                              <MdRestaurantMenu  
                                className="text-main-color" 
                                size={18} 
                              />
                            </i>
                           Menu Card With Button
                          </button>
                        </li>
                        <li>
                          <button
                          
                            onClick={() => {
                              setShowImgbtn7(true)
                              setShowTimingControl(true)
                              setShowActiveTrigger('Img_btn7')
                              setImgbtn7Data({
                                ...Imgbtn7Data,
                                Imgbtn7StartTime:(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):ytPlayer.start,
                                Imgbtn7EndTime:format(ytPlayer.end),
                              })
                            }}
                            className={
                              actionPoint.some(
                                (element) =>
                                  element.action_event === "Img_btn7"
                              )
                                ? "action-added"
                                : ""
                            }
                            disabled={actionPoint.some(
                              (element) =>
                                element.action_event === "Img_btn7"
                            )}
                          >
                            <i>
                              <MdRestaurantMenu  
                                className="text-main-color" 
                                size={18} 
                              />
                            </i>
                           Menu Card Without Button
                          </button>
                        </li>
                      </>  
                    )}

                      
                      
                    </ul>
                  </div>
                </div>
              )
            }
            {showMeetingLink && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>CTA Link</h4>
                    <p className="m-0">Design your own end card</p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleMeetingData}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Full Name</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {videoMeetingData.fullname.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.fullname ? "is-invalid" : ""
                          }`}
                          placeholder="John Smith"
                          onChange={(e) =>
                            setVideoMeetingData({
                              ...videoMeetingData,
                              fullname: e.target.value,
                            })
                          }
                          value={videoMeetingData.fullname}
                        />
                      </div>
                    </div>

                    <div className="form_rw mb-3 ">
                      <label>Designation</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {videoMeetingData.designation.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.designation ? "is-invalid" : ""
                          }`}
                          placeholder="Senior Manager"
                          onChange={(e) =>
                            setVideoMeetingData({
                              ...videoMeetingData,
                              designation: e.target.value,
                            })
                          }
                          value={videoMeetingData.designation}
                        />
                      </div>
                    </div>

                    <div className="form_rw mb-3 ">
                      <label>Button Name</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {videoMeetingData.buttontext.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.buttontext ? "is-invalid" : ""
                          }`}
                          placeholder="Go to Link"
                          onChange={(e) =>
                            setVideoMeetingData({
                              ...videoMeetingData,
                              buttontext: e.target.value,
                            })
                          }
                          value={videoMeetingData.buttontext}
                        />
                      </div>
                    </div>

                    <div className="form_rw mb-3 ">
                      <label>Meeting Link</label>
                      <div className="position-relative">
                        {/* <div className="mlnk_txt position-absolute">15/100</div> */}
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.buttontext ? "is-invalid" : ""
                          }`}
                          placeholder="Add URL Here"
                          onChange={(e) =>
                            setVideoMeetingData({
                              ...videoMeetingData,
                              meetingLink: e.target.value,
                            })
                          }
                          value={videoMeetingData.meetingLink}
                        />
                      </div>
                    </div>

                    <div className="form_rw mb-3 ">
                      <label>Button Color</label>
                      {/* <div className="rw">
                                                <a href="#0" className="m-0 colorcode text-decoration-none font12 me-3"><i className="fa fa-square"></i> #FF597E</a>
                                                <a href="#0" className="m-0 link_blue"><i className="fa fa-pencil"></i> Change</a>
                                            </div> */}
                      <input
                        type={"color"}
                        className="form-control"
                        onChange={(e) =>
                          setVideoMeetingData({
                            ...videoMeetingData,
                            buttonColor: e.target.value,
                          })
                        }
                        value={videoMeetingData.buttonColor}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => setShowMeetingLink(false)}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}

            {showCTA && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Custom CTA Link</h4>
                    <p className="m-0">
                      Customise your videos. Drive your viewers into your sales
                      pipeline using different tools.
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleCTAData}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Type</label>
                      <select
                        className="form-control select3 shadow-none textbx2"
                        onChange={(e) =>
                          setVideoCTAData({
                            ...videoCTAData,
                            formtype: e.target.value,
                          })
                        }
                      >
                        <option value="text">Text</option>
                        <option value="image">Image</option>
                      </select>
                    </div>
                    {videoCTAData.formtype && videoCTAData.formtype === "text" && (
                      <div className="form_rw mb-3">
                        <label>Text</label>
                        <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {videoCTAData.text.length}/100
                        </div>
                        <input
                          className={`form-control textbx2 border shadow-none mb-4 ${
                            errors && errors.text ? "is-invalid" : ""
                          }`}
                          placeholder="Add your text here"
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 100) {
                              setVideoCTAData({
                                ...videoCTAData,
                                text: e.target.value,
                              })
                            } else {
                              textLimitExceed(100)
                            }
                          }}
                          value={videoCTAData.text}
                        />
                      </div>
                      </div>
                    )}

                    {videoCTAData.formtype &&
                      videoCTAData.formtype === "image" && (
                        <div className="form_rw mb-3">
                          <label>Image</label>
                          <input
                            className={`form-control font12 ${
                              errors && errors.image ? "is-invalid" : ""
                            }`}
                            type="file"
                            onChange={handleImageChange}
                          />
                          <div className="mt-1">
                            <p className="m-0 font12">
                            1) Upload only "png," "jpeg," or "gif" images.
                            </p>
                            <p className="m-0 font12">
                            2) Max file size is 4MB.
                            </p>
                          </div>
                          {videoCTAData.image && (
                            <img 
                            src={videoCTAData.image} 
                            alt="https://google.com" 
                            className="img-fluid" 
                            style={{width: "50px"}} />
                          )}
                          
                        </div>
                      )}

                    <div className="form_rw mb-3">
                      <label>Link</label>
                      <input
                        type="text"
                        className={`form-control h35  p_holder textbx2 shadow-none ${
                          errors && errors.link ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setVideoCTAData({
                            ...videoCTAData,
                            link: e.target.value,
                          })
                        }
                        value={videoCTAData.link}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Time</label>

                      <input
                        className="form-control p_holder textbx2 shadow-none"
                        type="text"
                        placeholder="00:00"
                        value={videoCTAData.actiontime}
                        onChange={(e) =>
                          setVideoCTAData({
                            ...videoCTAData,
                            actiontime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "ctaTime")}
                        onBlur={(e) => handleTimeBlur(e, "ctaTime")}
                        ref={timeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) => handleTimeUpDown(e, "up", "ctaTime")}
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) => handleTimeUpDown(e, "down", "ctaTime")}
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="allowviewers"
                        checked={
                          videoCTAData.ctaSkipCheck ? true : false
                        }
                        onChange={(e) =>
                          setVideoCTAData({
                            ...videoCTAData,
                            videoCTAData: !videoCTAData.ctaSkipCheck,
                          })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="allowviewers"
                      >
                        Allow viewers to skip
                      </label>
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        className="btn btn2 me-2"
                        onClick={() => setShowCTA(false)}
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}

            {showAnnotation && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Link Card</h4>
                    <p className="m-0">
                      Send your viewers to a sales page by adding custom
                      annotation
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleAnnotationData}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Text</label> 
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {annotationData.annotationText.length}/60
                        </div>
                        <input
                          type="text"
                          className={`form-control p_holder textbx2 shadow-none ${
                            errors && errors.annotationText ? "is-invalid" : ""
                          }`}
                          placeholder="Click on this link"
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 60) {
                              setAnnotationData({
                                ...annotationData,
                                annotationText: e.target.value,
                              })
                            } else {
                              textLimitExceed(60)
                            }
                          }}
                          value={annotationData.annotationText}
                        />
                      </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.annotationLink ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setAnnotationData({
                            ...annotationData,
                            annotationLink: e.target.value,
                          })
                        }
                        value={annotationData.annotationLink}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.annotationStartTime
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="00:00"
                        value={annotationData.annotationStartTime}
                        onChange={(e) =>
                          setAnnotationData({
                            ...annotationData,
                            annotationStartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) =>
                          handleTimeKeyUp(e, "annotationStartTime")
                        }
                        onBlur={(e) => handleTimeBlur(e, "annotationStartTime")}
                        ref={annoStartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "annotationStartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "annotationStartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.annotationEndTime ? "is-invalid" : ""
                        }`}
                        placeholder="00:00"
                        value={annotationData.annotationEndTime}
                        onChange={(e) =>
                          setAnnotationData({
                            ...annotationData,
                            annotationEndTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "annotationEndTime")}
                        onBlur={(e) => handleTimeBlur(e, "annotationEndTime")}
                        ref={annoEndtimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "annotationEndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "annotationEndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => {
                          setShowAnnotation(false)
                          setShowTimingControl(false)
                        }}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}

            {showBuybutton && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Free Software Download</h4>
                    <p className="m-0">
                      Send your viewers to a sales page by adding custom
                      Free Software Download
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleBuybuttonData}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Title</label>
                        <div className="position-relative">
                          <div className="mlnk_txt position-absolute">
                            {buybuttonData.buybuttonText.length}/40
                          </div>
                          <input
                            type="text"
                            className={`form-control p_holder textbx2 shadow-none ${
                              errors && errors.buybuttonText ? "is-invalid" : ""
                            }`}
                            placeholder="Free Software"
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              if (inputValue.length <= 40) {
                                setBuybuttonData({
                                  ...buybuttonData,
                                  buybuttonText: e.target.value,
                                })
                              } else {
                                textLimitExceed(40)
                              }
                            }}
                            value={buybuttonData.buybuttonText}
                          />
                      </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Sub Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {buybuttonData.buybuttonText2.length}/70
                        </div>

                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="Our website is under construction"
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 70) {
                              setBuybuttonData({
                                ...buybuttonData,
                                buybuttonText2: e.target.value,
                              })
                            } else {
                              textLimitExceed(70)
                            }
                          }}
                          value={buybuttonData.buybuttonText2}
                        />
                      </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Button Text</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {buybuttonData.buybuttonText2.length}/40
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Download"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                        
                          if (inputValue.length <= 40) {
                            setBuybuttonData({
                              ...buybuttonData,
                              buybuttonText3: inputValue,
                            });
                          } else {
                            textLimitExceed(40)
                          }
                        }}
                        value={buybuttonData.buybuttonText3}
                      />
                      </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.buybuttonLink ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setBuybuttonData({
                            ...buybuttonData,
                            buybuttonLink: e.target.value,
                          })
                        }
                        value={buybuttonData.buybuttonLink}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.buybuttonStartTime
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="00:00"
                        value={buybuttonData.buybuttonStartTime}
                        onChange={(e) =>
                          setBuybuttonData({
                            ...buybuttonData,
                            buybuttonStartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) =>
                          handleTimeKeyUp(e, "buybuttonStartTime")
                        }
                        onBlur={(e) => handleTimeBlur(e, "buybuttonStartTime")}
                        ref={buybtnStartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "buybuttonStartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "buybuttonStartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.buybuttonEndTime ? "is-invalid" : ""
                        }`}
                        placeholder="00:00"
                        value={buybuttonData.buybuttonEndTime}
                        onChange={(e) =>
                          setBuybuttonData({
                            ...buybuttonData,
                            buybuttonEndTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "buybuttonEndTime")}
                        onBlur={(e) => handleTimeBlur(e, "buybuttonEndTime")}
                        ref={buybtnEndtimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "buybuttonEndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "buybuttonEndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => {
                          setShowBuybutton(false)
                          setShowTimingControl(false)
                        }}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )
            }
            

            {showLinkbutton2 && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>COMING SOON BUTTON</h4>
                    <p className="m-0">
                      Send your viewers to a sales page by adding custom
                      Coming Soon Button
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleLinkbtn2Data}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {linkbtn2Data.linkbtnText.length}/35
                        </div>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtnText ? "is-invalid" : ""
                        }`}
                        placeholder="COMING SOON"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (inputValue.length <= 35) {
                            setLinkbtn2Data({
                              ...linkbtn2Data,
                              linkbtnText: e.target.value,
                            })
                          } else {
                            textLimitExceed(35)
                          }
                        }}
                        value={linkbtn2Data.linkbtnText}
                      />
                      </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Sub Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {linkbtn2Data.linkbtnText2.length}/90
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Our website is under construction"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (inputValue.length <= 90) {
                            setLinkbtn2Data({
                              ...linkbtn2Data,
                              linkbtnText2: e.target.value,
                            })
                          } else {
                            textLimitExceed(90)
                          }
                        }}
                        value={linkbtn2Data.linkbtnText2}
                      />
                      </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Button Text</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {linkbtn2Data.linkbtnText3.length}/30
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Get Updates"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                        
                          if (inputValue.length <= 30) {
                            setLinkbtn2Data({
                              ...linkbtn2Data,
                              linkbtnText3: e.target.value,
                            })
                          } else {
                            textLimitExceed(30)
                          }
                        }}
                        value={linkbtn2Data.linkbtnText3}
                      />
                      </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtnLink ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setLinkbtn2Data({
                            ...linkbtn2Data,
                            linkbtnLink: e.target.value,
                          })
                        }
                        value={linkbtn2Data.linkbtnLink}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtn2StartTime
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="00:00"
                        value={linkbtn2Data.linkbtn2StartTime}
                        onChange={(e) =>
                          setLinkbtn2Data({
                            ...linkbtn2Data,
                            linkbtn2StartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) =>
                          handleTimeKeyUp(e, "linkbtn2StartTime")
                        }
                        onBlur={(e) => handleTimeBlur(e, "linkbtn2StartTime")}
                        ref={linkbtn2StartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "linkbtn2StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "linkbtn2StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtn2EndTime ? "is-invalid" : ""
                        }`}
                        placeholder="00:00"
                        value={linkbtn2Data.linkbtn2EndTime}
                        onChange={(e) =>
                          setLinkbtn2Data({
                            ...linkbtn2Data,
                            linkbtn2EndTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "linkbtn2EndTime")}
                        onBlur={(e) => handleTimeBlur(e, "linkbtn2EndTime")}
                        ref={linkbtn2EndtimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "linkbtn2EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "linkbtn2EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => {
                          setShowLinkbutton2(false)
                          setShowTimingControl(false)
                        }}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}

            {showLinkbutton3 && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>EBook Download Button</h4>
                    <p className="m-0">
                      Send your viewers to a sales page by adding custom
                      EBook Download Button
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleLinkbtn3Data}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {linkbtn3Data.linkbtnText.length}/35
                        </div>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtnText ? "is-invalid" : ""
                        }`}
                        placeholder="GET FREE"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 35) {
                              setLinkbtn3Data({
                                ...linkbtn3Data,
                                linkbtnText: e.target.value,
                              })
                            } else {
                              textLimitExceed(35)
                            }
                          }}
                        value={linkbtn3Data.linkbtnText}
                      />
                      </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Sub Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {linkbtn3Data.linkbtnText2.length}/70
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="EBook Unlocked With Button"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (inputValue.length <= 70) {
                            setLinkbtn3Data({
                              ...linkbtn3Data,
                              linkbtnText2: e.target.value,
                            })
                          } else {
                            textLimitExceed(70)
                          }
                        }}
                        value={linkbtn3Data.linkbtnText2}
                      />
                      </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Button Text</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {linkbtn3Data.linkbtnText3.length}/30
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Download"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (inputValue.length <= 30) {
                            setLinkbtn3Data({
                              ...linkbtn3Data,
                              linkbtnText3: e.target.value,
                            })
                          } else {
                            textLimitExceed(30)
                          }
                        }}
                        value={linkbtn3Data.linkbtnText3}
                      />
                    </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtnLink ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setLinkbtn3Data({
                            ...linkbtn3Data,
                            linkbtnLink: e.target.value,
                          })
                        }
                        value={linkbtn3Data.linkbtnLink}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtn3StartTime
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="00:00"
                        value={linkbtn3Data.linkbtn3StartTime}
                        onChange={(e) =>
                          setLinkbtn3Data({
                            ...linkbtn3Data,
                            linkbtn3StartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) =>
                          handleTimeKeyUp(e, "linkbtn3StartTime")
                        }
                        onBlur={(e) => handleTimeBlur(e, "linkbtn3StartTime")}
                        ref={linkbtn3StartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "linkbtn3StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "linkbtn3StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtn3EndTime ? "is-invalid" : ""
                        }`}
                        placeholder="00:00"
                        value={linkbtn3Data.linkbtn3EndTime}
                        onChange={(e) =>
                          setLinkbtn3Data({
                            ...linkbtn3Data,
                            linkbtn3EndTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "linkbtn3EndTime")}
                        onBlur={(e) => handleTimeBlur(e, "linkbtn3EndTime")}
                        ref={linkbtn3EndtimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "linkbtn3EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "linkbtn3EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => {
                          setShowLinkbutton3(false)
                          setShowTimingControl(false)
                        }}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}
            
            {showLinkbutton4 && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>FREE GIFT BUTTON</h4>
                    <p className="m-0">
                      Send your viewers to a sales page by adding custom
                      Free Gift Button
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleLinkbtn4Data}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {linkbtn4Data.linkbtnText.length}/120
                        </div>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtnText ? "is-invalid" : ""
                        }`}
                        placeholder="FREE GIFT AVAILABLE"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (inputValue.length <= 120) {
                            setLinkbtn4Data({
                              ...linkbtn4Data,
                              linkbtnText: e.target.value,
                            })
                          } else {
                            textLimitExceed(120)
                          }
                        }}
                        value={linkbtn4Data.linkbtnText}
                      />
                      </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  linkbtn4Data.text1FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setLinkbtn4Data({ ...linkbtn4Data, text1FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={linkbtn4Data.text1FontColor}
                              onChange={(e) =>
                                setLinkbtn4Data({ ...linkbtn4Data, text1FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${linkbtn4Data.text1bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLinkbtn4Data({ ...linkbtn4Data, text1bold: !linkbtn4Data.text1bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${linkbtn4Data.text1Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLinkbtn4Data({ ...linkbtn4Data, text1Italic: !linkbtn4Data.text1Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtnLink ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setLinkbtn4Data({
                            ...linkbtn4Data,
                            linkbtnLink: e.target.value,
                          })
                        }
                        value={linkbtn4Data.linkbtnLink}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtn4StartTime
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="00:00"
                        value={linkbtn4Data.linkbtn4StartTime}
                        onChange={(e) =>
                          setLinkbtn4Data({
                            ...linkbtn4Data,
                            linkbtn4StartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) =>
                          handleTimeKeyUp(e, "linkbtn4StartTime")
                        }
                        onBlur={(e) => handleTimeBlur(e, "linkbtn4StartTime")}
                        ref={linkbtn4StartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "linkbtn4StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "linkbtn4StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtn4EndTime ? "is-invalid" : ""
                        }`}
                        placeholder="00:00"
                        value={linkbtn4Data.linkbtn4EndTime}
                        onChange={(e) =>
                          setLinkbtn4Data({
                            ...linkbtn4Data,
                            linkbtn4EndTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "linkbtn4EndTime")}
                        onBlur={(e) => handleTimeBlur(e, "linkbtn4EndTime")}
                        ref={linkbtn4EndtimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "linkbtn4EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "linkbtn4EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => {
                          setShowLinkbutton4(false)
                          setShowTimingControl(false)
                        }}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}
            
            {showLinkbutton5 && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>QUIZ BUTTON</h4>
                    <p className="m-0">
                      Send your viewers to a sales page by adding custom
                      Quiz button
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleLinkbtn5Data}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {linkbtn5Data.linkbtnText.length}/50
                        </div>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtnText ? "is-invalid" : ""
                        }`}
                        placeholder="ENGAGE WITH QUIZZES"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 50) {
                              setLinkbtn5Data({
                                ...linkbtn5Data,
                                linkbtnText: e.target.value,
                              })
                            } else {
                              textLimitExceed(50)
                            }
                          }}
                        value={linkbtn5Data.linkbtnText}
                      />
                    </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Sub Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {linkbtn5Data.linkbtnText2.length}/210
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Our website is under construction"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (inputValue.length <= 210) {
                            setLinkbtn5Data({
                              ...linkbtn5Data,
                              linkbtnText2: e.target.value,
                            })
                          } else {
                            textLimitExceed(210)
                          }
                        }}
                        value={linkbtn5Data.linkbtnText2}
                      />
                    </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Button Text</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {linkbtn5Data.linkbtnText3.length}/30
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Get Updates"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (inputValue.length <= 30) {
                            setLinkbtn5Data({
                              ...linkbtn5Data,
                              linkbtnText3: e.target.value,
                            })
                          } else {
                            textLimitExceed(30)
                          }
                        }}
                        value={linkbtn5Data.linkbtnText3}
                      />
                    </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtnLink ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setLinkbtn5Data({
                            ...linkbtn5Data,
                            linkbtnLink: e.target.value,
                          })
                        }
                        value={linkbtn5Data.linkbtnLink}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtn5StartTime
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="00:00"
                        value={linkbtn5Data.linkbtn5StartTime}
                        onChange={(e) =>
                          setLinkbtn5Data({
                            ...linkbtn5Data,
                            linkbtn5StartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) =>
                          handleTimeKeyUp(e, "linkbtn5StartTime")
                        }
                        onBlur={(e) => handleTimeBlur(e, "linkbtn5StartTime")}
                        ref={linkbtn5StartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "linkbtn5StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "linkbtn5StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtn5EndTime ? "is-invalid" : ""
                        }`}
                        placeholder="00:00"
                        value={linkbtn5Data.linkbtn5EndTime}
                        onChange={(e) =>
                          setLinkbtn5Data({
                            ...linkbtn5Data,
                            linkbtn5EndTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "linkbtn5EndTime")}
                        onBlur={(e) => handleTimeBlur(e, "linkbtn5EndTime")}
                        ref={linkbtn5EndtimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "linkbtn5EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "linkbtn5EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => {
                          setShowLinkbutton5(false)
                          setShowTimingControl(false)
                        }}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}
            
            {showLinkbutton6 && (
              <>
                <div className="vac_aside bg-white p-3 shadow2 vac_aside2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Timer Button</h4> 
                    <p className="m-0">
                      Send your viewers to a sales page by adding custom
                      Timer Button
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleLinkbtn6Data}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {linkbtn6Data.linkbtnText.length}/55
                        </div>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtnText ? "is-invalid" : ""
                        }`}
                        placeholder="COMING SOON"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 55) {
                              setLinkbtn6Data({
                                ...linkbtn6Data,
                                linkbtnText: e.target.value,
                              })
                            } else {
                              textLimitExceed(55)
                            }
                          }}
                        value={linkbtn6Data.linkbtnText}
                      />
                      </div>
                    </div>
                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  linkbtn6Data.text1FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setLinkbtn6Data({ ...linkbtn6Data, text1FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={linkbtn6Data.text1FontColor}
                              onChange={(e) =>
                                setLinkbtn6Data({ ...linkbtn6Data, text1FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${linkbtn6Data.text1bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLinkbtn6Data({ ...linkbtn6Data, text1bold: !linkbtn6Data.text1bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${linkbtn6Data.text1Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLinkbtn6Data({ ...linkbtn6Data, text1Italic: !linkbtn6Data.text1Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Sub Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {linkbtn6Data.linkbtnText2.length}/200
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Reference site about Lorem Ipsum, giving information on its origins"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 200) {
                              setLinkbtn6Data({
                                ...linkbtn6Data,
                                linkbtnText2: e.target.value,
                              })
                            } else {
                              textLimitExceed(200)
                            }
                          }}
                        value={linkbtn6Data.linkbtnText2}
                      />
                      </div>
                    </div>
                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  linkbtn6Data.text2FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setLinkbtn6Data({ ...linkbtn6Data, text2FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={linkbtn6Data.text2FontColor}
                              onChange={(e) =>
                                setLinkbtn6Data({ ...linkbtn6Data, text2FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${linkbtn6Data.text2bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLinkbtn6Data({ ...linkbtn6Data, text2bold: !linkbtn6Data.text2bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${linkbtn6Data.text2Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLinkbtn6Data({ ...linkbtn6Data, text2Italic: !linkbtn6Data.text2Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Timer Time</label>
                      <input
                        type="datetime-local"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="2024-06-25T00:00:00"
                        onChange={(e) =>
                          setLinkbtn6Data({
                            ...linkbtn6Data,
                            TimerTime: e.target.value,
                          })
                        }
                        value={linkbtn6Data.TimerTime}
                      />
                    </div>
                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  linkbtn6Data.text3FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setLinkbtn6Data({ ...linkbtn6Data, text3FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={linkbtn6Data.text3FontColor}
                              onChange={(e) =>
                                setLinkbtn6Data({ ...linkbtn6Data, text3FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${linkbtn6Data.text3bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLinkbtn6Data({ ...linkbtn6Data, text3bold: !linkbtn6Data.text3bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${linkbtn6Data.text3Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLinkbtn6Data({ ...linkbtn6Data, text3Italic: !linkbtn6Data.text3Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    
                    <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={linkbtn6Data.bgcolor}
                              onChange={(e) =>
                                setLinkbtn6Data({ ...linkbtn6Data, bgcolor: e.target.value })
                              }
                            />
                      </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtn6StartTime
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="00:00"
                        value={linkbtn6Data.linkbtn6StartTime}
                        onChange={(e) =>
                          setLinkbtn6Data({
                            ...linkbtn6Data,
                            linkbtn6StartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) =>
                          handleTimeKeyUp(e, "linkbtn6StartTime")
                        }
                        onBlur={(e) => handleTimeBlur(e, "linkbtn6StartTime")}
                        ref={linkbtn6StartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "linkbtn6StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "linkbtn6StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtn6EndTime ? "is-invalid" : ""
                        }`}
                        placeholder="00:00"
                        value={linkbtn6Data.linkbtn6EndTime}
                        onChange={(e) =>
                          setLinkbtn6Data({
                            ...linkbtn6Data,
                            linkbtn6EndTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "linkbtn6EndTime")}
                        onBlur={(e) => handleTimeBlur(e, "linkbtn6EndTime")}
                        ref={linkbtn6EndtimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "linkbtn6EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "linkbtn6EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => {
                          setShowLinkbutton6(false)
                          setShowTimingControl(false)
                        }}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}
            
            {showLinkbutton7 && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Google Review Badge</h4>
                    <p className="m-0">
                      Send your viewers to a sales page by adding custom
                      Review Badge
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleLinkbtn7Data}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Text</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {linkbtn7Data.linkbtnText.length}/70
                        </div>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtnText ? "is-invalid" : ""
                        }`}
                        placeholder=""
                        onChange={(e) => {
                          const inputValue = e.target.value;
                        
                          if (inputValue.length <= 70) {
                            setLinkbtn7Data({
                              ...linkbtn7Data,
                              linkbtnText: e.target.value,
                            })
                          } else {
                            textLimitExceed(70)
                          }
                        }}
                        value={linkbtn7Data.linkbtnText}
                      />
                    </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Rating  (1 to 5)</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="5"
                        onChange={(e) => {
                          setLinkbtn7Data({
                            ...linkbtn7Data,
                            googleRating: e.target.value,
                          })
                        }}
                          onBlur={(e) => {
                              let ratingValue = e.target.value;
                              if (ratingValue > 5)
                                  {
                                    cuteToast({
                                      type: "error",
                                      message: "Rating should be less than 5",
                                      timer: 2000,
                                      title: "",
                                    });
                                    ratingValue = 5; 
                                  }else if(ratingValue < 1){
                                    cuteToast({
                                      type: "error",
                                      message:  "Atleast 1 star is required",
                                      timer: 2000,
                                      title: "",
                                    }); 
                                    ratingValue = 1;
                                  }
                          setLinkbtn7Data({
                            ...linkbtn7Data,
                            googleRating: ratingValue,
                          })
                        }}
                        value={linkbtn7Data.googleRating}
                      />
                    </div>


                    <div className="form_rw mb-3">
                      <label>URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtnLink ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setLinkbtn7Data({
                            ...linkbtn7Data,
                            linkbtnLink: e.target.value,
                          })
                        }
                        value={linkbtn7Data.linkbtnLink}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtn7StartTime
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="00:00"
                        value={linkbtn7Data.linkbtn7StartTime}
                        onChange={(e) =>
                          setLinkbtn7Data({
                            ...linkbtn7Data,
                            linkbtn7StartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) =>
                          handleTimeKeyUp(e, "linkbtn7StartTime")
                        }
                        onBlur={(e) => handleTimeBlur(e, "linkbtn7StartTime")}
                        ref={linkbtn7StartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "linkbtn7StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "linkbtn7StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtn7EndTime ? "is-invalid" : ""
                        }`}
                        placeholder="00:00"
                        value={linkbtn7Data.linkbtn7EndTime}
                        onChange={(e) =>
                          setLinkbtn7Data({
                            ...linkbtn7Data,
                            linkbtn7EndTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "linkbtn7EndTime")}
                        onBlur={(e) => handleTimeBlur(e, "linkbtn7EndTime")}
                        ref={linkbtn7EndtimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "linkbtn7EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "linkbtn7EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => {
                          setShowLinkbutton7(false)
                          setShowTimingControl(false)
                        }}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}
            
            {showLinkbutton8 && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Social Media</h4>
                    <p className="m-0"></p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleLinkbtn8Data}>
                    


                    <div className="form_rw mb-3">
                      <label>Facebook Link</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setLinkbtn8Data({
                            ...linkbtn8Data,
                            linkbtnLink1: e.target.value,
                          })
                        }
                        value={linkbtn8Data.linkbtnLink1}
                      />
                    </div>

                    <div className="form_rw mb-3">
                      <label>Twitter Link</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setLinkbtn8Data({
                            ...linkbtn8Data,
                            linkbtnLink2: e.target.value,
                          })
                        }
                        value={linkbtn8Data.linkbtnLink2}
                      />
                    </div>

                    <div className="form_rw mb-3">
                      <label>Instagram Link</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setLinkbtn8Data({
                            ...linkbtn8Data,
                            linkbtnLink3: e.target.value,
                          })
                        }
                        value={linkbtn8Data.linkbtnLink3}
                      />
                    </div>

                    <div className="form_rw mb-3">
                      <label>LinkedIn Link</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setLinkbtn8Data({
                            ...linkbtn8Data,
                            linkbtnLink4: e.target.value,
                          })
                        }
                        value={linkbtn8Data.linkbtnLink4}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtn8StartTime
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="00:00"
                        value={linkbtn8Data.linkbtn8StartTime}
                        onChange={(e) =>
                          setLinkbtn8Data({
                            ...linkbtn8Data,
                            linkbtn8StartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) =>
                          handleTimeKeyUp(e, "linkbtn8StartTime")
                        }
                        onBlur={(e) => handleTimeBlur(e, "linkbtn8StartTime")}
                        ref={linkbtn8StartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "linkbtn8StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "linkbtn8StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtn8EndTime ? "is-invalid" : ""
                        }`}
                        placeholder="00:00"
                        value={linkbtn8Data.linkbtn8EndTime}
                        onChange={(e) =>
                          setLinkbtn8Data({
                            ...linkbtn8Data,
                            linkbtn8EndTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "linkbtn8EndTime")}
                        onBlur={(e) => handleTimeBlur(e, "linkbtn8EndTime")}
                        ref={linkbtn8EndtimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "linkbtn8EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "linkbtn8EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => {
                          setShowLinkbutton8(false)
                          setShowTimingControl(false)
                        }}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}
            
            {showLinkbutton9 && (
              <>
                <div className="vac_aside bg-white p-3 shadow2 vac_aside2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Voucher</h4>
                    <p className="m-0"></p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleLinkbtn9Data}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {linkbtn9Data.linkbtnText.length}/50
                        </div>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtnText ? "is-invalid" : ""
                        }`}
                        placeholder=""
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 50) {
                              setLinkbtn9Data({
                                ...linkbtn9Data,
                                linkbtnText: e.target.value,
                              })
                            } else {
                              textLimitExceed(50)
                            }
                          }}
                        value={linkbtn9Data.linkbtnText}
                      />
                    </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  linkbtn9Data.text1FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setLinkbtn9Data({ ...linkbtn9Data, text1FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={linkbtn9Data.text1FontColor}
                              onChange={(e) =>
                                setLinkbtn9Data({ ...linkbtn9Data, text1FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${linkbtn9Data.text1bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLinkbtn9Data({ ...linkbtn9Data, text1bold: !linkbtn9Data.text1bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${linkbtn9Data.text1Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLinkbtn9Data({ ...linkbtn9Data, text1Italic: !linkbtn9Data.text1Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Sub Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {linkbtn9Data.linkbtnText2.length}/15
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Our website is under construction"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 15) {
                              setLinkbtn9Data({
                                ...linkbtn9Data,
                                linkbtnText2: e.target.value,
                              })
                            } else {
                              textLimitExceed(15)
                            }
                          }}
                        value={linkbtn9Data.linkbtnText2}
                      />
                    </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  linkbtn9Data.text2FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setLinkbtn9Data({ ...linkbtn9Data, text2FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={linkbtn9Data.text2FontColor}
                              onChange={(e) =>
                                setLinkbtn9Data({ ...linkbtn9Data, text2FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${linkbtn9Data.text2bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLinkbtn9Data({ ...linkbtn9Data, text2bold: !linkbtn9Data.text2bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${linkbtn9Data.text2Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLinkbtn9Data({ ...linkbtn9Data, text2Italic: !linkbtn9Data.text2Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Percentage</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {linkbtn9Data.linkbtnText3.length}/25
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Get Updates"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 25) {
                              setLinkbtn9Data({
                                ...linkbtn9Data,
                                linkbtnText3: e.target.value,
                              })
                            } else {
                              textLimitExceed(25)
                            }
                          }}
                        value={linkbtn9Data.linkbtnText3}
                      />
                    </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  linkbtn9Data.text3FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setLinkbtn9Data({ ...linkbtn9Data, text3FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={linkbtn9Data.text3FontColor}
                              onChange={(e) =>
                                setLinkbtn9Data({ ...linkbtn9Data, text3FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${linkbtn9Data.text3bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLinkbtn9Data({ ...linkbtn9Data, text3bold: !linkbtn9Data.text3bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${linkbtn9Data.text3Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLinkbtn9Data({ ...linkbtn9Data, text3Italic: !linkbtn9Data.text3Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                   

                    <div className="form_rw mb-3">
                      <label>URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtnLink ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setLinkbtn9Data({
                            ...linkbtn9Data,
                            linkbtnLink: e.target.value,
                          })
                        }
                        value={linkbtn9Data.linkbtnLink}
                      />
                    </div>
 
                    <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtn9StartTime
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="00:00"
                        value={linkbtn9Data.linkbtn9StartTime}
                        onChange={(e) =>
                          setLinkbtn9Data({
                            ...linkbtn9Data,
                            linkbtn9StartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) =>
                          handleTimeKeyUp(e, "linkbtn9StartTime")
                        }
                        onBlur={(e) => handleTimeBlur(e, "linkbtn9StartTime")}
                        ref={linkbtn9StartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "linkbtn9StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "linkbtn9StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.linkbtn9EndTime ? "is-invalid" : ""
                        }`}
                        placeholder="00:00"
                        value={linkbtn9Data.linkbtn9EndTime}
                        onChange={(e) =>
                          setLinkbtn9Data({
                            ...linkbtn9Data,
                            linkbtn9EndTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "linkbtn9EndTime")}
                        onBlur={(e) => handleTimeBlur(e, "linkbtn9EndTime")}
                        ref={linkbtn9EndtimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "linkbtn9EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "linkbtn9EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>
 
                    <div className="btn_wrap_p pt-3">
                      <button
                        type="button"
                        onClick={() => {
                          setShowLinkbutton9(false)
                          setShowTimingControl(false)
                        }}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}
             
            {showImgbtn1 && (
              <>
                <div className="vac_aside bg-white p-3 shadow2 vac_aside2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Shopping Card</h4>
                    <p className="m-0">
                      Send your viewers to a sales page by adding custom
                      Buy Button
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleImgbtn1Data}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {Imgbtn1Data.ImgbtnText.length}/50
                        </div>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnText ? "is-invalid" : ""
                        }`}
                        placeholder="COMING SOON"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 50) {
                              setImgbtn1Data({
                                ...Imgbtn1Data,
                                ImgbtnText: e.target.value,
                              })
                            } else {
                              textLimitExceed(50)
                            }
                          }}
                        value={Imgbtn1Data.ImgbtnText}
                      />
                    </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  Imgbtn1Data.text1FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setImgbtn1Data({ ...Imgbtn1Data, text1FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={Imgbtn1Data.text1FontColor}
                              onChange={(e) =>
                                setImgbtn1Data({ ...Imgbtn1Data, text1FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${Imgbtn1Data.text1bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn1Data({ ...Imgbtn1Data, text1bold: !Imgbtn1Data.text1bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${Imgbtn1Data.text1Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn1Data({ ...Imgbtn1Data, text1Italic: !Imgbtn1Data.text1Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Price Text</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {Imgbtn1Data.ImgbtnText2.length}/15
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Our website is under construction"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 15) {
                              setImgbtn1Data({
                                ...Imgbtn1Data,
                                ImgbtnText2: e.target.value,
                              })
                            } else {
                              textLimitExceed(15)
                            }
                          }}
                        value={Imgbtn1Data.ImgbtnText2}
                      />
                    </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  Imgbtn1Data.text2FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setImgbtn1Data({ ...Imgbtn1Data, text2FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={Imgbtn1Data.text2FontColor}
                              onChange={(e) =>
                                setImgbtn1Data({ ...Imgbtn1Data, text2FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${Imgbtn1Data.text2bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn1Data({ ...Imgbtn1Data, text2bold: !Imgbtn1Data.text2bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${Imgbtn1Data.text2Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn1Data({ ...Imgbtn1Data, text2Italic: !Imgbtn1Data.text2Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Button Text</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {Imgbtn1Data.ImgbtnText3.length}/25
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Get Updates"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 25) {
                              setImgbtn1Data({
                                ...Imgbtn1Data,
                                ImgbtnText3: e.target.value,
                              })
                            } else {
                              textLimitExceed(25)
                            }
                          }}
                        value={Imgbtn1Data.ImgbtnText3}
                      />
                    </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  Imgbtn1Data.text3FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setImgbtn1Data({ ...Imgbtn1Data, text3FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={Imgbtn1Data.text3FontColor}
                              onChange={(e) =>
                                setImgbtn1Data({ ...Imgbtn1Data, text3FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${Imgbtn1Data.text3bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn1Data({ ...Imgbtn1Data, text3bold: !Imgbtn1Data.text3bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${Imgbtn1Data.text3Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn1Data({ ...Imgbtn1Data, text3Italic: !Imgbtn1Data.text3Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>Image URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnURL ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setImgbtn1Data({
                            ...Imgbtn1Data,
                            ImgbtnURL: e.target.value,
                          })
                        }
                        value={Imgbtn1Data.ImgbtnURL}
                      />

                      <div className="text-center mt-3">      
                        <BiImageAdd
                          size={30}
                          className="text-main-color cursor-pointer"
                          data-tip="Upload Image"
                          onClick={() =>   addImage(inputFileRef) }
                        />
                      </div>
                      <input
                        name=""
                        ref={inputFileRef}
                        className="d-none"
                        type="file"
                        onChange={(e) =>   onFileChange(e,1) }
                      />
                    </div>

                    <div className="form_rw mb-3">
                      <label>URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnLink ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setImgbtn1Data({
                            ...Imgbtn1Data,
                            ImgbtnLink: e.target.value,
                          })
                        }
                        value={Imgbtn1Data.ImgbtnLink}
                      />
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Description</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {Imgbtn1Data.ImgbtnText4.length}/80
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Our website is under construction"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (inputValue.length <= 80) {
                            setImgbtn1Data({
                              ...Imgbtn1Data,
                              ImgbtnText4: e.target.value,
                            })
                          } else {
                            textLimitExceed(80)
                          }
                        }}
                        value={Imgbtn1Data.ImgbtnText4}
                      />
                    </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  Imgbtn1Data.text4FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setImgbtn1Data({ ...Imgbtn1Data, text4FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={Imgbtn1Data.text4FontColor}
                              onChange={(e) =>
                                setImgbtn1Data({ ...Imgbtn1Data, text4FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${Imgbtn1Data.text4bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn1Data({ ...Imgbtn1Data, text4bold: !Imgbtn1Data.text4bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${Imgbtn1Data.text4Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn1Data({ ...Imgbtn1Data, text4Italic: !Imgbtn1Data.text4Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>
                        Price Button Background Color
                        <span> 
                          <TiArrowRepeat 
                          data-tip="Set Default"
                          className="text-main-color cursor-pointer default-icon"
                          size={23}
                          onClick={(e) =>
                            setImgbtn1Data({
                              ...Imgbtn1Data,
                              buybuttonbgcolor: "#fa452d"
                            })
                          }
                           /> 
                        </span> 
                      </label>
                      <input
                        type="color"
                        className="form-control"
                        onChange={(e) =>
                          setImgbtn1Data({
                            ...Imgbtn1Data,
                            buybuttonbgcolor: e.target.value,
                          })
                        }
                        value={Imgbtn1Data.buybuttonbgcolor}
                      />
                    </div>
                    
                    <div className="form_rw mb-3 pt-2">
                      <label>
                        background color
                        <span> 
                          <TiArrowRepeat 
                          data-tip="Set Default"
                          className="text-main-color cursor-pointer default-icon"
                          size={23}
                          onClick={(e) =>
                            setImgbtn1Data({
                              ...Imgbtn1Data,
                              bgcolor: "#ffffff"
                            })
                          }
                           /> 
                        </span> 
                      </label>
                      <input
                        type="color"
                        className="form-control"
                        onChange={(e) =>
                          setImgbtn1Data({
                            ...Imgbtn1Data,
                            bgcolor: e.target.value,
                          })
                        }
                        value={Imgbtn1Data.bgcolor}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.Imgbtn1StartTime
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="00:00"
                        value={Imgbtn1Data.Imgbtn1StartTime}
                        onChange={(e) =>
                          setImgbtn1Data({
                            ...Imgbtn1Data,
                            Imgbtn1StartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) =>
                          handleTimeKeyUp(e, "Imgbtn1StartTime")
                        }
                        onBlur={(e) => handleTimeBlur(e, "Imgbtn1StartTime")}
                        ref={Imgbtn1StartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "Imgbtn1StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "Imgbtn1StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.Imgbtn1EndTime ? "is-invalid" : ""
                        }`}
                        placeholder="00:00"
                        value={Imgbtn1Data.Imgbtn1EndTime}
                        onChange={(e) =>
                          setImgbtn1Data({
                            ...Imgbtn1Data,
                            Imgbtn1EndTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "Imgbtn1EndTime")}
                        onBlur={(e) => handleTimeBlur(e, "Imgbtn1EndTime")}
                        ref={Imgbtn1EndtimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "Imgbtn1EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "Imgbtn1EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => {
                          setShowImgbtn1(false)
                          setShowTimingControl(false)
                        }}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}

            {showImgbtn2 && (
              <>
                <div className="vac_aside vac_aside2 bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>QR Code Button 1</h4>
                    <p className="m-0">
                      Send your viewers to a sales page by adding custom
                      QR Code
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleImgbtn2Data}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {Imgbtn2Data.ImgbtnText.length}/70
                        </div>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnText ? "is-invalid" : ""
                        }`}
                        placeholder="SCAN QR CODE"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 70) {
                              setImgbtn2Data({
                                ...Imgbtn2Data,
                                ImgbtnText: e.target.value,
                              })
                            } else {
                              textLimitExceed(70)
                            }
                          }}
                        value={Imgbtn2Data.ImgbtnText}
                      />
                      </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  Imgbtn2Data.text1FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setImgbtn2Data({ ...Imgbtn2Data, text1FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={Imgbtn2Data.text1FontColor}
                              onChange={(e) =>
                                setImgbtn2Data({ ...Imgbtn2Data, text1FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${Imgbtn2Data.text1bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn2Data({ ...Imgbtn2Data, text1bold: !Imgbtn2Data.text1bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${Imgbtn2Data.text1Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn2Data({ ...Imgbtn2Data, text1Italic: !Imgbtn2Data.text1Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Sub Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {Imgbtn2Data.ImgbtnText2.length}/150
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Scan it to login to your dashboard "
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 150) {
                              setImgbtn2Data({
                                ...Imgbtn2Data,
                                ImgbtnText2: e.target.value,
                              })
                            } else {
                              textLimitExceed(150)
                            }
                          }}
                        value={Imgbtn2Data.ImgbtnText2}
                      />
                      </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  Imgbtn2Data.text2FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setImgbtn2Data({ ...Imgbtn2Data, text2FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={Imgbtn2Data.text2FontColor}
                              onChange={(e) =>
                                setImgbtn2Data({ ...Imgbtn2Data, text2FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${Imgbtn2Data.text2bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn2Data({ ...Imgbtn2Data, text2bold: !Imgbtn2Data.text2bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${Imgbtn2Data.text2Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn2Data({ ...Imgbtn2Data, text2Italic: !Imgbtn2Data.text2Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>QR Code Image URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnURL ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setImgbtn2Data({
                            ...Imgbtn2Data,
                            ImgbtnURL: e.target.value,
                          })
                        }
                        value={Imgbtn2Data.ImgbtnURL}
                      />

                      <button type="button" className="btn btn2 mt-2" onClick={() => setShowQrCodeModal(true)} >Generate QR Code </button>
                      
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>
                        background color
                        <span> 
                          <TiArrowRepeat 
                          data-tip="Set Default"
                          className="text-main-color cursor-pointer default-icon"
                          size={23}
                          onClick={(e) =>
                            setImgbtn2Data({
                              ...Imgbtn2Data,
                              bgcolor: "#6d34ff"
                            })
                          }
                           /> 
                        </span> 
                      </label>
                      <input
                        type="color"
                        className="form-control"
                        onChange={(e) =>
                          setImgbtn2Data({
                            ...Imgbtn2Data,
                            bgcolor: e.target.value,
                          })
                        }
                        value={Imgbtn2Data.bgcolor}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.Imgbtn2StartTime
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="00:00"
                        value={Imgbtn2Data.Imgbtn2StartTime}
                        onChange={(e) =>
                          setImgbtn2Data({
                            ...Imgbtn2Data,
                            Imgbtn2StartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) =>
                          handleTimeKeyUp(e, "Imgbtn2StartTime")
                        }
                        onBlur={(e) => handleTimeBlur(e, "Imgbtn2StartTime")}
                        ref={Imgbtn2StartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "Imgbtn2StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "Imgbtn2StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.Imgbtn2EndTime ? "is-invalid" : ""
                        }`}
                        placeholder="00:00"
                        value={Imgbtn2Data.Imgbtn2EndTime}
                        onChange={(e) =>
                          setImgbtn2Data({
                            ...Imgbtn2Data,
                            Imgbtn2EndTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "Imgbtn2EndTime")}
                        onBlur={(e) => handleTimeBlur(e, "Imgbtn2EndTime")}
                        ref={Imgbtn2EndtimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "Imgbtn2EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "Imgbtn2EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => {
                          setShowImgbtn2(false)
                          setShowTimingControl(false)
                        }}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}

            {showImgbtn3 && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Product Buy Button</h4> 
                    <p className="m-0">
                      Send your viewers to a sales page by adding custom
                      Buy Button
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleImgbtn3Data}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {Imgbtn3Data.ImgbtnText.length}/50
                        </div>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnText ? "is-invalid" : ""
                        }`}
                        placeholder="COMING SOON"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 50) {
                              setImgbtn3Data({
                                ...Imgbtn3Data,
                                ImgbtnText: e.target.value,
                              })
                            } else {
                              textLimitExceed(50)
                            }
                          }}
                        value={Imgbtn3Data.ImgbtnText}
                      />
                    </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  Imgbtn3Data.text1FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setImgbtn3Data({ ...Imgbtn3Data, text1FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={Imgbtn3Data.text1FontColor}
                              onChange={(e) =>
                                setImgbtn3Data({ ...Imgbtn3Data, text1FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${Imgbtn3Data.text1bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn3Data({ ...Imgbtn3Data, text1bold: !Imgbtn3Data.text1bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${Imgbtn3Data.text1Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn3Data({ ...Imgbtn3Data, text1Italic: !Imgbtn3Data.text1Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Price Text</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {Imgbtn3Data.ImgbtnText2.length}/40
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Our website is under construction"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 40) {
                              setImgbtn3Data({
                                ...Imgbtn3Data,
                                ImgbtnText2: e.target.value,
                              })
                            } else {
                              textLimitExceed(40)
                            }
                          }}
                        value={Imgbtn3Data.ImgbtnText2}
                      />
                    </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  Imgbtn3Data.text2FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setImgbtn3Data({ ...Imgbtn3Data, text2FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={Imgbtn3Data.text2FontColor}
                              onChange={(e) =>
                                setImgbtn3Data({ ...Imgbtn3Data, text2FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${Imgbtn3Data.text2bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn3Data({ ...Imgbtn3Data, text2bold: !Imgbtn3Data.text2bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${Imgbtn3Data.text2Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn3Data({ ...Imgbtn3Data, text2Italic: !Imgbtn3Data.text2Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>Image URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnURL ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setImgbtn3Data({
                            ...Imgbtn3Data,
                            ImgbtnURL: e.target.value,
                          })
                        }
                        value={Imgbtn3Data.ImgbtnURL}
                      />

                      <div className="text-center mt-3">      
                        <BiImageAdd
                          size={30}
                          className="text-main-color cursor-pointer"
                          data-tip="Upload Image"
                          onClick={() =>   addImage(inputFileRef2) }
                        />
                      </div>
                      <input
                        name=""
                        ref={inputFileRef2}
                        className="d-none"
                        type="file"
                        onChange={(e) =>   onFileChange(e,2) }
                      />
                    </div>

                    <div className="form_rw mb-3">
                      <label>URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnLink ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setImgbtn3Data({
                            ...Imgbtn3Data,
                            ImgbtnLink: e.target.value,
                          })
                        }
                        value={Imgbtn3Data.ImgbtnLink}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.Imgbtn3StartTime
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="00:00"
                        value={Imgbtn3Data.Imgbtn3StartTime}
                        onChange={(e) =>
                          setImgbtn3Data({
                            ...Imgbtn3Data,
                            Imgbtn3StartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) =>
                          handleTimeKeyUp(e, "Imgbtn3StartTime")
                        }
                        onBlur={(e) => handleTimeBlur(e, "Imgbtn3StartTime")}
                        ref={Imgbtn3StartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "Imgbtn3StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "Imgbtn3StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.Imgbtn3EndTime ? "is-invalid" : ""
                        }`}
                        placeholder="00:00"
                        value={Imgbtn3Data.Imgbtn3EndTime}
                        onChange={(e) =>
                          setImgbtn3Data({
                            ...Imgbtn3Data,
                            Imgbtn3EndTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "Imgbtn3EndTime")}
                        onBlur={(e) => handleTimeBlur(e, "Imgbtn3EndTime")}
                        ref={Imgbtn3EndtimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "Imgbtn3EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "Imgbtn3EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => {
                          setShowImgbtn3(false)
                          setShowTimingControl(false)
                        }}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}
            
            {showImgbtn4 && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>QR Code Button 2</h4>
                    <p className="m-0">
                      Send your viewers to a sales page by adding custom
                      QR Code
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleImgbtn4Data}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {Imgbtn4Data.ImgbtnText.length}/100
                        </div>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnText ? "is-invalid" : ""
                        }`}
                        placeholder="SCAN THE QR TO CONTINUE"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (inputValue.length <= 100) {
                            setImgbtn4Data({
                              ...Imgbtn4Data,
                              ImgbtnText: e.target.value,
                            })
                          } else {
                            textLimitExceed(100)
                          }
                        }}
                        value={Imgbtn4Data.ImgbtnText}
                      />
                      </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  Imgbtn4Data.text1FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setImgbtn4Data({ ...Imgbtn4Data, text1FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={Imgbtn4Data.text1FontColor}
                              onChange={(e) =>
                                setImgbtn4Data({ ...Imgbtn4Data, text1FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${Imgbtn4Data.text1bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn4Data({ ...Imgbtn4Data, text1bold: !Imgbtn4Data.text1bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${Imgbtn4Data.text1Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn4Data({ ...Imgbtn4Data, text1Italic: !Imgbtn4Data.text1Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>
                        background color 1
                        <span> 
                          <TiArrowRepeat 
                          data-tip="Set Default"
                          className="text-main-color cursor-pointer default-icon"
                          size={23}
                          onClick={(e) =>
                            setImgbtn4Data({
                              ...Imgbtn4Data,
                              bgcolor: "#282a39"
                            })
                          }
                           /> 
                        </span> 
                      </label>
                      <input
                        type="color"
                        className="form-control"
                        onChange={(e) =>
                          setImgbtn4Data({
                            ...Imgbtn4Data,
                            bgcolor: e.target.value,
                          })
                        }
                        value={Imgbtn4Data.bgcolor}
                      />
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>
                        background color 2
                        <span> 
                          <TiArrowRepeat 
                          data-tip="Set Default"
                          className="text-main-color cursor-pointer default-icon"
                          size={23}
                          onClick={(e) =>
                            setImgbtn4Data({
                              ...Imgbtn4Data,
                              bgcolor2: "#0E1437"
                            })
                          }
                           /> 
                        </span> 
                      </label>
                      <input
                        type="color"
                        className="form-control"
                        onChange={(e) =>
                          setImgbtn4Data({
                            ...Imgbtn4Data,
                            bgcolor2: e.target.value,
                          })
                        }
                        value={Imgbtn4Data.bgcolor2}
                      />
                    </div>

                    <div className="form_rw mb-3">
                      <label>Image URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnURL ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setImgbtn4Data({
                            ...Imgbtn4Data,
                            ImgbtnURL2: e.target.value,
                          })
                        }
                        value={Imgbtn4Data.ImgbtnURL2}
                      />

                      <div className="text-center mt-3">      
                        <BiImageAdd
                          size={30}
                          className="text-main-color cursor-pointer"
                          data-tip="Upload Image"
                          onClick={() =>   addImage(inputFileRef6) }
                        />
                      </div>
                      <input
                        name=""
                        ref={inputFileRef6}
                        className="d-none"
                        type="file"
                        onChange={(e) =>   onFileChange(e,6) }
                      />
                    </div>

                    <div className="form_rw mb-3">
                      <label>QR Code Image URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnURL ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setImgbtn4Data({
                            ...Imgbtn4Data,
                            ImgbtnURL: e.target.value,
                          })
                        }
                        value={Imgbtn4Data.ImgbtnURL}
                      />

                      <button type="button" className="btn btn2 mt-2" onClick={() => setShowQrCodeModal(true)} >Generate QR Code </button>
                      
                    </div>


                    <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.Imgbtn4StartTime
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="00:00"
                        value={Imgbtn4Data.Imgbtn4StartTime}
                        onChange={(e) =>
                          setImgbtn4Data({
                            ...Imgbtn4Data,
                            Imgbtn4StartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) =>
                          handleTimeKeyUp(e, "Imgbtn4StartTime")
                        }
                        onBlur={(e) => handleTimeBlur(e, "Imgbtn4StartTime")}
                        ref={Imgbtn4StartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "Imgbtn4StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "Imgbtn4StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.Imgbtn4EndTime ? "is-invalid" : ""
                        }`}
                        placeholder="00:00"
                        value={Imgbtn4Data.Imgbtn4EndTime}
                        onChange={(e) =>
                          setImgbtn4Data({
                            ...Imgbtn4Data,
                            Imgbtn4EndTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "Imgbtn4EndTime")}
                        onBlur={(e) => handleTimeBlur(e, "Imgbtn4EndTime")}
                        ref={Imgbtn4EndtimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "Imgbtn4EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "Imgbtn4EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => {
                          setShowImgbtn4(false)
                          setShowTimingControl(false)
                        }}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}

            {showImgbtn5 && (
              <>
                <div className="vac_aside bg-white p-3 shadow2 vac_aside2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Timer With Shopping Card</h4>
                    <p className="m-0">
                      Send your viewers to a sales page by adding custom
                      Timer Button
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleImgbtn5Data}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {Imgbtn5Data.ImgbtnText.length}/35
                        </div>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnText ? "is-invalid" : ""
                        }`}
                        placeholder="COMING SOON"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 35) {
                              setImgbtn5Data({
                                ...Imgbtn5Data,
                                ImgbtnText: e.target.value,
                              })
                            } else {
                              textLimitExceed(35)
                            }
                          }}
                        value={Imgbtn5Data.ImgbtnText}
                      />
                      </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  Imgbtn5Data.text1FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setImgbtn5Data({ ...Imgbtn5Data, text1FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={Imgbtn5Data.text1FontColor}
                              onChange={(e) =>
                                setImgbtn5Data({ ...Imgbtn5Data, text1FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${Imgbtn5Data.text1bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn5Data({ ...Imgbtn5Data, text1bold: !Imgbtn5Data.text1bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${Imgbtn5Data.text1Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn5Data({ ...Imgbtn5Data, text1Italic: !Imgbtn5Data.text1Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Price Text</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {Imgbtn5Data.ImgbtnText2.length}/16
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Our website is under construction"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 16) {
                              setImgbtn5Data({
                                ...Imgbtn5Data,
                                ImgbtnText2: e.target.value,
                              })
                            } else {
                              textLimitExceed(16)
                            }
                          }}
                        value={Imgbtn5Data.ImgbtnText2}
                      />
                      </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  Imgbtn5Data.text2FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setImgbtn5Data({ ...Imgbtn5Data, text2FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={Imgbtn5Data.text2FontColor}
                              onChange={(e) =>
                                setImgbtn5Data({ ...Imgbtn5Data, text2FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${Imgbtn5Data.text2bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn5Data({ ...Imgbtn5Data, text2bold: !Imgbtn5Data.text2bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${Imgbtn5Data.text2Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn5Data({ ...Imgbtn5Data, text2Italic: !Imgbtn5Data.text2Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Button Text</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {Imgbtn5Data.ImgbtnText3.length}/15
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Get Updates"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 15) {
                              setImgbtn5Data({
                                ...Imgbtn5Data,
                                ImgbtnText3: e.target.value,
                              })
                            } else {
                              textLimitExceed(15)
                            }
                          }}
                        value={Imgbtn5Data.ImgbtnText3}
                      />
                      </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  Imgbtn5Data.text3FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setImgbtn5Data({ ...Imgbtn5Data, text3FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={Imgbtn5Data.text3FontColor}
                              onChange={(e) =>
                                setImgbtn5Data({ ...Imgbtn5Data, text3FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${Imgbtn5Data.text3bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn5Data({ ...Imgbtn5Data, text3bold: !Imgbtn5Data.text3bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${Imgbtn5Data.text3Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn5Data({ ...Imgbtn5Data, text3Italic: !Imgbtn5Data.text3Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Timer Time</label>
                      <input
                        type="datetime-local"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="2024-06-25T00:00:00"
                        onChange={(e) =>
                          setImgbtn5Data({
                            ...Imgbtn5Data,
                            TimerTime: e.target.value,
                          })
                        }
                        value={Imgbtn5Data.TimerTime}
                      />
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  Imgbtn5Data.text4FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setImgbtn5Data({ ...Imgbtn5Data, text4FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={Imgbtn5Data.text4FontColor}
                              onChange={(e) =>
                                setImgbtn5Data({ ...Imgbtn5Data, text4FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${Imgbtn5Data.text4bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn5Data({ ...Imgbtn5Data, text4bold: !Imgbtn5Data.text4bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${Imgbtn5Data.text4Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn5Data({ ...Imgbtn5Data, text4Italic: !Imgbtn5Data.text4Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>Image URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnURL ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setImgbtn5Data({
                            ...Imgbtn5Data,
                            ImgbtnURL: e.target.value,
                          })
                        }
                        value={Imgbtn5Data.ImgbtnURL}
                      />

                      <div className="text-center mt-3">      
                        <BiImageAdd
                          size={30}
                          className="text-main-color cursor-pointer"
                          data-tip="Upload Image"
                          onClick={() =>   addImage(inputFileRef3) }
                        />
                      </div>
                      <input
                        name=""
                        ref={inputFileRef3}
                        className="d-none"
                        type="file"
                        onChange={(e) =>   onFileChange(e,3) }
                      />
                    </div>

                    <div className="form_rw mb-3">
                      <label>Buy Button URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnLink ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setImgbtn5Data({
                            ...Imgbtn5Data,
                            ImgbtnLink: e.target.value,
                          })
                        }
                        value={Imgbtn5Data.ImgbtnLink}
                      />
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Description</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {Imgbtn5Data.ImgbtnText4.length}/100
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Our website is under construction"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 100) {
                              setImgbtn5Data({
                                ...Imgbtn5Data,
                                ImgbtnText4: e.target.value,
                              })
                            } else {
                              textLimitExceed(100)
                            }
                          }}
                        value={Imgbtn5Data.ImgbtnText4}
                      />
                      </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  Imgbtn5Data.text5FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setImgbtn5Data({ ...Imgbtn5Data, text5FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={Imgbtn5Data.text5FontColor}
                              onChange={(e) =>
                                setImgbtn5Data({ ...Imgbtn5Data, text5FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${Imgbtn5Data.text5bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn5Data({ ...Imgbtn5Data, text5bold: !Imgbtn5Data.text5bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${Imgbtn5Data.text5Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn5Data({ ...Imgbtn5Data, text5Italic: !Imgbtn5Data.text5Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Timer Background Color 
                        <span> 
                          <TiArrowRepeat 
                          data-tip="Set Default"
                          className="text-main-color cursor-pointer default-icon"
                          size={23}
                          onClick={(e) =>
                            setImgbtn5Data({
                              ...Imgbtn5Data,
                              timerbgcolor: "#FFE695"
                            })
                          }
                           /> 
                        </span> 
                      </label>
                      <input
                        type="color"
                        className="form-control"
                        onChange={(e) =>
                          setImgbtn5Data({
                            ...Imgbtn5Data,
                            timerbgcolor: e.target.value,
                          })
                        }
                        value={Imgbtn5Data.timerbgcolor}
                      />
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>
                        Buy Button Background Color
                        <span> 
                          <TiArrowRepeat 
                          data-tip="Set Default"
                          className="text-main-color cursor-pointer default-icon"
                          size={23}
                          onClick={(e) =>
                            setImgbtn5Data({
                              ...Imgbtn5Data,
                              buybuttonbgcolor: "#fa452d"
                            })
                          }
                           /> 
                        </span> 
                      </label>
                      <input
                        type="color"
                        className="form-control"
                        onChange={(e) =>
                          setImgbtn5Data({
                            ...Imgbtn5Data,
                            buybuttonbgcolor: e.target.value,
                          })
                        }
                        value={Imgbtn5Data.buybuttonbgcolor}
                      />
                    </div>
                    
                    <div className="form_rw mb-3 pt-2">
                      <label>
                        Background Color
                        <span> 
                          <TiArrowRepeat 
                          data-tip="Set Default"
                          className="text-main-color cursor-pointer default-icon"
                          size={23}
                          onClick={(e) =>
                            setImgbtn5Data({
                              ...Imgbtn5Data,
                              bgcolor: "#ffffff"
                            })
                          }
                           /> 
                        </span> 
                      </label>
                      <input
                        type="color"
                        className="form-control"
                        onChange={(e) =>
                          setImgbtn5Data({
                            ...Imgbtn5Data,
                            bgcolor: e.target.value,
                          })
                        }
                        value={Imgbtn5Data.bgcolor}
                      />
                    </div>


                    <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.Imgbtn5StartTime
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="00:00"
                        value={Imgbtn5Data.Imgbtn5StartTime}
                        onChange={(e) =>
                          setImgbtn5Data({
                            ...Imgbtn5Data,
                            Imgbtn5StartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) =>
                          handleTimeKeyUp(e, "Imgbtn5StartTime")
                        }
                        onBlur={(e) => handleTimeBlur(e, "Imgbtn5StartTime")}
                        ref={Imgbtn5StartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "Imgbtn5StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "Imgbtn5StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.Imgbtn5EndTime ? "is-invalid" : ""
                        }`}
                        placeholder="00:00"
                        value={Imgbtn5Data.Imgbtn5EndTime}
                        onChange={(e) =>
                          setImgbtn5Data({
                            ...Imgbtn5Data,
                            Imgbtn5EndTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "Imgbtn5EndTime")}
                        onBlur={(e) => handleTimeBlur(e, "Imgbtn5EndTime")}
                        ref={Imgbtn5EndtimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "Imgbtn5EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "Imgbtn5EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => {
                          setShowImgbtn5(false)
                          setShowTimingControl(false)
                        }}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}
            
            {showImgbtn6 && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Menu Card With Button</h4>
                    <p className="m-0">
                      Send your viewers to a sales page by adding custom
                      Restaurant Menu
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleImgbtn6Data}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Menu Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {Imgbtn6Data.ImgbtnText.length}/140
                        </div>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnText ? "is-invalid" : ""
                        }`}
                        placeholder=""
                        onChange={(e) => {
                          const inputValue = e.target.value;
                        
                          if (inputValue.length <= 140) {
                            setImgbtn6Data({
                              ...Imgbtn6Data,
                              ImgbtnText: e.target.value,
                            })
                          } else {
                            textLimitExceed(140)
                          }
                        }}
                        value={Imgbtn6Data.ImgbtnText}
                      />
                      </div>
                    </div>
                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  Imgbtn6Data.text1FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setImgbtn6Data({ ...Imgbtn6Data, text1FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={Imgbtn6Data.text1FontColor}
                              onChange={(e) =>
                                setImgbtn6Data({ ...Imgbtn6Data, text1FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${Imgbtn6Data.text1bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn6Data({ ...Imgbtn6Data, text1bold: !Imgbtn6Data.text1bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${Imgbtn6Data.text1Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn6Data({ ...Imgbtn6Data, text1Italic: !Imgbtn6Data.text1Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Menu Description</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {Imgbtn6Data.ImgbtnText2.length}/340
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Get Updates"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                        
                          if (inputValue.length <= 340) {
                            setImgbtn6Data({
                              ...Imgbtn6Data,
                              ImgbtnText2: e.target.value,
                            })
                          } else {
                            textLimitExceed(340)
                          }
                        }}
                        value={Imgbtn6Data.ImgbtnText2}
                      />
                      </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  Imgbtn6Data.text2FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setImgbtn6Data({ ...Imgbtn6Data, text2FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={Imgbtn6Data.text2FontColor}
                              onChange={(e) =>
                                setImgbtn6Data({ ...Imgbtn6Data, text2FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${Imgbtn6Data.text2bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn6Data({ ...Imgbtn6Data, text2bold: !Imgbtn6Data.text2bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${Imgbtn6Data.text2Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn6Data({ ...Imgbtn6Data, text2Italic: !Imgbtn6Data.text2Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Price Text</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {Imgbtn6Data.ImgbtnText3.length}/10
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Our website is under construction"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                        
                          if (inputValue.length <= 10) {
                            setImgbtn6Data({
                              ...Imgbtn6Data,
                              ImgbtnText3: e.target.value,
                            })
                          } else {
                            textLimitExceed(10)
                          }
                        }}
                        value={Imgbtn6Data.ImgbtnText3}
                      />
                      </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  Imgbtn6Data.text3FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setImgbtn6Data({ ...Imgbtn6Data, text3FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={Imgbtn6Data.text3FontColor}
                              onChange={(e) =>
                                setImgbtn6Data({ ...Imgbtn6Data, text3FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${Imgbtn6Data.text3bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn6Data({ ...Imgbtn6Data, text3bold: !Imgbtn6Data.text3bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${Imgbtn6Data.text3Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn6Data({ ...Imgbtn6Data, text3Italic: !Imgbtn6Data.text3Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>Card Redirect URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnLink ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setImgbtn6Data({
                            ...Imgbtn6Data,
                            ImgbtnLink: e.target.value,
                          })
                        }
                        value={Imgbtn6Data.ImgbtnLink}
                      />
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Card Background Color 
                        <span> 
                          <TiArrowRepeat 
                          data-tip="Set Default"
                          className="text-main-color cursor-pointer default-icon"
                          size={23}
                          onClick={(e) =>
                            setImgbtn6Data({
                              ...Imgbtn6Data,
                              bgColor: "#ffffff"
                            })
                          }
                           /> 
                        </span> 
                      </label>
                      <input
                        type="color"
                        className="form-control"
                        onChange={(e) =>
                          setImgbtn6Data({
                            ...Imgbtn6Data,
                            bgColor: e.target.value,
                          })
                        }
                        value={Imgbtn6Data.bgColor}
                      />
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>
                        Price Button Background Color
                        <span> 
                          <TiArrowRepeat 
                          data-tip="Set Default"
                          className="text-main-color cursor-pointer default-icon"
                          size={23}
                          onClick={(e) =>
                            setImgbtn6Data({
                              ...Imgbtn6Data,
                              buttonColor: "#ff302f"
                            })
                          }
                           /> 
                        </span> 
                      </label>
                      <input
                        type="color"
                        className="form-control"
                        onChange={(e) =>
                          setImgbtn6Data({
                            ...Imgbtn6Data,
                            buttonColor: e.target.value,
                          })
                        }
                        value={Imgbtn6Data.buttonColor}
                      />
                    </div>

                    <div className="form_rw mb-3">
                      <label>Image URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnURL ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setImgbtn6Data({
                            ...Imgbtn6Data,
                            ImgbtnURL: e.target.value,
                          })
                        }
                        value={Imgbtn6Data.ImgbtnURL}
                      />

                      <div className="text-center mt-3">      
                        <BiImageAdd
                          size={30}
                          className="text-main-color cursor-pointer"
                          data-tip="Upload Image"
                          onClick={() =>   addImage(inputFileRef4) }
                        />
                      </div>
                      <input
                        name=""
                        ref={inputFileRef4}
                        className="d-none"
                        type="file"
                        onChange={(e) =>   onFileChange(e,4) }
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.Imgbtn6StartTime
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="00:00"
                        value={Imgbtn6Data.Imgbtn6StartTime}
                        onChange={(e) =>
                          setImgbtn6Data({
                            ...Imgbtn6Data,
                            Imgbtn6StartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) =>
                          handleTimeKeyUp(e, "Imgbtn6StartTime")
                        }
                        onBlur={(e) => handleTimeBlur(e, "Imgbtn6StartTime")}
                        ref={Imgbtn6StartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "Imgbtn6StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "Imgbtn6StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.Imgbtn6EndTime ? "is-invalid" : ""
                        }`}
                        placeholder="00:00"
                        value={Imgbtn6Data.Imgbtn6EndTime}
                        onChange={(e) =>
                          setImgbtn6Data({
                            ...Imgbtn6Data,
                            Imgbtn6EndTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "Imgbtn6EndTime")}
                        onBlur={(e) => handleTimeBlur(e, "Imgbtn6EndTime")}
                        ref={Imgbtn6EndtimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "Imgbtn6EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "Imgbtn6EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => {
                          setShowImgbtn6(false)
                          setShowTimingControl(false)
                        }}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}
            
            {showImgbtn7 && (
              <>
                <div className="vac_aside bg-white p-3 shadow2 vac_aside2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Menu Card Without Button</h4>
                    <p className="m-0">
                      Send your viewers to a sales page by adding custom
                      Restaurant Menu
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleImgbtn7Data}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Menu Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {Imgbtn7Data.ImgbtnText.length}/55
                        </div>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnText ? "is-invalid" : ""
                        }`}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                        
                          if (inputValue.length <= 55) {
                            setImgbtn7Data({
                              ...Imgbtn7Data,
                              ImgbtnText: e.target.value,
                            })
                          } else {
                            textLimitExceed(55)
                          }
                        }}
                        value={Imgbtn7Data.ImgbtnText}
                      />
                      </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  Imgbtn7Data.text1FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setImgbtn7Data({ ...Imgbtn7Data, text1FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={Imgbtn7Data.text1FontColor}
                              onChange={(e) =>
                                setImgbtn7Data({ ...Imgbtn7Data, text1FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${Imgbtn7Data.text1bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn7Data({ ...Imgbtn7Data, text1bold: !Imgbtn7Data.text1bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${Imgbtn7Data.text1Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn7Data({ ...Imgbtn7Data, text1Italic: !Imgbtn7Data.text1Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    


                    <div className="form_rw mb-3 pt-2">
                      <label>Price Text</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {Imgbtn7Data.ImgbtnText2.length}/30
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Our website is under construction"
                        
                        onChange={(e) => {
                          const inputValue = e.target.value;
                        
                          if (inputValue.length <= 30) {
                            setImgbtn7Data({
                              ...Imgbtn7Data,
                              ImgbtnText2: e.target.value,
                            })
                          } else {
                            textLimitExceed(30)
                          }
                        }}
                        value={Imgbtn7Data.ImgbtnText2}
                      />
                      </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  Imgbtn7Data.text2FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setImgbtn7Data({ ...Imgbtn7Data, text2FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={Imgbtn7Data.text2FontColor}
                              onChange={(e) =>
                                setImgbtn7Data({ ...Imgbtn7Data, text2FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${Imgbtn7Data.text2bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn7Data({ ...Imgbtn7Data, text2bold: !Imgbtn7Data.text2bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${Imgbtn7Data.text2Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn7Data({ ...Imgbtn7Data, text2Italic: !Imgbtn7Data.text2Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>Card Redirect URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnLink ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setImgbtn7Data({
                            ...Imgbtn7Data,
                            ImgbtnLink: e.target.value,
                          })
                        }
                        value={Imgbtn7Data.ImgbtnLink}
                      />
                    </div>

                    <div className="form_rw mb-3">
                      <label>Image URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnURL ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setImgbtn7Data({
                            ...Imgbtn7Data,
                            ImgbtnURL: e.target.value,
                          })
                        }
                        value={Imgbtn7Data.ImgbtnURL}
                      />

                      <div className="text-center mt-3">      
                        <BiImageAdd
                          size={30}
                          className="text-main-color cursor-pointer"
                          data-tip="Upload Image"
                          onClick={() =>   addImage(inputFileRef5) }
                        />
                      </div>
                      <input
                        name=""
                        ref={inputFileRef5}
                        className="d-none"
                        type="file"
                        onChange={(e) =>   onFileChange(e,5) }
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.Imgbtn7StartTime
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="00:00"
                        value={Imgbtn7Data.Imgbtn7StartTime}
                        onChange={(e) =>
                          setImgbtn7Data({
                            ...Imgbtn7Data,
                            Imgbtn7StartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) =>
                          handleTimeKeyUp(e, "Imgbtn7StartTime")
                        }
                        onBlur={(e) => handleTimeBlur(e, "Imgbtn7StartTime")}
                        ref={Imgbtn7StartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "Imgbtn7StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "Imgbtn7StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.Imgbtn7EndTime ? "is-invalid" : ""
                        }`}
                        placeholder="00:00"
                        value={Imgbtn7Data.Imgbtn7EndTime}
                        onChange={(e) =>
                          setImgbtn7Data({
                            ...Imgbtn7Data,
                            Imgbtn7EndTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "Imgbtn7EndTime")}
                        onBlur={(e) => handleTimeBlur(e, "Imgbtn7EndTime")}
                        ref={Imgbtn7EndtimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "Imgbtn7EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "Imgbtn7EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => {
                          setShowImgbtn7(false)
                          setShowTimingControl(false)
                        }}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}
            
            {showImgbtn8 && (
              <>
                <div className="vac_aside bg-white p-3 shadow2 vac_aside2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Text & Image CTA Card </h4>
                    <p className="m-0">
                      Send your viewers to a sales page by adding custom
                      Text & Image CTA Card 
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleImgbtn8Data}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {Imgbtn8Data.ImgbtnText.length}/40
                        </div>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnText ? "is-invalid" : ""
                        }`}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                        
                          if (inputValue.length <= 40) {
                            setImgbtn8Data({
                              ...Imgbtn8Data,
                              ImgbtnText: e.target.value,
                            })
                          } else {
                            textLimitExceed(40)
                          }
                        }}
                        value={Imgbtn8Data.ImgbtnText}
                      />
                    </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  Imgbtn8Data.text1FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setImgbtn8Data({ ...Imgbtn8Data, text1FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={Imgbtn8Data.text1FontColor}
                              onChange={(e) =>
                                setImgbtn8Data({ ...Imgbtn8Data, text1FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${Imgbtn8Data.text1bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn8Data({ ...Imgbtn8Data, text1bold: !Imgbtn8Data.text1bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${Imgbtn8Data.text1Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn8Data({ ...Imgbtn8Data, text1Italic: !Imgbtn8Data.text1Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    


                    <div className="form_rw mb-3 pt-2">
                      <label>Button Text</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {Imgbtn8Data.ImgbtnText2.length}/20
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Our website is under construction"
                        
                        onChange={(e) => {
                          const inputValue = e.target.value;
                        
                          if (inputValue.length <= 20) {
                            setImgbtn8Data({
                              ...Imgbtn8Data,
                              ImgbtnText2: e.target.value,
                            })
                          } else {
                            textLimitExceed(20)
                          }
                        }}
                        value={Imgbtn8Data.ImgbtnText2}
                      />
                      </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  Imgbtn8Data.text2FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setImgbtn8Data({ ...Imgbtn8Data, text2FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={Imgbtn8Data.text2FontColor}
                              onChange={(e) =>
                                setImgbtn8Data({ ...Imgbtn8Data, text2FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${Imgbtn8Data.text2bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn8Data({ ...Imgbtn8Data, text2bold: !Imgbtn8Data.text2bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${Imgbtn8Data.text2Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setImgbtn8Data({ ...Imgbtn8Data, text2Italic: !Imgbtn8Data.text2Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Card Background color 
                        <span> 
                          <TiArrowRepeat 
                          data-tip="Set Default"
                          className="text-main-color cursor-pointer default-icon"
                          size={23}
                          onClick={(e) =>
                            setImgbtn8Data({
                              ...Imgbtn8Data,
                              bgcolor1: "#6b71ff"
                            })
                          }
                           /> 
                        </span> 
                      </label>
                      <input
                        type="color"
                        className="form-control"
                        onChange={(e) =>
                          setImgbtn8Data({
                            ...Imgbtn8Data,
                            bgcolor1: e.target.value,
                          })
                        }
                        value={Imgbtn8Data.bgcolor1}
                      />
                    </div>
                    <div className="form_rw mb-3 pt-2">
                      <label>Top Section Background color 
                        <span> 
                          <TiArrowRepeat 
                          data-tip="Set Default"
                          className="text-main-color cursor-pointer default-icon"
                          size={23}
                          onClick={(e) =>
                            setImgbtn8Data({
                              ...Imgbtn8Data,
                              bgcolor2: "#ffffff"
                            })
                          }
                           /> 
                        </span> 
                      </label>
                      <input
                        type="color"
                        className="form-control"
                        onChange={(e) =>
                          setImgbtn8Data({
                            ...Imgbtn8Data,
                            bgcolor2: e.target.value,
                          })
                        }
                        value={Imgbtn8Data.bgcolor2}
                      />
                    </div>
                    <div className="form_rw mb-3 pt-2">
                      <label>Bottom Section Background color 
                        <span> 
                          <TiArrowRepeat 
                          data-tip="Set Default"
                          className="text-main-color cursor-pointer default-icon"
                          size={23}
                          onClick={(e) =>
                            setImgbtn8Data({
                              ...Imgbtn8Data,
                              bgcolor3: "#ffffff"
                            })
                          }
                           /> 
                        </span> 
                      </label>
                      <input
                        type="color"
                        className="form-control"
                        onChange={(e) =>
                          setImgbtn8Data({
                            ...Imgbtn8Data,
                            bgcolor3: e.target.value,
                          })
                        }
                        value={Imgbtn8Data.bgcolor3}
                      />
                    </div>

                    <div className="form_rw mb-3">
                      <label>Card Redirect URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnLink ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setImgbtn8Data({
                            ...Imgbtn8Data,
                            ImgbtnLink: e.target.value,
                          })
                        }
                        value={Imgbtn8Data.ImgbtnLink}
                      />
                    </div>

                    <div className="form_rw mb-3">
                      <label>Image URL</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.ImgbtnURL ? "is-invalid" : ""
                        }`}
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setImgbtn8Data({
                            ...Imgbtn8Data,
                            ImgbtnURL: e.target.value,
                          })
                        }
                        value={Imgbtn8Data.ImgbtnURL}
                      />

                      <div className="text-center mt-3">      
                        <BiImageAdd
                          size={30}
                          className="text-main-color cursor-pointer"
                          data-tip="Upload Image"
                          onClick={() =>   addImage(inputFileRef7) }
                        />
                      </div>
                      <input
                        name=""
                        ref={inputFileRef7}
                        className="d-none"
                        type="file"
                        onChange={(e) =>   onFileChange(e,7) }
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.Imgbtn8StartTime
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="00:00"
                        value={Imgbtn8Data.Imgbtn8StartTime}
                        onChange={(e) =>
                          setImgbtn8Data({
                            ...Imgbtn8Data,
                            Imgbtn8StartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) =>
                          handleTimeKeyUp(e, "Imgbtn8StartTime")
                        }
                        onBlur={(e) => handleTimeBlur(e, "Imgbtn8StartTime")}
                        ref={Imgbtn8StartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "Imgbtn8StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "Imgbtn8StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.Imgbtn8EndTime ? "is-invalid" : ""
                        }`}
                        placeholder="00:00"
                        value={Imgbtn8Data.Imgbtn8EndTime}
                        onChange={(e) =>
                          setImgbtn8Data({
                            ...Imgbtn8Data,
                            Imgbtn8EndTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "Imgbtn8EndTime")}
                        onBlur={(e) => handleTimeBlur(e, "Imgbtn8EndTime")}
                        ref={Imgbtn8EndtimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "Imgbtn8EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "Imgbtn8EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => {
                          setShowImgbtn8(false)
                          setShowTimingControl(false)
                        }}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}
            
            {showCopyPaste && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Content Locker Lead Form</h4>
                    <p className="m-0">Embed Content Locker Lead form here</p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleCopyPasteData}>
                    <div className="form_rw mb-3">
                      <label>HTML</label>
                      <textarea
                        className={`form-control textbx2 border shadow-none height100 mb-4 ${
                          errors && errors.CRMHtmlText ? "is-invalid" : ""
                        }`}
                        placeholder=""
                        onChange={(e) =>
                          setCopyPasteData({
                            ...copyPasteData,
                            CRMHtmlText: e.target.value,
                          })
                        }
                        value={copyPasteData.CRMHtmlText}
                      ></textarea>
                    </div>

                    <div className="form_rw mb-3">
                      <label>
                        <span>Background Theme</span>
                        <Switch
                          onChange={() =>
                            setCopyPasteData({
                              ...copyPasteData,
                              bgCRMTheme: !copyPasteData.bgCRMTheme,
                            })
                          }
                          checked={copyPasteData.bgCRMTheme}
                          className="react-switch ms-4"
                          uncheckedIcon={
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%",
                                fontSize: 12,
                                color: "white",
                                padding: 5,
                                fontWeight: 600,
                              }}
                            >
                              Dark
                            </div>
                          }
                          checkedIcon={
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%",
                                fontSize: 12,
                                color: "white",
                                padding: 5,
                                fontWeight: 600,
                              }}
                            >
                              Light
                            </div>
                          }
                          onColor="#86d3ff"
                          onHandleColor="#2693e6"
                          handleDiameter={30}
                          width={80}
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                          // height={20}
                        />
                      </label>
                    </div>

                    <div className="form-check mb-3 pastevideo">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="allowviewers"
                        checked={copyPasteData.CRMskipCheck}
                        onChange={(e) =>
                          setCopyPasteData({
                            ...copyPasteData,
                            CRMskipCheck: !copyPasteData.CRMskipCheck,
                          })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="allowviewers"
                      >
                        Skip Video{" "}
                        <i
                          className="fa fa-question-circle"
                          title="Check this box to pause the video with CRM form."
                        ></i>
                      </label>
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>
                        {copyPasteData.CRMskipCheck ? "Time" : "Start Time"}
                      </label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={copyPasteData.CRMstartTime}
                        onChange={(e) =>
                          setCopyPasteData({
                            ...copyPasteData,
                            CRMstartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "CRMstartTime")}
                        onBlur={(e) => handleTimeBlur(e, "CRMstartTime")}
                        ref={CRMstartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "CRMstartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "CRMstartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    {!copyPasteData.CRMskipCheck && (
                      <div className="form_rw mb-3 timer-input d-none">
                        <label>End Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={copyPasteData.CRMendTime}
                          onChange={(e) =>
                            setCopyPasteData({
                              ...copyPasteData,
                              CRMendTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "CRMendTime")}
                          onBlur={(e) => handleTimeBlur(e, "CRMendTime")}
                          ref={CRMendtimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "CRMendTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "CRMendTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    )}

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => setShowCopyPaste(false)}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1">Apply</button>
                    </div>
                  </form>
                </div>
              </>
            )}
            
            {scriptCodeForm_Visible && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Embed Code Form</h4>
                    <p className="m-0 f-13"><span className="experiment">Experiment</span> This feature is in beta</p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleScriptCodeData}>
                    <div className="form_rw mb-3">
                      <label>Add Script Code Here</label>
                      <textarea
                        className={`form-control textbx2 border shadow-none height100 mb-4 ${
                          errors && errors.CRMHtmlText ? "is-invalid" : ""
                        }`}
                        placeholder=""
                        onChange={(e) =>
                          setScriptCodeData({
                            ...scriptCodeData,
                            script: e.target.value,
                          })
                        }
                        value={scriptCodeData.script}
                      ></textarea>
                    </div>

                  

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => setScriptCodeForm_Visible(false)}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1">Apply</button>
                    </div>
                  </form>
                </div>
              </>
            )}
            
            {showLeadGenForm && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Trigger Reel Form</h4>
                    <p className="m-0">
                      Add a custom form to generate leads through your videos.
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleLeadGenData}>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="askphonenumber"
                        checked={leadgenFormData.askphonechk ? true : false}
                        onChange={(e) =>
                          setLeadgenFormData({
                            ...leadgenFormData,
                            askphonechk: !leadgenFormData.askphonechk,
                          })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="askphonenumber"
                      >
                        Ask for phone number
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="askcompanyname"
                        checked={leadgenFormData.askcompanychk ? true : false}
                        onChange={(e) =>
                          setLeadgenFormData({
                            ...leadgenFormData,
                            askcompanychk: !leadgenFormData.askcompanychk,
                          })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="askcompanyname"
                      >
                        Ask for company name
                      </label>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {leadgenFormData.headline.length}/85
                        </div>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none mb-4 ${
                          errors && errors.headline ? "is-invalid" : ""
                        }`}
                        placeholder="To get exclusive offer"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 85) {
                              setLeadgenFormData({
                                ...leadgenFormData,
                                headline: e.target.value,
                              })
                            } else {
                              textLimitExceed(85)
                            }
                          }}
                        value={leadgenFormData.headline}
                      />
                      </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>Note</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {leadgenFormData.note.length}/100
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="This is note text"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 100) {
                              setLeadgenFormData({
                                ...leadgenFormData,
                                note: e.target.value,
                              })
                            } else {
                              textLimitExceed(100)
                            }
                          }}
                        value={leadgenFormData.note}
                      />
                      </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>Button Name</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {leadgenFormData.buttonname.length}/30
                        </div>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none  mb-4 ${
                          errors && errors.buttonname ? "is-invalid" : ""
                        }`}
                        placeholder="Play"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 30) {
                              setLeadgenFormData({
                                ...leadgenFormData,
                                buttonname: e.target.value,
                              })
                            } else {
                              textLimitExceed(30)
                            }
                          }}
                        value={leadgenFormData.buttonname}
                      />
                      </div>
                    </div>

                    <div className="form_rw mb-3 ">
                      <label>Button Color</label>
                      <input
                        type={"color"}
                        className="form-control"
                        onChange={(e) =>
                          setLeadgenFormData({
                            ...leadgenFormData,
                            buttonColor: e.target.value,
                          })
                        }
                        value={leadgenFormData.buttonColor}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={leadgenFormData.leadgenTime}
                        onChange={(e) =>
                          setLeadgenFormData({
                            ...leadgenFormData,
                            leadgenTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "leadgenTime")}
                        onBlur={(e) => handleTimeBlur(e, "leadgenTime")}
                        ref={leadgenTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "leadgenTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "leadgenTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                    {(autoresponder && autoresponder.length > 0) && (
                      <div className="form_rw mb-3 pt-2">
                        <label>Select AutoResponder </label>
                        <select
                          className="form-control select3 shadow-none textbx2 text-capitalize"
                          onChange={handleResponderChange}
                        >
                          <option value="">Select Autoresponder</option>
                          {(autoresponder && autoresponder.length > 0) && autoresponder.map((responder)=>(
                            <option key={responder.id} value={responder.meta_key}>{responder.meta_key}</option>
                          ))}
                        </select>
                      </div>
                    )}

                    {(activeCampaignLists && activeCampaignLists.length > 0) && (
                      <div className="form_rw mb-3 pt-2">
                      <label>Select List </label>
                      <select
                        className="form-control select3 shadow-none textbx2"
                        onChange={(e)=>setLeadgenFormData({
                            ...leadgenFormData,
                            param1:e.target.value
                          })
                        }
                      >
                        <option value="">Select List</option>
                        {(activeCampaignLists && activeCampaignLists.length > 0) && activeCampaignLists.map((list)=>(
                          <option key={list.id} value={list.id}>{list.name}</option>
                        ))}
                      </select>
                    </div>
                    )}

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="allowviewers"
                        checked={
                          leadgenFormData.leadgenSkipCheck ? true : false
                        }
                        onChange={(e) =>
                          setLeadgenFormData({
                            ...leadgenFormData,
                            leadgenSkipCheck: !leadgenFormData.leadgenSkipCheck,
                          })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="allowviewers"
                      >
                        Allow viewers to skip
                      </label>
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => setShowLeadGenForm(false)}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}


            {showLeadGen2Form && (
              <>
                <div className="vac_aside bg-white p-3 shadow2 vac_aside2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Lead Collection Form</h4>
                    <p className="m-0">
                      Add a custom form to generate leads through your videos.
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleLeadGen2Data}>
                    

                    <div className="form_rw mb-3 pt-2">
                      <label>Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {leadgen2FormData.headline.length}/25
                        </div>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none mb-4 ${
                          errors && errors.headline ? "is-invalid" : ""
                        }`}
                        placeholder="To get exclusive offer"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 25) {
                              setLeadgen2FormData({
                                ...leadgen2FormData,
                                headline: e.target.value,
                              })
                            } else {
                              textLimitExceed(25)
                            }
                          }}
                        value={leadgen2FormData.headline}
                      />
                    </div>
                    </div>
                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  leadgen2FormData.text1FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setLeadgen2FormData({ ...leadgen2FormData, text1FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={leadgen2FormData.text1FontColor}
                              onChange={(e) =>
                                setLeadgen2FormData({ ...leadgen2FormData, text1FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${leadgen2FormData.text1bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLeadgen2FormData({ ...leadgen2FormData, text1bold: !leadgen2FormData.text1bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${leadgen2FormData.text1Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLeadgen2FormData({ ...leadgen2FormData, text1Italic: !leadgen2FormData.text1Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>Note</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {leadgen2FormData.note.length}/150
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="This is note text"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 150) {
                              setLeadgen2FormData({
                                ...leadgen2FormData,
                                note: e.target.value,
                              })
                            } else {
                              textLimitExceed(150)
                            }
                          }}
                        value={leadgen2FormData.note}
                      />
                    </div>
                    </div>
                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  leadgen2FormData.text2FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setLeadgen2FormData({ ...leadgen2FormData, text2FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={leadgen2FormData.text2FontColor}
                              onChange={(e) =>
                                setLeadgen2FormData({ ...leadgen2FormData, text2FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${leadgen2FormData.text2bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLeadgen2FormData({ ...leadgen2FormData, text2bold: !leadgen2FormData.text2bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${leadgen2FormData.text2Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLeadgen2FormData({ ...leadgen2FormData, text2Italic: !leadgen2FormData.text2Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>Terms & Conditions Text</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {leadgen2FormData.termsText.length}/80
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Agree To Our Terms & Conditions"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 80) {
                              setLeadgen2FormData({
                                ...leadgen2FormData,
                                termsText: e.target.value,
                              })
                            } else {
                              textLimitExceed(80)
                            }
                          }}
                        value={leadgen2FormData.termsText}
                      />
                    </div>
                    </div>
                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  leadgen2FormData.text3FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setLeadgen2FormData({ ...leadgen2FormData, text3FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={leadgen2FormData.text3FontColor}
                              onChange={(e) =>
                                setLeadgen2FormData({ ...leadgen2FormData, text3FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${leadgen2FormData.text3bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLeadgen2FormData({ ...leadgen2FormData, text3bold: !leadgen2FormData.text3bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${leadgen2FormData.text3Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLeadgen2FormData({ ...leadgen2FormData, text3Italic: !leadgen2FormData.text3Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form-check mb-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="show_terms"
                        checked={
                          leadgen2FormData.hideterms ? true : false
                        }
                        onChange={(e) =>
                          setLeadgen2FormData({
                            ...leadgen2FormData,
                            hideterms: !leadgen2FormData.hideterms,
                          })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="show_terms"
                      >
                        Hide Terms & Conditions Text
                      </label>
                    </div>

                    <div className="form_rw mb-3">
                      <label>Terms & Conditions URL</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Add URL Here"
                        onChange={(e) =>
                          setLeadgen2FormData({
                            ...leadgen2FormData,
                            termsURL: e.target.value,
                          })
                        }
                        value={leadgen2FormData.termsURL}
                      />
                    </div>

                    <div className="form_rw mb-3">
                      <label>Button Name</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {leadgen2FormData.buttonname.length}/60
                        </div>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none  mb-4 ${
                          errors && errors.buttonname ? "is-invalid" : ""
                        }`}
                        placeholder="Play"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 60) {
                              setLeadgen2FormData({
                                ...leadgen2FormData,
                                buttonname: e.target.value,
                              })
                            } else {
                              textLimitExceed(60)
                            }
                          }}
                        value={leadgen2FormData.buttonname}
                      />
                    </div>
                    </div>
                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  leadgen2FormData.text4FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setLeadgen2FormData({ ...leadgen2FormData, text4FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={leadgen2FormData.text4FontColor}
                              onChange={(e) =>
                                setLeadgen2FormData({ ...leadgen2FormData, text4FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${leadgen2FormData.text4bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLeadgen2FormData({ ...leadgen2FormData, text4bold: !leadgen2FormData.text4bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${leadgen2FormData.text4Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setLeadgen2FormData({ ...leadgen2FormData, text4Italic: !leadgen2FormData.text4Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>
                    
                    <div className="form_rw mb-3 pt-2">
                      <label>
                        Background Color
                        <span> 
                          <TiArrowRepeat 
                          data-tip="Set Default"
                          className="text-main-color cursor-pointer default-icon"
                          size={23}
                          onClick={(e) =>
                            setLeadgen2FormData({
                              ...leadgen2FormData,
                              bgcolor1: "#23013E"
                            })
                          }
                           /> 
                        </span> 
                      </label>
                      <input
                        type="color"
                        className="form-control"
                        onChange={(e) =>
                          setLeadgen2FormData({
                            ...leadgen2FormData,
                            bgcolor1: e.target.value,
                          })
                        }
                        value={leadgen2FormData.bgcolor1}
                      />
                    </div>
                    <div className="form_rw mb-3 pt-2">
                      <label>
                        Button Background Color
                        <span> 
                          <TiArrowRepeat 
                          data-tip="Set Default"
                          className="text-main-color cursor-pointer default-icon"
                          size={23}
                          onClick={(e) =>
                            setLeadgen2FormData({
                              ...leadgen2FormData,
                              bgcolor2: "#99EEFF"
                            })
                          }
                           /> 
                        </span> 
                      </label>
                      <input
                        type="color"
                        className="form-control"
                        onChange={(e) =>
                          setLeadgen2FormData({
                            ...leadgen2FormData,
                            bgcolor2: e.target.value,
                          })
                        }
                        value={leadgen2FormData.bgcolor2}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={leadgen2FormData.leadgenTime}
                        onChange={(e) =>
                          setLeadgen2FormData({
                            ...leadgen2FormData,
                            leadgenTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "leadgen2Time")}
                        onBlur={(e) => handleTimeBlur(e, "leadgen2Time")}
                        ref={leadgen2TimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "leadgen2Time")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "leadgen2Time")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                    {(autoresponder && autoresponder.length > 0) && (
                      <div className="form_rw mb-3 pt-2">
                        <label>Select AutoResponder </label>
                        <select
                          className="form-control select3 shadow-none textbx2 text-capitalize"
                          onChange={handleResponderChange}
                        >
                          <option value="">Select Autoresponder</option>
                          {(autoresponder && autoresponder.length > 0) && autoresponder.map((responder)=>(
                            <option key={responder.id} value={responder.meta_key}>{responder.meta_key}</option>
                          ))}
                        </select>
                      </div>
                    )}

                    {(activeCampaignLists && activeCampaignLists.length > 0) && (
                      <div className="form_rw mb-3 pt-2">
                      <label>Select List </label>
                      <select
                        className="form-control select3 shadow-none textbx2"
                        onChange={(e)=>setLeadgen2FormData({
                            ...leadgen2FormData,
                            param1:e.target.value
                          })
                        }
                      >
                        <option value="">Select List</option>
                        {(activeCampaignLists && activeCampaignLists.length > 0) && activeCampaignLists.map((list)=>(
                          <option key={list.id} value={list.id}>{list.name}</option>
                        ))}
                      </select>
                    </div>
                    )}

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="allowviewers"
                        checked={
                          leadgen2FormData.leadgenSkipCheck ? true : false
                        }
                        onChange={(e) =>
                          setLeadgen2FormData({
                            ...leadgen2FormData,
                            leadgenSkipCheck: !leadgen2FormData.leadgenSkipCheck,
                          })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="allowviewers"
                      >
                        Allow viewers to skip
                      </label>
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => setShowLeadGen2Form(false)}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}

            {showCustomPoll && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Full Screen Custom Poll</h4>
                    <p className="m-0">
                      Activate a poll within your videos for quality research &
                      data collection
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handlePollData} >
                    <div className="form_rw mb-3 pt-2">
                      <label>Question</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {custPollData.question.length}/90
                        </div>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none mb-4 ${
                          errors && errors.question ? "is-invalid" : ""
                        }`}
                        placeholder=""
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (inputValue.length <= 90) {
                            setCustPollData({
                              ...custPollData,
                              question: e.target.value,
                            })
                          } else {
                            textLimitExceed(90)
                          }
                        }}
                        value={custPollData.question}
                      />
                    </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>Option 1</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {custPollData.option1.length}/30
                        </div>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none mb-4 ${
                          errors && errors.option1 ? "is-invalid" : ""
                        }`}
                        placeholder=""
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (inputValue.length <= 30) {
                            setCustPollData({
                              ...custPollData,
                              option1: e.target.value,
                            })
                          } else {
                            textLimitExceed(30)
                          }
                        }}
                        value={custPollData.option1}
                      />
                    </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>Option 2</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {custPollData.option2.length}/30
                        </div>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none mb-4 ${
                          errors && errors.option2 ? "is-invalid" : ""
                        }`}
                        placeholder=""
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (inputValue.length <= 30) {
                            setCustPollData({
                              ...custPollData,
                              option2: e.target.value,
                            })
                          } else {
                            textLimitExceed(30)
                          }
                        }}
                        value={custPollData.option2}
                      />
                    </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>Option 3</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {custPollData.option3.length}/30
                        </div>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none mb-4`}
                        placeholder="Optional"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (inputValue.length <= 30) {
                            setCustPollData({
                              ...custPollData,
                              option3: e.target.value,
                            })
                          } else {
                            textLimitExceed(30)
                          }
                        }}
                        value={custPollData.option3}
                      />
                    </div>
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={custPollData.pollTime}
                        onChange={(e) =>
                          setCustPollData({
                            ...custPollData,
                            pollTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "pollTime")}
                        onBlur={(e) => handleTimeBlur(e, "pollTime")}
                        ref={pollTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) => handleTimeUpDown(e, "up", "pollTime")}
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) => handleTimeUpDown(e, "down", "pollTime")}
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="allowviewers"
                        checked={custPollData.pollSkipChk ? true : false}
                        onChange={(e) =>
                          setCustPollData({
                            ...custPollData,
                            pollSkipChk: !custPollData.pollSkipChk,
                          })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="allowviewers"
                      >
                        Allow viewers to skip
                      </label>
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => setShowCustomPoll(false)}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}

            {showCustom2Poll && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>4 Option Poll - Small</h4>
                    <p className="m-0">
                      Activate a poll within your videos for quality research &
                      data collection
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handlePoll2Data}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Question</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {cust2PollData.question.length}/140
                        </div> 
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none mb-4 ${
                          errors && errors.question ? "is-invalid" : ""
                        }`}
                        placeholder=""
                        onChange={(e) => {
                          const inputValue = e.target.value;
                      
                          if (inputValue.length <= 140) {
                            setCust2PollData({
                              ...cust2PollData,
                              question: e.target.value,
                            });
                          }else {
                            textLimitExceed(140)
                          }
                        }}
                        value={cust2PollData.question}
                      />
                    </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>Option 1</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {cust2PollData.option1.length}/40
                        </div>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none mb-4 ${
                          errors && errors.option1 ? "is-invalid" : ""
                        }`}
                        placeholder=""
                        onChange={(e) => {
                          const inputValue = e.target.value;
                        
                          if (inputValue.length <= 40) {
                            setCust2PollData({
                              ...cust2PollData,
                              option1: e.target.value,
                            })
                          }else {
                            textLimitExceed(40)
                          }
                        }}
                        value={cust2PollData.option1}
                      />
                    </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>Option 2</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {cust2PollData.option2.length}/40
                        </div>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none mb-4 ${
                          errors && errors.option2 ? "is-invalid" : ""
                        }`}
                        placeholder=""
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          
                          if (inputValue.length <= 40) {
                            setCust2PollData({
                              ...cust2PollData,
                              option2: e.target.value,
                            })
                          }else {
                            textLimitExceed(40)
                          }
                        }}
                        value={cust2PollData.option2}
                      />
                    </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>Option 3</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {cust2PollData.option3.length}/40
                        </div>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none mb-4`}
                        placeholder="Optional"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          
                          if (inputValue.length <= 40) {
                            setCust2PollData({
                              ...cust2PollData,
                              option3: e.target.value,
                            })
                          }else {
                            textLimitExceed(40)
                          }
                        }}
                        value={cust2PollData.option3}
                      />
                    </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>Option 4</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {cust2PollData.option4.length}/40
                        </div>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none mb-4`}
                        placeholder="Optional"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          
                          if (inputValue.length <= 40) {
                            setCust2PollData({
                              ...cust2PollData,
                              option4: e.target.value,
                            })
                          }else {
                            textLimitExceed(40)
                          }
                        }}
                        value={cust2PollData.option4}
                      />
                    </div>
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={cust2PollData.pollTime}
                        onChange={(e) =>
                          setCust2PollData({
                            ...cust2PollData,
                            pollTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "poll2Time")}
                        onBlur={(e) => handleTimeBlur(e, "poll2Time")}
                        ref={poll2TimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) => handleTimeUpDown(e, "up", "poll2Time")}
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) => handleTimeUpDown(e, "down", "poll2Time")}
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="allowviewers"
                        checked={cust2PollData.pollSkipChk ? true : false}
                        onChange={(e) =>
                          setCust2PollData({
                            ...cust2PollData,
                            pollSkipChk: !cust2PollData.pollSkipChk,
                          })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="allowviewers"
                      >
                        Allow viewers to skip
                      </label>
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => setShowCustom2Poll(false)}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}

            {showCustom3Poll && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>4 Option Poll - Half Screen</h4>
                    <p className="m-0">
                      Activate a poll within your videos for quality research &
                      data collection
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handlePoll3Data}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Question</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {cust3PollData.question.length}/100
                        </div>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none mb-4 ${
                          errors && errors.question ? "is-invalid" : ""
                        }`}
                        placeholder=""
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 100) {
                              setCust3PollData({
                                ...cust3PollData,
                                question: e.target.value,
                              })
                            } else {
                              textLimitExceed(100)
                            }
                          }}
                        value={cust3PollData.question}
                      />
                    </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Description</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {cust3PollData.polldesc.length}/250
                        </div>
                      <input
                        type="text"
                        className="form-control textbx2 border shadow-none mb-4"
                        placeholder=""
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 250) {
                              setCust3PollData({
                                ...cust3PollData,
                                polldesc: e.target.value,
                              })
                            } else {
                              textLimitExceed(250)
                            }
                          }}
                        value={cust3PollData.polldesc}
                      />
                    </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>Option 1</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {cust3PollData.option1.length}/30
                        </div>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none mb-4 ${
                          errors && errors.option1 ? "is-invalid" : ""
                        }`}
                        placeholder=""
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 30) {
                              setCust3PollData({
                                ...cust3PollData,
                                option1: e.target.value,
                              })
                            } else {
                              textLimitExceed(30)
                            }
                          }}
                        value={cust3PollData.option1}
                      />
                    </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>Option 2</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {cust3PollData.option2.length}/30
                        </div>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none mb-4 ${
                          errors && errors.option2 ? "is-invalid" : ""
                        }`}
                        placeholder=""
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 30) {
                              setCust3PollData({
                                ...cust3PollData,
                                option2: e.target.value,
                              })
                            } else {
                              textLimitExceed(30)
                            }
                          }}
                        value={cust3PollData.option2}
                      />
                    </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>Option 3</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {cust3PollData.option3.length}/30
                        </div>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none mb-4`}
                        placeholder="Optional"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 30) {
                              setCust3PollData({
                                ...cust3PollData,
                                option3: e.target.value,
                              })
                            } else {
                              textLimitExceed(30)
                            }
                          }}
                        value={cust3PollData.option3}
                      />
                    </div>
                    </div>

                    <div className="form_rw mb-3">
                      <label>Option 4</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {cust3PollData.option4.length}/30
                        </div>
                      <input
                        type="text"
                        className={`form-control textbx2 border shadow-none mb-4`}
                        placeholder="Optional"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 30) {
                              setCust3PollData({
                                ...cust3PollData,
                                option4: e.target.value,
                              })
                            } else {
                              textLimitExceed(30)
                            }
                          }}
                        value={cust3PollData.option4}
                      />
                    </div>
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={cust3PollData.pollTime}
                        onChange={(e) =>
                          setCust3PollData({
                            ...cust3PollData,
                            pollTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "poll3Time")}
                        onBlur={(e) => handleTimeBlur(e, "poll3Time")}
                        ref={poll3TimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) => handleTimeUpDown(e, "up", "poll3Time")}
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) => handleTimeUpDown(e, "down", "poll3Time")}
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="allowviewers"
                        checked={cust3PollData.pollSkipChk ? true : false}
                        onChange={(e) =>
                          setCust3PollData({
                            ...cust3PollData,
                            pollSkipChk: !cust3PollData.pollSkipChk,
                          })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="allowviewers"
                      >
                        Allow viewers to skip
                      </label>
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => setShowCustom3Poll(false)}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}

            {showopentable1 && (
              <>
                <div className="vac_aside bg-white p-3 shadow2 vac_aside2">
                  <div className="video_action_h text-center mb-3">
                    <h4>OpenTable</h4>
                    <p className="m-0">
                      Add a custom form to generate leads through your videos.
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleOpentable1Data}>
                    
                  <div className="form_rw mb-3 pt-2">
                      <label>Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {opentable1Data.opentableText.length}/100
                        </div>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.opentableText ? "is-invalid" : ""
                        }`}
                        placeholder="FIND YOUR DREAM HOME"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 100) {
                              setOpentable1Data({
                                ...opentable1Data,
                                opentableText: e.target.value,
                              })
                            } else {
                              textLimitExceed(100)
                            }
                          }}
                        value={opentable1Data.opentableText}
                      />
                      </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  opentable1Data.text1FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setOpentable1Data({ ...opentable1Data, text1FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={opentable1Data.text1FontColor}
                              onChange={(e) =>
                                setOpentable1Data({ ...opentable1Data, text1FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${opentable1Data.text1bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setOpentable1Data({ ...opentable1Data, text1bold: !opentable1Data.text1bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${opentable1Data.text1Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setOpentable1Data({ ...opentable1Data, text1Italic: !opentable1Data.text1Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Sub Title</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {opentable1Data.opentableText2.length}/200
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="Head Over To Dashboard To Get Started"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 200) {
                              setOpentable1Data({
                                ...opentable1Data,
                                opentableText2: e.target.value,
                              })
                            } else {
                              textLimitExceed(200)
                            }
                          }}
                        value={opentable1Data.opentableText2}
                      />
                      </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  opentable1Data.text2FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setOpentable1Data({ ...opentable1Data, text2FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={opentable1Data.text2FontColor}
                              onChange={(e) =>
                                setOpentable1Data({ ...opentable1Data, text2FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${opentable1Data.text2bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setOpentable1Data({ ...opentable1Data, text2bold: !opentable1Data.text2bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${opentable1Data.text2Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setOpentable1Data({ ...opentable1Data, text2Italic: !opentable1Data.text2Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Button Text</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {opentable1Data.opentableText3.length}/12
                        </div>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="LET'S GO"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 12) {
                              setOpentable1Data({
                                ...opentable1Data,
                                opentableText3: e.target.value,
                              })
                            } else {
                              textLimitExceed(12)
                            }
                          }}
                        value={opentable1Data.opentableText3}
                      />
                      </div>
                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  opentable1Data.text3FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setOpentable1Data({ ...opentable1Data, text3FontFamily: e.value })
                              }
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="inputFontColor">Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={opentable1Data.text3FontColor}
                              onChange={(e) =>
                                setOpentable1Data({ ...opentable1Data, text3FontColor: e.target.value })
                              }
                            />
                        </div> 
                        <div className="col">
                            <label className="text-white" >Bold</label>
                            <button
                            className={`btn5 ${opentable1Data.text3bold ? "bold" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setOpentable1Data({ ...opentable1Data, text3bold: !opentable1Data.text3bold })
                            }
                            >
                              B
                            </button>
                        </div>
                        <div className="col">
                            <label className="text-white" >Italic</label>
                            <button
                            className={`btn5 ${opentable1Data.text3Italic ? "font-italic" : ""}`}
                            type="button"
                            onClick={(e) =>
                              setOpentable1Data({ ...opentable1Data, text3Italic: !opentable1Data.text3Italic })
                            }
                            >
                              I
                            </button>
                        </div>
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Background color 
                        <span> 
                          <TiArrowRepeat 
                          data-tip="Set Default"
                          className="text-main-color cursor-pointer default-icon"
                          size={23}
                          onClick={(e) =>
                            setOpentable1Data({
                              ...opentable1Data,
                              bgcolor: "#0E1437"
                            })
                          }
                           /> 
                        </span> 
                      </label>
                      <input
                        type="color"
                        className="form-control"
                        onChange={(e) =>
                          setOpentable1Data({
                            ...opentable1Data,
                            bgcolor: e.target.value,
                          })
                        }
                        value={opentable1Data.bgcolor}
                      />
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>
                        Submit button background color
                        <span> 
                          <TiArrowRepeat 
                          data-tip="Set Default"
                          className="text-main-color cursor-pointer default-icon"
                          size={23}
                          onClick={(e) =>
                            setOpentable1Data({
                              ...opentable1Data,
                              submitbgcolor: "#99EEFF"
                            })
                          }
                           /> 
                        </span> 
                      </label>
                      <input
                        type="color"
                        className="form-control"
                        onChange={(e) =>
                          setOpentable1Data({
                            ...opentable1Data,
                            submitbgcolor: e.target.value,
                          })
                        }
                        value={opentable1Data.submitbgcolor}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={opentable1Data.booktime}
                        onChange={(e) =>
                          setOpentable1Data({
                            ...opentable1Data,
                            booktime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "booktime1")}
                        onBlur={(e) => handleTimeBlur(e, "booktime1")}
                        ref={opentable1Ref}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) => handleTimeUpDown(e, "up", "booktime1")}
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) => handleTimeUpDown(e, "down", "booktime1")}
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="allowviewers"
                        checked={opentable1Data.pollSkipChk ? true : false}
                        onChange={(e) =>
                          setOpentable1Data({
                            ...opentable1Data,
                            pollSkipChk: !opentable1Data.pollSkipChk,
                          })
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="allowviewers"
                      >
                        Allow viewers to skip
                      </label>
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => setShowopentable1(false)}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}
            
            {showReview1 && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Review</h4>
                    <p className="m-0">
                    </p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={handleReview1Data}>

                    <div className="animated-form ">

                    <div className="form_rw mb-3 pt-2 d-btn">
                        <button type="button" className={`expand-button ${isVisible3 ? 'rotate' : ''}`} onClick={() => setIsVisible3(!isVisible3)}>
                          <span>Edit Summary</span>
                          <i className="fas fa-chevron-down"></i>
                        </button>
                      </div>

                        {isVisible3 && (
                          <>
                            <div className="form_rw mb-3 pt-2">
                              <label>Summary 1 </label>
                              <div className="position-relative">
                                <div className="mlnk_txt position-absolute">
                                  {review1Data.summery1.length}/55
                                </div>
                              <input
                                type="text"
                                className="form-control p_holder textbx2 shadow-none"
                                placeholder=""
                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  if (inputValue.length <= 55) {
                                    setReview1Data({
                                      ...review1Data,
                                      summery1: e.target.value,
                                    })
                                  } else {
                                    textLimitExceed(55)
                                  }
                                }}
                                value={review1Data.summery1}
                              />
                            </div>
                            </div>
                            <div className="form_rw mb-3 pt-2">
                              <label>Summary 2 </label>
                              <div className="position-relative">
                                <div className="mlnk_txt position-absolute">
                                  {review1Data.summery2.length}/55
                                </div>
                              <input
                                type="text"
                                className="form-control p_holder textbx2 shadow-none"
                                placeholder=""
                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  if (inputValue.length <= 55) {
                                    setReview1Data({
                                      ...review1Data,
                                      summery2: e.target.value,
                                    })
                                  } else {
                                    textLimitExceed(55)
                                  }
                                }}
                                value={review1Data.summery2}
                              />
                            </div>
                            </div>
                            <div className="form_rw mb-3 pt-2">
                              <label>Summary 3 </label>
                              <div className="position-relative">
                                <div className="mlnk_txt position-absolute">
                                  {review1Data.summery3.length}/55
                                </div>
                              <input
                                type="text"
                                className="form-control p_holder textbx2 shadow-none"
                                placeholder=""
                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  if (inputValue.length <= 55) {
                                    setReview1Data({
                                      ...review1Data,
                                      summery3: e.target.value,
                                    })
                                  } else {
                                    textLimitExceed(55)
                                  }
                                }}
                                value={review1Data.summery3}
                              />
                            </div>
                            </div>
                          </>
                        )}
                        
                      <div className="form_rw mb-3 pt-2 d-btn">
                        <button type="button" className={`expand-button ${isVisible ? 'rotate' : ''}`} onClick={() => setIsVisible(!isVisible)}>
                          <span>Edit Review 1</span>
                          <i className="fas fa-chevron-down"></i>
                        </button>
                      </div>

                        {isVisible && (
                          <>
                            <div className="form_rw mb-3 pt-2">
                              <label>Author Name</label>
                              <div className="position-relative">
                                <div className="mlnk_txt position-absolute">
                                  {review1Data.author_name.length}/15
                                </div>
                              <input
                                type="text"
                                className="form-control p_holder textbx2 shadow-none"
                                placeholder="Author Name"
                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  if (inputValue.length <= 15) {
                                    setReview1Data({
                                      ...review1Data,
                                      author_name: e.target.value,
                                    })
                                  } else {
                                    textLimitExceed(15)
                                  }
                                }}
                                value={review1Data.author_name}
                              />
                              </div>
                            </div>
                            <div className="form_rw mb-3 pt-2">
                              <label>Author Profile URL</label>
                              <input
                                type="text"
                                className="form-control p_holder textbx2 shadow-none"
                                placeholder="Author Profile URL"
                                onChange={(e) =>
                                  setReview1Data({
                                    ...review1Data,
                                    auth_profile_url: e.target.value,
                                  })
                                }
                                value={review1Data.auth_profile_url}
                              />
                            </div>
                            <div className="form_rw mb-3 pt-2">
                              <label>Time Description</label>
                              <div className="position-relative">
                                <div className="mlnk_txt position-absolute">
                                  {review1Data.time_description.length}/20
                                </div>
                              <input
                                type="text"
                                className="form-control p_holder textbx2 shadow-none"
                                placeholder="Time Description"
                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  if (inputValue.length <= 20) {
                                    setReview1Data({
                                      ...review1Data,
                                      time_description: e.target.value,
                                    })
                                  } else {
                                    textLimitExceed(20)
                                  }
                                }}
                                value={review1Data.time_description}
                              />
                              </div>
                            </div>
                            <div className="form_rw mb-3 pt-2">
                              <label>Rating (1 to 5)</label>
                              <input
                                type="text"
                                className="form-control p_holder textbx2 shadow-none"
                                placeholder="Rating"
                                onChange={(e) => {
                                  let ratingValue = e.target.value;
                                  if (ratingValue > 5)
                                  {
                                    cuteToast({
                                      type: "error",
                                      message: "Rating should be less than 5",
                                      timer: 2000,
                                      title: "",
                                    });
                                    ratingValue = 5; 
                                  }else if(ratingValue < 1){
                                    cuteToast({
                                      type: "error",
                                      message:  "Atleast 1 star is required",
                                      timer: 2000,
                                      title: "",
                                    }); 
                                    ratingValue = 1;
                                  }
                                  setReview1Data({
                                    ...review1Data,
                                    rating: ratingValue,
                                  });
                                }}
                                value={review1Data.rating}
                              />
                            </div>
                            <div className="form_rw mb-3 pt-2">
                              <label>Review Text</label>
                              <div className="position-relative">
                                <div className="mlnk_txt position-absolute">
                                  {review1Data.reviewText.length}/340
                                </div>
                              <input
                                type="text"
                                className="form-control p_holder textbx2 shadow-none"
                                placeholder="Review Text"
                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  if (inputValue.length <= 340) {
                                    setReview1Data({
                                      ...review1Data,
                                      reviewText: e.target.value,
                                    })
                                  } else {
                                    textLimitExceed(340)
                                  }
                                }}
                                value={review1Data.reviewText}
                              />
                              </div>
                            </div>
                          </>
                        )}

                      <div className="form_rw mb-3 pt-2 d-btn">
                        <button type="button" className={`expand-button ${isVisible2 ? 'rotate' : ''}`} onClick={() => setIsVisible2(!isVisible2)}>
                          <span>Edit Review 2</span>
                          <i className="fas fa-chevron-down"></i>
                        </button>
                      </div>

                        {isVisible2 && (
                          <>
                            <div className="form_rw mb-3 pt-2">
                              <label>Author Name 2</label>
                              <div className="position-relative">
                                <div className="mlnk_txt position-absolute">
                                  {review1Data.author_name2.length}/15
                                </div>
                              <input
                                type="text"
                                className="form-control p_holder textbx2 shadow-none"
                                placeholder="Author Name 2"
                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  if (inputValue.length <= 20) {
                                    setReview1Data({
                                      ...review1Data,
                                      author_name2: e.target.value,
                                    })
                                  } else {
                                    textLimitExceed(20)
                                  }
                                }}
                                value={review1Data.author_name2}
                              />
                              </div>
                            </div>
                            <div className="form_rw mb-3 pt-2">
                              <label>Author Profile URL 2</label>
                              <input
                                type="text"
                                className="form-control p_holder textbx2 shadow-none"
                                placeholder="Author Profile URL 2"
                                onChange={(e) =>
                                  setReview1Data({
                                    ...review1Data,
                                    auth_profile_url2: e.target.value,
                                  })
                                }
                                value={review1Data.auth_profile_url2}
                              />
                            </div>
                            <div className="form_rw mb-3 pt-2">
                              <label>Time Description 2</label>
                              <div className="position-relative">
                                <div className="mlnk_txt position-absolute">
                                  {review1Data.time_description2.length}/20
                                </div>
                              <input
                                type="text"
                                className="form-control p_holder textbx2 shadow-none"
                                placeholder="Time Description 2"
                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  if (inputValue.length <= 20) {
                                    setReview1Data({
                                      ...review1Data,
                                      time_description2: e.target.value,
                                    })
                                  } else {
                                    textLimitExceed(20)
                                  }
                                }}
                                value={review1Data.time_description2}
                              />
                              </div>
                            </div>
                            <div className="form_rw mb-3 pt-2">
                              <label>Rating 2  (1 to 5)</label>
                              <input
                                type="text"
                                className="form-control p_holder textbx2 shadow-none"
                                placeholder="5"
                                onChange={(e) => {
                                  let ratingValue = e.target.value;
                                  if (ratingValue > 5)
                                  {
                                    cuteToast({
                                      type: "error",
                                      message: "Rating should be less than 5",
                                      timer: 2000,
                                      title: "",
                                    });
                                    ratingValue = 5; 
                                  }else if(ratingValue < 1){
                                    cuteToast({
                                      type: "error",
                                      message:  "Atleast 1 star is required",
                                      timer: 2000,
                                      title: "",
                                    }); 
                                    ratingValue = 1;
                                  }
                                  setReview1Data({
                                    ...review1Data,
                                    rating2: ratingValue,
                                  })
                                }}
                                value={review1Data.rating2}
                              />
                            </div>
                            <div className="form_rw mb-3 pt-2">
                              <label>Review Text 2</label>
                              <div className="position-relative">
                                <div className="mlnk_txt position-absolute">
                                  {review1Data.reviewText2.length}/340
                                </div>
                              <input
                                type="text"
                                className="form-control p_holder textbx2 shadow-none"
                                placeholder="Review Text 2"
                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  if (inputValue.length <= 340) {
                                    setReview1Data({
                                      ...review1Data,
                                      reviewText2: e.target.value,
                                    })
                                  } else {
                                    textLimitExceed(340)
                                  }
                                }}
                                value={review1Data.reviewText2}
                              />
                              </div>
                            </div>
                          </>
                        )}


                      
                    </div>
                    
                    
                            



                    <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.review1StartTime
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="00:00"
                        value={review1Data.review1StartTime}
                        onChange={(e) =>
                          setReview1Data({
                            ...review1Data,
                            review1StartTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) =>
                          handleTimeKeyUp(e, "review1StartTime")
                        }
                        onBlur={(e) => handleTimeBlur(e, "review1StartTime")}
                        ref={review1StartTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "review1StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "review1StartTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className={`form-control p_holder textbx2 shadow-none ${
                          errors && errors.review1EndTime ? "is-invalid" : ""
                        }`}
                        placeholder="00:00"
                        value={review1Data.review1EndTime}
                        onChange={(e) =>
                          setReview1Data({
                            ...review1Data,
                            review1EndTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "review1EndTime")}
                        onBlur={(e) => handleTimeBlur(e, "review1EndTime")}
                        ref={review1EndtimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "review1EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "review1EndTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={() => 
                          {
                            setShowReview1(false)
                            setShowTimingControl(false)}
                        }
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}


            {showOverlay && (
              <>
                <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>Overlay Template</h4>
                    <p className="m-0">
                      Select Overlay Template
                    </p>
                  </div>
                  <div className="template-list-container">
                    <ul className="list-unstyled m-0 px-4">
                      <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'name_animation')}
                        >
                          
                          Text Overlay
                        </button>
                      </li>
                      <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'text_animation_1')}
                        >
                          
                          Simple Text Animation 1
                        </button>
                      </li>
                      <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'text_animation_2')}
                        >
                          
                          Simple Text Animation 2
                        </button>
                      </li>
                      <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'simple_reveal')}
                        >
                          
                          Simple Reveal Effect
                        </button>
                      </li>
                      <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'speech_bubble')}
                        >
                          
                          Speech Bubble 1
                        </button>
                      </li>
                      <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'speech_thought')}
                        >
                          
                          Speech Bubble Thought
                        </button>
                      </li>
                      <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'speech_bubble_2')}
                        >
                          
                          Preset-Horizontal Wobble
                        </button>
                      </li>
                      <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'speech_bubble_3')}
                        >
                          
                          Speech Bubble 3
                        </button>
                      </li>
                      {/* <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'speech_bubble_4')}
                        >
                          
                          Speech Bubble 4
                        </button>
                      </li> */}
                       <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'border_animation')}
                        >
                          
                          Border Animation
                        </button>
                      </li>
                      <li className="mb-1">
                        <button
                          onClick={(e)=>handleEffectSetting(e,'border_animation_2')}
                        >
                          
                          Border Animation 2
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div className="btn_wrap_p pt-3 px-4">
                    <button
                      onClick={() => setShowOverlay(false)}
                      className="btn btn2 me-2"
                    >
                      Cancel
                    </button>
                    <button className="btn btn1" type="submit">
                      Select
                    </button>
                  </div>
                </div>
              </>
            )}

            {showLowerThird && (
              <>
              <div className="vac_aside bg-white p-3 shadow2">
                <div className="video_action_h text-center mb-3">
                  <h4>Lower Third Template</h4>
                  <p className="m-0">
                    Select Lower Third Template
                  </p>
                </div>
                <div className="template-list-container">
                  <ul className="list-unstyled m-0 px-4">
                    <li className="mb-1">
                      <button
                        onClick={(e)=>handleEffectSetting(e,'lt_animation_1')}
                      >
                        
                        Template 1
                      </button>
                    </li>
                    <li className="mb-1">
                      <button
                        onClick={(e)=>handleEffectSetting(e,'lt_animation_2')}
                      >
                        
                        Template 2
                      </button>
                    </li>
                    <li className="mb-1">
                      <button
                        onClick={(e)=>handleEffectSetting(e,'lt_animation_3')}
                      >
                        
                        Template 3
                      </button>
                    </li>
                    <li className="mb-1">
                      <button
                        onClick={(e)=>handleEffectSetting(e,'lt_animation_4')}
                      >
                        
                        Template 4
                      </button>
                    </li>
                    <li className="mb-1">
                      <button
                        onClick={(e)=>handleEffectSetting(e,'lt_animation_5')}
                      >
                        
                        Template 5
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="btn_wrap_p pt-3 px-4">
                  <button
                    onClick={() => setShowLowerThird(false)}
                    className="btn btn2 me-2"
                  >
                    Cancel
                  </button>
                  <button className="btn btn1" type="submit">
                    Select
                  </button>
                </div>
              </div>
              </>
            )}

            {showIcons && (
              <div className="vac_aside bg-white p-3 shadow2 element_shape">
                <div className="video_action_h text-center mb-3">
                  <h4>Icons</h4>
                  <p className="m-0">
                    Select type of icon which you want to add on video.
                  </p>
                </div>
                <div className="template-list-container">
                  <div className="accordion" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingEmoji">
                        <button 
                          className="accordion-button" 
                          type="button" 
                          data-bs-toggle="collapse" 
                          data-bs-target="#collapseOne" 
                          aria-expanded="true" 
                          aria-controls="collapseOne"
                        >
                          Emoji
                        </button>
                      </h2>
                      <div 
                        id="collapseOne" 
                        className="accordion-collapse collapse show" 
                        aria-labelledby="headingOne" 
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <ul className="p-2">
                          
                            {(smiley && smiley.length > 0) && smiley.map((icon,index)=>(
                              <li key={index}>
                                <button className="element_svg" onClick={(e)=>handleEffectSetting(e,icon)}>
                                  <img 
                                    src={process.env.REACT_APP_ICONSLINK+"smiley/show/"+icon} 
                                    alt={icon} 
                                  />
                                </button>
                              </li>
                            ))}
                           
                          </ul>
                        </div>
                      </div>
                    </div>
                   
                  </div>
                </div>
                <div className="btn_wrap_p pt-3">
                  <button
                    onClick={handleCloseShowIcon}
                    className="btn btn2 bg-transparent text-danger"
                  >
                    Cancel
                  </button>
                  {/* <button className="btn btn1" type="submit">
                    Select
                  </button> */}
                </div>
              </div>
            )}

            {showEffectControls && (
              <>
                {(showAnimation && showAnimation.nameAnim) && (
                  <>
                    <div className="vac_aside bg-white p-3 shadow2">
                      <div className="video_action_h text-center mb-3">
                        <h4>{showAnimation.name}</h4>
                        <p className="m-0">Design your own Template</p>
                      </div>

                      <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,'name_animation')}>
                        <div className="form_rw mb-3 pt-2">
                          <label>Text 1</label>
                          <div className="position-relative">
                            <div className="mlnk_txt position-absolute">
                              {showAnimation.text1.length}/50
                            </div>
                            <input
                              name=""
                              type="text"
                              className={`form-control pe-5 p_holder textbx2 shadow-none ${
                                errors && errors.text1 ? "is-invalid" : ""
                              }`}
                              placeholder="John Smith"
                              onChange={(e) =>
                                setShowAnimation({
                                  ...showAnimation,
                                  text1: e.target.value,
                                })
                              }
                              value={showAnimation.text1}
                            />
                            <div className="dropdown">
                              <button 
                                className="btn btn-secondary dropdown-toggle p-1 rounded" 
                                type="button" 
                                id="dropdownMenuButton1" 
                                data-bs-toggle="dropdown" 
                                aria-expanded="false"
                              >
                                Personalize
                              </button>
                              <ul 
                                className="dropdown-menu" 
                                aria-labelledby="dropdownMenuButton1" 
                                style={{background:"#e7e3e3"}}>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'name_animation','text1')}
                                  >FIRSTNAME</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'name_animation','text1')}
                                  >LASTNAME</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'name_animation','text1')}
                                  >EMAIL</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'name_animation','text1')}
                                  >GEOCOUNTRY</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'name_animation','text1')}
                                  >GEOCITY</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'name_animation','text1')}
                                  >GEOSTATE</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'name_animation','text1')}
                                  >COMPANY</a></li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="row mb-3 g-3">
                          <div className="col">
                            <label htmlFor="inputFontFamily">Select Animation</label>
                            <Select
                              options={animationLists}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={animationLists.filter(
                                (option) =>
                                  option.value === showAnimation.animationType
                              )}
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, animationType: e.value })
                              }
                            />
                          </div>
                        </div>
                        
                        <div className="row mb-3 g-3">
                          <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  showAnimation.text1FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                              }
                            />
                          </div>
                          <div className="col">
                            <label htmlFor="inputFontSize">Font Size</label>
                            <Input
                              type="number"
                              inputClass="form-control textbx2 shadow-none "
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                              }
                              value={showAnimation.text1FontSize}
                            />
                          </div>
                          <div className="col">
                            <label htmlFor="inputFontColor">Font Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={showAnimation.text1FontColor}
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                              }
                            />
                          </div> 
                        </div>

                        <div className="form_rw mb-3 timer-input">
                        <label>Start Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={showAnimation.startTime}
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              startTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                          onBlur={(e) => handleTimeBlur(e, "startTime")}
                          ref={startTimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "startTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "startTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        </div>

                        <div className="form_rw mb-3 timer-input">
                          <label>End Time</label>
                          <input
                            type="text"
                            className="form-control p_holder textbx2 shadow-none"
                            placeholder="00:00"
                            value={showAnimation.endTime}
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                endTime: e.target.value,
                              })
                            }
                            onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                            onBlur={(e) => handleTimeBlur(e, "endTime")}
                            ref={endTimeRef}
                          />
                          <FaSortDown
                            className="up"
                            onClick={(e) =>
                              handleTimeUpDown(e, "up", "endTime")
                            }
                            style={{ cursor: "pointer" }}
                          />
                          <FaSortUp
                            className="down"
                            onClick={(e) =>
                              handleTimeUpDown(e, "down", "endTime")
                            }
                            style={{ cursor: "pointer" }}
                          />
                        </div>

                        <div className="btn_wrap_p pt-3">
                          <button
                            onClick={(e) => handleClose(e,'name_animation')}
                            className="btn btn2 me-2"
                          >
                            Cancel
                          </button>
                          <button className="btn btn1" type="submit">
                            Apply
                          </button>
                        </div>
                      </form>
                    </div>
                  </>
                )}
                {(showAnimation && showAnimation.textAnim1) && (
                  <>
                    <div className="vac_aside bg-white p-3 shadow2">
                      <div className="video_action_h text-center mb-3">
                        <h4>{showAnimation.name}</h4>
                        <p className="m-0">Design your own Template</p>
                      </div>

                      <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,'text_animation_1')}>
                        <div className="form_rw mb-3 pt-2">
                          <label>Text 1</label>
                          <div className="position-relative">
                            <div className="mlnk_txt position-absolute">
                              {showAnimation.text1.length}/50
                            </div>
                            <input
                              name=""
                              type="text"
                              className={`form-control pe-5 p_holder textbx2 shadow-none ${
                                errors && errors.text1 ? "is-invalid" : ""
                              }`}
                              placeholder="John Smith"
                              onChange={(e) =>
                                setShowAnimation({
                                  ...showAnimation,
                                  text1: e.target.value,
                                })
                              }
                              value={showAnimation.text1}
                            />
                            <div className="dropdown">
                              <button 
                                className="btn btn-secondary dropdown-toggle p-1 rounded" 
                                type="button" 
                                id="dropdownMenuButton1" 
                                data-bs-toggle="dropdown" 
                                aria-expanded="false"
                              >
                                Personalize
                              </button>
                              <ul 
                                className="dropdown-menu" 
                                aria-labelledby="dropdownMenuButton1" 
                                style={{background:"#e7e3e3"}}>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_1','text1')}
                                  >FIRSTNAME</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_1','text1')}
                                  >LASTNAME</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_1','text1')}
                                  >EMAIL</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_1','text1')}
                                  >GEOCOUNTRY</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_1','text1')}
                                  >GEOCITY</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_1','text1')}
                                  >GEOSTATE</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_1','text1')}
                                  >COMPANY</a></li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="row mb-3 g-3">
                          <div className="col">
                            <label htmlFor="inputFontFamily">Select Animation</label>
                            <Select
                              options={animationLists}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={animationLists.filter(
                                (option) =>
                                  option.value === showAnimation.animationType
                              )}
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, animationType: e.value })
                              }
                            />
                          </div>
                        </div>
                        
                        <div className="row mb-3 g-3">
                          <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  showAnimation.text1FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                              }
                            />
                          </div>
                          <div className="col">
                            <label htmlFor="inputFontSize">Font Size</label>
                            <Input
                              type="number"
                              inputClass="form-control textbx2 shadow-none "
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                              }
                              value={showAnimation.text1FontSize}
                            />
                          </div>
                          <div className="col">
                            <label htmlFor="inputFontColor">Font Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={showAnimation.text1FontColor}
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                              }
                            />
                          </div> 
                        </div>

                        <div className="form_rw mb-3 timer-input">
                        <label>Start Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={showAnimation.startTime}
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              startTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                          onBlur={(e) => handleTimeBlur(e, "startTime")}
                          ref={startTimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "startTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "startTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        </div>

                        <div className="form_rw mb-3 timer-input">
                          <label>End Time</label>
                          <input
                            type="text"
                            className="form-control p_holder textbx2 shadow-none"
                            placeholder="00:00"
                            value={showAnimation.endTime}
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                endTime: e.target.value,
                              })
                            }
                            onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                            onBlur={(e) => handleTimeBlur(e, "endTime")}
                            ref={endTimeRef}
                          />
                          <FaSortDown
                            className="up"
                            onClick={(e) =>
                              handleTimeUpDown(e, "up", "endTime")
                            }
                            style={{ cursor: "pointer" }}
                          />
                          <FaSortUp
                            className="down"
                            onClick={(e) =>
                              handleTimeUpDown(e, "down", "endTime")
                            }
                            style={{ cursor: "pointer" }}
                          />
                        </div>

                        <div className="btn_wrap_p pt-3">
                          <button
                            onClick={(e) => handleClose(e,'text_animation_1')}
                            className="btn btn2 me-2"
                          >
                            Cancel
                          </button>
                          <button className="btn btn1" type="submit">
                            Apply
                          </button>
                        </div>
                      </form>
                    </div>
                  </>
                )}
                {(showAnimation && showAnimation.textAnim2) && (
                  <>
                    <div className="vac_aside bg-white p-3 shadow2">
                      <div className="video_action_h text-center mb-3">
                        <h4>{showAnimation.name}</h4>
                        <p className="m-0">Design your own Template</p>
                      </div>

                      <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,'text_animation_2')}>
                        <div className="form_rw mb-3 pt-2">
                          <label>Text 1</label>
                          <div className="position-relative">
                            <div className="mlnk_txt position-absolute">
                              {showAnimation.text1.length}/50
                            </div>
                            <input
                              name=""
                              type="text"
                              className={`form-control pe-5 p_holder textbx2 shadow-none ${
                                errors && errors.text1 ? "is-invalid" : ""
                              }`}
                              placeholder="John Smith"
                              onChange={(e) =>
                                setShowAnimation({
                                  ...showAnimation,
                                  text1: e.target.value,
                                })
                              }
                              value={showAnimation.text1}
                            />
                            <div className="dropdown">
                              <button 
                                className="btn btn-secondary dropdown-toggle p-1 rounded" 
                                type="button" 
                                id="dropdownMenuButton1" 
                                data-bs-toggle="dropdown" 
                                aria-expanded="false"
                              >
                                Personalize
                              </button>
                              <ul 
                                className="dropdown-menu" 
                                aria-labelledby="dropdownMenuButton1" 
                                style={{background:"#e7e3e3"}}>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_2','text1')}
                                  >FIRSTNAME</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_2','text1')}
                                  >LASTNAME</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_2','text1')}
                                  >EMAIL</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_2','text1')}
                                  >GEOCOUNTRY</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_2','text1')}
                                  >GEOCITY</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_2','text1')}
                                  >GEOSTATE</a></li>
                                <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'text_animation_2','text1')}
                                  >COMPANY</a></li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="row mb-3 g-3">
                          <div className="col">
                            <label htmlFor="inputFontFamily">Select Animation</label>
                            <Select
                              options={animationLists}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={animationLists.filter(
                                (option) =>
                                  option.value === showAnimation.animationType
                              )}
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, animationType: e.value })
                              }
                            />
                          </div>
                        </div>
                        
                        <div className="row mb-3 g-3">
                          <div className="col-6">
                            <label htmlFor="inputFontFamily">Font Family</label>
                            <Select
                              options={options}
                              formatOptionLabel={formatOptionLabel}
                              styles={selectStyles}
                              className="form-control textbx2 shadow-none"
                              value={options.filter(
                                (option) =>
                                  option.value.toLowerCase() ===
                                  showAnimation.text1FontFamily.toLowerCase()
                              )}
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                              }
                            />
                          </div>
                          <div className="col">
                            <label htmlFor="inputFontSize">Font Size</label>
                            <Input
                              type="number"
                              inputClass="form-control textbx2 shadow-none "
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                              }
                              value={showAnimation.text1FontSize}
                            />
                          </div>
                          <div className="col">
                            <label htmlFor="inputFontColor">Font Color</label>
                            <Input
                              type="color"
                              inputClass="form-control textbx2 shadow-none "
                              value={showAnimation.text1FontColor}
                              onChange={(e) =>
                                setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                              }
                            />
                          </div> 
                        </div>

                        <div className="form_rw mb-3 timer-input">
                        <label>Start Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={showAnimation.startTime}
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              startTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                          onBlur={(e) => handleTimeBlur(e, "startTime")}
                          ref={startTimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "startTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "startTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        </div>

                        <div className="form_rw mb-3 timer-input">
                          <label>End Time</label>
                          <input
                            type="text"
                            className="form-control p_holder textbx2 shadow-none"
                            placeholder="00:00"
                            value={showAnimation.endTime}
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                endTime: e.target.value,
                              })
                            }
                            onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                            onBlur={(e) => handleTimeBlur(e, "endTime")}
                            ref={endTimeRef}
                          />
                          <FaSortDown
                            className="up"
                            onClick={(e) =>
                              handleTimeUpDown(e, "up", "endTime")
                            }
                            style={{ cursor: "pointer" }}
                          />
                          <FaSortUp
                            className="down"
                            onClick={(e) =>
                              handleTimeUpDown(e, "down", "endTime")
                            }
                            style={{ cursor: "pointer" }}
                          />
                        </div>

                        <div className="btn_wrap_p pt-3">
                          <button
                            onClick={(e) => handleClose(e,'text_animation_2')}
                            className="btn btn2 me-2"
                          >
                            Cancel
                          </button>
                          <button className="btn btn1" type="submit">
                            Apply
                          </button>
                        </div>
                      </form>
                    </div>
                  </>
                )}
                {(showAnimation && showAnimation.simpleRevealShow) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                    <div className="video_action_h text-center mb-3">
                      <h4>{showAnimation.name}</h4>
                      <p className="m-0">Design your own Template</p>
                    </div>

                    <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,'simple_reveal')}>
                      <div className="form_rw mb-3 pt-2">
                        <label>Text 1</label>
                        <div className="position-relative">
                          <div className="mlnk_txt position-absolute">
                            {showAnimation.text1.length}/50
                          </div>
                          <input
                            name=""
                            type="text"
                            className={`form-control pe-5 p_holder textbx2 shadow-none ${
                              errors && errors.text1 ? "is-invalid" : ""
                            }`}
                            placeholder="John Smith"
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                text1: e.target.value,
                              })
                            }
                            value={showAnimation.text1}
                          />
                          <div className="dropdown">
                            <button 
                              className="btn btn-secondary dropdown-toggle p-1 rounded" 
                              type="button" 
                              id="dropdownMenuButton1" 
                              data-bs-toggle="dropdown" 
                              aria-expanded="false"
                            >
                              Personalize
                            </button>
                            <ul 
                              className="dropdown-menu" 
                              aria-labelledby="dropdownMenuButton1" 
                              style={{background:"#e7e3e3"}}>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text1')}
                                >FIRSTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text1')}
                                >LASTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text1')}
                                >EMAIL</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text1')}
                                >GEOCOUNTRY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text1')}
                                >GEOCITY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text1')}
                                >GEOSTATE</a></li>
                              <li>
                                  <a 
                                    className="dropdown-item" 
                                    href="#0"
                                    onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text1')}
                                  >COMPANY</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                        </div> 
                        <div className="col">
                          <label htmlFor="inputFontColor">Background Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1BgColor: e.target.value })
                            }
                          />
                        </div> 
                      </div>

                      <div className="form_rw mb-3 ">
                        <label>Text 2</label>
                        <div className="position-relative">
                          <div className="mlnk_txt position-absolute">
                            {showAnimation.text2.length}/50
                          </div>
                          <input
                            name=""
                            type="text"
                            className={`form-control pe-5 p_holder textbx2 shadow-none ${
                              errors && errors.text2 ? "is-invalid" : ""
                            }`}
                            placeholder="Senior Manager"
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                text2: e.target.value,
                              })
                            }
                            value={showAnimation.text2}
                          />
                          <div className="dropdown">
                            <button 
                              className="btn btn-secondary dropdown-toggle p-1 rounded" 
                              type="button" 
                              id="dropdownMenuButton1" 
                              data-bs-toggle="dropdown" 
                              aria-expanded="false"
                            >
                              Personalize
                            </button>
                            <ul 
                              className="dropdown-menu" 
                              aria-labelledby="dropdownMenuButton1" 
                              style={{background:"#e7e3e3"}}>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text2')}
                                >FIRSTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text2')}
                                >LASTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text2')}
                                >EMAIL</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text2')}
                                >GEOCOUNTRY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text2')}
                                >GEOCITY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text2')}
                                >GEOSTATE</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'simple_reveal','text2')}
                                >COMPANY</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text2FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontSize: e.target.value })
                            }
                            value={showAnimation.text2FontSize}
                          />
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                        <div className="col">
                          <label htmlFor="inputFontColor">Background Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2BgColor: e.target.value })
                            }
                          />
                        </div> 
                      </div>

                      <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.startTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            startTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                        onBlur={(e) => handleTimeBlur(e, "startTime")}
                        ref={startTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      </div>

                      <div className="form_rw mb-3 timer-input">
                        <label>End Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={showAnimation.endTime}
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              endTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                          onBlur={(e) => handleTimeBlur(e, "endTime")}
                          ref={endTimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Background Theme</label>
                          {/* <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.bgTheme}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, bgTheme: e.target.value })
                            }
                            
                          /> */}
                          <ColorPicker
                            layers_name={"bgTheme"}
                            font_color={showAnimation.bgTheme}
                            index={"bgTheme"}
                            handleColor={handleChange}
                          />
                        </div> 
                      </div>
                      <div className="btn_wrap_p pt-3">
                        <button
                          onClick={(e) => handleClose(e,'simple_reveal')}
                          className="btn btn2 me-2"
                        >
                          Cancel
                        </button>
                        <button className="btn btn1" type="submit">
                          Apply
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                {(showAnimation && showAnimation.speechBubble) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                    <div className="video_action_h text-center mb-3">
                      <h4>{showAnimation.name}</h4>
                      <p className="m-0">Design your own Template</p>
                    </div>

                    <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,'speech_bubble')}>
                      <div className="form_rw mb-3 pt-2">
                        <label>Text 1</label>
                        <div className="position-relative">
                          <div className="mlnk_txt position-absolute">
                            {showAnimation.text1.length}/30
                          </div>
                          <input
                            name=""
                            type="text"
                            className={`form-control pe-5 p_holder textbx2 shadow-none ${
                              errors && errors.text1 ? "is-invalid" : ""
                            }`}
                            placeholder="John Smith"
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                text1: e.target.value,
                              })
                            }
                            value={showAnimation.text1}
                          />
                           <div className="dropdown">
                            <button 
                              className="btn btn-secondary dropdown-toggle p-1 rounded" 
                              type="button" 
                              id="dropdownMenuButton1" 
                              data-bs-toggle="dropdown" 
                              aria-expanded="false"
                            >
                              Personalize
                            </button>
                            <ul 
                              className="dropdown-menu" 
                              aria-labelledby="dropdownMenuButton1" 
                              style={{background:"#e7e3e3"}}>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble','text1')}
                                >FIRSTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble','text1')}
                                >LASTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble','text1')}
                                >EMAIL</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble','text1')}
                                >GEOCOUNTRY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble','text1')}
                                >GEOCITY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble','text1')}
                                >GEOSTATE</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble','text1')}
                                >COMPANY</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                        <div className="col">
                          <label htmlFor="inputFontColor">Border Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1BgColor: e.target.value })
                            }
                          />
                        </div> 
                      </div>


                      <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.startTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            startTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                        onBlur={(e) => handleTimeBlur(e, "startTime")}
                        ref={startTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      </div>

                      <div className="form_rw mb-3 timer-input">
                        <label>End Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={showAnimation.endTime}
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              endTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                          onBlur={(e) => handleTimeBlur(e, "endTime")}
                          ref={endTimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Background Theme</label>
                          
                          <ColorPicker
                            layers_name={"bgTheme"}
                            font_color={showAnimation.bgTheme}
                            index={"bgTheme"}
                            handleColor={handleChange}
                          />
                        </div> 
                      </div>

                      <div className="btn_wrap_p pt-3">
                        <button
                         onClick={(e) => handleClose(e,'speech_bubble')}
                          className="btn btn2 me-2"
                        >
                          Cancel
                        </button>
                        <button className="btn btn1" type="submit">
                          Apply
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                {(showAnimation && showAnimation.speechBubble2) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                    <div className="video_action_h text-center mb-3">
                      <h4>{showAnimation.name}</h4>
                      <p className="m-0">Design your own Template</p>
                    </div>

                    <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,'speech_bubble_2')}>
                      <div className="form_rw mb-3 pt-2">
                        <label>Quote</label>
                        <div className="position-relative">
                          <div className="mlnk_txt position-absolute">
                            {showAnimation.text1.length}/30
                          </div>
                          <input
                            name=""
                            type="text"
                            className={`form-control pe-5 p_holder textbx2 shadow-none ${
                              errors && errors.text1 ? "is-invalid" : ""
                            }`}
                            placeholder="John Smith"
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                text1: e.target.value,
                              })
                            }
                            value={showAnimation.text1}
                          />
                           <div className="dropdown">
                            <button 
                              className="btn btn-secondary dropdown-toggle p-1 rounded" 
                              type="button" 
                              id="dropdownMenuButton1" 
                              data-bs-toggle="dropdown" 
                              aria-expanded="false"
                            >
                              Personalize
                            </button>
                            <ul 
                              className="dropdown-menu" 
                              aria-labelledby="dropdownMenuButton1" 
                              style={{background:"#e7e3e3"}}>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text1')}
                                >FIRSTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text1')}
                                >LASTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text1')}
                                >EMAIL</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text1')}
                                >GEOCOUNTRY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text1')}
                                >GEOCITY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text1')}
                                >GEOSTATE</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text1')}
                                >COMPANY</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                      </div>

                      <div className="form_rw mb-3 pt-2">
                        <label>Author</label>
                        <div className="position-relative">
                          <div className="mlnk_txt position-absolute">
                            {showAnimation.text2.length}/20
                          </div>
                          <input
                            name=""
                            type="text"
                            className={`form-control pe-5 p_holder textbx2 shadow-none ${
                              errors && errors.text2 ? "is-invalid" : ""
                            }`}
                            placeholder="John Smith"
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                text2: e.target.value,
                              })
                            }
                            value={showAnimation.text2}
                          />
                           <div className="dropdown">
                            <button 
                              className="btn btn-secondary dropdown-toggle p-1 rounded" 
                              type="button" 
                              id="dropdownMenuButton1" 
                              data-bs-toggle="dropdown" 
                              aria-expanded="false"
                            >
                              Personalize
                            </button>
                            <ul 
                              className="dropdown-menu" 
                              aria-labelledby="dropdownMenuButton1" 
                              style={{background:"#e7e3e3"}}>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text2')}
                                >FIRSTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text2')}
                                >LASTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text2')}
                                >EMAIL</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text2')}
                                >GEOCOUNTRY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text2')}
                                >GEOCITY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text2')}
                                >GEOSTATE</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_2','text2')}
                                >COMPANY</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text2FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontSize: e.target.value })
                            }
                            value={showAnimation.text2FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                      </div>

                      <div className="row g-3">
                        
                        <div className="col">
                          <label htmlFor="inputFontColor">Bubble Background Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1BgColor: e.target.value })
                            }
                          />
                        </div> 
                      </div>

                      <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.startTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            startTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                        onBlur={(e) => handleTimeBlur(e, "startTime")}
                        ref={startTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      </div>

                      <div className="form_rw mb-3 timer-input">
                        <label>End Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={showAnimation.endTime}
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              endTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                          onBlur={(e) => handleTimeBlur(e, "endTime")}
                          ref={endTimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Background Theme</label>
                          
                          <ColorPicker
                            layers_name={"bgTheme"}
                            font_color={showAnimation.bgTheme}
                            index={"bgTheme"}
                            handleColor={handleChange}
                          />
                        </div> 
                      </div>

                      <div className="btn_wrap_p pt-3">
                        <button
                         onClick={(e) => handleClose(e,'speech_bubble_2')}
                          className="btn btn2 me-2"
                        >
                          Cancel
                        </button>
                        <button className="btn btn1" type="submit">
                          Apply
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                {(showAnimation && showAnimation.speechBubble3) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                    <div className="video_action_h text-center mb-3">
                      <h4>{showAnimation.name}</h4>
                      <p className="m-0">Design your own Template</p>
                    </div>

                    <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,'speech_bubble_3')}>
                      <div className="form_rw mb-3 pt-2">
                        <label>Text 1</label>
                        <div className="position-relative">
                          <div className="mlnk_txt position-absolute">
                            {showAnimation.text1.length}/30
                          </div>
                          <input
                            name=""
                            type="text"
                            className={`form-control pe-5 p_holder textbx2 shadow-none ${
                              errors && errors.text1 ? "is-invalid" : ""
                            }`}
                            placeholder="John Smith"
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                text1: e.target.value,
                              })
                            }
                            value={showAnimation.text1}
                          />
                           <div className="dropdown">
                            <button 
                              className="btn btn-secondary dropdown-toggle p-1 rounded" 
                              type="button" 
                              id="dropdownMenuButton1" 
                              data-bs-toggle="dropdown" 
                              aria-expanded="false"
                            >
                              Personalize
                            </button>
                            <ul 
                              className="dropdown-menu" 
                              aria-labelledby="dropdownMenuButton1" 
                              style={{background:"#e7e3e3"}}>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_3','text1')}
                                >FIRSTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_3','text1')}
                                >LASTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_3','text1')}
                                >EMAIL</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_3','text1')}
                                >GEOCOUNTRY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_3','text1')}
                                >GEOCITY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_3','text1')}
                                >GEOSTATE</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_bubble_3','text1')}
                                >COMPANY</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                        <div className="col">
                          <label htmlFor="inputFontColor">Border Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1BgColor: e.target.value })
                            }
                          />
                        </div> 
                      </div>


                      <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.startTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            startTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                        onBlur={(e) => handleTimeBlur(e, "startTime")}
                        ref={startTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      </div>

                      <div className="form_rw mb-3 timer-input">
                        <label>End Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={showAnimation.endTime}
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              endTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                          onBlur={(e) => handleTimeBlur(e, "endTime")}
                          ref={endTimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Background Theme</label>
                          
                          <ColorPicker
                            layers_name={"bgTheme"}
                            font_color={showAnimation.bgTheme}
                            index={"bgTheme"}
                            handleColor={handleChange}
                          />
                        </div> 
                      </div>

                      <div className="btn_wrap_p pt-3">
                        <button
                         onClick={(e) => handleClose(e,'speech_bubble_3')}
                          className="btn btn2 me-2"
                        >
                          Cancel
                        </button>
                        <button className="btn btn1" type="submit">
                          Apply
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                {(showAnimation && showAnimation.speechThought) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                    <div className="video_action_h text-center mb-3">
                      <h4>{showAnimation.name}</h4>
                      <p className="m-0">Design your own Template</p>
                    </div>

                    <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,'speech_thought')}>
                      <div className="form_rw mb-3 pt-2">
                        <label>Text 1</label>
                        <div className="position-relative">
                          <div className="mlnk_txt position-absolute">
                            {showAnimation.text1.length}/30
                          </div>
                          <input
                            name=""
                            type="text"
                            className={`form-control pe-5 p_holder textbx2 shadow-none ${
                              errors && errors.text1 ? "is-invalid" : ""
                            }`}
                            placeholder="Please Enter Your Message"
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                text1: e.target.value,
                              })
                            }
                            value={showAnimation.text1}
                          />
                           <div className="dropdown">
                            <button 
                              className="btn btn-secondary dropdown-toggle p-1 rounded" 
                              type="button" 
                              id="dropdownMenuButton1" 
                              data-bs-toggle="dropdown" 
                              aria-expanded="false"
                            >
                              Personalize
                            </button>
                            <ul 
                              className="dropdown-menu" 
                              aria-labelledby="dropdownMenuButton1" 
                              style={{background:"#e7e3e3"}}>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_thought','text1')}
                                >FIRSTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_thought','text1')}
                                >LASTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_thought','text1')}
                                >EMAIL</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_thought','text1')}
                                >GEOCOUNTRY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_thought','text1')}
                                >GEOCITY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_thought','text1')}
                                >GEOSTATE</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'speech_thought','text1')}
                                >COMPANY</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                        <div className="col">
                          <label htmlFor="inputFontColor">Border Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1BgColor: e.target.value })
                            }
                          />
                        </div> 
                      </div>

                      <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.startTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            startTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                        onBlur={(e) => handleTimeBlur(e, "startTime")}
                        ref={startTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      </div>

                      <div className="form_rw mb-3 timer-input">
                        <label>End Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={showAnimation.endTime}
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              endTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                          onBlur={(e) => handleTimeBlur(e, "endTime")}
                          ref={endTimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Background Theme</label>
                          
                          <ColorPicker
                            layers_name={"bgTheme"}
                            font_color={showAnimation.bgTheme}
                            index={"bgTheme"}
                            handleColor={handleChange}
                          />
                        </div> 
                      </div>

                      <div className="btn_wrap_p pt-3">
                        <button
                          onClick={(e) => handleClose(e,'speech_thought')}
                          className="btn btn2 me-2"
                        >
                          Cancel
                        </button>
                        <button className="btn btn1" type="submit">
                          Apply
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                {(showAnimation && showAnimation.borderAnim) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                    <div className="video_action_h text-center mb-3">
                      <h4>{showAnimation.name}</h4>
                      <p className="m-0">Design your own Template</p>
                    </div>

                    <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,'border_animation')}>
                      <div className="form_rw mb-3 pt-2">
                        <label>Text 1</label>
                        <div className="position-relative">
                          <div className="mlnk_txt position-absolute">
                            {showAnimation.text1.length}/30
                          </div>
                          <input
                            name=""
                            type="text"
                            className={`form-control pe-5 p_holder textbx2 shadow-none ${
                              errors && errors.text1 ? "is-invalid" : ""
                            }`}
                            placeholder="Please Enter Your Message"
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                text1: e.target.value,
                              })
                            }
                            value={showAnimation.text1}
                          />
                           <div className="dropdown">
                            <button 
                              className="btn btn-secondary dropdown-toggle p-1 rounded" 
                              type="button" 
                              id="dropdownMenuButton1" 
                              data-bs-toggle="dropdown" 
                              aria-expanded="false"
                            >
                              Personalize
                            </button>
                            <ul 
                              className="dropdown-menu" 
                              aria-labelledby="dropdownMenuButton1" 
                              style={{background:"#e7e3e3"}}>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation','text1')}
                                >FIRSTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation','text1')}
                                >LASTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation','text1')}
                                >EMAIL</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation','text1')}
                                >GEOCOUNTRY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation','text1')}
                                >GEOCITY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation','text1')}
                                >GEOSTATE</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation','text1')}
                                >COMPANY</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                        <div className="col">
                          <label htmlFor="inputFontColor">Border Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2BgColor: e.target.value })
                            }
                          />
                        </div> 
                      </div>
                      
                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Background Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1BgColor: e.target.value })
                            }
                          />
                          
                        </div>
                      </div>

                      <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.startTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            startTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                        onBlur={(e) => handleTimeBlur(e, "startTime")}
                        ref={startTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      </div>

                      <div className="form_rw mb-3 timer-input">
                        <label>End Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={showAnimation.endTime}
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              endTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                          onBlur={(e) => handleTimeBlur(e, "endTime")}
                          ref={endTimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Background Theme</label>
                          
                          <ColorPicker
                            layers_name={"bgTheme"}
                            font_color={showAnimation.bgTheme}
                            index={"bgTheme"}
                            handleColor={handleChange}
                          />
                        </div> 
                      </div>

                      <div className="btn_wrap_p pt-3">
                        <button
                          onClick={(e) => handleClose(e,'border_animation')}
                          className="btn btn2 me-2"
                        >
                          Cancel
                        </button>
                        <button className="btn btn1" type="submit">
                          Apply
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                {(showAnimation && showAnimation.borderAnim2) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                    <div className="video_action_h text-center mb-3">
                      <h4>{showAnimation.name}</h4>
                      <p className="m-0">Design your own Template</p>
                    </div>

                    <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,'border_animation_2')}>
                      <div className="form_rw mb-3 pt-2">
                        <label>Text 1</label>
                        <div className="position-relative">
                          <div className="mlnk_txt position-absolute">
                            {showAnimation.text1.length}/30
                          </div>
                          <input
                            name=""
                            type="text"
                            className={`form-control pe-5 p_holder textbx2 shadow-none ${
                              errors && errors.text1 ? "is-invalid" : ""
                            }`}
                            placeholder="Please Enter Your Message"
                            onChange={(e) =>
                              setShowAnimation({
                                ...showAnimation,
                                text1: e.target.value,
                              })
                            }
                            value={showAnimation.text1}
                          />
                           <div className="dropdown">
                            <button 
                              className="btn btn-secondary dropdown-toggle p-1 rounded" 
                              type="button" 
                              id="dropdownMenuButton1" 
                              data-bs-toggle="dropdown" 
                              aria-expanded="false"
                            >
                              Personalize
                            </button>
                            <ul 
                              className="dropdown-menu" 
                              aria-labelledby="dropdownMenuButton1" 
                              style={{background:"#e7e3e3"}}>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation_2','text1')}
                                >FIRSTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation_2','text1')}
                                >LASTNAME</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation_2','text1')}
                                >EMAIL</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation_2','text1')}
                                >GEOCOUNTRY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation_2','text1')}
                                >GEOCITY</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation_2','text1')}
                                >GEOSTATE</a></li>
                              <li>
                                <a 
                                  className="dropdown-item" 
                                  href="#0"
                                  onClick={(e)=>handlePersonalizeClick(e,'border_animation_2','text1')}
                                >COMPANY</a></li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                        <div className="col">
                          <label htmlFor="inputFontColor">Bg Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1BgColor: e.target.value })
                            }
                          />
                        </div> 
                        <div className="col">
                          <label htmlFor="inputFontColor">Border Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2BgColor: e.target.value })
                            }
                          />
                        </div> 
                      </div>

                      <div className="form_rw mb-3 timer-input">
                      <label>Start Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.startTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            startTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                        onBlur={(e) => handleTimeBlur(e, "startTime")}
                        ref={startTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "startTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      </div>

                      <div className="form_rw mb-3 timer-input">
                        <label>End Time</label>
                        <input
                          type="text"
                          className="form-control p_holder textbx2 shadow-none"
                          placeholder="00:00"
                          value={showAnimation.endTime}
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              endTime: e.target.value,
                            })
                          }
                          onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                          onBlur={(e) => handleTimeBlur(e, "endTime")}
                          ref={endTimeRef}
                        />
                        <FaSortDown
                          className="up"
                          onClick={(e) =>
                            handleTimeUpDown(e, "up", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <FaSortUp
                          className="down"
                          onClick={(e) =>
                            handleTimeUpDown(e, "down", "endTime")
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </div>

                      <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontColor">Background Theme</label>
                          
                          <ColorPicker
                            layers_name={"bgTheme"}
                            font_color={showAnimation.bgTheme}
                            index={"bgTheme"}
                            handleColor={handleChange}
                          />
                        </div> 
                      </div>

                      <div className="btn_wrap_p pt-3">
                        <button
                          onClick={(e) => handleClose(e,'border_animation_2')}
                          className="btn btn2 me-2"
                        >
                          Cancel
                        </button>
                        <button className="btn btn1" type="submit">
                          Apply
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                {(showAnimation && showAnimation.ltAnimation1) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>{showAnimation.name}</h4>
                    <p className="m-0">Design your own Template</p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,'lt_animation_1')}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Text 1</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {showAnimation.text1.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.text1 ? "is-invalid" : ""
                          }`}
                          placeholder="Please Enter Your Message"
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              text1: e.target.value,
                            })
                          }
                          value={showAnimation.text1}
                        />
                      </div>
                    </div>

                    <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Text 2</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {showAnimation.text2.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.text2 ? "is-invalid" : ""
                          }`}
                          placeholder="Please Enter Your Message"
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              text2: e.target.value,
                            })
                          }
                          value={showAnimation.text2}
                        />
                      </div>
                    </div>

                    <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text2FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontSize: e.target.value })
                            }
                            value={showAnimation.text2FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                    </div>

                    <div className="row g-3">    
                      <div className="col">
                        <label htmlFor="inputFontColor">Background Theme</label>
                        
                        <ColorPicker
                          layers_name={"bgTheme"}
                          font_color={showAnimation.bgTheme}
                          index={"bgTheme"}
                          handleColor={handleChange}
                        />
                      </div>  
                        <div className="col">
                          <label htmlFor="inputFontColor">Border Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2BgColor: e.target.value })
                            }
                          />
                        </div> 
                    </div>


                    <div className="form_rw mb-3 timer-input">
                    <label>Start Time</label>
                    <input
                      type="text"
                      className="form-control p_holder textbx2 shadow-none"
                      placeholder="00:00"
                      value={showAnimation.startTime}
                      onChange={(e) =>
                        setShowAnimation({
                          ...showAnimation,
                          startTime: e.target.value,
                        })
                      }
                      onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                      onBlur={(e) => handleTimeBlur(e, "startTime")}
                      ref={startTimeRef}
                    />
                    <FaSortDown
                      className="up"
                      onClick={(e) =>
                        handleTimeUpDown(e, "up", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    <FaSortUp
                      className="down"
                      onClick={(e) =>
                        handleTimeUpDown(e, "down", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.endTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            endTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                        onBlur={(e) => handleTimeBlur(e, "endTime")}
                        ref={endTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                   
                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={(e) => handleClose(e,'lt_animation_1')}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                  </div>
                )}

                {(showAnimation && showAnimation.ltAnimation2) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>{showAnimation.name}</h4>
                    <p className="m-0">Design your own Template</p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,'lt_animation_2')}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Text 1</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {showAnimation.text1.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.text1 ? "is-invalid" : ""
                          }`}
                          placeholder="Please Enter Your Message"
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              text1: e.target.value,
                            })
                          }
                          value={showAnimation.text1}
                        />
                      </div>
                    </div>

                    <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Text 2</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {showAnimation.text2.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.text2 ? "is-invalid" : ""
                          }`}
                          placeholder="Please Enter Your Message"
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              text2: e.target.value,
                            })
                          }
                          value={showAnimation.text2}
                        />
                      </div>
                    </div>

                    <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text2FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontSize: e.target.value })
                            }
                            value={showAnimation.text2FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                    </div>

                    <div className="form_rw mb-3 timer-input">
                    <label>Start Time</label>
                    <input
                      type="text"
                      className="form-control p_holder textbx2 shadow-none"
                      placeholder="00:00"
                      value={showAnimation.startTime}
                      onChange={(e) =>
                        setShowAnimation({
                          ...showAnimation,
                          startTime: e.target.value,
                        })
                      }
                      onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                      onBlur={(e) => handleTimeBlur(e, "startTime")}
                      ref={startTimeRef}
                    />
                    <FaSortDown
                      className="up"
                      onClick={(e) =>
                        handleTimeUpDown(e, "up", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    <FaSortUp
                      className="down"
                      onClick={(e) =>
                        handleTimeUpDown(e, "down", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.endTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            endTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                        onBlur={(e) => handleTimeBlur(e, "endTime")}
                        ref={endTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="row g-3">    
                      <div className="col">
                        <label htmlFor="inputFontColor">Background Theme</label>
                        
                        <ColorPicker
                          layers_name={"bgTheme"}
                          font_color={showAnimation.bgTheme}
                          index={"bgTheme"}
                          handleColor={handleChange}
                        />
                      </div>  
                        
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={(e) => handleClose(e,'lt_animation_2')}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                  </div>
                )}

                {(showAnimation && showAnimation.ltAnimation3) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>{showAnimation.name}</h4>
                    <p className="m-0">Design your own Template</p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,'lt_animation_3')}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Text 1</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {showAnimation.text1.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.text1 ? "is-invalid" : ""
                          }`}
                          placeholder="Please Enter Your Message"
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              text1: e.target.value,
                            })
                          }
                          value={showAnimation.text1}
                        />
                      </div>
                    </div>

                    <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                    </div>


                    <div className="form_rw mb-3 pt-2">
                      <label>Text 2</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {showAnimation.text2.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.text2 ? "is-invalid" : ""
                          }`}
                          placeholder="Please Enter Your Message"
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              text2: e.target.value,
                            })
                          }
                          value={showAnimation.text2}
                        />
                      </div>
                    </div>

                    <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text2FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontSize: e.target.value })
                            }
                            value={showAnimation.text2FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                    </div>

                    <div className="form_rw mb-3 timer-input">
                    <label>Start Time</label>
                    <input
                      type="text"
                      className="form-control p_holder textbx2 shadow-none"
                      placeholder="00:00"
                      value={showAnimation.startTime}
                      onChange={(e) =>
                        setShowAnimation({
                          ...showAnimation,
                          startTime: e.target.value,
                        })
                      }
                      onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                      onBlur={(e) => handleTimeBlur(e, "startTime")}
                      ref={startTimeRef}
                    />
                    <FaSortDown
                      className="up"
                      onClick={(e) =>
                        handleTimeUpDown(e, "up", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    <FaSortUp
                      className="down"
                      onClick={(e) =>
                        handleTimeUpDown(e, "down", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.endTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            endTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                        onBlur={(e) => handleTimeBlur(e, "endTime")}
                        ref={endTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="row g-3">    
                      <div className="col">
                        <label htmlFor="inputFontColor">Background Theme</label>
                        
                        <ColorPicker
                          layers_name={"bgTheme"}
                          font_color={showAnimation.bgTheme}
                          index={"bgTheme"}
                          handleColor={handleChange}
                        />
                      </div>  
                        
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={(e) => handleClose(e,'lt_animation_3')}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                  </div>
                )}

                {(showAnimation && showAnimation.ltAnimation4) && (
                  <div className="vac_aside bg-white p-3 shadow2">  
                  <div className="video_action_h text-center mb-3">
                    <h4>{showAnimation.name}</h4>
                    <p className="m-0">Design your own Template</p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,'lt_animation_4')}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Text 1</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {showAnimation.text1.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.text1 ? "is-invalid" : ""
                          }`}
                          placeholder="Please Enter Your Message"
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              text1: e.target.value,
                            })
                          }
                          value={showAnimation.text1}
                        />
                      </div>
                    </div>

                    <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                    </div>

                    <div className="row g-3">    
                      <div className="col">
                        <label htmlFor="inputFontColor">Background Theme</label>
                        
                        <ColorPicker
                          layers_name={"bgTheme"}
                          font_color={showAnimation.bgTheme}
                          index={"bgTheme"}
                          handleColor={handleChange}
                        />
                      </div>  

                      <div className="col">
                          <label htmlFor="inputFontColor">Border Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2BgColor: e.target.value })
                            }
                          />
                        </div> 
                        
                    </div>

                    <div className="form_rw mb-3 timer-input">
                    <label>Start Time</label>
                    <input
                      type="text"
                      className="form-control p_holder textbx2 shadow-none"
                      placeholder="00:00"
                      value={showAnimation.startTime}
                      onChange={(e) =>
                        setShowAnimation({
                          ...showAnimation,
                          startTime: e.target.value,
                        })
                      }
                      onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                      onBlur={(e) => handleTimeBlur(e, "startTime")}
                      ref={startTimeRef}
                    />
                    <FaSortDown
                      className="up"
                      onClick={(e) =>
                        handleTimeUpDown(e, "up", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    <FaSortUp
                      className="down"
                      onClick={(e) =>
                        handleTimeUpDown(e, "down", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.endTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            endTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                        onBlur={(e) => handleTimeBlur(e, "endTime")}
                        ref={endTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                  

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={(e) => handleClose(e,'lt_animation_4')}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                  </div>
                )}

                {(showAnimation && showAnimation.ltAnimation5) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>{showAnimation.name}</h4>
                    <p className="m-0">Design your own Template</p>
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,'lt_animation_5')}>
                    <div className="form_rw mb-3 pt-2">
                      <label>Text 1</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {showAnimation.text1.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.text1 ? "is-invalid" : ""
                          }`}
                          placeholder="Please Enter Your Message"
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              text1: e.target.value,
                            })
                          }
                          value={showAnimation.text1}
                        />
                      </div>
                    </div>

                    <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text1FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontSize: e.target.value })
                            }
                            value={showAnimation.text1FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text1FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text1FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                    </div>

                    <div className="form_rw mb-3 pt-2">
                      <label>Text 2</label>
                      <div className="position-relative">
                        <div className="mlnk_txt position-absolute">
                          {showAnimation.text2.length}/30
                        </div>
                        <input
                          name=""
                          type="text"
                          className={`form-control pe-5 p_holder textbx2 shadow-none ${
                            errors && errors.text2 ? "is-invalid" : ""
                          }`}
                          placeholder="Please Enter Your Message"
                          onChange={(e) =>
                            setShowAnimation({
                              ...showAnimation,
                              text2: e.target.value,
                            })
                          }
                          value={showAnimation.text2}
                        />
                      </div>
                    </div>

                    <div className="row g-3">
                        <div className="col">
                          <label htmlFor="inputFontFamily">Font Family</label>
                          <Select
                            options={options}
                            formatOptionLabel={formatOptionLabel}
                            value={options.filter(
                              (option) =>
                                option.value.toLowerCase() ===
                                showAnimation.text2FontFamily.toLowerCase()
                            )}
                            styles={selectStyles}
                            className="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontFamily: e.value })
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontSize">Font Size</label>
                          <Input
                            type="number"
                            inputClass="form-control textbx2 shadow-none "
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontSize: e.target.value })
                            }
                            value={showAnimation.text2FontSize}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="inputFontColor">Font Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2FontColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2FontColor: e.target.value })
                            }
                          />
                          
                        </div> 
                    </div>

                    <div className="form_rw mb-3 timer-input">
                    <label>Start Time</label>
                    <input
                      type="text"
                      className="form-control p_holder textbx2 shadow-none"
                      placeholder="00:00"
                      value={showAnimation.startTime}
                      onChange={(e) =>
                        setShowAnimation({
                          ...showAnimation,
                          startTime: e.target.value,
                        })
                      }
                      onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                      onBlur={(e) => handleTimeBlur(e, "startTime")}
                      ref={startTimeRef}
                    />
                    <FaSortDown
                      className="up"
                      onClick={(e) =>
                        handleTimeUpDown(e, "up", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    <FaSortUp
                      className="down"
                      onClick={(e) =>
                        handleTimeUpDown(e, "down", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.endTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            endTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                        onBlur={(e) => handleTimeBlur(e, "endTime")}
                        ref={endTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="row g-3">    
                      <div className="col">
                        <label htmlFor="inputFontColor">Background Theme</label>
                        
                        <ColorPicker
                          layers_name={"bgTheme"}
                          font_color={showAnimation.bgTheme}
                          index={"bgTheme"}
                          handleColor={handleChange}
                        />
                      </div>  

                      <div className="col">
                          <label htmlFor="inputFontColor">Border Color</label>
                          <Input
                            type="color"
                            inputClass="form-control textbx2 shadow-none "
                            value={showAnimation.text2BgColor}
                            onChange={(e) =>
                              setShowAnimation({ ...showAnimation, text2BgColor: e.target.value })
                            }
                          />
                        </div> 
                        
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={(e) => handleClose(e,'lt_animation_5')}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                  </div>
                )}

                {(showAnimation && showAnimation.smiley) && (
                  <div className="vac_aside bg-white p-3 shadow2">
                  <div className="video_action_h text-center mb-3">
                    <h4>{showAnimation.name}</h4>
                    {/* <p className="m-0">Design your own Template</p> */}
                  </div>

                  <div className="position-absolute bckbtn">
                    <IoArrowBackOutline onClick={hideAllTriggers} />
                  </div>

                  <form onSubmit={(e)=>handleEffectData(e,"emoji_content")}>
                   
                    <div className="form_rw mb-3 pt-2">
                      <label>Smiley Icons</label>
                      <div className="position-relative">
                        <div className="smileyEditor">
                          {(showAnimation.smileyContent && showAnimation.smileyContent.length > 0) && showAnimation.smileyContent.map((icon,index)=>(
                            <div className="position-relative p-2 svgIcon-container" key={icon+index}>
                              <img 
                                src={process.env.REACT_APP_ICONSLINK+"smiley/show/"+icon} 
                                alt={showAnimation.smileyContent} 
                                style={{height:"45px",width:"45px"}}
                                className="svgIcon"
                              />
                              <button 
                                onClick={(e)=>handleDeleteIcon(e,icon)}
                                className="btn text-danger iconDelete"
                              ><FaTimesCircle /></button>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="form_rw mb-3 timer-input">
                    <label>Start Time</label>
                    <input
                      type="text"
                      className="form-control p_holder textbx2 shadow-none"
                      placeholder="00:00"
                      value={showAnimation.startTime}
                      onChange={(e) =>
                        setShowAnimation({
                          ...showAnimation,
                          startTime: e.target.value,
                        })
                      }
                      onKeyUp={(e) => handleTimeKeyUp(e, "startTime")}
                      onBlur={(e) => handleTimeBlur(e, "startTime")}
                      ref={startTimeRef}
                    />
                    <FaSortDown
                      className="up"
                      onClick={(e) =>
                        handleTimeUpDown(e, "up", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    <FaSortUp
                      className="down"
                      onClick={(e) =>
                        handleTimeUpDown(e, "down", "startTime")
                      }
                      style={{ cursor: "pointer" }}
                    />
                    </div>

                    <div className="form_rw mb-3 timer-input">
                      <label>End Time</label>
                      <input
                        type="text"
                        className="form-control p_holder textbx2 shadow-none"
                        placeholder="00:00"
                        value={showAnimation.endTime}
                        onChange={(e) =>
                          setShowAnimation({
                            ...showAnimation,
                            endTime: e.target.value,
                          })
                        }
                        onKeyUp={(e) => handleTimeKeyUp(e, "endTime")}
                        onBlur={(e) => handleTimeBlur(e, "endTime")}
                        ref={endTimeRef}
                      />
                      <FaSortDown
                        className="up"
                        onClick={(e) =>
                          handleTimeUpDown(e, "up", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <FaSortUp
                        className="down"
                        onClick={(e) =>
                          handleTimeUpDown(e, "down", "endTime")
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>

                    <div className="btn_wrap_p pt-3">
                      <button
                        onClick={(e) => handleClose(e,"emoji_content")}
                        className="btn btn2 me-2"
                      >
                        Cancel
                      </button>
                      <button className="btn btn1" type="submit">
                        Apply
                      </button>
                    </div>
                  </form>
                  </div>
                )}

                
              </>
            )}
          </div>

          <div className="col-xl-7 col-lg-7 col-md-12">
            <div className="v_new_bx position-relative mb-3">
              <div className="video_a_r1 vidAmaze-player" ref={videoFrameRef}>
                {/* <img src={process.env.PUBLIC_URL + "/assets/images/video_pic_1.png"} className=" w-100" alt="img" /> */}
                {campaign_data && (campaign_data.video_type === "upload" || campaign_data.video_type === "cust_upload") && (
                  <>
                     <ReactPlayer 
                      url={ytPlayer.url} 
                      className="w-100 react-player"
                      height="auto"
                      id="video_player"
                      playing={ytPlayer.playing}
                      onPlay={()=>setYtPlayer({...ytPlayer,playing:true})}
                      onPause={()=>setYtPlayer({...ytPlayer,playing:false})}
                      onProgress={handleProgress}
                      onDuration={handleDuration}
                      muted={ytPlayer.muted}
                      volume={ytPlayer.volume}
                      ref={ytPlayerRef}
                      onError={e => console.log('onError', e)}
                    />
                  </>
                )}
                {campaign_data && campaign_data.video_type === "embed" && (
                  <>
                  {/* {console.log(ytPlayer)} */}
                  <ReactPlayer 
                    url={ytPlayer.url} 
                    // url={`https://www.youtube.com/watch?v=Q3FZv7fZi48?start=30&end=180`}
                    // className="w-100"
                    // height="390px"
                    height="320px"
                    width="auto"
                    id="video_player"
                    playing={ytPlayer.playing}
                    onPlay={()=>setYtPlayer({...ytPlayer,playing:true})}
                    onPause={()=>setYtPlayer({...ytPlayer,playing:false})}
                    onProgress={handleProgress}
                    onDuration={handleDuration}
                    muted={ytPlayer.muted}
                    volume={ytPlayer.volume}
                    ref={ytPlayerRef}
                    onEnded={()=>setYtPlayer({...ytPlayer,playing:false})}
                  />
                  </>
                )}
                <div className="player-controls-container player-controls-inside showing-controls">
                  <button
                    className="border-0 bg-transparent play-pause-button"
                    id="pauseAndPlayBtn"
                    onClick={()=>setYtPlayer({...ytPlayer,playing:!ytPlayer.playing})}
                  >
                    {!ytPlayer.playing ? (
                      <FaPlay className="text-white" />
                    ) : (
                      <FaPause className="text-white" />
                    )}
                  </button>
                  <div className="cta-indicator">
                    <div
                      id="ctaIndicatorInner"
                      className="cta-indicator-inner"
                    >
                      {actionPoint &&
                        actionPoint.length > 0 &&
                        actionPoint.map((elem, index) => (
                          <div key={index}>
                            {elem.action_event === "video_cta" && (
                              <span
                                className="call-to-action-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}

                            {elem.action_event === "video_leadgen" && (
                              <span
                                className="leadgen-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}

                            {elem.action_event === "video_leadgen2" && (
                              <span
                                className="leadgen-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}

                            {elem.action_event === "video_annotation" && (
                              <span
                                className="annotation-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}

                            {elem.action_event === "buy_button" && (
                              <span
                                className="buynow-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}
                            
                            {elem.action_event === "link_button2" && (
                              <span
                                className="buynow-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}

                            {elem.action_event === "link_button3" && (
                              <span
                                className="buynow-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}

                            {elem.action_event === "link_button4" && (
                              <span
                                className="buynow-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}

                            {elem.action_event === "link_button5" && (
                              <span
                                className="buynow-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}

                            {elem.action_event === "link_button6" && (
                              <span
                                className="timer-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}

                            {elem.action_event === "link_button7" && (
                              <span
                                className="review-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}
                            
                            {elem.action_event === "link_button8" && (
                              <span
                                className="buynow-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}
                            {elem.action_event === "link_button9" && (
                              <span
                                className="buynow-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}

                          {elem.action_event === "Img_btn1" && (
                              <span
                                className="shoping-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}

                          {elem.action_event === "Img_btn2" && (
                                <span
                                  className="qrcode-marker"
                                  style={{
                                    left: getActioTime(elem.action_time),
                                  }}
                                ></span>
                            )}

                            {elem.action_event === "Img_btn3" && (
                                <span
                                  className="shoping-marker"
                                  style={{
                                    left: getActioTime(elem.action_time),
                                  }}
                                ></span>
                              )}
  
                            {elem.action_event === "Img_btn4" && (
                                  <span
                                    className="qrcode-marker"
                                    style={{
                                      left: getActioTime(elem.action_time),
                                    }}
                                  ></span>
                              )}
  
                            {elem.action_event === "Img_btn5" && (
                                    <span
                                      className="timer-marker"
                                      style={{
                                        left: getActioTime(elem.action_time),
                                      }}
                                    ></span>
                              )}
                            
                            {elem.action_event === "Img_btn6" && (
                                    <span
                                      className="menu-marker"
                                      style={{
                                        left: getActioTime(elem.action_time),
                                      }}
                                    ></span>
                              )}

                            {elem.action_event === "Img_btn7" && (
                                    <span
                                      className="menu-marker"
                                      style={{
                                        left: getActioTime(elem.action_time),
                                      }}
                                    ></span>
                              )}
                            {elem.action_event === "Img_btn8" && (
                                    <span
                                      className="menu-marker"
                                      style={{
                                        left: getActioTime(elem.action_time),
                                      }}
                                    ></span>
                              )}

                            {elem.action_event === "video_copypaste" && (
                              <span
                                className="copypaste-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}
                            {elem.action_event === "scriptCode" && (
                              <span
                                className="copypaste-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}

                            {elem.action_event === "video_custPoll" && (
                              <span
                                className="custpoll-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}

                            {elem.action_event === "video_cust2Poll" && (
                              <span
                                className="custpoll-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}
                            
                            {elem.action_event === "video_cust3Poll" && (
                              <span
                                className="custpoll-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}
                            
                            {elem.action_event === "video_opentable1" && (
                              <span
                                className="custpoll-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}
                            
                            {elem.action_event === "video_review1" && (
                              <span
                                className="review-marker"
                                style={{
                                  left: getActioTime(elem.action_time),
                                }}
                              ></span>
                            )}

                            {elem.action_event === "video_meeting" && (
                              <span
                                className="end-card-marker"
                                style={{ left: "99%" }}
                              ></span>
                            )}

                            {(elem.action_event === "simple_reveal" || 
                              elem.action_event === "speech_bubble" || 
                              elem.action_event === "speech_bubble_2" || 
                              elem.action_event === "speech_bubble_3" || 
                              elem.action_event === "speech_bubble_4" || 
                              elem.action_event === "speech_thought" || 
                              elem.action_event === "border_animation" || 
                              elem.action_event === "border_animation_2" || 
                              elem.action_event === "lt_animation_1" || 
                              elem.action_event === "lt_animation_2" || 
                              elem.action_event === "lt_animation_3" || 
                              elem.action_event === "lt_animation_4" || 
                              elem.action_event === "lt_animation_5" || 
                              elem.action_event === "text_animation_1" || 
                              elem.action_event === "text_animation_2" || 
                              elem.action_event === "name_animation") && (
                              <span
                                className="end-card-marker"
                                style={{ left: getActioTime(elem.action_time) }}
                                title={elem.action_event}
                              ></span>
                            )}

                            {elem.action_event === "emoji_content" && (
                              <span
                                className="emoji-action-marker"
                                style={{ left: getActioTime(elem.action_time) }}
                              ></span>
                            )}
                          </div>
                        ))}
                    </div>
                  </div>
                  <div
                    id="chapterIndicatorId"
                    className="hp-indicator hide"
                  ></div>
                  <div className="player-progress">
                    <input
                      type="range"
                      // allowCross={true}
                      min={0}
                      max={1}
                      value={ytPlayer.played}
                      // value={ytPlayer.playedSeconds/ytPlayer.duration}
                      onMouseDown={handleSeekMouseDown}
                      onChange={handleSeekChange}
                      onMouseUp={handleSeekMouseUp}
                      step="any"
                      className="player-progress-input"
                    />
                    
                  </div>
                  <span className="player-currenttime">
                    {" "}
                    {format(Math.round(ytPlayer.duration * ytPlayer.played))}
                    /{" "}
                    {format(Math.round(ytPlayer.duration))}
                  </span>
                  <div className="actions-container pull-right">
                    <span
                      className="player-audio controls-btn"
                      id="videoVolumeBtn"
                    >
                      {!ytPlayer.muted ? (
                        <HiVolumeUp
                          className="text-white player-volume"
                          onClick={toggleYtMute}
                        />
                      ) : (
                        <HiVolumeOff
                          className="text-white player-volume"
                          onClick={toggleYtMute}
                        />
                      )}
                      <div className="volume-container">
                        <Slider
                          vertical
                          min={0}
                          max={1}
                          step={0.1}
                          onChange={handleYtAudioLevel}
                          defaultValue={ytPlayer.muted ? 0 : ytPlayer.volume}
                          value={
                            ytPlayer.muted ? 0 : ytPlayer.volume
                          }
                        />
                      </div>
                    </span>
                  </div>
                </div>
              </div>
              <div className="overlay-container-preview">
                {showMeetingLink && (
                  <div className="popup_sml d-flex align-items-center justify-content-center rounded">
                    <div className="row w-100">
                      <div className="col-xl-8 col-lg-8 col-md-10 m-auto text-center">
                        <p className="text-white text-center fw600 m-0 mb-4">
                          {videoMeetingData.fullname}
                        </p>
                        <p className="text-white text-center fw600 m-0 mb-4">
                          {videoMeetingData.designation}
                        </p>
                        <p></p>
                        <a
                          href="#!"
                          className="btn mt-4"
                          style={{
                            backgroundColor: videoMeetingData.buttonColor,
                          }}
                        >
                          {videoMeetingData.buttontext}
                        </a>
                      </div>
                    </div>
                  </div>
                )}
                {showCTA && (
                  <div className="popup_sml d-flex align-items-center justify-content-center rounded">
                    <div className="row w-100">
                      <div className="col-xl-8 col-lg-8 col-md-10 m-auto text-center">
                        {videoCTAData.formtype === "text" && (
                          <a
                            href="#!"
                            className="text-white text-center h2 fw600 m-0 d-block"
                          >
                            {videoCTAData.text}
                          </a>
                        )}
                        {videoCTAData.formtype === "image" && (
                          <a
                            href="#!"
                            className="text-white text-center fw600 m-0"
                          >
                            <img
                              src={videoCTAData.image}
                              alt={videoCTAData.link}
                              className="img-fluid"
                              style={{width: "192px"}}
                            />
                          </a>
                        )}
                        {videoCTAData.ctaSkipCheck && (
                          <button 
                            className="cta-player-skip" 
                            onClick={(e)=>{
                              setShowCTA(false)
                              setYtPlayer({...ytPlayer,playing:true})
                              setShowPreviewElem(true)
                            }}
                            
                          >
                            Skip <FaPlay />
                          </button>
                        )}
                  
                      </div>
                    </div>
                  </div>
                )}
                {showAnnotation &&
                  (annotationData.annotationLink.length > 0 ||
                    annotationData.annotationText.length > 0) && (
                    <div className="cta-player-annotation ">
                      <a
                        className="cta-player-annotation-link"
                        href="#!"
                        rel="noreferrer"
                      >
                        <label
                          className="cta-annotation-label"
                          id="ctaPlayerAnnotationLbl"
                        >
                          {annotationData.annotationText}
                        </label>
                      </a>
                    </div>
                  )}
                {showBuybutton &&
                  (buybuttonData.buybuttonLink.length > 0 ||
                    buybuttonData.buybuttonText.length > 0) && (

                    <div className="popup_sml2 d-flex align-items-center justify-content-center rounded" >
                      <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: buybuttonData.xPosition, y: buybuttonData.yPosition}}
                      >

                        <div className="freesoftware">
                          <div className="cl_1">
                            <h4>{buybuttonData.buybuttonText}</h4>
                            <p>{buybuttonData.buybuttonText2}</p>
                          </div>
                          <div className="cl_2">
                            <a 
                                href="#!"
                                rel="noreferrer">
                                  {buybuttonData.buybuttonText3}
                              </a>
                          </div>
                        </div>
                         
                      </Draggable>
                    </div>
                  )}

                {showLinkbutton2 &&
                  (linkbtn2Data.linkbtnLink.length > 0 ||
                    linkbtn2Data.linkbtnText.length > 0) && (

                    <div className="popup_sml2 d-flex align-items-center justify-content-center rounded" >
                      <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: linkbtn2Data.xPosition, y: linkbtn2Data.yPosition}}
                      >
                        <div className="coming_soon">
                          <h4>{linkbtn2Data.linkbtnText}</h4>
                          <p>{linkbtn2Data.linkbtnText2}</p>
                          <div className="last_rw">
                            <a 
                              href="#!"
                              rel="noreferrer" >{linkbtn2Data.linkbtnText3}</a>
                          </div>
                        </div> 
                          
                      </Draggable>
                    </div>
                  )}

                {showLinkbutton3 &&
                  (linkbtn3Data.linkbtnLink.length > 0 ||
                    linkbtn3Data.linkbtnText.length > 0) && (

                    <div className="popup_sml2 d-flex align-items-center justify-content-center rounded" >
                      <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: linkbtn3Data.xPosition, y: linkbtn3Data.yPosition}}
                      >
                        <div className="getfree">
                          <h4>{linkbtn3Data.linkbtnText}</h4>
                          <h5>{linkbtn3Data.linkbtnText2}</h5>
                          <div className="last_rw">
                            <a 
                              href="#!"
                              rel="noreferrer" >{linkbtn3Data.linkbtnText3}</a>
                          </div>
                        </div> 
                          
                      </Draggable>
                    </div>
                  )}

                {showLinkbutton4 &&
                  (linkbtn4Data.linkbtnLink.length > 0 ||
                    linkbtn4Data.linkbtnText.length > 0) && (

                    <div className="popup_sml2 d-flex align-items-center justify-content-center rounded" >
                      <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: linkbtn4Data.xPosition, y: linkbtn4Data.yPosition}}
                      >
                        <div className="gift_available">
                          <a className="d-flex"
                            href="#!"
                            rel="noreferrer" >
                            <i><img src={process.env.PUBLIC_URL +
                                    "/assets/images/gift.png"} alt="img" /></i>
                            <h5
                            className={` ${linkbtn4Data.text1Italic ? "font-italic" : ""}`}  
                            style={{ color: linkbtn4Data.text1FontColor, fontFamily: linkbtn4Data.text1FontFamily, fontWeight: linkbtn4Data.text1bold ? "700" : "500" }}
                            >{linkbtn4Data.linkbtnText}</h5>
                          </a>
                        </div> 
                      </Draggable>
                    </div>
                  )}
                
                {showLinkbutton5 &&
                  (linkbtn5Data.linkbtnLink.length > 0 ||
                    linkbtn5Data.linkbtnText.length > 0) && (

                    <div className="popup_sml4 d-flex align-items-end rounded" >
                      
                        <div className="quizze_4">
                          <div className="cl_1"> <h3>{linkbtn5Data.linkbtnText}</h3>
                            <p>{linkbtn5Data.linkbtnText2}</p>
                          </div> 
                          <div className="cl_2">
                            <a href="#!"
                            rel="noreferrer" 
                            className="btn">{linkbtn5Data.linkbtnText3}
                              <span> 
                                <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.4872 0.88757C6.4251 0.618499 6.15664 0.450711 5.88757 0.512804L1.50281 1.52467C1.23374 1.58677 1.06595 1.85523 1.12804 2.1243C1.19014 2.39337 1.4586 2.56116 1.72767 2.49906L5.62523 1.59963L6.52467 5.49719C6.58677 5.76626 6.85523 5.93405 7.1243 5.87196C7.39337 5.80986 7.56116 5.5414 7.49906 5.27233L6.4872 0.88757ZM1.424 9.265L6.424 1.265L5.576 0.735001L0.576001 8.735L1.424 9.265Z" fill="black"/>
                                </svg> 
                              </span> 
                            </a>
                          </div>
                        </div> 
                    </div>
                  )}
                
                {showLinkbutton6 &&
                    ( linkbtn6Data.linkbtnText.length > 0) && (
  
                      <div className="popup_sml4 d-flex align-items-center justify-content-center rounded" >
                        <Draggable 
                          bounds='parent'
                          onDrag = {DraggableEventHandler}
                          defaultPosition={{x: linkbtn6Data.xPosition, y: linkbtn6Data.yPosition}}
                        >
                           <div className="coming_soon2" style={{ backgroundColor: linkbtn6Data.bgcolor }}>
                              <h4 className={` ${linkbtn6Data.text1Italic ? "font-italic" : ""}`}  
                                  style={{ color: linkbtn6Data.text1FontColor, fontFamily: linkbtn6Data.text1FontFamily, fontWeight: linkbtn6Data.text1bold ? "800" : "500" }} 
                                >{linkbtn6Data.linkbtnText}</h4>
                              <p className={` ${linkbtn6Data.text2Italic ? "font-italic" : ""}`}  
                                  style={{ color: linkbtn6Data.text2FontColor, fontFamily: linkbtn6Data.text2FontFamily, fontWeight: linkbtn6Data.text2bold ? "700" : "400" }}
                                >{linkbtn6Data.linkbtnText2}</p>
                            <div className={`timer ${linkbtn6Data.text3Italic ? "font-italic" : ""}`}  
                                  style={{fontFamily: linkbtn6Data.text3FontFamily }}>
                              <ul>
                                <li className="day">
                                  <div className="number" style={{ color: linkbtn6Data.text3FontColor, fontWeight: linkbtn6Data.text3bold ? "700" : "400" }}>
                                    {String(timeLeft1.days).padStart(2, '0')}
                                  </div>
                                  <p style={{ color: linkbtn6Data.text3FontColor, fontWeight: linkbtn6Data.text3bold ? "700" : "400" }}>Day</p>
                                </li>
                                <li className="month">
                                  <div className="number" style={{ color: linkbtn6Data.text3FontColor, fontWeight: linkbtn6Data.text3bold ? "700" : "400" }}>
                                    {String(timeLeft1.hours).padStart(2, '0')}
                                  </div>
                                  <p style={{ color: linkbtn6Data.text3FontColor, fontWeight: linkbtn6Data.text3bold ? "700" : "400" }}>Hour</p>
                                </li>
                                <li className="hours">
                                  <div className="number" style={{ color: linkbtn6Data.text3FontColor, fontWeight: linkbtn6Data.text3bold ? "700" : "400" }}>
                                    {String(timeLeft1.mins).padStart(2, '0')}
                                  </div>
                                  <p style={{ color: linkbtn6Data.text3FontColor, fontWeight: linkbtn6Data.text3bold ? "700" : "400" }}>Minute</p>
                                </li>
                                <li className="sec">
                                  <div className="number" style={{ color: linkbtn6Data.text3FontColor, fontWeight: linkbtn6Data.text3bold ? "700" : "400" }}>
                                    {String(timeLeft1.sec).padStart(2, '0')}
                                  </div>
                                  <p style={{ color: linkbtn6Data.text3FontColor, fontWeight: linkbtn6Data.text3bold ? "700" : "400" }}>Sec</p>
                                </li>
                              </ul>
                            </div>
                          </div> 

                        </Draggable>
                      </div>
                    )}
                
                {showLinkbutton7 &&
                    ( linkbtn7Data.linkbtnText.length > 0) && (
  
                      <div className="popup_sml4 d-flex align-items-center justify-content-center rounded" >
                        <Draggable 
                          bounds='parent'
                          onDrag = {DraggableEventHandler}
                          defaultPosition={{x: linkbtn7Data.xPosition, y: linkbtn7Data.yPosition}}
                        >
                          <div className="main-container badge1">
                            <div className="header">
                              <header>{linkbtn7Data.googleRating} </header>
                              <div>
                              {getStarIcons(linkbtn7Data.googleRating)}
                              </div>
                            </div>
                            <div className="r_content">
                              <img
                                loading="lazy"
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/de2b90a3d26faf5f0e1abc52da8b835dfdf884d80e560d36a6dba0035f6d1098?apiKey=a520b1951fdc460185feff71c8ac30ff&"
                                className="image-2"
                                alt="img-r2"
                              />
                              <div className="reviews-link">
                                <a href="#!"  className="link">{linkbtn7Data.linkbtnText}</a>
                              </div>
                            </div>
                          </div> 

                        </Draggable>
                      </div>
                    )}
              
                {showLinkbutton8 && ( linkbtn8Data.design.length > 0 ) && (
  
                      <div className="popup_sml4 d-flex align-items-center justify-content-center rounded" >
                        <Draggable 
                          bounds='parent'
                          onDrag = {DraggableEventHandler}
                          defaultPosition={{x: linkbtn8Data.xPosition, y: linkbtn8Data.yPosition}}
                        >
                          <div className="social_media">
                          { linkbtn8Data.design === "design1" && (
                            <div className="social_media1 d-flex" >
                              
                              { linkbtn8Data.linkbtnLink1 && (
                                <a href="#!" rel="noreferrer" className="link">
                                  <img src={ process.env.PUBLIC_URL + "/assets/images/social/Group 153.png"} alt="img" />
                                </a>
                              )}
                              { linkbtn8Data.linkbtnLink2 && (
                                <a href="#!" rel="noreferrer" className="link">
                                  <img src={ process.env.PUBLIC_URL + "/assets/images/social/Group 152.png"} alt="img" />
                                </a>
                              )}
                              { linkbtn8Data.linkbtnLink3 && (
                                <a href="#!" rel="noreferrer" className="link">
                                  <img src={ process.env.PUBLIC_URL + "/assets/images/social/Group 151.png"} alt="img" />
                                </a>
                              )}
                              { linkbtn8Data.linkbtnLink4 && (
                                <a href="#!" rel="noreferrer" className="link">
                                  <img src={ process.env.PUBLIC_URL + "/assets/images/social/Group 150.png"} alt="img" />
                                </a>
                              )}
                            </div> 
                          )}

                          
                          { linkbtn8Data.design === "design2" && (
                            <div className="social_media2 d-flex" >

                              { linkbtn8Data.linkbtnLink1 && (
                                <a href="#!" rel="noreferrer" className="link">
                                  <img src={ process.env.PUBLIC_URL + "/assets/images/social/Group 166.png"} alt="img" />
                                </a>
                              )}
                              
                              { linkbtn8Data.linkbtnLink2 && (
                                <a href="#!" rel="noreferrer" className="link">
                                  <img src={ process.env.PUBLIC_URL + "/assets/images/social/Group 165.png"} alt="img" />
                                </a>
                              )}
                              { linkbtn8Data.linkbtnLink3 && (
                                <a href="#!" rel="noreferrer" className="link">
                                  <img src={ process.env.PUBLIC_URL + "/assets/images/social/Group 164.png"} alt="img" />
                                </a>
                              )}
                              { linkbtn8Data.linkbtnLink4 && (
                                <a href="#!" rel="noreferrer" className="link">
                                  <img src={ process.env.PUBLIC_URL + "/assets/images/social/Group 163.png"} alt="img" />
                                </a>
                              )}

                              
                              
                              
                              
                            </div> 
                          )}
                          
                          { linkbtn8Data.design === "design3" && (
                            <div className="social_media3 d-flex" >

                              { linkbtn8Data.linkbtnLink1 && (
                                <a href="#!" rel="noreferrer" className="link">
                                  <img src={ process.env.PUBLIC_URL + "/assets/images/social/Group 154.png"} alt="img" />
                                </a>
                              )}
                              
                              { linkbtn8Data.linkbtnLink2 && (
                                <a href="#!" rel="noreferrer" className="link">
                                  <img src={ process.env.PUBLIC_URL + "/assets/images/social/Group 161.png"} alt="img" />
                                </a>
                              )}
                              { linkbtn8Data.linkbtnLink3 && (
                                <a href="#!" rel="noreferrer" className="link">
                                  <img src={ process.env.PUBLIC_URL + "/assets/images/social/Group 160.png"} alt="img" />
                                </a>
                              )}
                              { linkbtn8Data.linkbtnLink4 && (
                                <a href="#!" rel="noreferrer" className="link">
                                  <img src={ process.env.PUBLIC_URL + "/assets/images/social/Group 157.png"} alt="img" />
                                </a>
                              )}
                              
                              
                              
                              
                            </div> 
                          )}
                          { linkbtn8Data.design === "design4" && (
                            <div className="social_media4 " >

                              { linkbtn8Data.linkbtnLink1 && (
                                <a href="#!" rel="noreferrer" className="link">
                                  <img src={ process.env.PUBLIC_URL + "/assets/images/social/Group 176.png"} alt="img" />
                                </a>
                              )}
                              { linkbtn8Data.linkbtnLink2 && (
                                <a href="#!" rel="noreferrer" className="link">
                                  <img src={ process.env.PUBLIC_URL + "/assets/images/social/Group 177.png"} alt="img" />
                                </a>
                              )}
                              { linkbtn8Data.linkbtnLink3 && (
                                <a href="#!" rel="noreferrer" className="link">
                                  <img src={ process.env.PUBLIC_URL + "/assets/images/social/Group 178.png"} alt="img" />
                                </a>
                              )}
                              { linkbtn8Data.linkbtnLink4 && (
                                <a href="#!" rel="noreferrer" className="link">
                                  <img src={ process.env.PUBLIC_URL + "/assets/images/social/Group 179.png"} alt="img" />
                                </a>
                              )}
                              
                              
                            </div> 
                          )}
                          { linkbtn8Data.design === "design5" && (
                            <div className="social_media5 " >

                              { linkbtn8Data.linkbtnLink1 && (
                                <a href="#!" rel="noreferrer" className="link">
                                  <img src={ process.env.PUBLIC_URL + "/assets/images/social/Group 180.png"} alt="img" />
                                </a>
                              )}
                              { linkbtn8Data.linkbtnLink2 && (
                                <a href="#!" rel="noreferrer" className="link">
                                  <img src={ process.env.PUBLIC_URL + "/assets/images/social/Group 181.png"} alt="img" />
                                </a>
                              )}
                              { linkbtn8Data.linkbtnLink3 && (
                                <a href="#!" rel="noreferrer" className="link">
                                  <img src={ process.env.PUBLIC_URL + "/assets/images/social/Group 182.png"} alt="img" />
                                </a>
                              )}
                              { linkbtn8Data.linkbtnLink4 && (
                                <a href="#!" rel="noreferrer" className="link">
                                  <img src={ process.env.PUBLIC_URL + "/assets/images/social/Group 183.png"} alt="img" />
                                </a>
                              )}
                              
                              
                              
                              
                            </div> 
                          )}
                          </div>
                          

                        </Draggable>
                      </div>
                    )}

                    {showLinkbutton9 && ( linkbtn9Data.linkbtnText3.length > 0 ) && (
                      
                      <div className="popup_sml4 d-flex align-items-center justify-content-center rounded" >
                        <Draggable 
                          bounds='parent'
                          onDrag = {DraggableEventHandler}
                          defaultPosition={{x: linkbtn9Data.xPosition, y: linkbtn9Data.yPosition}}
                        >
                          <div className="voucher1 voucher1_div">
                            <img
                              src="https://cdn.builder.io/api/v1/image/assets/TEMP/9dc77f158b1ffedfbf31e5c4955f31aacd1ed42cda3baa1f305a257cc9df6063?apiKey=a520b1951fdc460185feff71c8ac30ff&"
                              className="img"
                              alt="img"
                            />
                            <span className="voucher1_span">{linkbtn9Data.linkbtnText1}</span>
                            <span className="voucher1_span-2">
                              <span className="voucher1_span-3">
                                <div className="voucher1_div-2">{linkbtn9Data.linkbtnText2}</div>
                              </span>
                              <div className="voucher1_div-4">{linkbtn9Data.linkbtnText3}</div>
                            </span>
                            <img
                              src="https://cdn.builder.io/api/v1/image/assets%2F1f5dd16f9c7340a78670061018496826%2F628a39be94f449d99346886ebe781e51?width=100"
                              className="voucher1_img-2"
                              alt="img"
                            />
                            <div className="voucher1_div-5">1298383-E4839-34848</div>
                          </div>

                        </Draggable>
                      </div>
                    )}

                {showImgbtn1 &&
                  (Imgbtn1Data.ImgbtnLink.length > 0 ||
                    Imgbtn1Data.ImgbtnText.length > 0) && (

                    <div className="popup_sml2 d-flex align-items-center justify-content-center rounded" >
                      <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: Imgbtn1Data.xPosition, y: Imgbtn1Data.yPosition}}
                      >
                        <div className="scaling_your_site" style={{ backgroundColor: Imgbtn1Data.bgcolor}}>
                          <h5 
                          className={` ${Imgbtn1Data.text1Italic ? "font-italic" : ""}`}  
                          style={{  
                            color: Imgbtn1Data.text1FontColor, 
                            fontFamily: Imgbtn1Data.text1FontFamily, 
                            fontWeight: Imgbtn1Data.text1bold ? "700" : "500" }}
                            >{Imgbtn1Data.ImgbtnText}</h5>
                          <div className="site_pic">
                            <img src={Imgbtn1Data.ImgbtnURL} alt="img"/>
                          </div>
                          <div
                          className={`price ${Imgbtn1Data.text2Italic ? "font-italic" : ""}`}  
                          style={{  
                            color: Imgbtn1Data.text2FontColor, 
                            fontFamily: Imgbtn1Data.text2FontFamily, 
                            fontWeight: Imgbtn1Data.text2bold ? "600" : "400" 
                          }}
                          >{Imgbtn1Data.ImgbtnText2}</div>
                          <div className="btn_rw">
                            <a href="#!"
                              className={`${Imgbtn1Data.text3Italic ? "font-italic" : ""}`}  
                              style={{ 
                                backgroundColor: Imgbtn1Data.buybuttonbgcolor, 
                                color: Imgbtn1Data.text3FontColor, 
                                fontFamily: Imgbtn1Data.text3FontFamily, 
                                fontWeight: Imgbtn1Data.text3bold ? "700" : "500" 
                              }}
                              >{Imgbtn1Data.ImgbtnText3}</a></div>
                          <div 
                            className={`last_rw ${Imgbtn1Data.text4Italic ? "font-italic" : ""}`}  
                            style={{  
                              color: Imgbtn1Data.text4FontColor, 
                              fontFamily: Imgbtn1Data.text4FontFamily, 
                              fontWeight: Imgbtn1Data.text4bold ? "600" : "400" 
                            }}>{Imgbtn1Data.ImgbtnText4}</div>
                        </div>
                          
                      </Draggable>
                    </div>
                  )}
                
                {showImgbtn2 &&
                    ( Imgbtn2Data.ImgbtnText.length > 0) && (
  
                      <div className="popup_sml2 d-flex align-items-center justify-content-center rounded" >
                        <Draggable 
                          bounds='parent'
                          onDrag = {DraggableEventHandler}
                          defaultPosition={{x: Imgbtn2Data.xPosition, y: Imgbtn2Data.yPosition}}
                        >
                         
                          <div className="sacn_qr_code" style={{ backgroundColor: Imgbtn2Data.bgcolor}} >
                              <h4 
                              className={` ${Imgbtn2Data.text1Italic ? "font-italic" : ""}`}  
                              style={{  
                                color: Imgbtn2Data.text1FontColor, 
                                fontFamily: Imgbtn2Data.text1FontFamily, 
                                fontWeight: Imgbtn2Data.text1bold ? "800" : "500" }}
                              >{Imgbtn2Data.ImgbtnText}</h4>
                              <div className="qr_pic">
                                <img src={Imgbtn2Data.ImgbtnURL} alt="img"/>
                              </div>
                              <p 
                              className={` ${Imgbtn2Data.text2Italic ? "font-italic" : ""}`}  
                              style={{  
                                color: Imgbtn2Data.text2FontColor, 
                                fontFamily: Imgbtn2Data.text2FontFamily, 
                                fontWeight: Imgbtn2Data.text2bold ? "700" : "400" }}
                              >{Imgbtn2Data.ImgbtnText2}</p>
                          </div> 
                            
                        </Draggable>
                      </div>
                  )}
                
                {showImgbtn3 &&
                      (Imgbtn3Data.ImgbtnLink.length > 0 ||
                        Imgbtn3Data.ImgbtnText.length > 0) && (
    
                        <div className="popup_sml2 d-flex align-items-center justify-content-center rounded" >
                          <Draggable 
                            bounds='parent'
                            onDrag = {DraggableEventHandler}
                            defaultPosition={{x: Imgbtn3Data.xPosition, y: Imgbtn3Data.yPosition}}
                          >
                            
                            <div className="product_s_bx">
                              <div className="cl_1">
                                <img src={Imgbtn3Data.ImgbtnURL} alt="img" />
                              </div>
                              <div className="cl_2">
                              <div className="c_rw">
                              <p className={` ${Imgbtn3Data.text1Italic ? "font-italic" : ""}`}  
                                  style={{  
                                  color: Imgbtn3Data.text1FontColor, 
                                  fontFamily: Imgbtn3Data.text1FontFamily, 
                                  fontWeight: Imgbtn3Data.text1bold ? "700" : "400" }}
                                  >{Imgbtn3Data.ImgbtnText}</p>
                              <div 
                                  className={`price_p ${Imgbtn3Data.text2Italic ? "font-italic" : ""}`}  
                                  style={{  
                                  color: Imgbtn3Data.text2FontColor, 
                                  fontFamily: Imgbtn3Data.text2FontFamily, 
                                  fontWeight: Imgbtn3Data.text2bold ? "600" : "400" }}
                                  >{Imgbtn3Data.ImgbtnText2}</div>
                              </div>  
                              </div>
                            </div>
                            
                          </Draggable>
                        </div>
                  )}
                
                {showImgbtn4 &&
                      (Imgbtn4Data.ImgbtnURL.length > 0 ||
                        Imgbtn4Data.ImgbtnURL.length > 0) && (
    
                        <div className="popup_sml2 d-flex align-items-center justify-content-center rounded" >
                          <Draggable 
                            bounds='parent'
                            onDrag = {DraggableEventHandler}
                            defaultPosition={{x: Imgbtn4Data.xPosition, y: Imgbtn4Data.yPosition}}
                          >
                            
                            <div className="scan_qr_el" style={{ backgroundColor: Imgbtn4Data.bgcolor}}>
                              <div className="scan_qr_pic">
                                <img src={Imgbtn4Data.ImgbtnURL} alt="img" />
                                </div>
                              <div className="sacn_qr_bottom" style={{ backgroundColor: Imgbtn4Data.bgcolor2}}>
                              <div className="ic">
                                <img src={Imgbtn4Data.ImgbtnURL2} alt="img" />
                              </div>
                              <h4 className={` ${Imgbtn4Data.text1Italic ? "font-italic" : ""}`}  
                                  style={{  
                                  color: Imgbtn4Data.text1FontColor, 
                                  fontFamily: Imgbtn4Data.text1FontFamily, 
                                  fontWeight: Imgbtn4Data.text1bold ? "700" : "500" }}
                                  >{Imgbtn4Data.ImgbtnText}</h4>
                              </div>
                            </div>

                            

                            
                          </Draggable>
                        </div>
                  )}

                {showImgbtn5 &&
                  (Imgbtn5Data.ImgbtnLink.length > 0 ||
                    Imgbtn5Data.ImgbtnText.length > 0) && (

                    <div className="popup_sml2 d-flex align-items-center justify-content-center rounded" >
                      <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: Imgbtn5Data.xPosition, y: Imgbtn5Data.yPosition}}
                      >
                        
                        <div className="scaling_your_site2" style={{ backgroundColor: Imgbtn5Data.bgcolor}}>
                          <div className="timer"
                          style={{  
                            backgroundColor: Imgbtn5Data.timerbgcolor, 
                            fontFamily: Imgbtn5Data.text4FontFamily, 
                            color: Imgbtn5Data.text4FontColor }}
                            >
                            <ul>
                              <li className="day">
                                <div 
                                  className={`number ${Imgbtn5Data.text4Italic ? "font-italic" : ""}`} 
                                  style={{  
                                    color: Imgbtn5Data.text4FontColor,
                                    fontWeight: Imgbtn5Data.text4bold ? "700" : "400" 
                                  }}
                                >
                                  {String(timeLeft1.days).padStart(2, '0')}
                                </div>
                                <p 
                                  className={`${Imgbtn5Data.text4Italic ? "font-italic" : ""}`} 
                                  style={{  
                                    color: Imgbtn5Data.text4FontColor,
                                    fontWeight: Imgbtn5Data.text4bold ? "700" : "400" 
                                  }}
                                >
                                  Day
                                </p>
                              </li>
                              <li className="month">
                                <div 
                                  className={`number ${Imgbtn5Data.text4Italic ? "font-italic" : ""}`} 
                                  style={{  
                                    color: Imgbtn5Data.text4FontColor,
                                    fontWeight: Imgbtn5Data.text4bold ? "700" : "400" 
                                  }}
                                >
                                  {String(timeLeft1.hours).padStart(2, '0')}
                                </div>
                                <p 
                                  className={`${Imgbtn5Data.text4Italic ? "font-italic" : ""}`} 
                                  style={{  
                                    color: Imgbtn5Data.text4FontColor,
                                    fontWeight: Imgbtn5Data.text4bold ? "700" : "400" 
                                  }}
                                >
                                  Hour
                                </p>
                              </li>
                              <li className="hours">
                                <div 
                                  className={`number ${Imgbtn5Data.text4Italic ? "font-italic" : ""}`} 
                                  style={{  
                                    color: Imgbtn5Data.text4FontColor,
                                    fontWeight: Imgbtn5Data.text4bold ? "700" : "400" 
                                  }}
                                >
                                  {String(timeLeft1.mins).padStart(2, '0')}
                                </div>
                                <p 
                                  className={`${Imgbtn5Data.text4Italic ? "font-italic" : ""}`} 
                                  style={{  
                                    color: Imgbtn5Data.text4FontColor,
                                    fontWeight: Imgbtn5Data.text4bold ? "700" : "400" 
                                  }}
                                >
                                  Minute
                                </p>
                              </li>
                            </ul>
                        </div>
                          <h5  className={` ${Imgbtn5Data.text1Italic ? "font-italic" : ""}`}  
                          style={{  
                            color: Imgbtn5Data.text1FontColor, 
                            fontFamily: Imgbtn5Data.text1FontFamily, 
                            fontWeight: Imgbtn5Data.text1bold ? "700" : "500" }} > {Imgbtn5Data.ImgbtnText}</h5>

                          <div className="site_pic"><img src={Imgbtn5Data.ImgbtnURL} alt="img" /></div>
                          <div 
                            className={`price ${Imgbtn5Data.text2Italic ? "font-italic" : ""}`}  
                            style={{  
                              color: Imgbtn5Data.text2FontColor, 
                              fontFamily: Imgbtn5Data.text2FontFamily, 
                              fontWeight: Imgbtn5Data.text2bold ? "600" : "400" 
                            }}
                          >
                            {Imgbtn5Data.ImgbtnText2}
                          </div>
                          <div className="btn_rw">
                            <a 
                              href="#!"
                              rel="noreferrer"
                              className={`${Imgbtn5Data.text3Italic ? "font-italic" : ""}`}  
                              style={{ 
                                backgroundColor: Imgbtn5Data.buybuttonbgcolor, 
                                color: Imgbtn5Data.text3FontColor, 
                                fontFamily: Imgbtn5Data.text3FontFamily, 
                                fontWeight: Imgbtn5Data.text3bold ? "700" : "500" 
                              }}
                            >
                              {Imgbtn5Data.ImgbtnText3}
                            </a></div>
                          <div 
                            className={`last_rw ${Imgbtn5Data.text5Italic ? "font-italic" : ""}`}  
                            style={{  
                              color: Imgbtn5Data.text5FontColor, 
                              fontFamily: Imgbtn5Data.text5FontFamily, 
                              fontWeight: Imgbtn5Data.text5bold ? "700" : "500" 
                            }}
                          >
                            {Imgbtn5Data.ImgbtnText4}
                          </div>
                        </div> 
                          
                      </Draggable>
                    </div>
                  )}
                
                {showImgbtn6 &&
                  (Imgbtn6Data.ImgbtnText.length > 0) && (

                    <div className="popup_sml2 d-flex align-items-center justify-content-center rounded" >
                      <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: Imgbtn6Data.xPosition, y: Imgbtn6Data.yPosition}}
                      >
                        
                        <div className="menu1_div menu_1" style={{ backgroundColor: Imgbtn6Data.bgColor }} >

                          <a 
                            href="#!"
                            rel="noreferrer"  >
                            <img
                              src={ Imgbtn6Data.ImgbtnURL} 
                              alt="img"
                              className="menu1_img"
                            />
                          
                            <span className="menu1_span"  >
                              <span className="menu1_span-2">
                                <div 
                                  className={`menu1_div-2 ${Imgbtn6Data.text1Italic ? "font-italic" : ""}`}  
                                  style={{ color: Imgbtn6Data.text1FontColor, fontFamily: Imgbtn6Data.text1FontFamily, fontWeight: Imgbtn6Data.text1bold ? "700" : "500" }}
                                >{Imgbtn6Data.ImgbtnText}</div>
                                <span 
                                  className={`menu1_span-3 ${Imgbtn6Data.text3Italic ? "font-italic" : ""}`}  
                                  style={{ backgroundColor: Imgbtn6Data.buttonColor , color: Imgbtn6Data.text3FontColor, fontFamily: Imgbtn6Data.text3FontFamily, fontWeight: Imgbtn6Data.text3bold ? "700" : "500" }} >{Imgbtn6Data.ImgbtnText3}</span>
                              </span>
                              <div 
                                  className={`menu1_div-3 ${Imgbtn6Data.text2Italic ? "font-italic" : ""}`}  
                                style={{ color: Imgbtn6Data.text2FontColor, fontFamily: Imgbtn6Data.text2FontFamily, fontWeight: Imgbtn6Data.text2bold ? "700" : "500" }}
                              >{Imgbtn6Data.ImgbtnText2}</div>
                            </span>
                          </a>
                        </div>
                          
                      </Draggable>
                    </div>
                  )}
                  
                {showImgbtn7 &&
                  (Imgbtn7Data.ImgbtnText.length > 0) && (

                    <div className="popup_sml2 d-flex align-items-center justify-content-center rounded" >
                      <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: Imgbtn7Data.xPosition, y: Imgbtn7Data.yPosition}}
                      >
                        
                        <div className="menu2_div menu_2">
                          <a 
                            className=""
                            href="#!"
                            rel="noreferrer"  >

                            <img
                              loading="lazy"
                              src={ Imgbtn7Data.ImgbtnURL} 
                              alt="img-2"
                              className="menu2_img "
                            />
                            <span className="menu2_span">
                              <div 
                                className={`menu2_div-2 ${Imgbtn7Data.text1Italic ? "font-italic" : ""}`}  
                                style={{ color: Imgbtn7Data.text1FontColor, fontFamily: Imgbtn7Data.text1FontFamily, fontWeight: Imgbtn7Data.text1bold ? "600" : "400" }}
                              
                              >{Imgbtn7Data.ImgbtnText}</div>
                              <div 
                                className={`menu2_div-3 ${Imgbtn7Data.text2Italic ? "font-italic" : ""}`}  
                                style={{ color: Imgbtn7Data.text2FontColor, fontFamily: Imgbtn7Data.text2FontFamily, fontWeight: Imgbtn7Data.text2bold ? "600" : "400" }}
                              >{Imgbtn7Data.ImgbtnText2}</div>
                            </span>
                          </a>
                        </div>
                          
                      </Draggable>
                    </div>
                  )}
                
                {showImgbtn8 &&
                  (Imgbtn8Data.ImgbtnText.length > 0) && (

                    <div className="popup_sml2 d-flex align-items-center justify-content-center rounded" >
                      <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: Imgbtn8Data.xPosition, y: Imgbtn8Data.yPosition}}
                      >
                        <div className="social_div_1 social_element_1">
                          <div className="social_1_div" style={{backgroundColor: Imgbtn8Data.bgcolor1}}>
                            <span className="social_1_span" style={{backgroundColor: Imgbtn8Data.bgcolor2}} >
                              <div
                              className={`social_1_div-2 ${Imgbtn8Data.text1Italic ? "font-italic" : ""}`}  
                              style={{ color: Imgbtn8Data.text1FontColor, fontFamily: Imgbtn8Data.text1FontFamily, fontWeight: Imgbtn8Data.text1bold ? "800" : "500" }}
                              >{Imgbtn8Data.ImgbtnText}</div>
                              <img
                                src={Imgbtn8Data.ImgbtnURL}
                                className="social_1_img"
                                alt="img"
                              />
                            </span>
                            <a href="#!" className="d-flex flex-direction-column">
                              <span
                              className={`social_1_span-2 ${Imgbtn8Data.text2Italic ? "font-italic" : ""}`}  
                              style={{ backgroundColor: Imgbtn8Data.bgcolor3, color: Imgbtn8Data.text2FontColor, fontFamily: Imgbtn8Data.text2FontFamily, fontWeight: Imgbtn8Data.text2bold ? "700" : "500" }}
                              >{Imgbtn8Data.ImgbtnText2}</span>
                            </a>
                            
                          </div>
                        </div>
                        
                          
                      </Draggable>
                    </div>
                  )}

                {showCopyPaste && (
                  <div
                    className="popup_sml d-flex align-items-center justify-content-center rounded"
                    style={{
                      background: `${
                        copyPasteData.bgCRMTheme ? "#000000b3" : "#ffffffb3"
                      }`,
                    }}
                  >
                    <div
                      className="crmForm"
                      dangerouslySetInnerHTML={{
                        __html: copyPasteData.CRMHtmlText,
                      }}
                    ></div>
                    {copyPasteData.CRMskipCheck && (
                      <button
                        className={`cta-player-skip ${
                          !copyPasteData.bgCRMTheme ? "cta-skip-inverse" : ""
                        }`}
                        onClick={(e)=>{
                          setShowCopyPaste(false)
                          setYtPlayer({...ytPlayer,playing:true})
                          setShowPreviewElem(true)
                        }}
                      >
                        Skip <FaPlay />
                      </button>
                    )}
                  </div>
                )}
                {showLeadGenForm && (
                  <div className="popup_sml d-flex align-items-center">
                    <div className="row">
                      <div className="col-xl-7 col-lg-8 col-md-10 m-auto">
                        <h5 className="text-white text-center fw600">
                          {leadgenFormData.headline}
                        </h5>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <input
                              type="text"
                              className="form-control p_holder textbx2 shadow-none h35 border-0"
                              placeholder="First Name"
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <input
                              type="text"
                              className="form-control p_holder textbx2 shadow-none h35 border-0"
                              placeholder="Last Name"
                            />
                          </div>
                          {leadgenFormData.askcompanychk &&
                            leadgenFormData.askphonechk && (
                              <>
                                <div className="col-md-6 mb-3">
                                  <input
                                    type="text"
                                    className="form-control p_holder textbx2 shadow-none h35 border-0"
                                    placeholder="Phone Number"
                                  />
                                </div>
                                <div className="col-md-6 mb-3">
                                  <input
                                    type="text"
                                    className="form-control p_holder textbx2 shadow-none h35 border-0"
                                    placeholder="Company Name"
                                  />
                                </div>
                                <div className="col-md-12 mb-3">
                                  <input
                                    type="text"
                                    className="form-control p_holder textbx2 shadow-none h35 border-0"
                                    placeholder="Email address"
                                  />
                                </div>
                              </>
                            )}
                          {leadgenFormData.askcompanychk &&
                            !leadgenFormData.askphonechk && (
                              <>
                                <div className="col-md-6 mb-3">
                                  <input
                                    type="text"
                                    className="form-control p_holder textbx2 shadow-none h35 border-0"
                                    placeholder="Company Name"
                                  />
                                </div>
                                <div className="col-md-6 mb-3">
                                  <input
                                    type="text"
                                    className="form-control p_holder textbx2 shadow-none h35 border-0"
                                    placeholder="Email address"
                                  />
                                </div>
                              </>
                            )}
                          {!leadgenFormData.askcompanychk &&
                            leadgenFormData.askphonechk && (
                              <>
                                <div className="col-md-6 mb-3">
                                  <input
                                    type="text"
                                    className="form-control p_holder textbx2 shadow-none h35 border-0"
                                    placeholder="Phone Number"
                                  />
                                </div>
                                <div className="col-md-6 mb-3">
                                  <input
                                    type="text"
                                    className="form-control p_holder textbx2 shadow-none h35 border-0"
                                    placeholder="Email address"
                                  />
                                </div>
                              </>
                            )}
                          {!leadgenFormData.askcompanychk &&
                            !leadgenFormData.askphonechk && (
                              <div className="col-md-12 mb-3">
                                <input
                                  type="text"
                                  className="form-control p_holder textbx2 shadow-none h35 border-0"
                                  placeholder="Email address"
                                />
                              </div>
                            )}
                          <div className="col-md-12 mb-3 text-center">
                            <input
                              style={{ backgroundColor: leadgenFormData.buttonColor }}
                              type="button"
                              className="btn btn1 min_w150" 
                              value={leadgenFormData.buttonname}
                            />
                          </div>
                          <p className="text-white h6 text-center">
                            {leadgenFormData.note}
                          </p>
                        </div>
                        {leadgenFormData.leadgenSkipCheck && (
                          <button 
                            className="cta-player-skip" 
                            onClick={(e)=>{
                              setShowLeadGenForm(false)
                              setYtPlayer({...ytPlayer,playing:true})
                              setShowPreviewElem(true)
                            }}
                          >
                            Skip <FaPlay />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {showLeadGen2Form && (
                  <div className="popup_sml4 d-flex align-items-center">
                    <div className="quizze_6" style={{ backgroundColor: leadgen2FormData.bgcolor1}}> 
                      <h3
                      className={` ${leadgen2FormData.text1Italic ? "font-italic" : ""}`}  
                      style={{ color: leadgen2FormData.text1FontColor, fontFamily: leadgen2FormData.text1FontFamily, fontWeight: leadgen2FormData.text1bold ? "700" : "500" }}
                      >{leadgen2FormData.headline}</h3>
                      <p
                      className={` ${leadgen2FormData.text2Italic ? "font-italic" : ""}`}  
                      style={{ color: leadgen2FormData.text2FontColor, fontFamily: leadgen2FormData.text2FontFamily, fontWeight: leadgen2FormData.text2bold ? "700" : "500" }}
                      >{leadgen2FormData.note}</p> 
                      
                      <div className="form_rw">
                        <input type="text"  name="name" placeholder="Name" className="text_bx" />
                        <input type="text"  name="email" placeholder="Email" className="text_bx" />
                      </div>
                      <input type="text"  name="number" placeholder="Number" className="text_bx" />
                      
                      {leadgen2FormData.hideterms ? "" : 
                        <div className="term_c"> 
                          <div className="form-check">
                            <input className="form-check-input" type="checkbox" value="" id="agreeto2" />
                            <label className="form-check-label" htmlFor="agreeto2"></label>
                          </div>
                          <div className="agreeto">
                            <a className={` ${leadgen2FormData.text3Italic ? "font-italic" : ""}`}  
                                style={{ color: leadgen2FormData.text3FontColor, fontFamily: leadgen2FormData.text3FontFamily, fontWeight: leadgen2FormData.text3bold ? "700" : "500" }}
                                href="#!" 
                                rel="noreferrer"  
                                >{leadgen2FormData.termsText}
                            </a>
                          </div>
                        </div>
                      }
                        
                      
                      <button 
                        type="button" 
                        className={`btn ${leadgen2FormData.text4Italic ? "font-italic" : ""}`}  
                        style={{ backgroundColor: leadgen2FormData.bgcolor2,  color: leadgen2FormData.text4FontColor, fontFamily: leadgen2FormData.text4FontFamily, fontWeight: leadgen2FormData.text4bold ? "700" : "500" }} > 
                      {leadgen2FormData.buttonname} 
                        <span> 
                          <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.4872 0.88757C6.4251 0.618499 6.15664 0.450711 5.88757 0.512804L1.50281 1.52467C1.23374 1.58677 1.06595 1.85523 1.12804 2.1243C1.19014 2.39337 1.4586 2.56116 1.72767 2.49906L5.62523 1.59963L6.52467 5.49719C6.58677 5.76626 6.85523 5.93405 7.1243 5.87196C7.39337 5.80986 7.56116 5.5414 7.49906 5.27233L6.4872 0.88757ZM1.424 9.265L6.424 1.265L5.576 0.735001L0.576001 8.735L1.424 9.265Z" fill="black"/>
                          </svg> 
                        </span>
                      </button>
                      
                    </div> 


                    {leadgen2FormData.leadgenSkipCheck && (
                          <button 
                            className="cta-player-skip" 
                            onClick={(e)=>{
                              setShowLeadGenForm(false)
                              setYtPlayer({...ytPlayer,playing:true})
                              setShowPreviewElem(true)
                            }}
                          >
                            Skip <FaPlay />
                          </button>
                    )}
                    
                  </div>
                )}

                {showCustomPoll && (
                  <div className="popup_sml d-flex align-items-center justify-content-center rounded">
                    <div className="row w-100">
                      <div className="col-xl-8 col-lg-8 col-md-10 m-auto">
                        <h6 className="text-white text-center fw600 font17 mb-3">
                          {custPollData.question}
                        </h6>
                        <div className="row">
                          <div className={`col-md-12 mb-3 text-center`}>
                            <input
                              type="button"
                              className="btn btn1 w-100 shadow-none rounded-pill"
                              value={custPollData.option1}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className={`col-md-12 mb-3 text-center`}>
                            <input
                              type="button"
                              className="btn btn1 lightbtn w-100 shadow-none rounded-pill"
                              value={custPollData.option2}
                            />
                          </div>
                        </div>
                        {custPollData.option3 && (
                          <div className="row">
                            <div className="col-md-12 text-center mb-3">
                              <input
                                type="button"
                                className="btn btn1 lightbtn w-100 shadow-none rounded-pill"
                                value={custPollData.option3}
                              />
                            </div>
                          </div>
                        )}

                        {custPollData.pollSkipChk && (
                          <button 
                            className="cta-player-skip" 
                            onClick={(e)=>{
                              setShowCustomPoll(false)
                              setYtPlayer({...ytPlayer,playing:true})
                              setShowPreviewElem(true)
                            }}
                          >
                            Skip <FaPlay />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {showCustom2Poll && (
                  <div className="popup_sml2 d-flex align-items-center justify-content-center rounded">

                    <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: cust2PollData.xPosition, y: cust2PollData.yPosition}}
                    >
                    <div className="ebook_unlocked">
                      <h5>{cust2PollData.question}</h5>
                      <ul>
                        <li>
                          <div className="eb_radio"> 
                           <input className="form-check-input" type="radio" name="flexRadio" id="flexRadio1" />
                            <label className="form-check-label" htmlFor="flexRadio1">{cust2PollData.option1}</label>
                          </div>
                        </li>
                        <li>
                          <div className="eb_radio"> 
                           <input className="form-check-input" type="radio" name="flexRadio" id="flexRadio2" />
                            <label className="form-check-label" htmlFor="flexRadio2">{cust2PollData.option2}</label>
                          </div>
                        </li>
                        {cust2PollData.option3 && (<li>
                          <div className="eb_radio"> 
                           <input className="form-check-input" type="radio" name="flexRadio" id="flexRadio3" />
                            <label className="form-check-label" htmlFor="flexRadio3">{cust2PollData.option3}</label>
                          </div>
                        </li>)}
                        {cust2PollData.option4 && (<li>
                          <div className="eb_radio"> 
                           <input className="form-check-input" type="radio" name="flexRadio" id="flexRadio4" />
                            <label className="form-check-label" htmlFor="flexRadio4">{cust2PollData.option4}</label>
                          </div>
                        </li>)}
                      </ul>
                    </div>
                    </Draggable>


                    <div className="row w-100">
                      <div className="col-xl-8 col-lg-8 col-md-10 m-auto">
                        
                        {cust2PollData.pollSkipChk && (
                          <button 
                            className="cta-player-skip" 
                            onClick={(e)=>{
                              setShowCustom2Poll(false)
                              setYtPlayer({...ytPlayer,playing:true})
                              setShowPreviewElem(true)
                            }}
                          >
                            Skip <FaPlay />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {showCustom3Poll && (
                  <div className="popup_sml3">
                    
                    {/* <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: cust2PollData.xPosition, y: cust2PollData.yPosition}}
                    > */}

                    <div className="quizze_2">
                        <h3>{cust3PollData.question}</h3>
                        <p>{cust3PollData.polldesc}</p>
                        <ul>
                          <li>
                          <div className="eb_radio"> 
                          <input className="form-check-input" type="radio" name="flexRadio" id="QflexRadio5" />
                            <label className="form-check-label" htmlFor="QflexRadio5">
                              <span className="cr_text">A</span> {cust3PollData.option1}</label>
                          </div>
                        </li>
                        <li>
                          <div className="eb_radio"> 
                          <input className="form-check-input" type="radio" name="flexRadio" id="QflexRadio6" />
                            <label className="form-check-label" htmlFor="QflexRadio6">
                              <span className="cr_text">B</span> {cust3PollData.option2}</label>
                          </div>
                        </li>
                        <li>
                          <div className="eb_radio">
                             <input className="form-check-input" type="radio" name="flexRadio" id="QflexRadio7" />
                            <label className="form-check-label" htmlFor="QflexRadio7">
                              <span className="cr_text">C</span> {cust3PollData.option3}</label>
                          </div>
                        </li>
                        <li>
                          <div className="eb_radio"> 
                          <input className="form-check-input" type="radio" name="flexRadio" id="QflexRadio8" />
                            <label className="form-check-label" htmlFor="QflexRadio8">
                              <span className="cr_text">D</span> {cust3PollData.option4}</label>
                          </div>
                        </li>
                          </ul>
                    </div>
                  {/* </Draggable> */}

                    <div className="row w-100">
                      <div className="col-xl-8 col-lg-8 col-md-10 m-auto">
                        
                        {cust3PollData.pollSkipChk && (
                          <button 
                            className="cta-player-skip" 
                            onClick={(e)=>{
                              setShowCustom3Poll(false)
                              setYtPlayer({...ytPlayer,playing:true})
                              setShowPreviewElem(true)
                            }}
                          >
                            Skip <FaPlay />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                
                {showopentable1 && (
                  <div className="popup_sml4 ">
                    
                    <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: opentable1Data.xPosition, y: opentable1Data.yPosition}}
                    >
                    <div className="find_dream_home3" style={{   backgroundColor: opentable1Data.bgcolor}} >
                      <div className="title_rw">
                        <h3 
                          className={` ${opentable1Data.text1Italic ? "font-italic" : ""}`}  
                          style={{ color: opentable1Data.text1FontColor, fontFamily: opentable1Data.text1FontFamily, fontWeight: opentable1Data.text1bold ? "600" : "400" }}
                          >{opentable1Data.opentableText}</h3>
                        <p 
                          className={` ${opentable1Data.text2Italic ? "font-italic" : ""}`}  
                          style={{ color: opentable1Data.text2FontColor, fontFamily: opentable1Data.text2FontFamily, fontWeight: opentable1Data.text2bold ? "600" : "400" }}
                          >{opentable1Data.opentableText2}</p>
                      </div>
                      
                      <div className="fdh_form" >
                      <div className="cl_1">
                        <span className="ic d-none">
                          <img src={ process.env.PUBLIC_URL + "/assets/images/calendar2.png" } alt="img" />
                        </span>
                        <input type="date" className="text_bx" />
                        {/* <select name="" className="selectbx">
                            <option>Dec, 22, 2024</option>
                        </select> */}
                      </div>
                      <div className="cl_2">
                        <span className="ic">
                          <img src={ process.env.PUBLIC_URL + "/assets/images/time2.png" } alt="img" />
                        </span>
                        <select name="" className="selectbx">
                            <option value="2000-02-01T00:00:00">12:00 AM</option>
                            <option value="2000-02-01T00:30:00">12:30 AM</option>
                            <option value="2000-02-01T01:00:00">1:00 AM</option>
                            <option value="2000-02-01T01:30:00">1:30 AM</option>
                            <option value="2000-02-01T02:00:00">2:00 AM</option>
                            <option value="2000-02-01T02:30:00">2:30 AM</option>
                            <option value="2000-02-01T03:00:00">3:00 AM</option>
                            <option value="2000-02-01T03:30:00">3:30 AM</option>
                            <option value="2000-02-01T04:00:00">4:00 AM</option>
                            <option value="2000-02-01T04:30:00">4:30 AM</option>
                            <option value="2000-02-01T05:00:00">5:00 AM</option>
                            <option value="2000-02-01T05:30:00">5:30 AM</option>
                            <option value="2000-02-01T06:00:00">6:00 AM</option>
                            <option value="2000-02-01T06:30:00">6:30 AM</option>
                            <option value="2000-02-01T07:00:00">7:00 AM</option>
                            <option value="2000-02-01T07:30:00">7:30 AM</option>
                            <option value="2000-02-01T08:00:00">8:00 AM</option>
                            <option value="2000-02-01T08:30:00">8:30 AM</option>
                            <option value="2000-02-01T09:00:00">9:00 AM</option>
                            <option value="2000-02-01T09:30:00">9:30 AM</option>
                            <option value="2000-02-01T10:00:00">10:00 AM</option>
                            <option value="2000-02-01T10:30:00">10:30 AM</option>
                            <option value="2000-02-01T11:00:00">11:00 AM</option>
                            <option value="2000-02-01T11:30:00">11:30 AM</option>
                            <option value="2000-02-01T12:00:00">12:00 PM</option>
                            <option value="2000-02-01T12:30:00">12:30 PM</option>
                            <option value="2000-02-01T13:00:00">1:00 PM</option>
                            <option value="2000-02-01T13:30:00">1:30 PM</option>
                            <option value="2000-02-01T14:00:00">2:00 PM</option>
                            <option value="2000-02-01T14:30:00">2:30 PM</option>
                            <option value="2000-02-01T15:00:00">3:00 PM</option>
                            <option value="2000-02-01T15:30:00">3:30 PM</option>
                            <option value="2000-02-01T16:00:00">4:00 PM</option>
                            <option value="2000-02-01T16:30:00">4:30 PM</option>
                            <option value="2000-02-01T17:00:00">5:00 PM</option>
                            <option value="2000-02-01T17:30:00">5:30 PM</option>
                            <option value="2000-02-01T18:00:00">6:00 PM</option>
                            <option value="2000-02-01T18:30:00">6:30 PM</option>
                            <option value="2000-02-01T19:00:00">7:00 PM</option>
                            <option value="2000-02-01T19:30:00">7:30 PM</option>
                            <option value="2000-02-01T20:00:00">8:00 PM</option>
                            <option value="2000-02-01T20:30:00">8:30 PM</option>
                            <option value="2000-02-01T21:00:00">9:00 PM</option>
                            <option value="2000-02-01T21:30:00">9:30 PM</option>
                            <option value="2000-02-01T22:00:00">10:00 PM</option>
                            <option value="2000-02-01T22:30:00">10:30 PM</option>
                            <option value="2000-02-01T23:00:00">11:00 PM</option>
                            <option value="2000-02-01T23:30:00">11:30 PM</option>
                        </select>
                      </div>
                      <div className="cl_3">
                        <span className="ic">
                          <img src={ process.env.PUBLIC_URL + "/assets/images/user2.png" } alt="img" />
                        </span>  
                        <select name="" className="selectbx">
                            <option>1 people</option>
                            <option>2 people</option>
                            <option>3 people</option>
                            <option>4 people</option>
                            <option>5 people</option>
                            <option>6 people</option>
                            <option>7 people</option>
                            <option>8 people</option>
                            <option>9 people</option>
                            <option>10 people</option>
                        </select>
                      </div>
                      <div className="cl_4">
                        <input 
                          type="button" 
                          className={`btn ${opentable1Data.text3Italic ? "font-italic" : ""}`}  
                          style={{ 
                            backgroundColor: opentable1Data.submitbgcolor,
                            color: opentable1Data.text3FontColor, 
                            fontFamily: opentable1Data.text3FontFamily, 
                            fontWeight: opentable1Data.text3bold ? "600" : "400" }}
                          value={opentable1Data.opentableText3} />
                      </div>
                      </div>

                    </div>  

                    </Draggable>

                    <div className="row w-100">
                      <div className="col-xl-8 col-lg-8 col-md-10 m-auto">
                        
                        {opentable1Data.pollSkipChk && (
                          <button 
                            className="cta-player-skip" 
                            onClick={(e)=>{
                              setShowopentable1(false)
                              setYtPlayer({...ytPlayer,playing:true})
                              setShowPreviewElem(true)
                            }}
                          >
                            Skip <FaPlay />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {showReview1 && (
                  <div className="popup_sml4 d-flex align-items-center justify-content-center rounded">
                    
                    <Draggable 
                      bounds='parent'
                      onDrag = {DraggableEventHandler}
                      defaultPosition={{x: review1Data.xPosition, y: review1Data.yPosition}}
                    >
                      <div className="div review_1">
                        <div className="div-2">
                          <div className="column">
                            <div className="div-3">
                              <div className="div-4">
                                <img
                                  loading="lazy"
                                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/d00302103bcb793c568c784c063d011572e81ef6f6a27b0046d3ecc2c68d38c5?apiKey=a520b1951fdc460185feff71c8ac30ff&"
                                  className="img"
                                  alt="img"
                                />
                                <div className="div-5">AI-Generated Summary</div>
                              </div>
                              <div className="div-6">
                                
                              </div>
                              {/* <div  className="star-icons">
                                {getStarIcons(5,review1Data.source)}
                              </div> */}
                              <img
                                loading="lazy" 
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/77e5e289e9cb1cc233d53e715c2b08447b0bd35b0561b422865072fe7afcdfc3?apiKey=a520b1951fdc460185feff71c8ac30ff&"
                                className="img-2"
                                alt="img-2"
                              />
                              <div className="div-7">
                                <img
                                  loading="lazy"
                                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/1eadcbd30955eee0875027d8862d8bee6d246660cd9bf49b6b4091bddf520f56?apiKey=a520b1951fdc460185feff71c8ac30ff&"
                                  className="img-3"
                                  alt="img-3"
                                />
                                <div className="div-8">{review1Data.summery1}</div>
                              </div>
                              <div className="div-9">
                                <img
                                  loading="lazy"
                                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/db76dfccae8ea13ffe02ee5827f23407dd46a60cbed5220428cc888e533702f4?apiKey=a520b1951fdc460185feff71c8ac30ff&"
                                  className="img-4"
                                  alt="img-4"
                                />
                                <div className="div-10">{review1Data.summery2}</div>
                              </div>
                              <div className="div-11">
                                <img
                                  loading="lazy"
                                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/db76dfccae8ea13ffe02ee5827f23407dd46a60cbed5220428cc888e533702f4?apiKey=a520b1951fdc460185feff71c8ac30ff&"
                                  className="img-5"
                                  alt="img-5"
                                />
                                <div className="div-12">{review1Data.summery3}</div>
                              </div>
                            </div>
                          </div>
                          <div className="column-2">
                            <div className="div-13">
                              <div className="div-14">
                                <img
                                  loading="lazy"
                                  srcSet={review1Data.auth_profile_url}
                                  className={`img-6  ${review1Data.source}-profile-img`}
                                  alt="img-6"
                                />
                                <div className="div-15">
                                  <div className="div-16">
                                    <div className="div-17">{review1Data.author_name}</div>
                                    <img
                                      loading="lazy"
                                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/93ce251bb364c82a49369965f68c10e6ea05c3836078e7940a45c723d2ad5c44?apiKey=a520b1951fdc460185feff71c8ac30ff&"
                                      className="img-7"
                                      alt="img-7"
                                    />
                                  </div>
                                  <div className="div-18">{review1Data.time_description}</div>
                                </div>
                              </div>
                              <div  className="star-icons">
                                {getStarIcons(review1Data.rating,review1Data.source)}
                              </div>
                              <div className="div-19">
                                {review1Data.reviewText}
                              </div>
                              <img
                                src={review1Data.source_logo}
                                className="img-9"
                                alt="img-9"
                              />
                            </div>
                          </div>
                          <div className="column-3">
                            <div className="div-20">
                              <div className="div-21">
                                <img
                                  loading="lazy"
                                  srcSet={review1Data.auth_profile_url2}
                                  className={`img-10  ${review1Data.source}-profile-img`}
                                  alt="img-10"
                                />
                                <div className="div-22">
                                  <div className="div-23">
                                    <div className="div-24">{review1Data.author_name2}</div>
                                    <img
                                      loading="lazy"
                                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/93ce251bb364c82a49369965f68c10e6ea05c3836078e7940a45c723d2ad5c44?apiKey=a520b1951fdc460185feff71c8ac30ff&"
                                      className="img-11"
                                      alt="img-11"
                                    />
                                  </div>
                                  <div className="div-25">{review1Data.time_description2}</div>
                                </div>
                              </div>
                              <div  className="star-icons">
                                      {getStarIcons(review1Data.rating2,review1Data.source )}
                              </div>
                              <div className="div-26">
                              {review1Data.reviewText2}
                              </div>
                              <img
                                src={review1Data.source_logo}
                                className="img-13"
                                alt="img-13"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                    </Draggable>
                  </div>
                )}

                {(showAnimation && showAnimation.nameAnim) && (
                  <div className={`popup_sml d-flex align-items-center justify-content-center rounded bg-transparent animate__animated ${showAnimation.animationType}`}>
                    
                    <Draggable 
                      bounds='parent'
                      onDrag = {DraggableEventHandler}
                      defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                    >
                      <div className="name-animation-container-resize">
                        <Resizable
                          style={style}
                          size={{ width, height }}
                          onResizeStop={(e, direction, ref, d) => {
                            setWidth(width + d.width);
                            setHeight(height + d.height);
                            setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                          }}
                          minWidth={100}
                          minHeight={50}
                          maxWidth={520}
                          maxHeight={310}
                        >
                          <div className="name-animation-container">
                            <span 
                              style={{
                                fontSize:showAnimation.text1FontSize+"px",
                                fontFamily:showAnimation.text1FontFamily+",sans-serif",
                                color:showAnimation.text1FontColor
                              }}
                            >
                              {showAnimation.text1}
                            </span>
                          </div>
                        </Resizable>
                      </div>
                    </Draggable> 
                  </div>
                )}  
                {(showAnimation && showAnimation.textAnim1) && (
                  <div className={`popup_sml d-flex align-items-center justify-content-center rounded bg-transparent animate__animated ${showAnimation.animationType}`}>
                    
                    <Draggable 
                      bounds='parent'
                      onDrag = {DraggableEventHandler}
                      defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                    >
                      <div className="text-animation-1-container-resize">
                        <Resizable
                          style={style}
                          size={{ width, height }}
                          onResizeStop={(e, direction, ref, d) => {
                            setWidth(width + d.width);
                            setHeight(height + d.height);
                            setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                          }}
                          minWidth={100}
                          minHeight={50}
                          maxWidth={520}
                          maxHeight={310}
                        >
                          <div className="text-animation-1-container">
                            <span 
                              style={{
                                fontSize:showAnimation.text1FontSize+"px",
                                fontFamily:showAnimation.text1FontFamily+",sans-serif",
                                color:showAnimation.text1FontColor
                              }}
                            >
                              {showAnimation.text1}
                            </span>
                          </div>
                        </Resizable>
                      </div>
                    </Draggable> 
                  </div>
                )}  
                {(showAnimation && showAnimation.textAnim2) && (
                  <div className={`popup_sml d-flex align-items-center justify-content-center rounded bg-transparent animate__animated ${showAnimation.animationType}`}>
                    
                    <Draggable 
                      bounds='parent'
                      onDrag = {DraggableEventHandler}
                      defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                    >
                      <div className="text-animation-2-container-resize">
                        <Resizable
                          style={style}
                          size={{ width, height }}
                          onResizeStop={(e, direction, ref, d) => {
                            setWidth(width + d.width);
                            setHeight(height + d.height);
                            setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                          }}
                          minWidth={100}
                          minHeight={50}
                          maxWidth={520}
                          maxHeight={310}
                        >
                          <div className="text-animation-2-container">
                            <span 
                              style={{
                                fontSize:showAnimation.text1FontSize+"px",
                                fontFamily:showAnimation.text1FontFamily+",sans-serif",
                                color:showAnimation.text1FontColor
                              }}
                            >
                              {showAnimation.text1}
                            </span>
                          </div>
                        </Resizable>
                      </div>
                    </Draggable> 
                  </div>
                )}  
                {(showAnimation && showAnimation.simpleRevealShow) && (
                  <div 
                    className="popup_sml d-flex align-items-center justify-content-center rounded" 
                    style={{background:`rgba(${showAnimation.bgTheme})`}}>
                    <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                      >
                      <div className="simple-reveal-container-resize">
                        <Resizable
                          style={style}
                          size={{ width, height }}
                          onResizeStop={(e, direction, ref, d) => {
                            setWidth(width + d.width);
                            setHeight(height + d.height);
                            setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                          }}
                          minWidth={200}
                          minHeight={180}
                          maxWidth={510}
                          maxHeight={310}
                        >
                          <div className="simple-reveal-container">
                            <div className="effect-wrap">
                              <div>
                                <h1 
                                  className="effect-block" 
                                  style={{
                                    "--background": showAnimation.text1BgColor,
                                    fontSize:showAnimation.text1FontSize+"px",
                                    fontFamily:showAnimation.text1FontFamily+",sans-serif",
                                    color:showAnimation.text1FontColor
                                  }}
                                >
                                  <span>{showAnimation.text1}</span>
                                </h1>
                              <h1 
                                className="effect-block" 
                                id="another" 
                                style={{
                                  "--background": showAnimation.text2BgColor,
                                  fontSize:showAnimation.text2FontSize+"px",
                                  fontFamily:showAnimation.text2FontFamily+",sans-serif",
                                  color:showAnimation.text2FontColor
                                }}
                              >
                                <span>{showAnimation.text2}</span>
                              </h1>
                              </div>
                            </div>
                          </div>
                        </Resizable>
                      </div>
                    </Draggable>
                  </div>
                )}  

                {(showAnimation && showAnimation.speechBubble) && (
                  <div 
                    className="popup_sml d-flex align-items-center justify-content-center rounded"
                    style={{background:`rgba(${showAnimation.bgTheme})`}}
                  >
                      <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                      >
                        <div className="speech-bubble-container-resize">
                          <Resizable
                            style={style}
                            size={{ width, height }}
                            onResizeStop={(e, direction, ref, d) => {
                              setWidth(width + d.width);
                              setHeight(height + d.height);
                              setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                            }}
                            minWidth={200}
                            minHeight={180}
                            maxWidth={510}
                            maxHeight={310}
                          >
                            <div className="speech-bubble-container">
                              <p 
                                className="bubble speech"
                                style={{
                                  "--border": showAnimation.text1BgColor,
                                  fontSize:showAnimation.text1FontSize+"px",
                                  fontFamily:showAnimation.text1FontFamily+",sans-serif",
                                  color:showAnimation.text1FontColor
                                }}
                              >
                                {showAnimation.text1}
                              </p>
                            </div>
                          </Resizable>
                        </div>
                      </Draggable>
                    
                  </div>
                )}  

                {(showAnimation && showAnimation.speechBubble2) && (
                  <div 
                    className="popup_sml d-flex align-items-center justify-content-center rounded"
                    style={{background:`rgba(${showAnimation.bgTheme})`}}
                  >
                    <Draggable 
                      bounds='parent'
                      onDrag = {DraggableEventHandler}
                      defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                    >
                      <div className="speech-bubble-2-container-resize">
                        <Resizable
                          style={style}
                          size={{ width, height }}
                          onResizeStop={(e, direction, ref, d) => {
                            setWidth(width + d.width);
                            setHeight(height + d.height);
                            setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                          }}
                          minWidth={200}
                          minHeight={120}
                          maxWidth={510}
                          maxHeight={310}
                        >
                          <div className="speech-bubble-2-container">
                            <div 
                              className="l-quote quote"
                              style={{
                                background:showAnimation.text1BgColor,
                                "--background": showAnimation.text1BgColor
                              }}
                            >
                              <blockquote
                                style={{
                                  fontSize:showAnimation.text1FontSize+"px",
                                  fontFamily:showAnimation.text1FontFamily+",sans-serif",
                                  color:showAnimation.text1FontColor
                                }}
                              >
                                <p>{showAnimation.text1}</p>
                              </blockquote>
                              <cite
                                style={{
                                  fontSize:showAnimation.text2FontSize+"px",
                                  fontFamily:showAnimation.text2FontFamily+",sans-serif",
                                  color:showAnimation.text2FontColor
                                }}
                              >{showAnimation.text2}</cite>
                            </div>
                          </div>
                        </Resizable>
                        </div>
                    </Draggable>
                  </div>
                )}            

                {(showAnimation && showAnimation.speechBubble3) && (
                  <div 
                    className="popup_sml d-flex align-items-center justify-content-center rounded"
                    style={{background:`rgba(${showAnimation.bgTheme})`}}
                  >
                      <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                      >
                        <div className="speech-bubble-3-container-resize">
                          <Resizable
                            style={style}
                            size={{ width, height }}
                            onResizeStop={(e, direction, ref, d) => {
                              setWidth(width + d.width);
                              setHeight(height + d.height);
                              setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                            }}
                            minWidth={200}
                            minHeight={120}
                            maxWidth={510}
                            maxHeight={310}
                          >
                            <div className="speech-bubble-3-container">
                              <div 
                                className='speech-bubble'
                                style={{
                                  "--background": showAnimation.text1BgColor,
                                  fontSize:showAnimation.text1FontSize+"px",
                                  fontFamily:showAnimation.text1FontFamily+",sans-serif",
                                  color:showAnimation.text1FontColor
                                }}
                              >{showAnimation.text1}</div>
                            </div>
                          </Resizable>
                        </div>
                      </Draggable>
                  </div>
                )}              
            
                {(showAnimation && showAnimation.speechThought) && (
                  <div 
                    className="popup_sml d-flex align-items-center justify-content-center rounded"
                    style={{background:`rgba(${showAnimation.bgTheme})`}}
                  >
                      <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                      >
                        <div className="speech-thought-container-resize">
                          <Resizable
                            style={style}
                            size={{ width, height }}
                            onResizeStop={(e, direction, ref, d) => {
                              setWidth(width + d.width);
                              setHeight(height + d.height);
                              setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                            }}
                            minWidth={200}
                            minHeight={180}
                            maxWidth={510}
                            maxHeight={310}
                          >
                            <div className="speech-thought-container">
                              <p 
                                className="bubble thought"
                                style={{
                                  "--border": showAnimation.text1BgColor,
                                  fontSize:showAnimation.text1FontSize+"px",
                                  fontFamily:showAnimation.text1FontFamily+",sans-serif",
                                  color:showAnimation.text1FontColor
                                }}
                              >
                                {showAnimation.text1}
                              </p>
                            </div>
                          </Resizable>
                        </div>
                      </Draggable>
                  </div>
                )}

                {(showAnimation && showAnimation.borderAnim) && (
                  <div 
                    className="popup_sml d-flex align-items-center justify-content-center rounded"
                    style={{background:`rgba(${showAnimation.bgTheme})`}}
                  >
                      <Draggable 
                        bounds='parent'
                        onDrag = {DraggableEventHandler}
                        defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                      >
                        <div className="border-animation-container-resize">
                          <Resizable
                            style={style}
                            size={{ width, height }}
                            onResizeStop={(e, direction, ref, d) => {
                              setWidth(width + d.width);
                              setHeight(height + d.height);
                              setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                            }}
                            minWidth={150}
                            minHeight={100}
                            maxWidth={510}
                            maxHeight={310}
                          >
                            <div className="border-animation-container">
                              <div 
                                className="border-animation"
                                style={{
                                  "--color": showAnimation.text2BgColor,
                                  fontSize:showAnimation.text1FontSize+"px",
                                  fontFamily:showAnimation.text1FontFamily+",sans-serif",
                                  color:showAnimation.text1FontColor
                                }}
                              >
                                <div 
                                  className="border-animation__inner"
                                  style={{background:showAnimation.text1}}
                                >{showAnimation.text1}</div>
                              </div>
                            </div>
                          </Resizable>
                        </div>
                      </Draggable>
                  </div>
                )}

                {(showAnimation && showAnimation.borderAnim2) && (
                  <div 
                    className="popup_sml d-flex align-items-center justify-content-center rounded"
                    style={{background:`rgba(${showAnimation.bgTheme})`}}
                  >
                    <Draggable 
                      bounds='parent'
                      onDrag = {DraggableEventHandler}
                      defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                    >
                      <div className="border-animation-2-container-resize">
                        <Resizable
                          style={style}
                          size={{ width, height }}
                          onResizeStop={(e, direction, ref, d) => {
                            setWidth(width + d.width);
                            setHeight(height + d.height);
                            setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                          }}
                          minWidth={200}
                          minHeight={100}
                          maxWidth={510}
                          maxHeight={310}
                        >
                        <div className="border-animation-2-container">
                          <div 
                            className="box"
                            style={{
                              background:showAnimation.text2BgColor,
                            }}
                          >
                            <div 
                              className="contentAnim"
                              style={{
                                background: showAnimation.text1BgColor,
                              }}
                            >
                              <h1 style={{
                                fontSize:showAnimation.text1FontSize+"px",
                                color:showAnimation.text1FontColor,
                                fontFamily:showAnimation.text1FontFamily+",sans-serif",
                              }}>
                                {showAnimation.text1}
                              </h1> 
                            </div>
                          </div>
                        </div>
                        </Resizable>
                      </div>
                    </Draggable>
                  </div>
                )}

                {(showAnimation && showAnimation.ltAnimation1) && (
                  <div 
                    className="popup_sml_lt d-flex align-items-left justify-content-left p-2 rounded"
                    style={{background:`rgba(${showAnimation.bgTheme})`}}
                  >
                    <div id="animation-1" className="animation ms-5">
                      <div 
                        className="red"
                        style={{color:showAnimation.text2BgColor}}
                      >/</div>
                      <div 
                        className="white light mask"
                        style={{
                          fontSize:showAnimation.text1FontSize+"px",
                          color:showAnimation.text1FontColor,
                          fontFamily:showAnimation.text1FontFamily+",sans-serif",
                        }}
                      >
                        <div>{showAnimation.text1}</div>
                      </div>
                      <div 
                        className="white light mask"
                        style={{
                          fontSize:showAnimation.text2FontSize+"px",
                          color:showAnimation.text2FontColor,
                          fontFamily:showAnimation.text2FontFamily+",sans-serif",
                        }}
                      >
                        <div>{showAnimation.text2}</div>
                      </div>
                    </div>
                  </div>
                )}             

                {(showAnimation && showAnimation.ltAnimation2) && (
                  <div 
                    className="popup_sml_lt d-flex align-items-left justify-content-left p-2 rounded"
                    style={{background:`rgba(${showAnimation.bgTheme})`}}
                  >
                    <div id="animation-2" className="animation">
                      <div 
                        className="red bold arimo mask"
                        style={{
                          fontSize:showAnimation.text1FontSize+"px",
                          color:showAnimation.text1FontColor,
                          fontFamily:showAnimation.text1FontFamily+",sans-serif",
                        }}
                      >
                        <div className="p-2">{showAnimation.text1}</div>
                      </div>
                      <div 
                        className="white light mask"
                        style={{
                          fontSize:showAnimation.text2FontSize+"px",
                          color:showAnimation.text2FontColor,
                          fontFamily:showAnimation.text2FontFamily+",sans-serif",
                        }}
                      >
                        <div className="px-2">{showAnimation.text2}</div>
                      </div>
                    </div>
                  </div>
                )}    

                {(showAnimation && showAnimation.ltAnimation3) && (
                  <div 
                    className="popup_sml_lt d-flex align-items-left justify-content-left p-2 rounded"
                    style={{background:`rgba(${showAnimation.bgTheme})`}}
                  >
                    <div id="animation-3" className="animation">
                      <div 
                        className="white light mask"
                        style={{
                          fontSize:showAnimation.text1FontSize+"px",
                          color:showAnimation.text1FontColor,
                          fontFamily:showAnimation.text1FontFamily+",sans-serif",
                        }}
                      >
                        <div>{showAnimation.text1}</div>
                      </div>
                      <div 
                        className="red bold arimo mask"
                        style={{
                          fontSize:showAnimation.text2FontSize+"px",
                          color:showAnimation.text2FontColor,
                          fontFamily:showAnimation.text2FontFamily+",sans-serif",
                        }}
                      >
                        <div>{showAnimation.text2}</div>
                      </div>
                    </div>
                  </div>
                )}      

                {(showAnimation && showAnimation.ltAnimation4) && (
                  <div 
                    className="popup_sml_lt d-flex align-items-left justify-content-left p-2 rounded"
                    style={{background:`rgba(${showAnimation.bgTheme})`}}
                  >
                    <div id="animation-4" className="animation">
                      <div 
                        className="white bold arimo mask"
                        style={{
                          fontSize:showAnimation.text1FontSize+"px",
                          color:showAnimation.text1FontColor,
                          fontFamily:showAnimation.text1FontFamily+",sans-serif",
                        }}
                      >
                        <div className="p-2">{showAnimation.text1}</div>
                      </div>
                      <div className="mask"><div style={{background:showAnimation.text2BgColor}}></div></div>
                    </div>
                  </div>
                )}   

                {(showAnimation && showAnimation.ltAnimation5) && (
                  <div 
                    className="popup_sml_lt d-flex align-items-left justify-content-left p-3 rounded"
                    style={{
                      background:`rgba(${showAnimation.bgTheme})`,
                      "--border-color":showAnimation.text2BgColor
                    }}
                  >
                    <div id="animation-5" className="animation">
                      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
                        <defs>
                          <clipPath id="mask-bottom-right">
                            <rect className="clip-path" x="70%" y="0" width="30%" height="100%"/>
                          </clipPath>
                          <clipPath id="mask-top">
                            <rect className="clip-path" x="0" y="0" width="100%" height="100%"/>
                          </clipPath>
                          <clipPath id="mask-bottom-left">
                            <rect className="clip-path" x="0" y="0" width="30%" height="100%"/>
                          </clipPath>
                        </defs>
                        
                        <line className="bottom-right" x1="70%" y1="100%" x2="100%" y2="100%"/>
                        <line className="right" x1="100%" y1="0" x2="100%" y2="100%"/>
                        <line className="top" x1="0" y1="0" x2="100%" y2="0"/>
                        <line className="left" x1="0" y1="0" x2="0" y2="100%"/>
                        <line className="bottom-left" x1="0" y1="100%" x2="30%" y2="100%"/>
                      </svg>
                      <div 
                        className="white bold arimo mask"
                        style={{
                          fontSize:showAnimation.text1FontSize+"px",
                          color:showAnimation.text1FontColor,
                          fontFamily:showAnimation.text1FontFamily+",sans-serif",
                        }}
                      >
                        <div>{showAnimation.text1}</div>
                      </div>
                      <div 
                        className="white mask"
                        style={{
                          fontSize:showAnimation.text2FontSize+"px",
                          color:showAnimation.text2FontColor,
                          fontFamily:showAnimation.text2FontFamily+",sans-serif",
                        }}
                      >
                        <div>{showAnimation.text2}</div>
                      </div>
                    </div>
                  </div>
                )}   

                {(showAnimation && showAnimation.smiley) && (
                  <div 
                    className="popup_sml d-flex align-items-center justify-content-center rounded bg-transparent"
                  >
                    <Draggable 
                      bounds='parent'
                      onDrag = {DraggableEventHandler}
                      defaultPosition={{x: showAnimation.xPosition, y: showAnimation.yPosition}}
                    >
                      <div className="icon-smiley-container-resize">
                        <Resizable
                          style={{border:"dashed 2px #ddd"}}
                          size={{ width, height }}
                          onResizeStop={(e, direction, ref, d) => {
                            setWidth(width + d.width);
                            setHeight(height + d.height);
                            setShowAnimation({...showAnimation,width:width + d.width,height:height + d.height})
                          }}
                          minWidth={50}
                          minHeight={50}
                          maxWidth={510}
                          maxHeight={310}
                        >
                        <div className="icon-smiley-container">
                          <div className="d-flex align-items-center justify-content-center">
                          {(showAnimation.smileyContent && showAnimation.smileyContent.length > 0) && showAnimation.smileyContent.map((icon,index)=>(
                            
                            <img 
                              src={process.env.REACT_APP_ICONSLINK+"smiley/show/"+icon}
                              alt={icon}
                              style={{
                                width: ((width-10)/showAnimation.smileyContent.length)+"px",
                                height: height+"px",
                              }}
                              key={icon+index}
                            />
                            
                          ))}
                          </div>
                        </div>
                        </Resizable>
                      </div>
                    </Draggable>
                  </div>
                )}
              </div>        
            </div>
            <div className="v_action_r_b">
              {showTimingControl && (
                <>
                <div className="time-set-container mb-4">
                  <Slider
                    range
                    allowCross={false}
                    defaultValue={[(
                      ((ytPlayer.playedSeconds) /
                        (ytPlayer.duration)) *
                        100 
                    ),(
                      (((ytPlayer.playedSeconds) + 12) /
                        (ytPlayer.duration)) *
                        100
                    )]}
                    value={[(
                      (((Number(ytPlayer.start) || ytPlayer.start === 0)?ytPlayer.start:getSeconds(ytPlayer.start)) /
                        (ytPlayer.duration)) *
                        100 
                    ),(
                      ((Number(ytPlayer.end)?ytPlayer.end:getSeconds(ytPlayer.end)) /
                        (ytPlayer.duration)) *
                        100
                    )]}
                    onAfterChange={handlePlayAfter}
                    onChange={handleTriggerTime}
                    draggableTrack={true}
                    tipFormatter={value => `${format(((value / 100) * ytPlayer.duration))}`}
                  />  
                </div>

                <div className="row">
                  <div className="col d-flex justify-content-start">
                    <button className="btn py-1" onClick={handlePlayBetween}>
                    {!ytPlayer.playing ? (
                      <FaPlay />
                    ) : (
                      <FaPause />
                    )} Play in Between 
                    </button>
                  </div>
                </div>
                
                <div className="timer-container">
                  <div className="row">
                    <div className="time-before-container col d-flex justify-content-start">
                      <div className="select-before-time-element">
                        <div className="arrow right-arrow"></div>
                        <div className="form_rw mb-3 timer-input">
                            <label>Start Time</label>
                            <input
                              type="text"
                              className="form-control p_holder shadow-none"
                              placeholder="00:00"
                              value={(Number(ytPlayer.start) || ytPlayer.start === 0)?format(ytPlayer.start):((ytPlayer.start === 0 || ytPlayer.start === '0')?"00:00":ytPlayer.start)}
                              onChange={(e) =>
                                setYtPlayer({
                                  ...ytPlayer,
                                  start: e.target.value,
                                })
                              }
                              onKeyUp={(e) => handleTimeKeyUp(e, "setStartTime")}
                              onBlur={(e) => handleTimeBlur(e, "setStartTime")}
                              ref={setStartTimeRef}
                            />
                            <FaSortDown
                              className="up"
                              onClick={(e) =>
                                handleTimeUpDown(e, "up", "setStartTime")
                              }
                              style={{ cursor: "pointer" }}
                            />
                            <FaSortUp
                              className="down"
                              onClick={(e) =>
                                handleTimeUpDown(e, "down", "setStartTime")
                              }
                              style={{ cursor: "pointer" }}
                            />
                        </div>
                      </div>
                    </div>
                    <div className="time-after-container col d-flex justify-content-end">
                      <div className="select-after-time-element">
                        <div className="arrow right-arrow"></div>
                        <div className="form_rw mb-3 timer-input">
                            <label>End Time</label>
                            <input
                              type="text"
                              className="form-control p_holder shadow-none"
                              placeholder="00:00"
                              value={Number(ytPlayer.end)?format(ytPlayer.end):ytPlayer.end}
                              onChange={(e) =>
                                setYtPlayer({
                                  ...ytPlayer,
                                  end: e.target.value,
                                })
                              }
                              onKeyUp={(e) => handleTimeKeyUp(e, "setEndTime")}
                              onBlur={(e) => handleTimeBlur(e, "setEndTime")}
                              ref={setEndTimeRef}
                            />
                            <FaSortDown
                              className="up"
                              onClick={(e) =>
                                handleTimeUpDown(e, "up", "setEndTime")
                              }
                              style={{ cursor: "pointer" }}
                            />
                            <FaSortUp
                              className="down"
                              onClick={(e) =>
                                handleTimeUpDown(e, "down", "setEndTime")
                              }
                              style={{ cursor: "pointer" }}
                            />
                        </div>
                      </div>
                    </div>
                    <div className="col d-flex justify-content-start align-items-center mt-2">
                      <div className="select-after-time-element">
                        <button className="btn" onClick={handleSetTime}>Set Time</button>
                      </div>
                    </div>
                  
                  </div>
                </div>
                </>
              )}
              <ul
                className={`m-0 p-0 list-unstyled ${
                  actionPoint.length > 0 ? "timeline" : "notimeline"
                }`}
              >
                {actionPoint && actionPoint.length === 0 && (
                  <li className="d-flex align-items-center justify-content-between">
                    <div className="cl_va_1">
                      <div className="radio_grey"></div>
                    </div>

                    <div className="cl_va_2 d-flex align-items-center justify-content-between position-relative">
                      <div className="cl_sml_v_a d-flex align-items-center">
                        <i>
                          <FaRegClock />
                        </i>
                        <div className="vtxt">
                          <h6 className="m-0">Timeline is empty</h6>
                          <p className="m-0">
                            No timeline actions created yet.
                          </p>
                        </div>
                      </div>
                    </div>
                  </li>
                )}

                {actionPoint &&
                  actionPoint.length > 0  &&
                  actionPoint
                  .sort((a, b) => {
                    // console.log(a);
                    if (a.action_time > b.action_time) {
                      return 1;
                    } else if (a.action_time < b.action_time) {
                      return -1;
                    } else {
                      return a.action_event > b.action_event ? 1 : -1;
                    }
                  })
                    .map((elem, index) => (
                      // (elem.action_event === 'video_leadgen') && (
                      <li 
                        className="d-flex align-items-center justify-content-between"
                        key={index}
                      >
                        <div className="cl_va_1">
                          {elem.action_event === "video_cta" && (
                            <div className="radio_yellow"></div>
                          )}
                          {elem.action_event === "video_meeting" && (
                            <div className="radio_primary"></div>
                          )}
                          {elem.action_event === "video_leadgen" && (
                            <div className="radio_green"></div>
                          )}
                          {elem.action_event === "video_leadgen2" && (
                            <div className="radio_green"></div>
                          )}
                          {elem.action_event === "video_annotation" && (
                            <div className="radio_info"></div>
                          )}
                          {elem.action_event === "buy_button" && (
                            <div className="radio_pink2"></div>
                          )}
                          {elem.action_event === "link_button2" && (
                            <div className="radio_pink2"></div>
                          )}
                          {elem.action_event === "link_button3" && (
                            <div className="radio_pink2"></div>
                          )}
                          {elem.action_event === "link_button4" && (
                            <div className="radio_pink2"></div>
                          )}
                          {elem.action_event === "link_button5" && (
                            <div className="radio_pink2"></div>
                          )}
                          {elem.action_event === "link_button6" && (
                            <div className="radio_darkgreen"></div>
                          )}
                          {elem.action_event === "link_button7" && (
                            <div className="radio_dark_purple"></div>
                          )}
                          {elem.action_event === "link_button8" && (
                            <div className="radio_pink2"></div>
                          )}
                          {elem.action_event === "link_button9" && (
                            <div className="radio_pink2"></div>
                          )}
                          {elem.action_event === "Img_btn1" && (
                            <div className="radio_yellow2"></div>
                          )}
                          {elem.action_event === "Img_btn2" && (
                            <div className="radio_darkblue"></div>
                          )}
                          {elem.action_event === "Img_btn3" && (
                            <div className="radio_yellow2"></div>
                          )}
                          {elem.action_event === "Img_btn4" && (
                            <div className="radio_darkblue"></div>
                          )}
                          {elem.action_event === "Img_btn5" && (
                            <div className="radio_darkgreen"></div>
                          )}
                          {elem.action_event === "Img_btn6" && (
                            <div className="radio_sky"></div>
                          )}
                          {elem.action_event === "Img_btn7" && (
                            <div className="radio_sky"></div>
                          )}
                          {elem.action_event === "Img_btn8" && (
                            <div className="radio_sky"></div>
                          )}
                          {elem.action_event === "video_copypaste" && (
                            <div className="radio_red"></div>
                          )}
                          {elem.action_event === "scriptCode" && (
                            <div className="radio_red"></div>
                          )}
                          {elem.action_event === "video_custPoll" && (
                            <div className="radio_pink"></div>
                          )}
                          {elem.action_event === "video_cust2Poll" && (
                            <div className="radio_pink"></div>
                          )}
                          {elem.action_event === "video_cust3Poll" && (
                            <div className="radio_pink"></div>
                          )}
                          {elem.action_event === "video_opentable1" && (
                            <div className="radio_pink"></div>
                          )}
                          {elem.action_event === "video_review1" && (
                            <div className="radio_dark_purple"></div>
                          )}
                          {elem.action_event === "emoji_content" && (
                            <div className="radio_yellow"></div>
                          )}
                          {(elem.action_event === "simple_reveal" || 
                          elem.action_event === "speech_bubble" || 
                          elem.action_event === "speech_bubble_2" || 
                          elem.action_event === "speech_bubble_3" || 
                          elem.action_event === "speech_bubble_4" || 
                          elem.action_event === "speech_thought" || 
                          elem.action_event === "border_animation" || 
                          elem.action_event === "border_animation_2" || 
                          elem.action_event === "lt_animation_1" || 
                          elem.action_event === "lt_animation_2" || 
                          elem.action_event === "lt_animation_3" || 
                          elem.action_event === "lt_animation_4" || 
                          elem.action_event === "lt_animation_5" || 
                          elem.action_event === "name_animation" || 
                          elem.action_event === "text_animation_1" || 
                          elem.action_event === "text_animation_2") && (
                            <div className="radio_primary"></div>
                          )}
                          {elem.action_end_time ? (
                            <span>{elem.action_time}-{elem.action_end_time}</span>
                          ):(
                            <span>{elem.action_time}</span>
                          )}
                        </div>

                        <div className="cl_va_2 d-flex align-items-center justify-content-between position-relative">
                          <div className="cl_sml_v_a d-flex align-items-center">
                            {elem.action_event === "video_leadgen" && (
                              <i>
                                <MdContentPaste  className="text-green-color" size={20} />
                              </i>
                            )}
                            {elem.action_event === "video_leadgen2" && (
                              <i>
                                <MdContentPaste  className="text-green-color" size={20} />
                              </i>
                            )}
                            {elem.action_event === "video_cta" && (
                              <i>
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/assets/images/va_ic_8.png"
                                  }
                                  className="img-fluid"
                                  alt="img"
                                />
                              </i>
                            )}
                            {elem.action_event === "video_meeting" && (
                              <i className="text-primary h3">
                                <FaLink  />
                              </i>
                            )}

                            {elem.action_event === "video_copypaste" && (
                              <i className="text-danger h3">
                                <BsCodeSlash />
                              </i>
                            )}
                            {elem.action_event === "scriptCode" && (
                              <i className="text-danger h3">
                                <BsCodeSlash />
                              </i>
                            )}

                            {elem.action_event === "video_annotation" && (
                              <i className="text-info h3">
                                {/* <img src={process.env.PUBLIC_URL + "/assets/images/va_ic_8.png"} className="img-fluid" alt="img" /> */}
                                <BiEditAlt />
                              </i>
                            )}

                            {elem.action_event === "buy_button" && (
                              <i className="link-color h3">
                                <FaFileDownload />
                              </i>
                            )}

                            {elem.action_event === "link_button2" && (
                              <i className="link-color h3">
                                <MdUpcoming />
                              </i>
                            )}
                            
                            {elem.action_event === "link_button3" && (
                              <i className="link-color h3">
                                <FaFileDownload />
                              </i>
                            )}
                            
                            {elem.action_event === "link_button4" && (
                              <i className="link-color h3">
                                <FaGift />
                              </i>
                            )}
                            
                            {elem.action_event === "link_button5" && (
                              <i className="link-color h3">
                                <HiCursorClick />
                              </i>
                            )}
                            
                            {elem.action_event === "link_button6" && (
                              <i className="timer-color h3">
                                <MdTimer />
                              </i>
                            )}

                            
                            {elem.action_event === "link_button7" && (
                              <i className="review-color h3">
                                <MdRateReview />
                              </i>
                            )}
                            
                            {elem.action_event === "link_button8" && (
                              <i className="link-color h3">
                                <IoShareSocial />
                              </i>
                            )}
                            {elem.action_event === "link_button9" && (
                              <i className="link-color h3">
                                <FaPercent   />
                              </i>
                            )}
                            
                            {elem.action_event === "Img_btn1" && (
                              <i className="shoping-color h3">
                                <FaTag
                                size={20} />
                              </i>
                            )}
                            
                            {elem.action_event === "Img_btn2" && (
                              <i className="qrcode-color h3">
                                <FaQrcode />
                              </i>
                            )}
                            
                            {elem.action_event === "Img_btn3" && (
                              <i className="shoping-color h3">
                                <FaTag
                                size={20} />
                              </i>
                            )}
                            
                            {elem.action_event === "Img_btn4" && (
                              <i className="qrcode-color h3">
                                <FaQrcode />
                              </i>
                            )}
                            
                            {elem.action_event === "Img_btn5" && (
                              <i className="timer-color h3">
                                <MdTimer />
                              </i>
                            )}
                            
                            {elem.action_event === "Img_btn6" && (
                              <i className="text-info h3">
                                <MdRestaurantMenu  />
                              </i>
                            )}
                            
                            {elem.action_event === "Img_btn7" && (
                              <i className="text-info h3">
                                <MdRestaurantMenu  />
                              </i>
                            )}
                            {elem.action_event === "Img_btn8" && (
                              <i className="text-info h3">
                                <FaCalendarAlt  />
                              </i>
                            )}

                            {elem.action_event === "video_custPoll" && (
                              <i className="text-pink h3">
                                {/* <img src={process.env.PUBLIC_URL + "/assets/images/va_ic_8.png"} className="img-fluid" alt="img" /> */}
                                <BsQuestionCircle />
                              </i>
                            )}

                            {elem.action_event === "video_cust2Poll" && (
                              <i className="text-pink h3">
                                <BsQuestionCircle />
                              </i>
                            )}

                            {elem.action_event === "video_cust3Poll" && (
                              <i className="text-pink h3">
                                <BsQuestionCircle />
                              </i>
                            )}

                            {elem.action_event === "video_opentable1" && (
                              <i className="text-pink h3">
                                <FaRegCalendarAlt />
                              </i>
                            )}

                            {elem.action_event === "video_review1" && (
                              <i className="review-color h3">
                                <MdRateReview />
                              </i>
                            )}

                            {(elem.action_event === "simple_reveal" || 
                              elem.action_event === "speech_bubble" || 
                              elem.action_event === "speech_bubble_2" || 
                              elem.action_event === "speech_bubble_3" || 
                              elem.action_event === "speech_bubble_4" || 
                              elem.action_event === "speech_thought" || 
                              elem.action_event === "border_animation" || 
                              elem.action_event === "border_animation_2" || 
                              elem.action_event === "lt_animation_1" || 
                              elem.action_event === "lt_animation_2" || 
                              elem.action_event === "lt_animation_3" || 
                              elem.action_event === "lt_animation_4" || 
                              elem.action_event === "lt_animation_5" ||
                              elem.action_event === "name_animation" || 
                              elem.action_event === "text_animation_1" || 
                              elem.action_event === "text_animation_2") && (
                              <i className="text-primary h3">
                                {/* <img src={process.env.PUBLIC_URL + "/assets/images/va_ic_8.png"} className="img-fluid" alt="img" /> */}
                                <MdRequestPage />
                              </i>
                            )}

                            {elem.action_event === "emoji_content" && (
                              <i className="text-warning h3">
                                {/* <img src={process.env.PUBLIC_URL + "/assets/images/va_ic_8.png"} className="img-fluid" alt="img" /> */}
                                <BsFillEmojiHeartEyesFill />
                              </i>
                            )}

                            
                            <div className="vtxt">
                              {elem.action_event === "video_leadgen" && (
                                <>
                                  <h6 className="m-0">
                                    {"Trigger Reel Form"} added
                                  </h6>
                                  <p className="m-0">
                                    {leadgenFormData.headline.length > 40 ?  leadgenFormData.headline.slice(0, 40) : leadgenFormData.headline}
                                  </p>
                                </>
                              )}
                              {elem.action_event === "video_leadgen2" && (
                                <>
                                  <h6 className="m-0">
                                    {"Lead Collection Form"} added
                                  </h6>
                                  <p className="m-0">
                                    {leadgen2FormData.headline.length > 40 ?  leadgen2FormData.headline.slice(0, 40) : leadgen2FormData.headline}
                                  </p>
                                </>
                              )}

                              {elem.action_event === "video_cta" && (
                                <>
                                  <h6 className="m-0">
                                    {"Custom CTA Link"} added
                                  </h6>
                                  <p className="m-0">
                                    {videoCTAData.formtype === "text"
                                      ? videoCTAData.text
                                      : "Image Added"}
                                  </p>
                                </>
                              )}

                              {elem.action_event === "video_meeting" && (
                                <>
                                  <h6 className="m-0">
                                    {"CTA Link"} added
                                  </h6>
                                  <p className="m-0">
                                    {videoMeetingData.fullname}
                                  </p>
                                </>
                              )}

                              {elem.action_event === "video_annotation" && (
                                <>
                                  <h6 className="m-0">{"Link Card"} added</h6>
                                  <p className="m-0">
                                    {annotationData.annotationText}
                                  </p>
                                </>
                              )}

                              {elem.action_event === "buy_button" && (
                                <>
                                  <h6 className="m-0">{"Free Software Download"} added</h6>
                                  <p className="m-0">
                                  {buybuttonData.buybuttonText}
                                  </p>
                                </>
                              )}

                              {elem.action_event === "link_button2" && (
                                <>
                                  <h6 className="m-0">{"Coming Soon Button "} added</h6>
                                  <p className="m-0">
                                  {linkbtn2Data.linkbtnText}
                                  </p>
                                </>
                              )}
                              
                              {elem.action_event === "link_button3" && (
                                <>
                                  <h6 className="m-0">{"EBook Download Button "} added</h6>
                                  <p className="m-0">
                                  {linkbtn3Data.linkbtnText}
                                  </p>
                                </>
                              )}
                              
                              {elem.action_event === "link_button4" && (
                                <>
                                  <h6 className="m-0">{"Free Gift Button "} added</h6>
                                  <p className="m-0">
                                  {linkbtn4Data.linkbtnText}
                                  </p>
                                </>
                              )}
                              
                              {elem.action_event === "link_button5" && (
                                <>
                                  <h6 className="m-0">{"Quiz button "} added</h6>
                                  <p className="m-0">
                                  {linkbtn5Data.linkbtnText}
                                  </p>
                                </>
                              )}
                              
                              {elem.action_event === "link_button6" && (
                                <>
                                  <h6 className="m-0">{"Timer With Text"} added</h6>
                                  <p className="m-0">
                                  {linkbtn6Data.linkbtnText}
                                  </p>
                                </>
                              )}
                              
                              {elem.action_event === "link_button7" && (
                                <>
                                  <h6 className="m-0">{"Google Review Badge"} added</h6>
                                  <p className="m-0">
                                  {linkbtn7Data.linkbtnText}
                                  </p>
                                </>
                              )}
                              
                              {elem.action_event === "link_button8" && (
                                <>
                                  <h6 className="m-0">{"Social Icon "} added</h6>
                                  <p className="m-0"></p>
                                </>
                              )}
                              {elem.action_event === "link_button9" && (
                                <>
                                  <h6 className="m-0">{"Voucher "} added</h6>
                                  <p className="m-0">{linkbtn9Data.linkbtnText}</p>
                                </>
                              )}
                              
                              {elem.action_event === "Img_btn1" && (
                                <>
                                  <h6 className="m-0">{"Shopping Card "} added</h6>
                                  <p className="m-0">
                                  {Imgbtn1Data.ImgbtnText}
                                  </p>
                                </>
                              )}
                              
                              {elem.action_event === "Img_btn2" && (
                                <>
                                  <h6 className="m-0">{"QR Code 1"} added</h6>
                                  <p className="m-0">
                                  {Imgbtn2Data.ImgbtnText}
                                  </p>
                                </>
                              )}
                              
                              {elem.action_event === "Img_btn3" && (
                                <>
                                  <h6 className="m-0">{"Product Buy Button "} added</h6>
                                  <p className="m-0">
                                  {Imgbtn3Data.ImgbtnText}
                                  </p>
                                </>
                              )}
                              
                              {elem.action_event === "Img_btn4" && (
                                <>
                                  <h6 className="m-0">{"QR Code 2"} added</h6>
                                  <p className="m-0">
                                  {Imgbtn4Data.ImgbtnText}
                                  </p>
                                </>
                              )}
                              
                              {elem.action_event === "Img_btn5" && (
                                <>
                                  <h6 className="m-0">{"Timer With Shopping Card"} added</h6>
                                  <p className="m-0">
                                  {Imgbtn5Data.ImgbtnText}
                                  </p>
                                </>
                              )}
                              
                              {elem.action_event === "Img_btn6" && (
                                <>
                                  <h6 className="m-0">{"Menu Card With Button "} added</h6>
                                  <p className="m-0">
                                  {Imgbtn6Data.ImgbtnText}
                                  </p>
                                </>
                              )}
                              
                              {elem.action_event === "Img_btn7" && (
                                <>
                                  <h6 className="m-0">{"Menu Card Without Button "} added</h6>
                                  <p className="m-0">
                                  {Imgbtn7Data.ImgbtnText}
                                  </p>
                                </>
                              )}
                              {elem.action_event === "Img_btn8" && (
                                <>
                                  <h6 className="m-0">{"Text & Image CTA Card "} added</h6>
                                  <p className="m-0">
                                  {Imgbtn8Data.ImgbtnText}
                                  </p>
                                </>
                              )}

                              {elem.action_event === "video_copypaste" && (
                                <>
                                  <h6 className="m-0">
                                    {"Content Locker Lead Form"} added
                                  </h6>
                                  <p className="m-0">
                                    {copyPasteData.CRMHtmlText.length > 40
                                      ? copyPasteData.CRMHtmlText.substring(
                                          0,
                                          40
                                        )
                                      : copyPasteData.CRMHtmlText}
                                  </p>
                                </>
                              )}
                              {elem.action_event === "scriptCode" && (
                                <>
                                  <h6 className="m-0">
                                    {"Script code"} added
                                  </h6>
                                  <p className="m-0">
                                    {scriptCodeData.script.length > 40
                                      ? scriptCodeData.script.substring(
                                          0,
                                          40
                                        )
                                      : scriptCodeData.script }
                                  </p>
                                </>
                              )}

                              {elem.action_event === "video_custPoll" && (
                                <>
                                  <h6 className="m-0">{"Full Screen Custom Poll"} added</h6>
                                  <p className="m-0">{custPollData.question}</p>
                                </>
                              )}

                              {elem.action_event === "video_cust2Poll" && (
                                <>
                                  <h6 className="m-0">{"4 Option Poll - Small "} added</h6>
                                  <p className="m-0">{cust2PollData.question}</p>
                                </>
                              )}

                              {elem.action_event === "video_cust3Poll" && (
                                <>
                                  <h6 className="m-0">{"4 Option Poll - Half Screen "} added</h6>
                                  <p className="m-0">{cust3PollData.question}</p>
                                </>
                              )}

                              {elem.action_event === "video_opentable1" && (
                                <>
                                  <h6 className="m-0">{"OpenTable "} added</h6>
                                  <p className="m-0">{opentable1Data.opentableText}</p>
                                </>
                              )}

                              {elem.action_event === "video_review1" && (
                                <>
                                  <h6 className="m-0">{"Review"} added</h6>
                                  <p className="m-0">{review1Data.author_name}</p>
                                </>
                              )}

                              {elem.action_event === "simple_reveal" && (
                                <>
                                  <h6 className="m-0">{"Simple Reveal"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "speech_bubble" && (
                                <>
                                  <h6 className="m-0">{"Speech Bubble 1"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "speech_bubble_2" && (
                                <>
                                  <h6 className="m-0">{"Speech Bubble 2"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "speech_bubble_3" && (
                                <>
                                  <h6 className="m-0">{"Speech Bubble 3"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "speech_thought" && (
                                <>
                                  <h6 className="m-0">{"Speech Thought "} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "border_animation" && (
                                <>
                                  <h6 className="m-0">{"Border Animation"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "border_animation_2" && (
                                <>
                                  <h6 className="m-0">{"Border Animation 2"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "lt_animation_1" && (
                                <>
                                  <h6 className="m-0">{"Lower Third Animation 1"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "lt_animation_2" && (
                                <>
                                  <h6 className="m-0">{"Lower Third Animation 2"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "lt_animation_3" && (
                                <>
                                  <h6 className="m-0">{"Lower Third Animation 3"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "lt_animation_4" && (
                                <>
                                  <h6 className="m-0">{"Lower Third Animation 4"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "lt_animation_5" && (
                                <>
                                  <h6 className="m-0">{"Lower Third Animation 5"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "name_animation" && (
                                <>
                                  <h6 className="m-0">{"Name Personalization"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "text_animation_1" && (
                                <>
                                  <h6 className="m-0">{"Text Animation 1"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "text_animation_2" && (
                                <>
                                  <h6 className="m-0">{"Text Animation 2"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}

                              {elem.action_event === "emoji_content" && (
                                <>
                                  <h6 className="m-0">{"Emoji Icon"} added</h6>
                                  {/* <p className="m-0">{showAnimation.text1}</p> */}
                                </>
                              )}
                            </div>
                          </div>

                          <div className="cl_sml_v_b">
                            <button
                              className="bg-transparent border-0"
                              onClick={(e) => {
                                handleEditTrigger(e, elem.action_event,elem.id)
                                elem.action_end_time ? setShowTimingControl(true) : setShowTimingControl(false)
                              }}
                            >
                              <i className="fa fa-pencil"></i>
                              <br />
                              Edit
                            </button>
                            <button
                              className="bg-transparent border-0"
                              onClick={(e) =>
                                handleDeleteTrigger(e, elem.action_event,elem.action_time,elem.id)
                              }
                            >
                              <i className="fa fa-trash"></i>
                              <br />
                              Delete
                            </button>
                          </div>
                        </div>
                      </li>
                    ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

        {showOverlayModal && (
          <>
            <OverlayTemplatesModal
              setShowOverlayModal={setShowOverlayModal}
              handleEffectSetting={handleEffectSetting}
            />
            <div className="modal-backdrop fade show"></div>
          </>
        )}

        {showLowerThirdModal && (
          <>
          <LowerThirdTemplatesModal
            setShowLowerThirdModal={setShowLowerThirdModal}
            handleEffectSetting={handleEffectSetting}
          />
          <div className="modal-backdrop fade show"></div>
        </>
        )}

        { showSocialMediaModal && (
          <>
          <SocialMediaTemplatesModal
            setShowSocialMediaModal={setShowSocialMediaModal}
            setShowLinkbutton8={setShowLinkbutton8}
            setLinkbtn8Data={setLinkbtn8Data}
            linkbtn8Data={linkbtn8Data}
          />
          <div className="modal-backdrop fade show"></div>
        </>
        )}
        
        {showQrCodeModal && showImgbtn2 && (
          <>
          <QrCodeModal
            setShowQrCodeModal={setShowQrCodeModal}
            setImgbtnData = {setImgbtn2Data}
            ImgbtnData = {Imgbtn2Data}
          />
          <div className="modal-backdrop fade show"></div>
        </>
        )}

        {showQrCodeModal && showImgbtn4 && (
          <>
          <QrCodeModal
            setShowQrCodeModal={setShowQrCodeModal}
            setImgbtnData = {setImgbtn4Data}
            ImgbtnData = {Imgbtn4Data}
          />
          <div className="modal-backdrop fade show"></div>
        </>
        )}

        {showReviewLayerModal && (
          <ReviewLayerModal 
            setShowReviewLayerModal={setShowReviewLayerModal}
            setReview1Data={setReview1Data}
            setShowReview1={setShowReview1}
            review1Data = {review1Data}
          />
        )}



    </>
  );
};

export default VideoActions;
